import {Hymn} from "./hymn";

export const hymnsDetailed: Hymn[] = [
  {
    "english": "Before Jehovah's awful throne",
    "hymnNumber": 1,
    "reference": "AL001",
    "title": "Buig Voor Jehova Met Ontsag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "Buig voor Jehova met ontsag;",
          "gee, mensdom, gee aan Hom die eer;",
          "God het alleen die oppermag,",
          "want Hy kan skep en ook verteer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy het die mens formeer uit stof",
          "sonder ons toedoen, deur Sy Woord;",
          "en ons gered - Hom Sy die lof -",
          "Sy kudde wat Hom toebehoort."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Betree Sy voorhof met gejuig,",
          "Psalmsing en prys Sy grote Naam;",
          "laat die verlostes dank betuig",
          "hier in Sy voorhowe te saam."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sy woorde staan onwankelbaar;",
          "Sy liefde is oneindig wyd;",
          "Sy waarheid sal in krag bestaan,",
          "van nou tot in die ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 2,
    "reference": "AL002",
    "title": "Laat Elk Die Heer Se Goedheid Lowe",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Laat elk die Heer se goedheid lowe;",
          "sing tot die Oppermajesteit!",
          "Sy goedheid gaan ons al te bowe;",
          "Sy goedheid duur in ewigheid.",
          "o Israel, kom die Here lowe!",
          "sing van Sy roem en majesteit!",
          "Sy goedheid gaan ons al te bowe;",
          "Sy goedheid duur in ewigheid."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Heer is my 'n sterke Vader,",
          "Hy is my lied, my psalmgesang.",
          "Hy bring my tot Sy howe nader,",
          "dus loof ek Hom my lewe lang!",
          "Ons hoor die vrome lied se galme",
          "van hulp en heil van dag tot dag;",
          "Daar sing ons bly ons dankb're psalme.",
          "God's regterhand doen grote krag!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dit is die roem, van alle dae,",
          "wat onse God geheilig het,",
          "laat ons verheug, van sorg ontslae,",
          "Hom roem in lofsang en gebed.",
          "o Heer, gee tans U seëninge!",
          "o Heer, gee heil op hierdie dag!",
          "Mag daar op al die eerstelinge",
          "‘n ryke oes van voorspoed wag!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U is my God, U wil ek lowe;",
          "ek sing U grote majesteit.",
          "My God, niks gaan U roem te bowe -",
          "U prys ek tot in ewigheid!",
          "Laat elk die Heer se goedheid lowe;",
          "sing tot die Oppermajesteit!",
          "Sy goedheid gaan ons al te bowe;",
          "Sy goedheid duur in ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O worship the Lord in the beauty of holiness",
    "hymnNumber": 3,
    "reference": "AL003",
    "title": "O Nader Die Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 20
    },
    "verses": [
      {
        "content": [
          "O nader die Heer",
          "in die sieraad van heiligheid;",
          "Buig en aanbid Hom,",
          "verkondig Sy eer,",
          "met goud van gehoorsaamheid",
          "en wierook van need'righeid;",
          "Bring Hom die hulde",
          "as Koning en Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Lê aan Sy voete",
          "u las van beslommernis -",
          "Hy het belowe om alles te dra -",
          "Werp op die Heer",
          "u verdriet en bekommernis,",
          "want Hy vertroos u",
          "En skenk wat u vra."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vrees nie, al voel u gebrek en",
          "armoedigheid,",
          "tree tot Sy heiligdom",
          "toe met gesang;",
          "Waarheid en liefde",
          "en tere sagmoedigheid -",
          "Dit is die offers wat Jesus verlang."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ja, al u onrus ",
          "en bange vertwyfeling",
          "sal in Sy liefde ",
          "soos newels verdwyn;",
          "Jesus genees al ons ",
          "dwaasheid en weifeling,",
          "en skenk weer vreugde ",
          "na droefheid en pyn."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Angel voices ever singing",
    "hymnNumber": 4,
    "reference": "AL004",
    "title": "Eng'lestemme Klink Gedurig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.8
    },
    "verses": [
      {
        "content": [
          "Eng'lestemme klink gedurig",
          "juigend voor U troon;",
          "Harpe speel gewyd en vurig,",
          "soet en wonderskoon.",
          "Talloos is hul wat aanbiddend",
          "eindeloos U eer betoon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U, so ver en hoog verhewe,",
          "buig U tot ons neer?",
          "Let U ook op onse strewe",
          "om U Naam te eer?",
          "Luister U na ons gesange",
          "en verlange, dierb're Heer?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, U het 'n welbehae",
          "in elk sterweling;",
          "Hand en stem het U geskape",
          "om U te besing.",
          "Snarespel en lied dien beide",
          "om U lof en eer te bring."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Singend bied ons U op aarde",
          "lof en harmonie;",
          "Loof met hart en mond U waarde",
          "op geboë knie.",
          "Luister nou met welbehae",
          "na ons soetste melodie."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "All people that on earth do dwell",
    "hymnNumber": 5,
    "reference": "AL005",
    "title": "Juig, Al Wat Leef",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 16
    },
    "verses": [
      {
        "content": [
          "Juig al wat leef, juig voor die Heer;",
          "Dien Hom met blydskap, gee Hom eer",
          "verheug U voor Sy aangesig",
          "en loof Sy Naam in lofgedig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Heer is goed en niemand meer",
          "Hy het ons uit die stof formeer",
          "ons is die skape wat Hy lei",
          "om veilig in Sy sorg te wei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gaan deur Sy poorte in met lof",
          "en dien Hom in Sy tempelhof.",
          "Verhoog en prys Sy grote Naam",
          "soos dit die volk van God betaam."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Want goedertiere is die Heer,",
          "Sy liefde eindig nimmermeer;",
          "Sy trou en waarheid bly van krag",
          "tot in die laaste nageslag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord of all being, throned afar",
    "hymnNumber": 6,
    "reference": "AL006",
    "title": "O Lewensbron, Oneindig Ver",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 24
    },
    "verses": [
      {
        "content": [
          "o Lewensbron, oneindig ver,",
          "die middelpunt van elke sfeer,",
          "U glorie vlam in son en ster;",
          "tog woon U in ons harte, Heer. ",
          "tog woon U in ons harte, Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "o Lewenson wat oor ons skyn,",
          "o Ster van hoop, as daglig kwyn,",
          "skenk op ons pad die middaggloed,",
          "deur die lang nagwaak, gee ons moed.",
          "Deur die lang nagwaak, gee ons moed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis middernag in elke hart",
          "waar sonde van die Heiland skei;",
          "Uit diepe duisternis en smart",
          "kan slegs U lig 'n sondaar lei. ",
          "Kan slegs U lig ‘n sondaar lei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "o Lewensbron, oneindig hoog,",
          "U glorie sien ons hier benee",
          "wanneer die wonderskone boog",
          "verskyn, wat U as teken gee,",
          "wat U, o Heer, as teken gee."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "o Mag U waarheid ons bevry;",
          "ons harte steeds die kwaad vermy",
          "tot elke sielealtaar brand",
          "in elke huis en elke land. ",
          "In elke huis en elke land."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord Jehovah reigns",
    "hymnNumber": 7,
    "reference": "AL007",
    "title": "Die Here God Regeer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28
    },
    "verses": [
      {
        "content": [
          "Die Here God regeer",
          "van Sy verhewe troon;",
          "Hy is bekleed met eer,",
          "met majesteit bekroon;",
          "Geen sterfling kan die lig aanskou",
          "wat Hom geheimnisvol omvou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die donder van Sy hand",
          "laat elke skepsel beef;",
          "Sy wet hou ewig stand",
          "vir elke mens wat leef;",
          "Genade en geregtigheid",
          "word saamgevoeg in Sy beleid."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In al Sy skeppingswerk",
          "sien ons Sy wyse raad,",
          "onpeilbaar, onbeperk,",
          "wat niemand kan verklaar;",
          "Die magte van die hel sal wyk",
          "en voor Sy majesteit beswyk."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die Vors van die heelal,",
          "Almagtig en alwys,",
          "deur wesens sonder tal",
          "verheerlik en geprys,",
          "is uit genade onverdiend,",
          "my troue Vader en my Vriend."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O for a heart to praise my God!",
    "hymnNumber": 8,
    "reference": "AL008",
    "title": "Gee My ‘n Hart Wat God Wil Dien",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19
    },
    "verses": [
      {
        "content": [
          "Gee my 'n hart wat God wil dien,",
          "‘n hart van sonde vry,",
          "‘n hart gereinig deur die bloed",
          "so ruim gestort vir my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "‘n Hart wat sag en teder is -",
          "maak dit, o Heer, U troon;",
          "Waar net my God alleen kan spreek",
          "en Jesus in kan woon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "‘n Hart wat rein gedagtes dink,",
          "waar net U liefde troon,",
          "volmaak en rein en reg en goed;",
          "soos Jesus net so skoon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gee my U rein gesindheid, Heer;",
          "o haas U na my sy;",
          "Skryf op my hart die beste naam -",
          "U nuwe naam vir my."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 9,
    "reference": "AL009",
    "title": "Prys Die Heer Met Blye Galme",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Prys die Heer met blye galme,",
          "o my siel, daar's ryke stof;",
          "heel my lewe sal ek psalme",
          "juigend sing Sy Naam tot lof",
          "en solank ek lig geniet,",
          "Hom verhoog in elke lied."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Moet geen hoop op mense bou nie;",
          "Waar kom tog jou hulp vandaan?",
          "As jy nie op God vertrou nie,",
          "sal hul jou beskaamd laat staan.",
          "Keer hul na die aarde weer,",
          "stort hul planne met hul neer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Salig Hy wat in die lewe",
          "op die God van Jakob steun;",
          "Hy wat Hom tot God begewe",
          "as die onweer om Hom dreun;",
          "Wat sy hoop in elke lot",
          "vestig op die Heer sy God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "With reverence let the saints appear",
    "hymnNumber": 10,
    "reference": "AL010",
    "title": "Met Eerbied Moet Die Heil'ges Wag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 20
    },
    "verses": [
      {
        "content": [
          "Met eerbied moet die heil'ges wag",
          "en need'rig kniel voor God;",
          "Beef voor Sy Woord met diep ontsag,",
          "getrou aan Sy gebod. ",
          "Getrou aan Sy gebod."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe vreeslik is U majesteit!",
          "Hoe groot U leërskaar!",
          "Wie kan U teenstaan in die stryd,",
          "of waarheid spreek so klaar. ",
          "Of waarheid spreek so klaar."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sing, vrygekooptes van die Heer,",
          "van U Verlosser, sing!",
          "Pelgrims op weg na Sion, leer",
          "u Koning hulde bring. ",
          "U Koning hulde bring."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O Jesus, onse Hemelheer,",
          "wat steeds U volk vertroos,",
          "U kom toe al die dank en eer",
          "vir ewig en altoos. ",
          "Vir ewig en altoos."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Come, Thou almighty King",
    "hymnNumber": 11,
    "reference": "AL011",
    "title": "Kom, O Almagtige Heer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.5
    },
    "verses": [
      {
        "content": [
          "Kom, o almagtige Heer",
          "help ons U Naam te eer;",
          "Laat ons U prys.",
          "Vader so glorieryk,",
          "laat nou U almag blyk;",
          "Stig onder ons U ryk,",
          "Skepper alwys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kom, heil'ge Trooster, kom,",
          "spreek en getuig alom",
          "in hierdie uur;",
          "Daal in ons harte neer,",
          "wil U in ons regeer,",
          "verlaat ons nimmermeer,",
          "o Bron van krag!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ver strek U magsgebied;",
          "laat nou U wil geskied",
          "waar mense woon;",
          "laat ons U majesteit",
          "aanskou in heerlikheid,",
          "en tot in ewigheid",
          "U eer betoon."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Praise ye the Lord! 'tis good to raise",
    "hymnNumber": 12,
    "reference": "AL012",
    "title": "O Prys Die Heer Met Hart En Stem",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "O prys die Heer met hart en stem",
          "en juig Hom toe, Jerusalem;",
          "Want hierdie plig is die genot",
          "vir kinders van die ware God."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sy handewerk is elke ster",
          "wat skitter, duislingwekkend ver;",
          "o diepe wysheid, wonderbaar!",
          "Wie kan dit peil of ooit verklaar?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verhef die Heer wat ons verbly",
          "as wolke aan die hemel sprei,",
          "wat ons van milde reëns voorsien",
          "en voedsel op Sy tyd bedien."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hy gee die gras wat vlaktes dek,",
          "en graan wat oor die lande strek.",
          "Hy voed Sy skepsels elke dag,",
          "en selfs die voëls wat op Hom wag."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "‘n Welgevalle het die Heer",
          "in almal wat Hom vrees en eer.",
          "Sy beeld sal Hy in elkeen sien",
          "wat Hom van ganser harte dien."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Praise God, from whom all blessings flow",
    "hymnNumber": 13,
    "reference": "AL013",
    "title": "Loof God Van Wie Die Seën Kom!",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "Loof God van wie die seën kom!",
          "Loof Hom, o ganse skepseldom!",
          "Loof Hom omhoog, o eng'le heer!",
          "Drie-enig God - Hom Sy die eer!"
        ],
        "verseNumber": 1
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 14,
    "reference": "AL014",
    "title": "Loof, Loof Hom Koning, God En Heer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Loof, loof Hom Koning, God en Heer,",
          "o al Sy knegte, gee Hom eer;",
          "u wat gedurig voor Hom staan,",
          "hef nou 'n vrome loflied aan!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hef nou u hande na omhoog,",
          "Rig tot Sy heiligdom u oog",
          "En kniel eerbiedig voor Hom neer;",
          "Loof, loof Hom Koning, God en Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O mag Gods seën op u daal -",
          "Sy guns uit Sion u bestraal.",
          "Die ganse skepping moet Hom eer;",
          "Loof, loof Hom Koning, God en Heer!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "God's free mercy streameth",
    "hymnNumber": 15,
    "reference": "AL015",
    "title": "God Se Groot Genade",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "God se groot genade",
          "stroom soos 'n rivier;",
          "Oor Sy kerk op aarde",
          "wapper Sy banier.",
          "Uitgestrek en magtig",
          "soos die hemelblou,",
          "spreek Sy dade kragtig",
          "van Sy liefdetrou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Helder somersonskyn",
          "baai die land en see,",
          "blye lig bring welsyn",
          "gul en ryklik mee,",
          "alles juig op aarde",
          "in die milde gloed;",
          "Kon ons U na waarde",
          "prys, want U is goed!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer, genees ons blindheid,",
          "ons wil U aanskou;",
          "Gee ons U gesindheid,",
          "liefderyk, getrou;",
          "Donker is ons lewe",
          "sonder U, ons Lig,",
          "en die moed begewe",
          "ons, as U nie rig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nimmer mag daar twyfel",
          "insluip in ons hart,",
          "nee, ons sal nie weifel,",
          "selfs in sterwensmart,",
          "want U het belowe",
          "om ons te gelei",
          "na die Huis daarbowe",
          "vir ons voorberei."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Blessed Jesus, at Thy word",
    "hymnNumber": 16,
    "reference": "AL016",
    "title": "Liewe Jesus, Op U Woord!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Liewe Jesus op U Woord",
          "het ons in U Naam vergader;",
          "Heer, ontsluit die hemelpoort,",
          "skenk ons toegang tot die Vader;",
          "Wek ons harte deur U lering",
          "tot aanbidding en verering."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al ons kennis is gehul",
          "in die newels van die sonde,",
          "tot U Gees ons lewe vul",
          "met U waarheid, ongeskonde.",
          "Heer, verbreek al onse boeie",
          "en werk self in ons die goeie."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Openbaar Uself, o Heer,",
          "ons is van U lig afhanklik.",
          "Maak ons vir U Woord en leer",
          "deur U Heil'ge Gees ontvanklik.",
          "Luister na U volk se rede",
          "hoor ons lofsang en gebede."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Father, again in Jesus' name we meet",
    "hymnNumber": 17,
    "reference": "AL017",
    "title": "Vader Ons Kom Weer Hier",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Vader, ons kom weer ",
          "hier in Jesus naam,",
          "en kniel ootmoedig aan ",
          "U voetbank saam;",
          "Ons stemme sal in ",
          "dankb're lof verrys;",
          "Skenk meer genade ",
          "om U Naam te prys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons loof U naam ",
          "vir al U troue sorg,",
          "want U is daagliks ",
          "vir ons lewe borg;",
          "Van al U liefde, Heer, ",
          "wil ons getuig;",
          "U hand behou ons ",
          "as die vyand dreig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Helaas, ons het in dwaasheid ",
          "menigmaal",
          "uit onbedagsaamheid",
          "van U gedwaal;",
          "Ons het U stem gehoor ",
          "en t'ruggekeer-",
          "Berouvol kniel ons ",
          "aan U voete neer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O, deur U Naam waarin ",
          "die volheid woon,",
          "en deur die liefde ",
          "in U guns betoon,",
          "en deur U bloed ",
          "gestort vir ons so vry,",
          "mag ons deur U ",
          "genade toegang kry!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, we come before Thee now",
    "hymnNumber": 18,
    "reference": "AL018",
    "title": "In U Voorhof, Liewe Heer",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 18
    },
    "verses": [
      {
        "content": [
          "In U voorhof, liewe Heer,",
          "kniel ons nou aanbiddend neer;",
          "neig tot ons gebed U oor!",
          "Sou ons roep en U nie hoor,",
          "sou ons roep en U nie hoor?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heiland, wil genadiglik",
          "onse siele nou verkwik",
          "met 'n boodskap uit U Woord,",
          "dan gaan ons blymoedig voort,",
          "dan gaan ons blymoedig voort."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skenk bevryding, deur U Gees,",
          "van bekommernis en vrees;",
          "Wyl ons need'rig op U wag,",
          "skenk verlossing, hoop en krag,",
          "skenk verlossing, hoop en krag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom, o Heer, en troos elkeen",
          "wat in rou en droefheid ween;",
          "Laat die hart wat smart moet ly,",
          "hom in U, o Heer, verbly,",
          "hom in U, o Heer, verbly."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Mag die pelgrim in U vind:",
          "Heler, Hoop en troue Vriend.",
          "stel die sondaar vry dat hy",
          "hom in Jesus kan verbly,",
          "hom in Jesus kan verbly."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Again our earthly cares we leave",
    "hymnNumber": 19,
    "reference": "AL019",
    "title": "Weer Kan Ons Opgaan Na U Huis",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 16
    },
    "verses": [
      {
        "content": [
          "Weer kan ons opgaan na U huis",
          "en van ons arbeid rus;",
          "Van U teenwoordigheid, o Heer,",
          "verseker en bewus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Groot Herder van U volk, ons kniel",
          "eerbiedig voor U neer;",
          "Stem nou ons harte tot gebed,",
          "en wil U self ons leer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Neem weg, in U genade, Heer,",
          "die wolke wat ons skei;",
          "Maak ons ontvanklik vir die leer",
          "waarin U ons wil lei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Heer, laat U aangesig tog skyn",
          "oor almal wat U vrees,",
          "dan sal ons in genade groei",
          "en wandel na die Gees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "'We would see Jesus;' for the shadows lengthen",
    "hymnNumber": 20,
    "reference": "AL020",
    "title": "Ons Soek Na Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.5
    },
    "verses": [
      {
        "content": [
          "Ons soek na Jesus,",
          "want die skadu's daal reeds;",
          "Vaag word die landskap",
          "van ons klein bestaan;",
          "Ons soek na Jesus,",
          "aardse ligte faal reeds;",
          "Die laaste worsteling",
          "breek spoedig aan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons soek na Jesus",
          "aardse steun begewe",
          "ons voor die kille,",
          "donker doodsvallei;",
          "Maar Hy bly met ons,",
          "en geen dood of lewe",
          "kan ons van Jesus",
          "en Sy liefde skei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons soek na Jesus;",
          "alles ag ons skade",
          "om die uitnemendheid",
          "van onse Heer;",
          "Want in die rykdom",
          "van Sy groot genade",
          "vind ons die volheid",
          "wat ons hart begeer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons soek na Jesus",
          "wat vir ons gesterf het",
          "om ons met God",
          "vir ewig te versoen;",
          "Hy wat die lewe",
          "vir Sy volk verwerf het,",
          "en, by Sy koms,",
          "die dood tot niet sal doen."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord in Zion reigneth",
    "hymnNumber": 21,
    "reference": "AL021",
    "title": "Die Heiland Heers In Sion",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Die Heiland heers in Sion;",
          "Laat al die volke juig",
          "en saam voor Sy genadetroon",
          "met dankb're harte buig!",
          "Die Heiland heers in Sion;",
          "Daar word Sy Naam geprys",
          "aan Hom sal prinse hulde bring",
          "en konings eer bewys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Heiland heers in Sion;",
          "En wie meet Sy bestaan?",
          "Die aarde hou Hy in Sy hand,",
          "gebied die oseaan;",
          "Aan Hom kom toe die ere,",
          "die sterkte en gesag;",
          "Verheug jul, verste eilande,",
          "en roem Sy reddingskrag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons Koning heers in Sion;",
          "Die uur is Hom gewy!",
          "Betree Sy tempelhof met sang;",
          "Hom Sy die heerskappy!",
          "Ja, loof Sy Naam in Sion",
          "en oor die groot heelal;",
          "Laat al die skepsels van Sy hand",
          "aanbiddend voor Hom val."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, dismiss us with Thy blessing",
    "hymnNumber": 22,
    "reference": "AL022",
    "title": "Here, Wil U Self Ons Seën",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Here, wil U self ons seën",
          "voordat ons U huis verlaat;",
          "Stort U liefde, soos 'n reën,",
          "mildelik in elke hart.",
          "O verkwik ons, o verkwik ons,",
          "op ons dorre pelgrimsreis."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons is dankbaar, liewe Here,",
          "vir die evangeliewoord.",
          "Skenk ons vrugte U ter ere -",
          "lofsang wat U toebehoort.",
          "Gee ons ywer, gee ons ywer",
          "in verspreiding van U Woord."
        ],
        "verseNumber": 2
      }
    ],
    "chorus": null
  },
  {
    "english": "God bless and keep thee through all thy days",
    "hymnNumber": 23,
    "reference": "AL023",
    "title": "Mag God U Weë Altoos Bewaar",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Mag God U weë altoos bewaar;",
          "Mag God U seën, steeds jaar na jaar;",
          "'mispa', ons afskeidsgroet,",
          "'mispa', tot ons ontmoet",
          "rondom ons Heer,",
          "as Hy Sy volk vergaar."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe lieflik is die aanbiddingstond",
          "saam met Gods kinders in heilverbond;",
          "Daar waar Gods vrede woon,",
          "daar waar Sy liefde troon,",
          "daar word die smart vergeet",
          "wat ons verwond."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Lewende strome vloei uit Sy Woord,",
          "en soete manna kom daaruit voort.",
          "U wat ons siele voed,",
          "U is ons hoogste God!",
          "ja, en in droefheid ",
          "onse toevlugsoord."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, have mercy, have mercy upon us",
    "hymnNumber": 24,
    "reference": "AL024",
    "title": "Heer, Wees Genadig",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "timestamps": {
      "intro": 9,
      "introEnd": 17
    },
    "verses": [
      {
        "content": [
          "Wees genadig, genadig, o Heer",
          "en verleen ons die krag om ",
          "U wet te hou!",
          "Amen"
        ],
        "verseNumber": 1
      }
    ],
    "chorus": null
  },
  {
    "english": "Saviour, again to Thy dear name we raise",
    "hymnNumber": 25,
    "reference": "AL025",
    "title": "Heiland, Ons Loof Nogmaals",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Heiland, ons loof nogmaals ",
          "U dierb're Naam;",
          "In hierdie slotsang ",
          "prys ons U tesaam.",
          "Eerbiedig staande ",
          "sing ons U ter eer,",
          "en need'rig wag ons ",
          "op U seën, o Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Skenk ons U vrede ",
          "as ons huiswaarts keer;",
          "Ons wil die dag ook ",
          "met U eindig, Heer",
          "waak oor ons lippe, ",
          "hou ons harte rein",
          "vir U aanbidding ",
          "as die daglig kwyn."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skenk ons U vrede ",
          "op ons lewensweg,",
          "balsem vir droefheid, ",
          "sterkte om te veg;",
          "Het ons dan eenmaal, ",
          "Heer, die stryd volstry,",
          "gee ons die vrede ",
          "wat vir ewig bly."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord be with us as we bend",
    "hymnNumber": 26,
    "reference": "AL026",
    "title": "Die Heer Sy Met Ons Wyl Ons Bid",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 16
    },
    "verses": [
      {
        "content": [
          "Die Heer Sy met ons wyl ons bid",
          "om vrede en om krag,",
          "waar ons nog in Sy huis vertoef",
          "en op Sy seën wag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Heer sy met ons langs die weg",
          "wanneer ons huiswaarts keer;",
          "Ons stil oorpeinsing of gesprek",
          "strek steeds Sy Naam tot eer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die Heer sy met ons tot die nag",
          "ons met Sy rus omvou;",
          "Wees U ons gas van dag tot dag -",
          "Ons lig wat nooit verflou. Amen."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord is in His holy temple",
    "hymnNumber": 27,
    "reference": "AL027",
    "title": "Die Heer Is In Sy Heil'ge Tempel",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "timestamps": {
      "intro": 32,
      "introEnd": 46
    },
    "verses": [
      {
        "content": [
          "Die Heer is in Sy heil'ge tempel; ",
          "die Heer is in Sy heil'ge tempel; ",
          "Swyg voor Hom, ganse aarde,",
          "swyg voor Hom, ganse aarde, ",
          "swyg voor God!",
          "Wees stil nou, wees stil nou",
          "Swyg voor Hom.",
          "Amen."
        ],
        "verseNumber": 1
      }
    ],
    "chorus": null
  },
  {
    "english": "New every morning is the love",
    "hymnNumber": 28,
    "reference": "AL028",
    "title": "Met Elke Dag As Ons Ontwaak",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 16
    },
    "verses": [
      {
        "content": [
          "Met elke dag as ons ontwaak,",
          "kan ons opnuut U liefde smaak;",
          "U het bewaar in donker nag",
          "en ons verfris met moed en krag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Genade vir die nuwe dag",
          "bestraal ons waar ons op U wag -",
          "opnuut bewaar, opnuut vergeef",
          "met nuwe moed om reg te leef."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As ons sou vasbeslote wees",
          "om met 'n rein, opregte gees",
          "aan God te wy wat ons besit,",
          "sou Hy meer gee as wat ons bid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons alledaagse weg en taak",
          "sal ons behoeftes duid'lik maak:",
          "geleentheid vir opoffering,",
          "‘n weg om ons na God te bring."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O Here, wil ons voorberei",
          "om ewig daar by U te bly;",
          "Help hier U kerk, ja elke lid,",
          "om so te wandel soos ons bid."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Sweetly the holy hymn",
    "hymnNumber": 29,
    "reference": "AL029",
    "title": "Soet Klink Die Oggendsang",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 14
    },
    "verses": [
      {
        "content": [
          "Soet klink die oggendsang",
          "deur klare môrelug,",
          "en voor daar weer 'n rookwaas hang,",
          "wil ons na U toe vlug."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wyl blomme, doubenat,",
          "wat tot die son verrys,",
          "stort uit U Gees, o Heer, sodat",
          "ons U opreg kan prys."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Beskerm ons met U skild",
          "in die verwoede stryd",
          "teen boesemsonde, wild en wreed",
          "en vol arglistigheid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Daar op die berg alleen,",
          "lank voor die daeraad,",
          "o Man van smart, het U geween",
          "en U op God verlaat."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Verhoor ons smeekgebed,",
          "want ons is swak en broos.",
          "in Jesus naam wil U ons red",
          "en tederlik vertroos."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Holy, holy, holy! Lord God Almighty!",
    "hymnNumber": 30,
    "reference": "AL030",
    "title": "Heilig, Heilig, Heilig",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.5
    },
    "verses": [
      {
        "content": [
          "Heilig, heilig, heilig,",
          "Here almagtig!",
          "In die vroeë môre",
          "aanbid ons voor U troon.",
          "Heilig, heilig, heilig,",
          "liefdevol, waaragtig!",
          "Heer wat omhoog die",
          "ewigheid bewoon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heilig, heilig, heilig,",
          "Eng'le daarbowe",
          "werp voor U hul krone,",
          "o Vader, Seun en Gees;",
          "Duisende aanbid U",
          "in die hemelhowe,",
          "Here wat was en is,",
          "en wat sal wees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heilig, heilig, heilig,",
          "U weg is duister,",
          "waar geen menseoog ooit",
          "U heerlikheid aanskou,",
          "U alleen is heilig,",
          "glorieryk, vol luister,",
          "enig in mag en",
          "ewiglik getrou!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, in the morning Thou shalt hear",
    "hymnNumber": 31,
    "reference": "AL031",
    "title": "Heer In Die Môre Styg My Lied",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10
    },
    "verses": [
      {
        "content": [
          "Heer in die môre styg my lied",
          "in dankbaarheid omhoog;",
          "Aan U wil ek 'n lofsang bied,",
          "tot U hef ek my oog."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek hef my oog gelowig ",
          "tot U berg van heerlikheid,",
          "waar Jesus voor U troon, o God,",
          "as Hoëpriester pleit."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O, mag U Gees my skrede rig",
          "en my versterk met krag,",
          "dan sal ek nougeset my plig",
          "vervul van dag tot dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vir almal wat Hom eer en vrees,",
          "liefhebbers van Sy Naam,",
          "sal God 'n skild en pantser wees;",
          "Nooit word hul hoop beskaam."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The sun is on the land and sea",
    "hymnNumber": 32,
    "reference": "AL032",
    "title": "Die Son Skyn Oor Die Land En See",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Die son skyn oor die land en see,",
          "dit is weer dag;",
          "En elke uur wil ons bestee,",
          "met diep ontsag,",
          "aan God wat ons die lewe gee;",
          "Dan kom die nag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U troue sorg omring ons hier",
          "soos sterreprag.",
          "U goedertierenhede sier",
          "ons lewensdag.",
          "Van U wat steeds ons lot bestier,",
          "kry ons die krag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ook moeilikhede en verdriet",
          "moet ons verwag;",
          "En onder al ons droefheid",
          "bied U hulp en krag.",
          "Ons hele lewe is 'n lied -",
          "‘n goue dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Aan U kom toe die heerlikheid!",
          "U sy die mag,",
          "O Vader, Seun en Gees,",
          "wat tyd nie ken of ag!",
          "Drie-enig God, en ewigheid",
          "loof ons U krag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "When morning gilds the skies",
    "hymnNumber": 33,
    "reference": "AL033",
    "title": "As Stil Die Dagbreek Kom",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.35
    },
    "verses": [
      {
        "content": [
          "As stil die dagbreek kom,",
          "verheug ek my in Hom.",
          "Loof Jesus, onse Heer!",
          "My arbeid en gebed",
          "verheerlik Hom wat red.",
          "Loof Jesus, onse Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "En klink die kerkklok bly",
          "oor dorp en rant en vlei,",
          "loof Jesus, onse Heer!",
          "O luister na die klank",
          "en bring aan God u dank;",
          "Loof Jesus, onse Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Lig sal ons nag verdring",
          "as ons van harte sing:",
          "Loof Jesus, onse Heer!",
          "Want bose magte wyk",
          "vir hierdie huldeblyk:",
          "Loof Jesus, onse Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Laat ons die wêreld oor",
          "verenig in die koor:",
          "Loof Jesus, onse Heer!",
          "Laat al die nasies juig,",
          "eendragtig dank betuig:",
          "Loof Jesus, onse Heer!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "In gindse saal'ge oord",
          "hoor ons die soet akkoord:",
          "Loof Jesus, onse Heer!",
          "Laat land en lug en see",
          "alom die antwoord gee:",
          "Loof Jesus, onse Heer!"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Solank U lewe bied,",
          "bly dit my hoogste lied:",
          "Loof Jesus, onse Heer!",
          "Hierna sing ek altoos",
          "deur eeue eindeloos:",
          "Loof Jesus, onse Heer!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "We Thank Thee",
    "hymnNumber": 34,
    "reference": "AL034",
    "title": "Vader, Ons Dank U Vir Die Nag",
    "hasMidi": true,
    "numberOfVerses": 2,
    "hasChorus": false,
    "timestamps": {
      "intro": 11
    },
    "verses": [
      {
        "content": [
          "Vader, ons dank U vir die nag",
          "en vir die môredou se prag,",
          "vir rus en voedsel wat ons kry,",
          "vir alles wat die dag verbly."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Mag ons aan and're doen en sê,",
          "wat U, o Heer, van ons wil hê.",
          "Maak ons in werk en spel en lag",
          "meer liefdevol van dag tot dag."
        ],
        "verseNumber": 2
      }
    ],
    "chorus": null
  },
  {
    "english": "Sun of my soul, O Saviour dear!",
    "hymnNumber": 35,
    "reference": "AL035",
    "title": "Son Van My Siel",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11
    },
    "verses": [
      {
        "content": [
          "Son van my siel, getroue Heer,",
          "daar is geen nag waar U regeer;",
          "Laat tog geen donker aardse wolk",
          "U skei, o Here, van U volk."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As sagte sluimer my omvou,",
          "weet ek dat U die wag sal hou;",
          "Van U getroue sorg bewus,",
          "versink my gees in soete rus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Bly U by my van vroeg tot laat!",
          "U is my hulp, my toeverlaat;",
          "Bly U by my waar ek mag swerf;",
          "Want sonder U durf ek nie sterf."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O seën my as ek ontwaak",
          "en sterk my vir die dag se taak -",
          "tot in verrukking eens my oog",
          "U sal aanskou, my Heer, omhoog."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "An Evening Prayer",
    "hymnNumber": 36,
    "reference": "AL036",
    "title": "As Iemand Dalk Vandag Deur My Moes Ly",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.6
    },
    "verses": [
      {
        "content": [
          "As iemand dalk vandag deur my moes ly;",
          "Het iemand van die regte pad gegly;",
          "Miskien het ek U aangesig vermy,",
          "vergewe Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Het ek vandag 'n ydel woord gespreek;",
          "My oor gesluit vir armes se gesmeek;",
          "Het ek my dwaasheid so op hul gewreek,",
          "vergewe Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Was ek vandag pervers of hard of koud;",
          "Het ek verlang na roem en eer en goud;",
          "Was my vernedering my eie fout,",
          "vergewe Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vergeef my sonde; ek het dit bely,",
          "vergeef geheime sondes ook in my.",
          "O Helper, Gids en Redder, wees naby -",
          "Amen amen!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Now God be with us, for the night is closing",
    "hymnNumber": 37,
    "reference": "AL037",
    "title": "Heer, Wees U Met Ons",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Heer, wees U met ons,",
          "want die nag kom nader,",
          "daglig en duister kom van U,",
          "ons Vader;",
          "Geen ander toevlug het ons hier benede;",
          "Hoor U ons bede."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat geen verskrikking",
          "hierdie woning nader,",
          "waak tot die daglig ons weer wek,",
          "o Vader;",
          "Onder U vleuels rus U kinders veilig -",
          "deur U geheilig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons het geen toevlug buiten U,",
          "o Vader,",
          "ons is U kinders,",
          "trek ons daagliks nader",
          "aan U groot liefde wat ons hart vir ewig",
          "in U verstewig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vader, U Naam kan ons nie prys",
          "na waarde;",
          "O laat U wil in ons geskied op aarde;",
          "U, wat die sonde wegneem en vergewe,",
          "skenk ons die lewe."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Softly now the light of day",
    "hymnNumber": 38,
    "reference": "AL038",
    "title": "Saggies Taan Die Daglig Nou",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Saggies taan die daglig nou",
          "weg tot avondskemer grou;",
          "Vry van elke sorg en plig",
          "soek ons, Heer, U aangesig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U alsiende oog ontbloot",
          "al ons sondes klein en groot;",
          "O, vergewe alles, Heer,",
          "en wil ons U weë leer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Spoedig sal ons lewe kwyn,",
          "in die lig vir ons verdwyn;",
          "Mag ons dan, van sorge vry,",
          "in U ligpaleise bly."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "The day Thou gavest, Lord, is ended",
    "hymnNumber": 39,
    "reference": "AL039",
    "title": "Die Dag, O Heer, Wat U Gegee Het",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.5
    },
    "verses": [
      {
        "content": [
          "Die dag, o Heer, wat U gegee het,",
          "daal in die weste; dit word nag.",
          "Soos ons die oggenduur bestee het",
          "met U, so eindig ons die dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons dank U dat U kerk, steeds wakend,",
          "haar oog oor heel die wêreld hou,",
          "terwyl die aarde, immer kerend,",
          "uit son en ster sy dae bou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "So breek oor elke land en eiland,",
          "op sy gesette tyd, die dag;",
          "Onafgebroke hoor die Heiland",
          "die loflied van Sy kerk op wag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dit sy so, Heer; U troon sal nimmer",
          "soos aardse koninkryke val,",
          "want U gesag verbrei hom immer,",
          "o Koning van die groot heelal."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Abide with me; fast falls the eventide",
    "hymnNumber": 40,
    "reference": "AL040",
    "title": "Bly By My Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Bly by my, Heer,",
          "terwyl die donker nag",
          "al digter word,",
          "en hou oor my die wag;",
          "As niemand anders",
          "meer by my wil bly,",
          "wees my, o troue Helper,",
          "dan naby."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ten einde spoed",
          "my korte lewensdag,",
          "sy glans en vreug",
          "verskemer reeds tot nag;",
          "Verand'ring en bederf",
          "is rondom my,",
          "o Heer, wat nooit verander,",
          "bly by my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U bystand het ek",
          "nodig, elke uur,",
          "en U beskerming",
          "in beproewingsvuur,",
          "want U alleen kan",
          "my versterk en lei;",
          "In storm en kalmte,",
          "Heer, o bly by my!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Met U vrees ek",
          "geen vyand in die stryd;",
          "Pyn baar geen angs",
          "en smart geen bitterheid;",
          "Dood en die graf",
          "hou vrees nog skrik vir my;",
          "Ek seëvier as U",
          "net by my bly!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Day is dying in the west",
    "hymnNumber": 41,
    "reference": "AL041",
    "title": "Stil Verdwyn ‘n Ander Dag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 29.9,
      "intro": 47.9
    },
    "verses": [
      {
        "content": [
          "Stil verdwyn 'n ander dag,",
          "saggies kom die donker nag;",
          "Wag en kyk eerbiedig nou",
          "hoe die sterreprag ontvou ",
          "en ons verlig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Lewensbron wat so getrou",
          "met U liefde ons omvou",
          "as U uit die hemel ",
          "hoor hoe U skepsels,",
          "oor en oor, om redding smeek!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In die nag se skaduwees",
          "sal U ons beskutting wees;",
          "Ons wil deur die sterre ",
          "dring om ons lof",
          "aan U te bring - tot voor U troon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Eenmaal sal die nag verdwyn",
          "en ons son vir ewig skyn;",
          "Vader, skenk ons in U ryk, ",
          "waar die dood",
          "se newels wyk, onsterflikheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Heilig, heilig, heilig! O Here God!",
      "U deurstraal die groot heelal,",
      "en U skepsels, sonder tal,",
      "loof U, o Heer!"
    ]
  },
  {
    "english": "Gezang 180",
    "hymnNumber": 42,
    "reference": "AL042",
    "title": "Ek Wil My Dank Betaal, O Vader",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 35.9
    },
    "verses": [
      {
        "content": [
          "Ek wil my dank betaal, o Vader,",
          "U loof en prys in hierdie lied;",
          "Die donker nag kom stadig nader",
          "maar U, my Lig, verlaat my nie.",
          "U maak my soos U gunstelinge,",
          "meer as 'n Vader, sorg U vry,",
          "o milde bron van seëninge -",
          "so 'n ontfermer is U my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek dank U vir U groot bewaring;",
          "U hand het my gevoed, gelei;",
          "U was die troos in my beswaring",
          "in elke moeilikheid naby;",
          "Die aand roep my, na al my sorge",
          "tot rus van liggaam, siel en gees;",
          "U Vaderhand was nooit verborge,",
          "U was heel dag my heil gewees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dank, Vader, dank vir die genade!",
          "U het my, sondaar, krag verleen;",
          "Slaan U my dwase sondes gade,",
          "waar skuil ek dan, waar vlug ek heen?",
          "Maar nee, ek wil nie, mag nie vrees nie,",
          "U spreek my vry deur Jesus bloed;",
          "Niks anders kan my hart genees nie,",
          "Hy bring ook rus vir my gemoed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek weet aan wie 'k my toevertrou het",
          "van vroeë dag tot donker nag;",
          "Ek ken die Rots waarop 'k gebou het",
          "Hy is die heil wat ek verwag.",
          "Eens aan die awend van my lewe -",
          "moeg van die sorg en worsteling -",
          "vir elke dag my hier gegewe,",
          "wil ek my dank as offer bring."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Saviour, breathe an evening blessing",
    "hymnNumber": 43,
    "reference": "AL043",
    "title": "Heiland, Strek U Hande Helend",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Heiland, strek U hande helend",
          "in die aanduur oor ons uit;",
          "Eerdat soete sluimer strelend",
          "ons vermoeide oë sluit."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waar U waak deur donker nagte,",
          "rus ons sag en kommervry;",
          "O, hoe soet is die gedagte",
          "dat geen nag ons van U skei!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Self wanneer verwoesting om ons",
          "wandel en die pyle val,",
          "vrees ons nie, want kyk, rondom ons",
          "staan die eng'lewagte pal."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As die dood vannag ons woning",
          "skielik, onverwags betree,",
          "wek ons weer, o Hemelkoning,",
          "met onsterflikheid beklee."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 44,
    "reference": "AL044",
    "title": "O Grote Christus, Eeu'ge Lig",
    "hasMidi": false,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "o Grote Christus, eeu'ge lig,",
          "niks is bedek voor U gesig",
          "wat oor ons straal net waar ons gaan",
          "al skyn geen son of bleke maan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Toon ons U liefde en U mag",
          "deur U beskerming, Heer, vannag;",
          "Bewaar ons van elk ramp of leed",
          "en staan as onse hulp gereed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verkwik ons met 'n soete rus",
          "om U te dien met nuwe lus,",
          "en laat ons matig slaap, o Heer,",
          "dat ons ook so U Naam kan eer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hou ons gereed, ook in die nag,",
          "dat ons selfs dan U koms verwag;",
          "Laat ons in stil vertroue leef",
          "dat U ons sondeskuld vergeef."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O Vader! Laat U liefde blyk,",
          "o Seun! Maak ons U beeld gelyk,",
          "o Gees! Stuur ons vertroosting neer,",
          "Drie-enig God, U sy die eer."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "O love of God, how strong and true",
    "hymnNumber": 45,
    "reference": "AL045",
    "title": "O Liefde, Ondeurgrondelik",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "o Liefde, ondeurgrondelik",
          "in alles wat die Heer beskik!",
          "Hoe hoog en diep en wonderbaar!",
          "Wie kan dit peil of ooit verklaar?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons sien dit in die bloue lug,",
          "in snelgewiekte voëlvlug;",
          "Dit staan geskryf op blom en boom,",
          "en word weerkaats in elke stroom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons sien dit bowe-al in Hom",
          "wat soos 'n lam, gedweë, stom,",
          "ons dood op Golgota moes sterf",
          "dat ons Sy lewe kan beërf."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Selfs merk ons U barmhartigheid",
          "in doodse slaap na lewenstryd;",
          "En heerlik is die blye dag",
          "as U ons opwek deur U mag!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ewige liefde, U behoed my",
          "as die storme om my woed;",
          "Van U beskerming steeds bewus,",
          "o liefde, vind ek sielerus."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "There's a wideness in God's mercy",
    "hymnNumber": 46,
    "reference": "AL046",
    "title": "Daar Is Dieptes In Gods Liefde",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Daar is dieptes in Gods liefde",
          "soos die dieptes van die see;",
          "Daar is volheid van verlossing",
          "in die gawe wat Hy gee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is blydskap in die hemel",
          "as 'n sondaar hom bekeer,",
          "daar is heling en vergifnis",
          "in die bloed van onse Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, Gods liefde is veel groter",
          "as wat ons ooit kan verstaan;",
          "In die hart van God almagtig",
          "sal die liefde nooit vergaan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As ons liefde meer opreg was,",
          "sou ons pal op Hom vertrou,",
          "en ons lewe sal soos sonskyn",
          "steeds sy helder glans behou."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Praise ye the Father for His loving-kindness",
    "hymnNumber": 47,
    "reference": "AL047",
    "title": "Loof God, Die Vader",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.6
    },
    "verses": [
      {
        "content": [
          "Loof God, die Vader,",
          "Hy is barmhartig;",
          "Tederlik sorg Hy",
          "vir Sy swakke kinders.",
          "Loof Hom, o engele,",
          "loof Hom in die heem'le,",
          "loof God Jehova."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Loof ons Verlosser,",
          "groot is Sy ontferming;",
          "Liefderyk sorg Hy",
          "vir Sy uitverkoor'nes.",
          "Jong manne, maagde,",
          "grysaards en ook kinders,",
          "loof ons Verlosser."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Loof God, die Trooster;",
          "Heil'ge Gees, ons Leidsman,",
          "kom van die Vader",
          "en die Seun tot Israel.",
          "Loof dan die Vader,",
          "Seun en Heil'ge Gees;",
          "Loof ons drie-enig God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Hear our prayer, O Lord",
    "hymnNumber": 48,
    "reference": "AL048",
    "title": "Hoor Ons Bede, Heer",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "timestamps": {
      "intro": 17,
      "introEnd": 24
    },
    "verses": [
      {
        "content": [
          "Hoor ons bede Heer,",
          "hoor ons bede Heer,",
          "o neig U oor tot ons",
          "en skenk ons U vree. ",
          "Amen"
        ],
        "verseNumber": 1
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 49,
    "reference": "AL049",
    "title": "O, Goedheid Gods",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "O, goedheid Gods, nog nooit volprese!",
          "Is Hy nog mens wat dit verag?",
          "Hoe diep ondankbaar is die wese",
          "wat nie met blydskap op Hom wag!",
          "Hom wil ek dank in doel en strewe;",
          "Dit is my plig, my lus, my lied.",
          "Hom wat my nooit nie sal begewe,",
          "sal ek my lof vir ewig bied."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wie gee my alles met die lewe?",
          "Die God wat my nie nodig het!",
          "Wie lei so wyslik al my strewe?",
          "Hy teen wie ek my soms verset!",
          "Wie skenk in my gemoed die vrede?",
          "Wie sterk my gees met nuwe krag?",
          "Wie antwoord so getrou my bede?",
          "Is dit nie God, so groot in mag?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En sou ek hierdie God nie eer nie?",
          "Sou ek Sy goedheid nie verstaan?",
          "Sou Hy my rig en ek nie leer nie?",
          "Die weg wat Hy berei, nie gaan?",
          "Sy wil bestier my hart en strewe;",
          "Sy Woord bly my gedurig by.",
          "Ek moet Hom liefhê bo my lewe,",
          "en ook my naaste min soos my."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dit is my dank, dit Sy behae:",
          "Ek moet volkome wees soos Hy.",
          "Hy is my strewe al my dae,",
          "daarom verrys Sy beeld in my;",
          "En vul Sy liefde heel my lewe,",
          "dan sal ek doen soos Hy begeer.",
          "Al moet ek vaak in swakheid bewe,",
          "tog heers die dood in my nie meer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Like as a father pities his child",
    "hymnNumber": 50,
    "reference": "AL050",
    "title": "Net Soos ‘n Vader",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Net soos 'n Vader,",
          "sy kind verstaan,",
          "So is die Heiland",
          "oor sondaars begaan.",
          "Hy wag geduldig,",
          "sal nooit beskuldig,",
          "al was ons sondaars,",
          "Hy neem ons tog aan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Net soos 'n Vader",
          "neem Hy ons aan",
          "vol medelye,",
          "as ons tot Hom gaan;",
          "En wyl ons fluister,",
          "weet ons Hy luister,",
          "wat al ons diepste",
          "begeertes verstaan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Net soos 'n Vader,",
          "immer getrou,",
          "skenk Hy ons sterkte",
          "wanneer ons verflou,",
          "dek ons verlede,",
          "hoor ons gebede,",
          "ken ons in wese",
          "en sien ons berou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Net soos 'n Vader",
          "sal Hy ons lei",
          "en deur Sy liefde",
          "van sonde bevry;",
          "Hy rig ons skrede,",
          "skenk ons Sy vrede,",
          "en sal ons Vader",
          "in ewigheid bly."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O worship the King, all glorious above",
    "hymnNumber": 51,
    "reference": "AL051",
    "title": "Verheerlik Die Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Verheerlik die Heer,",
          "die Koning alwys,",
          "Sy liefde en trou",
          "kan niemand volprys;",
          "Hoewel Hy in ewige heerlikheid woon,",
          "verkies Hy die hart",
          "van die mens as Sy troon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ontsettend Sy krag,",
          "verblindend Sy glans;",
          "Sy kleed is die lig,",
          "die ruimte Sy trans;",
          "Sy grimmigheid dreun",
          "in die swart donderwolk.",
          "Ja, vreeslik Sy toorn, soos die",
          "stormwind se kolk!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Met tedere sorg ",
          "het U ons omring;",
          "Dit skyn in die lug ",
          "wat lafenis bring",
          "dit vloei van die heuwels",
          "na vlakte en vlei,",
          "en blink in die reënt",
          "wat die velde verbly."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Verwek uit die stof,",
          "so nietig en broos,",
          "afhanklik van U ",
          "in alles, altoos -",
          "Hoe liefderyk sien U",
          "op sterflinge neer;",
          "Ons Maker, Beskermer,",
          "Verlosser en Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The God of Abraham praise",
    "hymnNumber": 52,
    "reference": "AL052",
    "title": "Die God Van Abraham",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Die God van Abraham",
          "sal ewiglik regeer;",
          "Geseënd is Sy heil'ge Naam,",
          "Hom Sy die eer!",
          "Jehova, groot “EK IS'",
          "wat aard en hemel prys!",
          "Neem aan ook my belydenis",
          "o God, alwys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O God van Abraham,",
          "my Rots en eeu'ge deel",
          "wat met die wonder van U Naam",
          "U volk verseël!",
          "Geen ydel singenot",
          "kan ooit my siel bekoor;",
          "Ek ken die vreugde van die God",
          "wat my verhoor."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die God moet almal vrees,",
          "wat ewiglik regeer;",
          "Heil Vader, Seun en Heil'ge Gees,",
          "U sy die eer!",
          "O God van Abraham",
          "beklee met majesteit,",
          "U skepsels prys U heil'ge Naam",
          "in ewigheid."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 53,
    "reference": "AL053",
    "title": "O God Van Lig",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "O God van lig,",
          "voor U gesig staan ",
          "almal skuldgebonde",
          "ons is bevlek, met skuld bedek,",
          "mismaak deur menig sonde."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heer, waar dan heen? ",
          "Tot U alleen;",
          "Nooit sal U ons begewe.",
          "U eie Seun, ons hulp en steun,",
          "ontsluit vir ons die lewe."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, amen, ja, op Golgota",
          "vloei lewe uit Sy wonde;",
          "En deur Sy bloed ",
          "word ons gemoed",
          "gereinig van die sonde."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sterk in ons Heer ",
          "steeds meer en meer",
          "vertroue sonder perke;",
          "Dan bring ons vry, gereed en bly,",
          "uit liefde goeie werke."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "My Maker and my King",
    "hymnNumber": 54,
    "reference": "AL054",
    "title": "My Skepper En My God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "My Skepper en my God,",
          "ek is U eiendom,",
          "ja, dit is steeds op U gebod",
          "dat seëninge kom.",
          "Ja, dit is steeds op U gebod",
          "dat seëninge kom."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Soms as U liefde dring,",
          "bevind ek my te stom",
          "om selfs 'n lied tot U te sing",
          "van Wie my lewe kom.",
          "Om selfs 'n lied tot U te sing",
          "van Wie my lewe kom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wat kan ek aan U bring?",
          "Van U kom alles, Heer.",
          "‘n hart wat van U goedheid sing",
          "is al wat U begeer.",
          "‘n hart wat van U goedheid sing",
          "is al wat U begeer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wil U my hart versterk;",
          "Vervul my met U Gees;",
          "Laat ek in elke woord en werk",
          "alleen U dienaar wees.",
          "Laat ek in elke woord en werk",
          "alleen U dienaar wees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 55,
    "reference": "AL055",
    "title": "Die Heer Is God, En Niemand Meer",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Die Heer is God, en niemand meer;",
          "Verheerlik Hom, o vrome!",
          "Wie is gelyk aan onse Heer?",
          "So heerlik - so volkome!",
          "Die Heer is groot, Sy Naam is groot,",
          "die luister van Sy deug is groot -",
          "oneindig groot Sy wese."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe sou ons skepsels ooit bestaan",
          "as God Sy werk gestaak het?",
          "Van Hom het lewe uitgegaan",
          "na ons wat Hy gemaak het.",
          "By Hom is wysheid en verstand;",
          "Die skeppingskrag is in Sy hand;",
          "Hy hou die heelal staande!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God is regverdig, Heilig, goed;",
          "Hy woon slegs by die vrome.",
          "Hul wat Sy wil met vreugde doen,",
          "eer Hy met vreugdekrone.",
          "Hy is onsterflik, Hy alleen,",
          "die sterfling kom en gaan weer heen -",
          "God is die bron van lewe!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sal daardie glans en majesteit",
          "my, sondaar, dan vernietig?",
          "Nee, daar is juis die heerlikheid",
          "van die geloof in Jesus!",
          "Nou styg my lied: die Heer is groot!",
          "Sy Naam is onuitspreeklik groot!",
          "Oneindig is Sy liefde."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "God, the Omnipotent! King, who ordainest",
    "hymnNumber": 56,
    "reference": "AL056",
    "title": "God, Die Almagtige",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "God, die Almagtige! ",
          "U wat as Koning",
          "oor sterke winde en donder regeer,",
          "sien in genade op ons uit U woning,",
          "skenk ons U rus, o genadige Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "God, die barmhartige!",
          "Deur die versaking van U gebod",
          "skend die mensdom U eer;",
          "Vreeslik U grimmigheid in sy ontwaking,",
          "wees ons barmhartig, genadige Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God, die regverdige!  Heiland, verhewe,",
          "onwankelbaar staan U woorde en leer;",
          "Leuenaars en boosdoeners",
          "sal voor U bewe",
          "ss reg geskied, o genadige Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "God, onse toeverlaat ",
          "in doodsgevare,",
          "wat onheil van al U kindere weer;",
          "Juigend weerklink oor die berge en bare:",
          "U kom toe sterkte en glorie, o Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Thy Glory Fills the Heavens",
    "hymnNumber": 57,
    "reference": "AL057",
    "title": "Heer, U Glans Verlig Die Hemel",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 26.9
    },
    "verses": [
      {
        "content": [
          "Heer, U glans verlig die hemel,",
          "op die aarde skyn dit neer;",
          "Al die eer word U gegewe,",
          "Heilig, heilig is U, Heer!",
          "In die hemel klink 'n loflied,",
          "aarde hoor die eng'leheer,",
          "Heilig, heilig, heilig, singend,",
          "Here God, U Sy die eer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Broeders, laat ons lofgesange",
          "saamsmelt tot Sy lof en eer.",
          "Hom is al die eer gegewe -",
          "Heilig, heilig is die Heer!",
          "Met Sy eng'leskare voor Hom,",
          "met Sy heil'ge kerk tesaam,",
          "sing ons voor die Heer aanbiddend;",
          "Heilig is Sy grote Naam."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer, U glans verlig die hemel,",
          "op die aarde skyn dit neer;",
          "Al die eer word U gegewe,",
          "Heilig, heilig is U, Heer!",
          "Ons bely U naam so heerlik -",
          "Sing dit met die eng'le saam -",
          "Heilig, heilig is U, Here,",
          "Heilig is U grote Naam."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O God, our help in ages past",
    "hymnNumber": 58,
    "reference": "AL058",
    "title": "O God, Ons Toevlugsoord En Krag",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "O God, ons toevlugsoord en krag",
          "deur al die eeue heen;",
          "Tot in die verste nageslag",
          "hoop ons op U alleen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Onder die skadu van U troon,",
          "waar onheil nimmer deer,",
          "kan al U kinders veilig woon",
          "o allerhoogste Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Voor berge in die vroegste tyd",
          "uit dieptes kon verrys;",
          "Van ewigheid tot ewigheid",
          "is U, o God, alwys!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Want duisend jaar is in U oog",
          "slegs soos 'n skemer uur -",
          "In die oneindigheid omhoog,",
          "‘n nagwaak, kort van duur."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O God, ons toevlugsoord en krag",
          "deur al die eeue heen;",
          "Wees U ons Leidsman elke dag,",
          "ons woning, U alleen."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "We may not climb the heavenly steeps",
    "hymnNumber": 59,
    "reference": "AL059",
    "title": "Ons Kan Nie Opklim Tot Sy Troon",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Ons kan nie opklim tot Sy troon",
          "om Jesus te bereik;",
          "Ons sou vergeefs na dieptes daal",
          "en in die afgrond kyk."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nog steeds is Hy ons hulp in nood,",
          "so liefdevol en teer;",
          "Olyfberg huisves nog geloof",
          "en liefde van die Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar is nog heling in Sy kleed",
          "vir wrede pyn en vrees;",
          "In die gedrang raak ons Hom aan -",
          "ons krankheid word genees."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O God, ons Meester en ons Heer,",
          "wat ook ons voetstap rig,",
          "ons weet dat U oor alles heers -",
          "ons leer van U ons plig."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 60,
    "reference": "AL060",
    "title": "Op Berge En In Dale",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Op berge en in dale",
          "en oweral is God;",
          "Waar ek herhaalde male",
          "mag dwaal of sit, is God.",
          "Waar my gedagtes swewe",
          "of styg, ook daar is God.",
          "Omlaag en hoog verhewe,",
          "ja, oweral is God!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sy troue Vaderoë",
          "sien alles van naby;",
          "Wie steun op Sy vermoë,",
          "bewaar en seën Hy.",
          "Hy hoor die jonge rawe,",
          "beklee met gras die dal;",
          "Die wurm vind ook 'n gawe -",
          "God sorg vir die heelal."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Juig Christen! Want die Vader",
          "is by in elke lot.",
          "Al kom die einde nader,",
          "in lyding, daar is God.",
          "Waar troue vriendehande",
          "gemis word, daar is God.",
          "In angs en doodse bande,",
          "ja, oweral is God!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "A mighty fortress is our God",
    "hymnNumber": 61,
    "reference": "AL061",
    "title": "‘n Vaste Burg Is Onse God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 33.5
    },
    "verses": [
      {
        "content": [
          "‘n Vaste burg is onse God,",
          "‘n vesting, immer veilig;",
          "Teen helse liste, hoon en spot,",
          "‘n skuilplek, kalm en heilig!",
          "Hy sal ons trou bewaar",
          "in droefheid en gevaar,",
          "en in ons felle stryd",
          "teen al die sluwe nyd",
          "van ons gedugte vyand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As ons in eie krag moes stry,",
          "dan was ons saak verlore -",
          "was nie die Heil'ge aan ons sy,",
          "die man van God verkore;",
          "Hy is die Seun van God,",
          "Jehova Sebaot!",
          "Ja, Christus, onse Heer",
          "wat heerlik triomfeer",
          "oor alle bose magte!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al dreig die wêreld en die hel",
          "ons siele met verskrikking,",
          "deur ons oorwin die waarheid wel,",
          "want dit is Gods beskikking!",
          "Ons veg dus onbevrees",
          "met onverskrokke gees;",
          "Die Vors van duisternis",
          "se lot is reeds beslis:",
          "Gods Woord sal Hom vernietig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die Woord, wat staan in ewigheid,",
          "beloof aan ons die lewe;",
          "Gods Gees is met ons in die stryd,",
          "sal ons vir duiwels bewe?",
          "Al verg dit aardse goed,",
          "die liggaam, as dit moet;",
          "Ja, selfs ons lewe, Heer,",
          "lê ons gewillig neer",
          "ter wille van U waarheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O God of Bethel, by whose hand",
    "hymnNumber": 62,
    "reference": "AL062",
    "title": "O God Van Bet-El",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "O God van Bet-el, dis U hand",
          "wat nog U kinders voed,",
          "U wat ons pelgrimsvadere",
          "gelei het en behoed."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Voor U genadetroon sal ons",
          "eerbiedig op U wag;",
          "God van ons vaders, wees die God",
          "ook van hul nageslag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe moeilik onse weg ook skyn,",
          "U sal ons voed en klee",
          "en met ons daelikse brood",
          "ons al die goeie gee."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O dek ons met U vleuels, Heer,",
          "solank ons hier moet swerf,",
          "totdat ons in die Vaderhuis",
          "ons woninge beërf."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "God moves in a mysterious way",
    "hymnNumber": 63,
    "reference": "AL063",
    "title": "Geheimnisvol Beweeg Die Heer",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Geheimnisvol beweeg die Heer",
          "om wonders te verrig;",
          "Ons sien Sy wandel in die see,",
          "in storms Sy aangesig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hou moed, o vreesbevange siel,",
          "die swartste onweerswolk",
          "sal - van genade swanger - breek",
          "in seën oor Gods volk."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vertrou op God wanneer dit skyn",
          "asof Hy ons vergeet;",
          "Tot onse beswil tugtig Hy",
          "wat alle dinge weet."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sy doel met ons sal spoedig ryp",
          "en ope vou voor Hom.",
          "Die bloeiselknop mag bitter smaak,",
          "maar soet is eens die blom."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Nou moet ons wandel deur geloof",
          "en kinderlik vertrou;",
          "Die 'waarom' sal ons eens verstaan",
          "as ons die Heer aanskou."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 64,
    "reference": "AL064",
    "title": "Rus, My Siel, Jou God Is Koning",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Rus, my siel, jou God is koning -",
          "Heerser oor die wêreld wyd.",
          "Op Sy wenke kom en gaan dit,",
          "maar Hy bly in ewigheid."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hier streef elkeen na verand'ring",
          "en betreur dit keer op keer,",
          "hunker steeds na nuwe dinge,",
          "wens Hy het die oue weer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Rus, my siel, jou God is koning,",
          "wees tevrede met jou lot.",
          "Kyk hoe alles hier verander",
          "en verlang alleen na God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "For the beauty of the earth",
    "hymnNumber": 65,
    "reference": "AL065",
    "title": "Vir Die Sonskyn En Die Reën",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Vir die sonskyn en die reën,",
          "vlei en veld en blommeprag,",
          "vir die liefde wat my seën",
          "sedert my geboortedag,",
          "milde Gewer, goed en wys,",
          "sal ek U steeds dank en prys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Vir my kommerlose jeug,",
          "ouerliefde, broedermin,",
          "rein genot en ware vreug,",
          "vriendekring en huisgesin,",
          "milde Gewer, goed en wys,",
          "sal ek U steeds dank en prys."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vir die gawe van U Seun,",
          "vir die hoop op saligheid,",
          "vir die Heil'ge Gees en steun,",
          "vir die kroon na hierdie stryd,",
          "milde Gewer, goed en wys,",
          "sal ek U steeds dank en prys."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "This is my Father's world",
    "hymnNumber": 66,
    "reference": "AL066",
    "title": "Dit Is Die Werk Van God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Dit is die werk van God -",
          "die aarde waar ons woon -",
          "en orals sing Sy handewerk",
          "‘n loflied wonderskoon.",
          "Dit is die werk van God,",
          "en ek verlustig my",
          "in gras en dou en seë blou;",
          "Sy hand het dit berei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is die werk van God;",
          "Die voëltjies sing Sy lof;",
          "Die goue dag, die blommeprag",
          "versier Sy aardse hof.",
          "Dit is die werk van God;",
          "Die skepping spreek van Hom;",
          "Elk vergesig weerkaats Sy lig -",
          "Sy skoonheid straal alom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dit is die werk van God;",
          "O laat my steeds onthou -",
          "al kom die kwaad in skrikgewaad,",
          "my Heerser bly getrou.",
          "Dit is die werk van God;",
          "Daarvan kan ek getuig.",
          "Die Heer regeer en niemand meer,",
          "laat heel die aarde juig!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I sing the mighty power of God",
    "hymnNumber": 67,
    "reference": "AL067",
    "title": "Ek Loof U Grote Mag, O God",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Ek loof U grote mag, o God",
          "wat setel in U Woord,",
          "U spreek, en daar kom berg en see",
          "en bloue heem'le voort!",
          "Ek loof die wysheid wat bedags",
          "die son oor ons laat skyn,",
          "en ons die maan en sterre gee",
          "wanneer die son verdwyn."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek loof U milde sorg, o Heer,",
          "wat al U skepsels voed,",
          "ja, alles wat U hand formeer",
          "is wonderbaarlik goed!",
          "So ver die menseoog kan reik",
          "sien ons U handewerk -",
          "die aarde in haar vrugbaarheid,",
          "die peilloos bloue swerk!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "‘n Glorieblyk is elke plant",
          "en blommekelk wat vorm,",
          "ons hoor U stem in donderwolk",
          "en in die woeste storm!",
          "Skepsels aan wie U lewe skenk,",
          "sal steeds U sorg ervaar;",
          "Ja, waar ek my ook mag bevind,",
          "God is teenwoordig daar!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "The spacious firmament on high",
    "hymnNumber": 68,
    "reference": "AL068",
    "title": "Die Bloute Wat Ons Hier Omring",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 47.5
    },
    "verses": [
      {
        "content": [
          "Die bloute wat ons hier omring",
          "soos 'n onmeetlik wye kring",
          "versier met fonkelligte skoon,",
          "bring aan die Skepper eerbetoon.",
          "Ja, onvermoeid van dag tot dag",
          "vermeld die son die Heer se krag,",
          "verkondig luid aan elke land:",
          "Almagtig is die Heer se hand!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wanneer die avondskadu's daal",
          "hervat die maan die groot verhaal;",
          "Deel aan die aarde kennis mee",
          "van skeppingsdade lank gelee.",
          "Die sterre in hul skitterprag",
          "bevestig dit van nag tot nag;",
          "Wyl elkeen op sy gang alleen",
          "sy weg baan deur die ruimtes heen."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoewel daar spraak nog woorde is",
          "verneem die Heer hul stem gewis;",
          "Onhoorbaar vir die menseoor,",
          "maar vir hul God 'n jubelkoor",
          "wat singend skyn en skynend sing,",
          "en aan hul Skepper hulde bring;",
          "'volmaak en God'lik is die wet",
          "van Hom wat ons geskape het'."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Hark! the herald angels sing",
    "hymnNumber": 69,
    "reference": "AL069",
    "title": "Luister Hoe Die Eng'le Sing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 38.3,
      "intro": 38.3
    },
    "verses": [
      {
        "content": [
          "Luister hoe die eng'le sing",
          "en aan Jesus hulde bring!",
          "Vrede daal op aarde neer",
          "en versoen ons met die Heer.",
          "Juig, o volk're, loof Sy naam,",
          "sing met al die eng'le saam,",
          "juig Hom toe met hart en stem,",
          "eer die Kind van Betlehem."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Christus, hoog in hemeleer,",
          "Christus, ewig God en Heer,",
          "voor wie hemelwesens val,",
          "word gebore in 'n stal!",
          "Welbehae in die mens,",
          "dis die Vadere se wens;",
          "Hoor die lied wat opwaarts wel:",
          "Jesus is Emmanuel!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vredevors vol majesteit,",
          "Son van Gods geregtigheid,",
          "laat U vleuels ons genees,",
          "leer ons om U naam te vrees.",
          "Hy wat Hom verneder het",
          "om ons van die dood te red,",
          "sal Gods liefde ons verklaar",
          "en ons siele wederbaar."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Luister hoe die eng'le sing",
      "en aan Jesus hulde bring!"
    ]
  },
  {
    "english": "As with gladness men of old",
    "hymnNumber": 70,
    "reference": "AL070",
    "title": "Soos Vanouds Die Wyse",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Soos vanouds die wyse,",
          "ver uit die ooste deur U ster",
          "oor rivier en berg en dal",
          "voortgelei is na die stal,",
          "lei ook ons, getroue Heer,",
          "om die Kindjie te vereer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Soos die wyse na die krip",
          "voortgehaas het om te bid,",
          "wil ons voor U hemeltroon",
          "ook ons hulde kom betoon;",
          "Mag so onse voete gaan",
          "tot ons by die kruishout staan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kon ons soos die wyse, Heer,",
          "U met aardse stof vereer,",
          "sou ons duur geskenke bring",
          "en die krip daarmee omring.",
          "Neem ons al - ons harte - aan,",
          "waar ons need'rig voor U staan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wil U ons, o Jesus,",
          "hou op U weë eng en nou;",
          "En, na hierdie aardsbestaan",
          "mag ons eendag tot U gaan,",
          "waar geen ster ons meer sal lei",
          "en geen wolk U van ons skei."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "There's a song in the air!",
    "hymnNumber": 71,
    "reference": "AL071",
    "title": "Kyk, ‘n Ster Het Verskyn",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Kyk, 'n ster het verskyn,",
          "en 'n engeleskaar,",
          "want 'n maagd - jonk en rein -",
          "het 'n Kindjie gebaar!",
          "En die ster daal in glorie",
          "oor Betlehem neer,",
          "want die Kind in die krip",
          "is ons Koning en Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jub'lend klink die gesang",
          "uit die hemelse oord;",
          "Want die Kindjie - ontvang van",
          "Gods Gees - is die Woord!",
          "En die ster skyn in glorie",
          "op Betlehem neer,",
          "want die Kind in die krip",
          "is ons Koning en Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In die lig van die ster",
          "lê die eeue omsluit;",
          "En die lied - sag en ver -",
          "styg dan, magtig en luid!",
          "Daal, o Lig van die wêreld,",
          "in Betlehem neer,",
          "Heil'ge Kind in die krip,",
          "onse Koning en Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Mag die ster ons ook lei,",
          "en na Betlehem bring!",
          "Mag die vrede gedy",
          "waarvan engele sing!",
          "Diep ontroerd kniel ook ons",
          "voor die Wonderkind neer,",
          "en aanbid Hom as Vors,",
          "onse Koning en Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Angels from the realms of glory",
    "hymnNumber": 72,
    "reference": "AL072",
    "title": "Eenmaal Het Die Hemelkore",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Eenmaal het die hemelkore",
          "oor die skeppingsdaad gejuig.",
          "Die Messias is gebore!",
          "Hulde het hul Hom betuig.",
          "Kom, aanbid Hom!",
          "Kom, aanbid Hom!",
          "Jesus Christus, onse Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Herders het die blye tyding",
          "van die Christus-kind ontvang:",
          "Juig, wees bly oor die bevryding,",
          "hef tot God 'n lofgesang!",
          "Kom, aanbid Hom!",
          "Kom, aanbid Hom!",
          "Jesus Christus, onse Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wyse manne soek Sy woning,",
          "volg Sy wonderteken ver,",
          "en hul vind die Hemelkoning",
          "onder Sy geboortester!",
          "Kom, aanbid Hom!",
          "Kom, aanbid Hom!",
          "Jesus Christus, onse Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Heiliges uit alle volke,",
          "wat die Heer lank verwag,",
          "kyk, Hy kom, Hy kom met wolke",
          "in Sy heerlikheid en krag!",
          "Kom, aanbid Hom!",
          "Kom, aanbid Hom!",
          "Jesus Christus, onse Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The first noel the angel did say",
    "hymnNumber": 73,
    "reference": "AL073",
    "title": "In Velde Digby Betlehem",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 30.2,
      "intro": 30.2
    },
    "verses": [
      {
        "content": [
          "In velde digby Betlehem",
          "is die wakende herders tot vreugde gestem",
          "met die tyding deur die eng'le tot mense gebring,",
          "in die lied in die nagt'like stilte gesing."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "En aan die trans het 'n blinkende ster",
          "verskyn in die ooste, al winkend van ver;",
          "En Sy lig was die lig van 'n Gids wat sou lei,",
          "as dit sag oor verlate woestynpaaie sprei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En deur die lig van hierdie ster",
          "het die wyse gekom uit die ooste ver,",
          "om te soek na die lang verwagte Kind",
          "wat hulle in Betlehem sou vind."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Na die weste het hierdie ster gegaan",
          "en stil oor die need'rige stal bly staan -",
          "waar 'n krip as die Koning se bedjie moes dien -",
          "en daar het die wyse die Kindjie gesien."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Eerbiedig het hul die stal betree",
          "om aan die Koning geskenke te gee,",
          "en in aanbidding onse Heer",
          "met wierook en mirre en goud te vereer."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Die hemel juig, die eng'le sing -",
      "tyding van blydskap kom hulle bring."
    ]
  },
  {
    "english": "O come, all ye faithful, joyful and triumphant",
    "hymnNumber": 74,
    "reference": "AL074",
    "title": "Kom Herwaarts Getroues",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Kom herwaarts, getroues, jub'lend, seëvierend;",
          "O haas U, o haas U na Betlehem!",
          "Kom en aanskou die Koning van die eng'le!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sing, hemelkore, juigend, triomferend;",
          "Verkondig die koms van die vredevors!",
          "Ere aan God, die mens 'n welbehae!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis die Messias, vleesgeworde Godheid;",
          "Dierbare Kindjie van Betlehem!",
          "Woord van die Vader, Seun ook van die mensheid!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "o kom na Hom aanbiddend;",
      "o kom na Hom aanbiddend;",
      "o kom na Hom aanbiddend;",
      "Christus, die Heer!"
    ]
  },
  {
    "english": "O little town of Bethlehem",
    "hymnNumber": 75,
    "reference": "AL075",
    "title": "O Kleine Dorpie Betlehem",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "O kleine dorpie Betlehem",
          "van alles onbewus -",
          "wyl sterre op hul weë gaan,",
          "in diepe slaap gesus!",
          "Tog lê daar in jou midde",
          "die Vadere se wens;",
          "Ons hoop deur al die eeue heen,",
          "die Seun van God en mens!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Christus is gebore,",
          "uit Dawid se geslag!",
          "Miljoene reine wesens",
          "hou eerbiedig oor Hom wag;",
          "Gods engele aanbid Hom,",
          "die vleesgeworde Woord;",
          "En môresterre juig tesaam -",
          "maar Betlehem slaap voort."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe stil en ongemerk het God",
          "die wonder laat geskied!",
          "Hoe stil die gawe van Sy Seun",
          "die mensheid aangebied!",
          "So daal Sy seëninge",
          "nog stil en ongemerk;",
          "In siele aan Hom oorgegee,",
          "kan Hy nog wond're werk."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O Heil'ge Kind van Betlehem,",
          "daal uit die hemel neer;",
          "Word in ons harte nou opnuut",
          "gebore, dierb're Heer!",
          "O wonderbare dinge,",
          "deur eng'le eens vertel,",
          "dat God Sy woning in ons maak",
          "deur U, Emmanuel!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "It came upon the midnight clear",
    "hymnNumber": 76,
    "reference": "AL076",
    "title": "‘n Wonderskone Lied",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.2
    },
    "verses": [
      {
        "content": [
          "‘n Wonderskone lied",
          "het in die stilte van die nag",
          "gesweef oor Betlehem vanouds,",
          "melodieus en sag:",
          "''n Welbehae in die mens",
          "het Hy wat vrede bring;",
          "Aan Hom kom toe die eer en krag,'",
          "het engele gesing."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nog klink die hemelse musiek",
          "van daardie eng'lerei,",
          "oor hierdie aarde so vol smart",
          "en wrede dwinglandy.",
          "Nog kom die boodskappers van God",
          "aan mense vrede bring;",
          "Vêr bo die wêreldse rumoer,",
          "hoor ons nog eng'le sing."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skep moed, terneergedrukte siel,",
          "vermoeid en afgemat,",
          "wat onder sware laste buk",
          "hier op jou lewenspad!",
          "Die boodskap van die hemelkoor",
          "sal vrede aan jou bring;",
          "Werp al jou laste op die Heer,",
          "en luister, eng'le sing!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Silent night, holy night",
    "hymnNumber": 77,
    "reference": "AL077",
    "title": "Stille Nag, Heilige Nag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Stille nag, heilige nag,",
          "lig-omstraal, glansend sag,",
          "lê die Kindjie in doeke gevou",
          "by Maria, bevoorregte vrou,",
          "soete, hemelse rus!",
          "Soete, hemelse rus!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Stille nag, heilige nag,",
          "in die velde op wag",
          "het die herders die tyding gehoor",
          "en die lied van die engelekoor;",
          "Hy is Christus, die Heer!",
          "Hy is Christus, die Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Stille nag, heilige nag,",
          "Seun van God, lank verwag -",
          "van U heilige aangesig",
          "straal daar hemelse liefde en lig!",
          "Ons Verlosser en Heer!",
          "Ons Verlosser en Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Stille nag, heilige nag,",
          "Wonderster, lei ons sag",
          "totdat ons ook die heilige Kind,",
          "soos die herders van Betlehem, vind",
          "en aanbid as ons Heer,",
          "En aanbid as ons Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "While shepherds watched their flocks by night",
    "hymnNumber": 78,
    "reference": "AL078",
    "title": "Toe Herders Een Nag In Die Veld",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 10
    },
    "verses": [
      {
        "content": [
          "Toe herders een nag in die veld",
          "hul kuddes moes bewaak,",
          "het daar 'n engel neergedaal -",
          "die landskap lig gemaak."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die engel het die wonderwerk",
          "aan herders daar vertolk:",
          "'kyk, tyding van groot blydskap bring",
          "ek aan die hele volk."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "“Vrees nie, maar gaan na Betlehem,",
          "en daar sal julle vind",
          "die Saad uit Dawid se geslag;",
          "Die heil'ge Christus-kind."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "“En dis die teken: in 'n krip",
          "vind jul die Seun van God;",
          "In skaam'le doeke toegedraai",
          "deel Hy die mens se lot.'"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "En skielik was 'n menigte",
          "van eng'le met hom saam!",
          "Toe juig die grote hemelkoor,",
          "en prys die Heer se Naam."
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "“Aan God kom toe die heerlikheid,",
          "wat alles, alles gee!",
          "‘n Welbehae in die mens",
          "en vrede hier benee!'"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "Dear Lord and Father of mankind",
    "hymnNumber": 79,
    "reference": "AL079",
    "title": "Bevry, O God, Ons Bang Gemoed",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.5
    },
    "verses": [
      {
        "content": [
          "Bevry, o God, ons bang bemoed,",
          "van alles wat beklem;",
          "Neem weg die onrus wat daar woed;",
          "Wil ons, gereinig deur U bloed,",
          "tot diep aanbidding stem."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ook ons wil goed en bloed verlaat,",
          "en volg waar U ons lei;",
          "Soos hulle wat vanouds in staat was",
          "tot die kinderlike daad,",
          "en alles U kon wy."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Sabbature, God-gewyd,",
          "met Jesus langs die meer!",
          "O Goddelike Majesteit!",
          "Die kalmte van die ewigheid",
          "straal uit U wese, Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Verfris ons met die sagte dou",
          "van vrede, diep en stil;",
          "Ons eie strewe moet verflou,",
          "sodat daar in ons kan ontvou",
          "‘n lewe na U wil."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Laat deur die drifte van die vlees",
          "U koele balsem vloei;",
          "Totdat die kalmte van U gees",
          "ons hete sinlikheid genees,",
          "en reinheid in ons bloei."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Tell me the old, old story",
    "hymnNumber": 80,
    "reference": "AL080",
    "title": "Bring My Die Ou, Ou Tyding",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 31.9,
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Bring my die ou, ou tyding",
          "van dinge nooit gesien,",
          "van Jesus en Sy liefde",
          "en eng'le wat Hom dien.",
          "Maak die verhaal eenvoudig",
          "soos vir 'n kindjie klein,",
          "want ek is swak en sondig -",
          "ja, hulpeloos, onrein."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Fluister die tyding saggies,",
          "dit sterk my bang gemoed,",
          "want ek is daardie sondaar",
          "vir wie die Heer moes boet.",
          "Bring my die tyding dikwels,",
          "as U vir my wil wees",
          "tot troos en ryke seën,",
          "in moeilikheid en vrees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Bring my die ou, ou tyding",
          "so dikwels U verneem",
          "dat ydel aardse vreugde",
          "my van my God vervreem;",
          "En as die doodsuur nader",
          "en ek my werk moet staak,",
          "vertel my hoe verlostes",
          "in Jesus sal ontwaak."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Bring my die ou, ou tyding",
      "bring my die ou, ou tyding",
      "bring my die ou, ou tyding",
      "van lewe deur Sy bloed."
    ]
  },
  {
    "english": "",
    "hymnNumber": 81,
    "reference": "AL081",
    "title": "Middelpunt Van Ons Verlange",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Middelpunt van ons verlange,",
          "Trooster van ons bang gemoed,",
          "Jesus onse lofgesange",
          "loof U liefde, ruim en goed.",
          "Uit U heerlik hemelhowe",
          "het U tot ons neergedaal",
          "om die offer eens belowe",
          "vir ons sondes te betaal."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Liefde! o Die medelyde",
          "wat U vir die sterfling het!",
          "Vir die sondaars was U lyde",
          "om hul van die vloek te red.",
          "Vir ons was U bloed en lyding",
          "in die bang Getsemane,",
          "maar Hy bring die blye tyding",
          "van verlossing, rus en vree."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Liefde! Spot was in U ore -",
          "spot wat dring deur murg en been.",
          "U is vir die kruis gebore -",
          "vir die wêreld - U alleen!",
          "Bitter was U lydensbeker",
          "aan die kruis van Golgota,",
          "maar ons redding was verseker",
          "meer as wat ons ooit kon vra."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Liefde! U is heel ons lewe;",
          "U is al ons hoogste goed.",
          "Deur die kruis is ons vergewe",
          "ons juig oor U offerbloed.",
          "O hoe lief het ons U, Meester,",
          "Jesus, Redder, God en mens,",
          "U gena het ons begeester,",
          "U vervul ons laaste wens."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Tell me the story of Jesus",
    "hymnNumber": 82,
    "reference": "AL082",
    "title": "Kom En Vertel My Van Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 40.3,
      "intro": 50.4
    },
    "verses": [
      {
        "content": [
          "Kom, en vertel my van Jesus,",
          "skryf op my hart elke woord;",
          "Bring weer die dierbare tyding,",
          "liefste op aarde gehoor.",
          "Meld hoe die hemelse kore",
          "by Sy geboorte kon sing;",
          "'ere aan God in die hoogste,",
          "Vrede op aard' kom Hy bring.'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Praat van Sy bitter versoekings,",
          "hoe Hy die Satan weerstaan;",
          "Hoe Hy alleen daar gevas het,",
          "moedig die vyand verslaan.",
          "Praat van Sy jare van arbeid,",
          "die Man van smarte was Hy;",
          "Hy was verag en verlate,",
          "eensaam het Hy hier gely."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skilder Sy dood aan die kruishout,",
          "daar hang die godslam geslag;",
          "Stil daal Hy neer na die dode,",
          "maar Hy verrys weer in krag.",
          "Hierdie verhaal spreek van liefde -",
          "liefde vir jou en vir my -",
          "laat my dan ween wyl jy fluister:",
          "'liefde het ons daar bevry'."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Kom, en vertel my van Jesus,",
      "skryf op my hart elke woord;",
      "Bring weer die dierbare tyding,",
      "liefste op aarde gehoor."
    ]
  },
  {
    "english": "There is a green hill far away",
    "hymnNumber": 83,
    "reference": "AL083",
    "title": "Dis Op ‘n Heuwel, Rustig-Groen",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.5
    },
    "verses": [
      {
        "content": [
          "Dis op 'n heuwel, rustig-groen,",
          "daar buite Sionsmuur,",
          "waar onse Heer vir ons behoud",
          "die kruisdood moes verduur."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Geen mens besef wat Hy moes ly,",
          "alleen op Golgota;",
          "Ons weet slegs: Hy het al ons smart",
          "en krankhede gedra."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Om sondaars van die dood te red",
          "het onse Heer gesterf;",
          "Ja, deur Sy bloed het Hy ons eens",
          "verlos van die verderf."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Geen ander in die groot heelal",
          "kon vir ons sonde boet;",
          "Die toegang tot Gods koninkryk",
          "is enkel deur Sy bloed."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Hoe innig lief het Jesus ons!",
          "Laat ons Hom ook bemin,",
          "en, deur die werking van Sy bloed,",
          "ons swakhede oorwin."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "On a hill far away stood an old rugged cross",
    "hymnNumber": 84,
    "reference": "AL084",
    "title": "Op ‘n Heuwel Daar Ver",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 31.9,
      "intro": 47.9
    },
    "verses": [
      {
        "content": [
          "Op 'n heuwel daar ver",
          "het 'n kruis eens gestaan,",
          "as teken van lyding en smaad;",
          "Ek bemin daardie kruis",
          "waar Gods enigste Seun",
          "Sy lewe vir sondaars moes laat."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Aan die ruwe ou kruis,",
          "deur die wêreld versmaad,",
          "het Jesus my lewe verwerf;",
          "God se dierbare Seun",
          "het die hemel verlaat",
          "om daar vir my sonde te sterf."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Uit die ruwe ou kruis,",
          "met die rein bloed bevlek,",
          "straal 'n lieflike skoonheid om my;",
          "Want dis aan daardie kruis",
          "dat die Here vir my",
          "soveel skande en smarte moes ly."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Aan die ruwe ou kruis",
          "bly ek altyd getrou;",
          "Ek sal dankbaar Sy skande hier dra;",
          "Want die spotstem verstil,",
          "en die kruis lê ek neer,",
          "vir die kroon van die lewe hierna."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ek bemin daardie ruwe ou kruis,",
      "tot ek eendag sal staan voor Gods troon;",
      "Ja, ek klem aan die dierb're ou kruis",
      "en verwissel dit eens vir 'n kroon."
    ]
  },
  {
    "english": "'Tis midnight; and on Olive's brow",
    "hymnNumber": 85,
    "reference": "AL085",
    "title": "Dis Nag, En Bo Olyfbergkruin",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Dis nag; en bo Olyfbergkruin",
          "verflou die sterre een vir een;",
          "Dis nag; en in die donker tuin",
          "stry Jesus in gebed alleen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dis nag; verlate en alleen",
          "moet Hy die foltering verduur;",
          "Geen vriend vertroos Hom waar Hy ween",
          "of waak met Hom 'n enkel uur."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis nag; die Man van smarte kniel",
          "om vir ons bose skuld te boet;",
          "Net God alleen verlaat Hom nie,",
          "al sweet Hy in die spanning bloed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dis nag; die worst'ling is verby,",
          "bleek en verwronge syg Hy neer;",
          "Dis nag; die stryd is nou volstry;",
          "En engele versterk die Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 86,
    "reference": "AL086",
    "title": "My Verlosser Aan Die Kruis",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "My Verlosser aan die kruis!",
          "Hy verduur die spot van sondaars:",
          "Seun van Dawid,",
          "waar is dan U almag tans -",
          "waar U Goddelike glans?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My Verlosser aan die kruis!",
          "Ter vergewing van my sonde",
          "dra Hy wonde.",
          "Van die vloek maak Hy my vry",
          "en Sy sterwe reinig my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My Verlosser aan die kruis!",
          "Mag 'k U liefde nooit versmaai nie,",
          "nooit verraai nie!",
          "En as mense my ooit spot,",
          "dra ek bly my kruis en lot."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Go to dark Gethsemane",
    "hymnNumber": 87,
    "reference": "AL087",
    "title": "Gaan Na Bang Getsemane",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Gaan na bang Getsemane",
          "as versoekings om jou woed;",
          "Maak met Hom die worst'ling mee;",
          "Waar die Heer moes stry tot bloed:",
          "moet die beker nie vermy:",
          "leer, soos Hy, die stryd volstry."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Volg Hom voor die Joodse Raad,",
          "vals beskuldig en bespot;",
          "Kyk hoe wreed word Hy gesmaad,",
          "liefde dra die mens se lot!",
          "Word ook jy verag, verguis?",
          "Dra, soos Jesus, stil jou kruis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kom, bestyg ook Golgota,",
          "kniel daar by Sy voete neer",
          "waar Hy wrede smart moes dra.",
          "O, die wonder van die Heer!",
          "Hoor, Hy roep: “Dit is verby!'",
          "Leer ons om te sterf soos Hy."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "There Was One Who Was Willing",
    "hymnNumber": 88,
    "reference": "AL088",
    "title": "Daar Was Een Wat Gewillig Gesterf Het",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Daar was Een wat gewillig",
          "gesterf het vir my,",
          "dat 'n siel so onwaardig mag leef;",
          "Aan die kruishout",
          "het Jesus vrywillig gely",
          "sodat Hy al my skuld kan vergeef."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O Sy liefde is teer",
          "en geduldig met my;",
          "Hy't my skuld aan die kruishout genael",
          "daar is nou geen verdoem'nis,",
          "ek weet ek is vry,",
          "want my losprys het Jesus betaal."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek sal klem aan my Heiland,",
          "in Hom sal ek bly;",
          "Ek sal reis op die weg wat Hy baan,",
          "met 'n lied op my lippe",
          "aan Jesus gewy,",
          "want deur Hom is my skuld nou voldaan"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Saam met Hom aan die kruis,",
      "saam met Hom aan die kruis,",
      "het die Heiland my sonde gedra;",
      "Ja, vrywillig het Hy",
      "aan die kruishout gely",
      "en my skuld in Sy liggaam gedra."
    ]
  },
  {
    "english": "When I survey the wondrous cross",
    "hymnNumber": 89,
    "reference": "AL089",
    "title": "As'k By Die Kruishout Peinsend Staan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.4
    },
    "verses": [
      {
        "content": [
          "As'k by die kruishout peinsend staan",
          "waaraan my Heiland eens moes sterf,",
          "verfoei ek alle eiewaan",
          "en hebsug wat my siel verderf."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Aanskou Sy hoof, Sy hand en voet:",
          "is reinheid ooit so swak beloon?",
          "Het smart die liefde ooit ontmoet",
          "in so 'n wrede doringkroon?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verhoed o God, dat ek ooit roem",
          "behalwe in my Heer se kruis;",
          "Vir my - verlore en gedoem -",
          "is Hy verbrysel en verguis!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Al was die skepping in my hand,",
          "as offer sou dit nietig wees;",
          "U liefde ver bo my verstand",
          "verg heel my liggaam, siel en gees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "When I survey the wondrous cross",
    "hymnNumber": 90,
    "reference": "AL090",
    "title": "As'k By Die Kruishout Peinsend Staan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.4
    },
    "verses": [
      {
        "content": [
          "As'k by die kruishout peinsend staan",
          "waaraan my Heiland eens moes sterf,",
          "verfoei ek alle eiewaan",
          "en hebsug wat my siel verderf."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Aanskou Sy hoof, Sy hand en voet:",
          "is reinheid ooit so swak beloon?",
          "Het smart die liefde ooit ontmoet",
          "in so 'n wrede doringkroon?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verhoed o God, dat ek ooit roem",
          "behalwe in my Heer se kruis;",
          "Vir my - verlore en gedoem -",
          "is Hy verbrysel en verguis!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Al was die skepping in my hand,",
          "as offer sou dit nietig wees;",
          "U liefde ver bo my verstand",
          "verg heel my liggaam, siel en gees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Alas! and did my Saviour bleed?",
    "hymnNumber": 91,
    "reference": "AL091",
    "title": "Helaas! Hoe Moes My Heiland Ly!",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.4
    },
    "verses": [
      {
        "content": [
          "Helaas! Hoe moes my Heiland ly!",
          "En moes my Koning sterf?",
          "Was dorings op Sy hoof om my",
          "te red van die verderf?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Het Hy die dood wat ek verdien,",
          "gesterf op Golgota?",
          "En smaad nog foltering ontsien,",
          "en al my skuld gedra?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die heuwel was omfloers met rou,",
          "toe God Sy beker vul;",
          "Geen skepsel kan die kruis aanskou,",
          "in duisternis gehul."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "So moet ek ook in skaamte bloos",
          "as ek Sy kruis aanskou;",
          "My in Sy groot verlossing troos",
          "en ween as ek onthou."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "My trane sou geen offer wees",
          "of my van skuld bevry,",
          "ek gee my liggaam, siel en gees",
          "wat vra U nog van my?"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "In the cross of Christ I glory",
    "hymnNumber": 92,
    "reference": "AL092",
    "title": "In Die Kruis Van Christus Roem Ek",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "In die kruis van Christus roem ek,",
          "hoog bo wrakke van die tyd;",
          "En die Skrif se lig gewaar ek",
          "oor die kruis in ewigheid."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As die lewenslas oorweldig,",
          "hoop verflou en kommer kwel,",
          "laat die kruis my nooit allenig,",
          "Christus is my metgesel."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vloek en seën, pyn en vreugde,",
          "Lig en liefde uit my nag,",
          "werp die kruis se ryke deugde",
          "nuwe luister op my dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vloek en seën, pyn en vreugde,",
          "word geheilig deur die kruis.",
          "Vrede is daar sonder weerga,",
          "blydskap ewig in Sy huis."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O who is this that cometh",
    "hymnNumber": 93,
    "reference": "AL093",
    "title": "O Wie Kom Daar Uit Edom?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 38.9,
      "intro": 52.1
    },
    "verses": [
      {
        "content": [
          "O wie kom daar uit Edom",
          "met bloedbevlekte kleed?",
          "Waarom moes Hy die wonde ly -",
          "waarom die bitter leed?",
          "“Ek wat jou ellende sien,",
          "hoor jou gebed.",
          "Met My groot geregtigheid",
          "kan Ek jou red'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waarom die rooi gewaad, Heer?",
          "Waarom is dit bevlek",
          "soos hulle wat die wynpers trap?",
          "Waarom met bloed bedek?",
          "“Ja, die pers het Ek getrap",
          "alleen - onteer'.",
          "Vir my het U bloed getap,",
          "Redder en Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "o Lam van God, my Heiland,",
          "U het ons smaad gedra!",
          "O Heer, U het, om my te red,",
          "gesterf op Golgota.",
          "“Daar het Ek die dood verslaan;",
          "Ek lewe weer.",
          "Spoedig breek die vreugde aan -",
          "Redder en Heer'."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "U kan my red,",
      "U kan my red;",
      "U kan my red!",
      "Heer, met U geregtigheid kan U my red."
    ]
  },
  {
    "english": "Christ the Lord is risen today",
    "hymnNumber": 94,
    "reference": "AL094",
    "title": "Christus Heer, Het Opgestaan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Christus, Heer het opgestaan,",
          "Halleluja!",
          "Hef 'n blye loflied aan,",
          "Halleluja!",
          "Laat die heem'le hulde bring,",
          "Halleluja!",
          "En die mensdom juigend sing,",
          "Halleluja!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus het getriomfeer,",
          "Halleluja!",
          "Oor Hom kon geen dood regeer,",
          "Halleluja!",
          "Voor Hom moes die magte wyk,",
          "Halleluja!",
          "Van die wrede doderyk,",
          "Halleluja!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die oorwinning is behaal,",
          "Halleluja!",
          "Onse losprys is betaal,",
          "Halleluja!",
          "Hy wat uit die graf herrys,",
          "Halleluja!",
          "Open ook die Paradys,",
          "Halleluja!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Christus het weer opgestaan,",
          "Halleluja!",
          "En vir ons die weg gebaan,",
          "Halleluja!",
          "Deur Sy soendood aan die kruis,",
          "Halleluja!",
          "Na die eeu'ge Vaderhuis,",
          "Halleluja!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I love to tell the story",
    "hymnNumber": 95,
    "reference": "AL095",
    "title": "Ek Bring So Graag Die Tyding",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 36.4,
      "intro": 45.6
    },
    "verses": [
      {
        "content": [
          "Ek bring so graag die tyding",
          "van dinge nooit gesien,",
          "van Jesus en Sy liefde,",
          "en eng'le wat Hom dien.",
          "Ek bring so graag die tyding",
          "omdat ek weet dis waar;",
          "Dit stil my diep verlange",
          "wat anders nooit bedaar."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek bring so graag die tyding,",
          "dit klink meer wonderbaar",
          "as al die goue drome",
          "wat ons begeertes baar.",
          "Ek bring so graag die tyding,",
          "dit doen soveel vir my,",
          "en ek verlang dat ander",
          "die tyding ook moet kry."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek bring so graag die tyding",
          "wat altyd soeter klink",
          "wanneer ek dit aan ander",
          "vertel, en daaroor dink.",
          "Ek bring so graag die tyding,",
          "vir vele ongehoord,",
          "Die boodskap van verlossing",
          "uit God se heil'ge Woord."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek bring so graag die tyding,",
          "want kinders van die Heer",
          "wat reeds daarmee bekend is,",
          "vra nog gedurig meer.",
          "En as ek in die hemel",
          "‘n nuwe lied kan sing,",
          "dan sing ek van die vreugde",
          "wat daardie tyding bring."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ek bring so graag die tyding,",
      "‘n loflied van bevryding;",
      "Dit is die ou, ou tyding",
      "die liefde van ons Heer."
    ]
  },
  {
    "english": "How sweet the name of Jesus sounds",
    "hymnNumber": 96,
    "reference": "AL096",
    "title": "Daar Is Geen Ander Naam So Soet",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.6
    },
    "verses": [
      {
        "content": [
          "Daar is geen ander Naam so soet,",
          "as 'Jesus' vir my hart;",
          "Dit stil die pyn in my gemoed,",
          "verban my vrees en smart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dis balsem wat my smart genees,",
          "dis soete lafenis,",
          "dis manna vir my siel en gees",
          "en vir vermoei'nis rus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Jesus, Rots op wie ek bou,",
          "my Skild en Hoogvertrek,",
          "die skathuis wat genade hou",
          "wat al my sonde dek."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O Jesus, Heiland, Rigter, Vriend,",
          "my Herder, Koning, Heer;",
          "o Lig en Lewe onverdiend,",
          "neem aan my lof en eer."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "My beste poging is gering,",
          "my grootste liefde flou;",
          "Ek sal U liefde nog besing",
          "wanneer ek U aanskou."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "The name of Jesus is so sweet",
    "hymnNumber": 97,
    "reference": "AL097",
    "title": "Die Naam Van Jesus, Wonderskoon",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.2,
      "intro": 25.2
    },
    "verses": [
      {
        "content": [
          "Die Naam van Jesus, wonderskoon,",
          "laat heel die hemel in my woon;",
          "Dit laat Sy vreugde in my troon -",
          "die dierb're Naam van Jesus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek min die Naam; Sy Vaderhart",
          "verstaan my droefheid en my smart,",
          "en Hy verdryf die wolke swart -",
          "ek min die Naam van Jesus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek wil die Naam gedurig hoor,",
          "niks wat my siel ooit so bekoor!",
          "My smart en trane wyk daarvoor -",
          "verhoog die Naam van Jesus."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Geen sterweling kan ooit vertel",
          "hoe veel dit in my lewe tel.",
          "O laat Sy lof steeds opwaarts wel -",
          "o loof die Naam van Jesus."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Jesus, o die Wondernaam!",
      "Jesus, wat my nooit beskaam;",
      "Jesus, kom ons loof Hom saam -",
      "Sy dierb're Naam vir ewig!"
    ]
  },
  {
    "english": "There's no other name like Jesus",
    "hymnNumber": 98,
    "reference": "AL098",
    "title": "Daar's Geen Ander Naam Soos Jesus",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Daar's geen ander naam soos Jesus,",
          "dis die soetste Naam vandag;",
          "In die hemel bring dit vreugde,",
          "en op aarde gee dit krag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar's geen ander naam soos Jesus",
          "as die hart van droefheid sug;",
          "Daar's geen ander naam soos Jesus",
          "as die hart sy vreugde lug."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis my hoop en my verwagting",
          "dat Hy spoedig sal verskyn;",
          "En dat Hy my sal verwelkom,",
          "dit laat al my leed verdwyn."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As Hy wil dat in Sy wingerd",
          "ek die dag se las moet dra;",
          "Sal ek niks meer op my arbeid",
          "as die Heer se seën vra."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Wil Hy dat die dood se sekel",
          "my sal neervel in die graf;",
          "Is my troos dat Jesus met my",
          "bly op hierdie laaste skof."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Sy Naam, so rein,",
      "daar's geen ander naam soos Jesus;",
      "Sy Naam, so rein,",
      "daar's geen ander naam soos Jesus."
    ]
  },
  {
    "english": "There were ninety and nine that safely lay",
    "hymnNumber": 99,
    "reference": "AL099",
    "title": "Neën-En-Neëntig Skape",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 17
    },
    "verses": [
      {
        "content": [
          "Neën-en-neëntig skape het saam gelê",
          "in die koelte van die kraal,",
          "maar van die trop het daar een  ontbreek",
          "in die wildernis verdwaal:",
          "Ver weg in die berge, ",
          "wild en kaal,",
          "weg van die Herder se veilige kraal,",
          "weg van die Herder se veilige kraal!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "'Heer, U het neën-en-neëntig hier,",
          "waarom dan gaan soek na een?'",
          "Maar die Herder antwoord:",
          "“Dié een dier is waar My hart oor ween.",
          "En waar die woestyn My ook mag lei,",
          "Ek gaan en Ek soek want Ek moet hom kry -",
          "Ek gaan en Ek soek, want Ek moet hom kry'."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Het een van die ander ooit geweet",
          "hoe diep daardie klowe was?",
          "Hoe die ruigte verskeur het",
          "die Herder se kleed",
          "en Sy voete verwond in die gras?",
          "O, ver in die stilte hoor Hy hom blêr:",
          "Verlate en sterwend op berge daar ver -",
          "verlate en sterwend op berge daar ver."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "'Heer, waarom die bloedmerke op U spoor",
          "waar die weg deur die berge lei?'",
          "'daar was een in die donker nag verloor",
          "Ek moes soek tot Ek Hom weer kry'.",
          "'En U hande, Heer, is vol bloed en geskeur!' 'Dis die rotse en dorings waar ek moes deur, dis die rotse en dorings waar ek moes deur'."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "En ver teen die berge onverstoor,",
          "en hoog teen die kranse klink",
          "‘n stem wat roep, tot die hemel hoor:",
          "'wees bly, My skaap is gevind!'",
          "En die eng'le sing in die hemelhuis:",
          "'o Juig! Want die skaap is weer",
          "veilig tuis!",
          "o juig! Want die skaap is weer",
          "veilig tuis!'."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Take the name of Jesus with you",
    "hymnNumber": 100,
    "reference": "AL100",
    "title": "Neem Die Naam Van Jesus Met Jou",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 18.5,
      "intro": 28.1
    },
    "verses": [
      {
        "content": [
          "Neem die Naam van Jesus met jou,",
          "kind van smarte en van wee;",
          "Dit bring vreugde en vertroosting,",
          "neem dit oral met jou mee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Neem die Naam van Jesus altyd",
          "as 'n pantser teen gevaar;",
          "As versoekings jou oorweldig,",
          "fluister: Jesus, wonderbaar!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O die dierb're Naam van Jesus!",
          "Dit vervul my siel met vreug;",
          "Vind ek in Sy skadu skuiling,",
          "sing my tong Sy lof en deug!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons sal eendag voor Hom neerbuig,",
          "en Sy grote Naam bely;",
          "Daar kroon ons Hom Heer der Here,",
          "dan is al ons stryd verby."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Dierb're Naam, o hoe soet!",
      "Hoop van aarde, hemelsvreug!",
      "Dierb're Naam, o hoe soet,",
      "Hoop van aarde, hemelsvreug!"
    ]
  },
  {
    "english": "Christ has for sin atonement made",
    "hymnNumber": 101,
    "reference": "AL101",
    "title": "God Neem In Christus Sondaars Aan",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": true,
    "timestamps": {
      "chorus": 18.7,
      "intro": 18.7
    },
    "verses": [
      {
        "content": [
          "God neem in Christus sondaars aan,",
          "wat 'n dierbare Heiland!",
          "Hy het die weg vir ons gebaan.",
          "wat 'n dierbare Heiland!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek sing van wat Sy bloed kan doen,",
          "wat 'n dierbare Heiland!",
          "Dit het my weer met God versoen,",
          "wat 'n dierbare Heiland!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hy reinig my, Hom sy die eer,",
          "wat 'n dierbare Heiland!",
          "Nou is dit Hy wat my regeer,",
          "wat 'n dierbare Heiland!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hy wandel naas my op die weg,",
          "wat 'n dierbare Heiland!",
          "En hou my skrede vas en reg,",
          "wat 'n dierbare Heiland!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Hy skenk my teen versoeking krag,",
          "wat 'n dierbare Heiland!",
          "In Hom oorwin ek dag na dag,",
          "wat 'n dierbare Heiland!"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Aan Hom het ek my hart gewy,",
          "wat 'n dierbare Heiland!",
          "Nou kan my siel geen skade ly,",
          "wat 'n dierbare Heiland!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": [
      "Wat 'n dierbare Heiland",
      "is Jesus, my Jesus!",
      "Wat 'n dierbare Heiland",
      "is Jesus, my Heer!"
    ]
  },
  {
    "english": "A wonderful Saviour is Jesus my Lord",
    "hymnNumber": 102,
    "reference": "AL102",
    "title": "‘n Dierbare Heiland Is Jesus My Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21,
      "intro": 31.6
    },
    "verses": [
      {
        "content": [
          "‘n Dierbare Heiland ",
          "is Jesus my Heer,",
          "‘n dierbare Heiland vir my,",
          "by Hom skuil my siel in die ewige Rots,",
          "waar strome van lewe verbly."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "‘n Dierbare Heiland is Jesus my Heer,",
          "Hy dra al my laste met my;",
          "Hy hou my onwankelbaar vas aan die hand,",
          "en vul my met krag as ek ly."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Onskatbaar die seën wat Hy aan my skenk – ",
          "die hemelse volheid aan my -",
          "ek sing en ek juig in die Here my God:",
          "my grote Verlosser is Hy."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Onsterflikheid sal Hy ons skenk as Hy kom, ",
          "om ons na die hemel te haal,",
          "en daar in die lug sal ons Jesus ontmoet",
          "en sing van oorwinning behaal."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "By Hom skuil my siel in die ewige Rots,",
      "so koel in die dorstige land;",
      "Met ewige liefde bewaak Hy my siel,",
      "en hou oor my altyd Sy hand,",
      "en hou oor my altyd Sy hand!"
    ]
  },
  {
    "english": "Have I need of aught, O Saviour!",
    "hymnNumber": 103,
    "reference": "AL103",
    "title": "Wat Ontbreek My Hier Op Aarde?",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15,
      "intro": 15
    },
    "verses": [
      {
        "content": [
          "Wat ontbreek my hier op aarde",
          "as ek U het, Heer?",
          "Wat verlang ek van die hemel",
          "as my Heiland meer?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al omring U my met vriende,",
          "liefde, goud en eer,",
          "bly ek eensaam hier op aarde",
          "sonder U, my Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Watter vriend bly so geduldig",
          "wanneer ek oortree?",
          "Watter een is so gewillig",
          "om Sy hulp te gee?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wat kan ek daarvoor in ruil neem -",
          "hierdie soet geloof?",
          "Aardse skatte sal my nooit nie",
          "van die troos ontroof."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "U alleen, U alleen,",
      "net U liefde, Heer, alleen;",
      "U alleen, U alleen,",
      "U, my Heer, alleen."
    ]
  },
  {
    "english": "Take the world, but give me Jesus",
    "hymnNumber": 104,
    "reference": "AL104",
    "title": "Neem Die Wêreld, Ek Kies Jesus!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Neem die wêreld, ek kies Jesus!",
          "Aardse vreugde snel verby;",
          "Maar Sy liefde bly dieselfde,",
          "deur die eeue heen vir my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Neem die wêreld, ek kies Jesus!",
          "Hy vertroos en gee weer krag.",
          "As my Heiland oor my waghou,",
          "kan ek sing deur storm en nag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Neem die wêreld, ek kies Jesus!",
          "Laat my steeds Sy heil aanskou,",
          "dan sal Hy my pad verhelder",
          "om die regte koers te hou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Neem die wêreld, ek kies Jesus!",
          "Ek verlaat my op die kruis.",
          "Eenmaal sal ek Hom in wese",
          "sien daar in Sy vaderhuis."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "o Hoe groot is Sy genade!",
      "Wie kan ooit Sy liefde peil?",
      "O hoe ruim is ons verlossing!",
      "Hy's die bron van eeu'ge heil."
    ]
  },
  {
    "english": "Lift Him up, 'tis He that bids you",
    "hymnNumber": 105,
    "reference": "AL105",
    "title": "Laat Die Here Nou Verhoog Word",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 31.9,
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Laat die Here nou verhoog word,",
          "laat die sondaars sien en leef;",
          "Kyk, Hy skenk die lewenswater,",
          "Hy kan sondaars ook vergeef.",
          "Hierdie nederige Jesus,",
          "was die Hemelprins gewees;",
          "Blindes wat in duister rondtas,",
          "word deur Jesus bloed genees."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat die Heiland nou verhoog word,",
          "dan sal Hy Sy mag ontvou;",
          "Sondaars wat verlang na Jesus,",
          "sal Sy heerlikheid aanskou.",
          "Uit die paaie en die lane,",
          "sal die skare juigend kom,",
          "singend met die kruis van Jesus,",
          "en verlossing vind in Hom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kom verhoog Hom in Sy luister,",
          "dis die Seun van God, die Heer;",
          "Sy genade en Sy liefde",
          "kon selfs moordenaars bekeer,",
          "laat die skares hoor van Jesus,",
          "van Sy kruis en skandedood,",
          "totdat almal Hom erken het",
          "en Sy dierb're Naam vergroot."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom, verhoog Sy Naam met lofsang,",
          "ja, verhoog Hom in gebed;",
          "Hy, die Koning van die hemel,",
          "het die mensdom uitgered.",
          "Jonk en oud sal voor Hom neerbuig,",
          "saam 'n loflied aan Hom bring;",
          "Dowes hoor die bly hosannas",
          "wat die stommes juigend sing."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Kom verhoog die Heer wat lewe,",
      "waar die mensdom sugtend wag;",
      "Hoor Sy stem, Hy roep die sondaar,",
      "kom tot Hom, o kom vandag."
    ]
  },
  {
    "english": "Must Jesus bear the cross alone",
    "hymnNumber": 106,
    "reference": "AL106",
    "title": "Dra Jesus Dan Die Kruis Alleen?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "Dra Jesus dan die kruis alleen?",
          "Is ons volkome vry?",
          "Nee, daar's 'n kruis vir elke een",
          "en daar's 'n kruis vir my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die kruis sal ek geduldig dra",
          "totdat Hy my bevry;",
          "En my 'n kroon skenk deur gena,",
          "want daar's 'n kroon vir my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dan werp ek self my goue kroon",
          "as offer voor Hom neer,",
          "en kniel aanbiddend voor Sy troon",
          "Sy grote Naam ter eer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O Love that wilt not let me go",
    "hymnNumber": 107,
    "reference": "AL107",
    "title": "O Liefde Wat My Staande Hou!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.1
    },
    "verses": [
      {
        "content": [
          "o Liefde wat my staande hou -",
          "die hawe van my moeë hart -",
          "die lewe aan my toevertrou,",
          "sal in U liefliker ontvou,",
          "verfyn, verryk deur smart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "o Lig wat altyd helder skyn,",
          "my floue flikkerliggie faal;",
          "Geleende lig sal immer kwyn",
          "totdat dit in die glans verdwyn",
          "wat uit die hemel straal."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "o Vreugde wat my vind in pyn,",
          "vir U ontsluit ek heel my hart.",
          "Die wolke laat die boog verskyn;",
          "Belofte dat as nag verdwyn,",
          "kom dagbreek sonder smart."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "o Kruis wat my verhef tot God,",
          "durf ek terugdeins vir U pyn?",
          "Ek sal berus, Heer, in my lot,",
          "want uit die stof sal lewe bot,",
          "onsterflik, skoon en rein."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I give my heart to Thee",
    "hymnNumber": 108,
    "reference": "AL108",
    "title": "Ek Gee My Hart Aan U",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Ek gee my hart aan U,",
          "o Jesus, dierb're Heer;",
          "Dis wederliefde wat die hart",
          "so vuriglik begeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe trek U liefde my,",
          "tot ek U ook bemin;",
          "U het my onverskilligheid",
          "met tederheid oorwin."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Het U, o Woord van God,",
          "‘n mens geword soos ek,",
          "en wrede foltering gely",
          "om my tot U te trek?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek gee myself aan U,",
          "o Heer, wat ewig leef;",
          "Ek wil U wil in alles doen",
          "en immer aan U kleef."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "U hart is oop vir my,",
          "bied milde liefde aan;",
          "O help my om U liefde, Heer,",
          "volkome te verstaan."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "More about Jesus would I know",
    "hymnNumber": 109,
    "reference": "AL109",
    "title": "Meer Van My Jesus Wil Ek Hoor",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Meer van my Jesus wil ek hoor,",
          "van Sy genade oor en oor,",
          "meer van Sy volle reddingskrag,",
          "meer van Sy liefde elke dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Meer van my Jesus wil ek leer,",
          "meer van Sy wil, dit bring Hom eer,",
          "Heilige Gees, kom woon in my,",
          "wil U my Heiland toon aan my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Meer van my Jesus; in Sy Woord",
          "hou ons gemeenskap ongestoord;",
          "In elke reël 'n boodskap soet -",
          "helende salf vir my gemoed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Meer van my Jesus waar Hy woon,",
          "op Sy verhewe hemeltroon,",
          "meer van Sy koninkryk wat kom,",
          "meer van Sy koms en meer van Hom."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Meer, meer van my Jesus,",
      "meer, meer van my Jesus;",
      "meer van Sy volle reddingskrag,",
      "meer van Sy liefde elke dag."
    ]
  },
  {
    "english": "Just when I need Him, Jesus is near",
    "hymnNumber": 110,
    "reference": "AL110",
    "title": "Roep Ek Tot Jesus - Hy Is Naby",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.5,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Roep ek tot Jesus - Hy is naby,",
          "as ek teen vrees en sonde moet stry;",
          "Altyd is Hy gereed aan my sy",
          "wanneer ek tot Hom roep."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Roep ek tot Jesus - Hy is getrou;",
          "Hy sal my altyd digby Hom hou;",
          "Hy laaf my siel met hemelse dou",
          "wanneer ek tot Hom roep."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Roep ek tot Jesus - Hy is my krag!",
          "Hy deel my laste, Sy juk is sag:",
          "selfs deur my trane, sien ek Sy prag",
          "wanneer ek tot Hom roep."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Roep ek tot Jesus - alles is Hy;",
          "Uit die benoudheid maak Hy my vry;",
          "Hy neem my hand nog voordat ek gly",
          "wanneer ek tot Hom roep."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Wanneer ek tot Hom roep,",
      "wanneer ek tot Hom roep,",
      "Hy staan my by, vertroos en verbly,",
      "wanneer ek tot Hom roep."
    ]
  },
  {
    "english": "I will sing of Jesus' love",
    "hymnNumber": 111,
    "reference": "AL111",
    "title": "Van Die Liefde Van Die Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.3,
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Van die liefde van die Heer",
          "wil ek sing, soos Hy my leer,",
          "want Hy het Sy hof verlaat,",
          "om vir my die kruis te dra."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Eer 'n traan my oog verdof,",
          "het die Heer oor my geween;",
          "Voordat ek kon spreek of bid,",
          "het die Heer gebid, alleen."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O hoe groot die liefde Gods!",
          "Niemand sal ooit kan verstaan",
          "hoedat Hy my van my skuld",
          "so genadiglik ontslaan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Niks het ek vir Hom gedoen,",
          "hoe kon Hy my so bemin!",
          "U het reeds my hart gewen;",
          "Help my U nog meer bemin."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ek wil van Sy liefde sing,",
      "ewig loof my siel die Heer;",
      "Hy moes sterf dat ek mag leef,",
      "van Sy liefde sal ek sing."
    ]
  },
  {
    "english": "I have a Friend so precious",
    "hymnNumber": 112,
    "reference": "AL112",
    "title": "Ek Het ‘n Vriend So Dierbaar",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Ek het 'n Vriend so dierbaar, ",
          "Hy is so lief vir my;",
          "Hy min my, o so tederlik ",
          "die trouste Vriend is Hy;",
          "En sonder Hom sal ek vergaan, ",
          "Sy liefde moet my dek;",
          "en so woon ons tesame my Heer en ek."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al voel ek soms verlate, ",
          "Hy ken my swakke hart;",
          "Dan gee Hy my weer nuwe moed ",
          "en lenig al my smart.",
          "Hy lei my op die weg van lig ",
          "waaroor die hemel strek;",
          "Ons wandel so tesame my Heer en ek."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek sê Hom van my weemoed, ",
          "vertel Hom van my vreug;",
          "Ek sê Hom wat tot droefheid stem ",
          "en wat my hart verheug.",
          "Hy leer my steeds wat ek moet doen, ",
          "wat tot Sy eer sal strek;",
          "Ons wandel so tesame - my Heer en ek."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hy weet van my verlange ",
          "om sondaars te kan red;",
          "Hy stuur my daarom met Sy woord ",
          "en leer hul ook Sy wet.",
          "Ek spreek van liefde en die kruis – ",
          "Sy bloed wat sonde dek;",
          "En so werk ons tesame - my Heer en ek."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I've found a Friend; oh, such a Friend!",
    "hymnNumber": 113,
    "reference": "AL113",
    "title": "Ek Het ‘n Troue Vriend Gevind",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.2
    },
    "verses": [
      {
        "content": [
          "Ek het 'n troue Vriend gevind",
          "wat my al lank bemin het;",
          "Sy liefde het my aangetrek,",
          "nog voor ek Hom geken het.",
          "En Hy het my aan Hom gebind",
          "met bande sag maar stewig;",
          "Hy is my Vriend en ek Sy kind",
          "vir ewig, ja vir ewig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het 'n troue Vriend gevind,",
          "vir my het Hy gesterwe;",
          "En met Sy vriendskap sal Hy my",
          "Sy lewe ook laat erwe.",
          "Wat ek besit, kom van my Heer -",
          "die Vader is vrygewig!",
          "My krag, my lewe, gee ek weer",
          "terug aan Hom vir ewig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek het 'n troue Vriend gevind,",
          "aan Hom is daar gegewe",
          "die wysheid om my voort te lei,",
          "tot reiner, hoër lewe.",
          "Hier moet ek werk en waak en wag,",
          "die aardse stryd is hewig;",
          "Maar ek verwag 'n nuwe dag,",
          "dan sal ek rus vir ewig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek het 'n troue Vriend gevind,",
          "so sag en vol ontferming;",
          "By Hom, my Raadsman en my Gids,",
          "is ook vir my beskerming.",
          "Wie sal my van my Heiland skei?",
          "Die liefdesband is stewig!",
          "Geen aardse mag skeur Hom van my!",
          "Ek bly in Hom vir ewig."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Oh, the best friend to have is Jesus",
    "hymnNumber": 114,
    "reference": "AL114",
    "title": "Die Dierbaarste Vriend Is Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 18.4,
      "intro": 27.3
    },
    "verses": [
      {
        "content": [
          "O die dierbaarste Vriend is Jesus",
          "as die sorge van die lewe kwel;",
          "Hy vertroos en Hy behoed",
          "Hy gee krag en hoop en moed;",
          "O die dierbaarste Vriend is Jesus!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O die Vriend wat ek het, is Jesus,",
          "troos en vrede bring Hy in my siel;",
          "Leunend op Sy grote mag,",
          "vrees ek nie die onweersnag;",
          "O die dierbaarste Vriend is Jesus!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As ek gaan deur die nag van lyding,",
          "en die koue branders oor my slaan,",
          "dan hoef ek geen kwaad te vrees,",
          "want my Heer sal by my wees;",
          "O die dierbaarste Vriend is Jesus!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom ons eens in ons hemelwoning,",
          "en ons sien die vriende wat nou rus;",
          "Dan sal almal juig en sing,",
          "Hom vir ewig hulde bring;",
          "O die dierbaarste Vriend is Jesus!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Die dierbaarste Vriend is Jesus,",
      "die dierbaarste Vriend is Jesus!",
      "Hy bewaar jou teen gevaar;",
      "As jy roep dan is Hy daar;",
      "O die dierbaarste Vriend is Jesus!"
    ]
  },
  {
    "english": "",
    "hymnNumber": 115,
    "reference": "AL115",
    "title": "Soos Die Hert Op Dorre Vlaktes",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Soos die hert op dorre vlaktes",
          "smagtend dors na die genot",
          "van die koele waterstrome,",
          "so smag ek na U, o God.",
          "Ja, my siel dors na die Heer;",
          "God van lewe, o wanneer",
          "sal ek nader voor U oë -",
          "Biddend in U tempelhowe."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Maar die Here self gee uitkoms!",
          "Hy wat die verkwikking bied,",
          "maak my lewe daagliks rustig",
          "en wek in my hart 'n lied;",
          "Ja, ek sing selfs in die nag",
          "van die God wat ek verwag,",
          "en soos wierook voor die Here",
          "bied ek daagliks my gebede."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "o My siel, van waar die trane?",
          "Wie beroof jou van die rus?",
          "Voed die ou vertroue weer eens;",
          "Soek in hoogste lof jou lus.",
          "Dikwels het die Heer jou nag",
          "laat verander in die dag.",
          "Hoop op Hom en kyk na bowe;",
          "Loof Hom in Sy tempelhowe."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, lover of my soul",
    "hymnNumber": 116,
    "reference": "AL116",
    "title": "Jesus Wat My Siel Bemin",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Jesus, wat my siel bemin,",
          "laat my aan U boesem leun,",
          "as die golwe om my slaan,",
          "as die donder dreigend dreun.",
          "Heiland, laat my by U skuil,",
          "stil in die onstuimigheid,",
          "veilig as die winde huil,",
          "veilig tot in ewigheid!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ander toevlug het ek geen,",
          "U is al wat ek begeer;",
          "Laat, o laat my nie alleen,",
          "sterk U en vertroos my, Heer.",
          "Ek wil niks van U weerhou -",
          "U wat my vervul met krag;",
          "wil oor my U vleuels hou,",
          "Heer, by U sal ek vernag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U, o Here, is my lus,",
          "U alleen bevredig my;",
          "Rig my op en skenk my rus,",
          "maak my van my sorge vry!",
          "Heilig, heilig is U Naam,",
          "U is reine heerlikheid;",
          "Voor U moet ek skuldig staan,",
          "vol van ongeregtigheid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U genade is so wyd",
          "dit kan al my sonde dek;",
          "Laat die stroom van saligheid",
          "my bevry van elke vlek.",
          "U, o Heer, die Heilfontein,",
          "laat my vrylik uit U drink;",
          "Lewenswater, koel en rein,",
          "vloei uit U in ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, lover of my soul",
    "hymnNumber": 117,
    "reference": "AL117",
    "title": "Jesus Wat My Siel Bemin",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Jesus, wat my siel bemin,",
          "laat my aan U boesem leun,",
          "as die golwe om my slaan,",
          "as die donder dreigend dreun.",
          "Heiland, laat my by U skuil,",
          "stil in die onstuimigheid,",
          "veilig as die winde huil,",
          "veilig tot in ewigheid!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ander toevlug het ek geen,",
          "U is al wat ek begeer;",
          "Laat, o laat my nie alleen,",
          "sterk U en vertroos my, Heer.",
          "Ek wil niks van U weerhou -",
          "U wat my vervul met krag;",
          "Wil oor my U vleuels hou,",
          "Heer, by U sal ek vernag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U, o Here, is my lus,",
          "U alleen bevredig my;",
          "Rig my op en skenk my rus,",
          "maak my van my sorge vry!",
          "Heilig, heilig is U Naam,",
          "U is reine heerlikheid;",
          "Voor U moet ek skuldig staan,",
          "vol van ongeregtigheid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U genade is so wyd",
          "dit kan al my sonde dek;",
          "Laat die stroom van saligheid",
          "my bevry van elke vlek.",
          "U, o Heer, die Heilfontein,",
          "laat my vrylik uit U drink;",
          "Lewenswater, koel en rein,",
          "vloei uit U in ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The Great Physician now is near",
    "hymnNumber": 118,
    "reference": "AL118",
    "title": "Die Groot Geneesheer Is Naby",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.5,
      "intro": 17.5
    },
    "verses": [
      {
        "content": [
          "Die groot Geneesheer is naby -",
          "die simpatieke Jesus -",
          "Sy woorde sal jou hart verbly,",
          "o hoor die stem van Jesus!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sy wonde bied genesing aan,",
          "die Lam van God is Jesus;",
          "Hoe mooi klink die Verlossersnaam -",
          "die skone Naam van Jesus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die Naam verdryf my angs en vrees -",
          "geen ander Naam as Jesus!",
          "Ek smag met liggaam, siel en gees",
          "na daardie Naam van Jesus!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hy kom verheerlik en met krag -",
          "my Heer, so hoog verhewe -",
          "saam sal ons dan in hemelprag",
          "die kroon ontvang van lewe!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Soetste klank in serafslied,",
      "soetste naam in Gods gebied;",
      "Soetste troos in ons verdriet;",
      "Daardie Naam is Jesus!"
    ]
  },
  {
    "english": "I hear the Saviour say",
    "hymnNumber": 119,
    "reference": "AL119",
    "title": "Die Heiland Sê Aan My",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 18.6,
      "intro": 18.6
    },
    "verses": [
      {
        "content": [
          "Die Heiland sê aan my:",
          "'jou eie krag is klein,",
          "jy moet waak en bid en stry;",
          "vind in My jou Heilfontein'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die wonderbare krag",
          "vind ek by U, o Heer;",
          "Om harte te versag",
          "en sondaars te bekeer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Geen vriend wat ek besit,",
          "kan vir my sonde boet;",
          "Daarom was Hy my wit",
          "in Golgota se bloed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Staan ek dan voor die troon,",
          "volmaak in onse Heer,",
          "lê ek my sterrekroon",
          "daar aan Sy voete neer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Hy't my skuld betaal!",
      "Wat kan ek besit?",
      "Sonde het my hart bevlek,",
      "maar Hy was dit weer wit."
    ]
  },
  {
    "english": "Love divine, all loves excelling",
    "hymnNumber": 120,
    "reference": "AL120",
    "title": "Liefde, Grenseloos, Onpeilbaar",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Liefde, grenseloos, onpeilbaar,",
          "daal in onse harte neer!",
          "Ondeurgrondelik, onfeilbaar,",
          "is U tederheid, o Heer!",
          "Weergaloos is U genade;",
          "U het self in ons kom woon!",
          "Dis van al U liefdedade",
          "die voltooiing en die kroon!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Stort U Gees in onse harte,",
          "maak ons van U krag bewus;",
          "Skenk ons, selfs in pyn en smarte,",
          "die beloofde soete rus.",
          "Neem die neiging tot die sonde",
          "weg, en lei ons, Heil'ge Gees,",
          "dat ons, slegs deur U gebonde,",
          "inderwaarheid vry mag wees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kom, Almagtige, om nimmer",
          "weer U Tempel te verlaat;",
          "Stel ons deur genade immer",
          "tot U hoogste diens in staat!",
          "Maak in ons U heil'ge woning;",
          "Leer ons hoe om U te prys,",
          "soos die eng'le wat hul Koning",
          "onophoud'lik eer bewys."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Laat U nuwe skepping heerlik",
          "en volmaak in liefde wees;",
          "Vorm ons na U beeld, begeerlik,",
          "deur die werking van U Gees;",
          "Tot ons eenmaal in U skone",
          "Hemelhowe, dier'bre Heer,",
          "in aanbidding onse krone",
          "voor U neerwerp, U ter eer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O Love divine, what hast Thou done!",
    "hymnNumber": 121,
    "reference": "AL121",
    "title": "O Liefde, Wat Het U Gedoen?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 24.4
    },
    "verses": [
      {
        "content": [
          "o Liefde, wat het U gedoen!",
          "Gesterf - uit deernis met ons lot -",
          "om sondaars met U te versoen,",
          "o Vleesgeworde Woord van God!",
          "Om my te red van die verderf,",
          "het my geliefde Heer gesterf."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Het Hy vir vyande gely?",
          "Kon Hy rebelle so bemin?",
          "Ja, Hy't gesterf vir U en my",
          "om ons tot God terug te win;",
          "Dat ons die lewe mag beërf,",
          "het my geliefde Heer gesterf."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kyk, onverskillige, aanskou",
          "die Prins van Vrede aan die kruis!",
          "Val voor Hom neer in diep berou,",
          "vir jou is Hy so wreed verguis;",
          "Om jou te red van die verderf,",
          "het my geliefde Heer gesterf."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Does Jesus Care",
    "hymnNumber": 122,
    "reference": "AL122",
    "title": "Gee Jesus Om",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 30.3
    },
    "verses": [
      {
        "content": [
          "Gee Jesus om as my bange hart",
          "van weemoed en pyn wil vlug,",
          "as my laste druk ",
          "en ek laag moet buk",
          "tot ek moeg en moedeloos sug?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gee Jesus om as my hart beswyk",
          "in die duistere nag van vrees,",
          "as die daglig faal ",
          "en die skadu's daal,",
          "sal die Heer ook dan by my wees?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gee Jesus om as versoeking kom",
          "en ek voor die druk beswyk,",
          "as my wange gloei ",
          "en my trane vloei,",
          "sal Sy hand my dan nog bereik?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gee Jesus om as ek afskeid neem",
          "van die liefste op aard' vir my,",
          "en die dood hom wreek ",
          "tot my hart wil breek, ",
          "is dit niks vir Hom as ek ly?"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ja, Hy gee om, my Heer gee om,",
      "Sy hart is week met my leed.",
      "As die dae lank is, ",
      "my hart snags krank is, ",
      "weet ek my Heer gee om."
    ]
  },
  {
    "english": "In joyful high and holy lays",
    "hymnNumber": 123,
    "reference": "AL123",
    "title": "My Lied Sal Opwaarts Tot U Styg",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.5,
      "intro": 29.1
    },
    "verses": [
      {
        "content": [
          "My lied sal opwaarts tot U styg;",
          "My hart wil U met liefde prys;",
          "Waar is die sterfling wat kan swyg",
          "oor die liefde van onse Jesus?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My vreug bedags, en vrede snags,",
          "my rus in storm, my steun en krag;",
          "Die balsem wat my pyn versag,",
          "is die liefde van onse Jesus!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Voor ek nog roep, dan hoor Hy al;",
          "Hy help my op as ek moeg val;",
          "In dood en lewe staan Hy pal -",
          "o die liefde van onse Jesus!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Liefde vir my, liefde vir my,",
      "liefde van onse Jesus;",
      "Liefde vir my, liefde vir my,",
      "liefde van onse Jesus!"
    ]
  },
  {
    "english": "The Saviour With Me",
    "hymnNumber": 124,
    "reference": "AL124",
    "title": "Ek Moet Jesus Aan My Sy Hê",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 13.8,
      "intro": 13.8
    },
    "verses": [
      {
        "content": [
          "Ek moet Jesus aan my sy hê,",
          "want ek durf alleen nie gaan;",
          "Hy moet lig gee op my weë",
          "en Sy arms om my slaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek moet Jesus aan my sy hê;",
          "My geloof is swak en klein;",
          "Hy kan my vertroos en aanspoor",
          "met Sy stem so skoon en rein."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek moet Jesus aan my sy hê",
          "elke oomblik, elke dag,",
          "op die weg wat ek bewandel",
          "deur die strydperk en die nag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek moet Jesus aan my sy hê",
          "want Hy rig my met Sy oog;",
          "Tot ek kom in gindse oorde",
          "van die Vaderhuis omhoog."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Dan kom my geen kwaad meer oor,",
      "waar Hy roep, daar gaan Hy voor,",
      "ek sal volg, nie murmureer nie,",
      "elke voetstap in Sy spoor."
    ]
  },
  {
    "english": "Crown Him with many crowns",
    "hymnNumber": 125,
    "reference": "AL125",
    "title": "Kroon Hom Met Lof En Seën",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 18.5
    },
    "verses": [
      {
        "content": [
          "Kroon Hom met lof en seën,",
          "Die Godslam hoog vereer!",
          "Hoor hoe die hemelkoor alleen",
          "Verrys bo elke sfeer.",
          "Ontwaak my siel en loof",
          "Die Koning van die tyd;",
          "Verhef Hom as jou God en Hoof",
          "Deur alle ewigheid."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kroon Hom wat liefde is,",
          "Ontferming en gena;",
          "Onpeilbare geheimenis -",
          "Die wonde wat Hy dra!",
          "Geen hemeling omhoog",
          "Kan die toneel aanskou,",
          "Maar swyg met vleuelbedekte oog",
          "Voor wat God daar ontvou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kroon Hom as Vredevors",
          "wat oor ons sal regeer!",
          "Die mensheid wat na vrede dors",
          "ken dan geen oorlog meer.",
          "Uit Sy deurboorde sy",
          "sal enkel heling vloei",
          "en aan Sy voete, ryk en vry,",
          "die skoonste blomme bloei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kroon Hom met majesteit",
          "wat was en kom en is;",
          "Die Koning van die ewigheid",
          "wat oor ons lot beslis!",
          "Heil Jesus, dierb're Heer,",
          "U wat moes sterf vir my!",
          "Aan U kom toe die lof en eer",
          "en eeu'ge heerskappy."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "All hail the power of Jesus' name!",
    "hymnNumber": 126,
    "reference": "AL126",
    "title": "Aanbid Die Here Op Sy Troon!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.5
    },
    "verses": [
      {
        "content": [
          "Aanbid die Here op Sy troon!",
          "Val, eng'le voor Hom neer;",
          "Bring voort 'n koninklike kroon",
          "en kroon Hom kroon Hom aller Heer!",
          "Bring voort 'n koninklike kroon",
          "en kroon Hom kroon Hom aller Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Verkore saad van Abraham,",
          "bring Hom die lof en eer!",
          "Juig, vrygekooptes van die Lam",
          "en kroon Hom kroon Hom aller Heer!",
          "Juig, vrygekooptes van die Lam",
          "en kroon Hom kroon Hom aller Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat elke nasie en geslag",
          "erken dat Hy regeer!",
          "Aanskou Sy majesteit en krag",
          "en kroon Hom kroon Hom aller Heer!",
          "Aanskou Sy majesteit en krag",
          "en kroon Hom kroon Hom aller Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O mag ons met die eng'le saam",
          "aanbiddend Hom vereer!",
          "Bring hulde aan Sy heil'ge Naam",
          "en kroon Hom kroon Hom aller Heer!",
          "Bring hulde aan Sy heil'ge Naam",
          "en kroon Hom kroon Hom aller Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "All hail the power of Jesus' name!",
    "hymnNumber": 127,
    "reference": "AL127",
    "title": "Aanbid Die Here Op Sy Troon!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "Aanbid die Here op Sy troon!",
          "Val, eng'le voor Hom neer;",
          "Bring voort 'n koninklike kroon",
          "en kroon Hom,",
          "kroon Hom,",
          "kroon Hom.",
          "Kroon Hom aller Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Verkore saad van Abraham,",
          "bring Hom die lof en eer!",
          "Juig, vrygekooptes van die Lam",
          "en kroon Hom,",
          "kroon Hom,",
          "kroon Hom.",
          "Kroon Hom aller Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat elke nasie en geslag",
          "erken dat Hy regeer!",
          "Aanskou Sy majesteit en krag",
          "en kroon Hom,",
          "kroon Hom,",
          "kroon Hom.",
          "Kroon Hom aller Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O mag ons met die eng'le saam",
          "aanbiddend Hom vereer!",
          "Bring hulde aan Sy heil'ge Naam",
          "en kroon Hom,",
          "kroon Hom,",
          "kroon Hom.",
          "Kroon Hom aller Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, Thou joy of loving hearts!",
    "hymnNumber": 128,
    "reference": "AL128",
    "title": "O Jesus Wat Die Hart Verheug",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.6
    },
    "verses": [
      {
        "content": [
          "O Jesus wat die hart verheug,",
          "ons bron van lewe, liefde, lig,",
          "ons was verdwaas deur aardse vreug,",
          "maar nou soek ons U aangesig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U waarheid staan vir ewig vas,",
          "U red die drenkeling wat sink;",
          "Vir hul wat soek, dra U die las,",
          "U laat hul van U vreugde drink."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Lewensbrood, vir ons so goed,",
          "o Heilfontein na wie ons smag,",
          "U sal ons met U waarheid voed",
          "en laaf'nis skenk van dag tot dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hoe rust'loos smag ons na die Heer",
          "waar ook die lewe ons mag lei.",
          "U glimlag maak ons vreugde meer",
          "as ons gelowig in U bly."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O Jesus, as U by ons bly,",
          "is elke oomblik kalm en soet,",
          "wil ons van sondemag bevry",
          "en drenk die aarde in U vloed."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, the very thought of Thee",
    "hymnNumber": 129,
    "reference": "AL129",
    "title": "Jesus, O Soet Gedagtenis",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.3
    },
    "verses": [
      {
        "content": [
          "Jesus, o soet gedagtenis,",
          "U vul my gees met lus;",
          "Maar hoeveel soeter sal dit wees",
          "om aan U bors te rus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Geen stem kan sing, geen hart verstaan",
          "geen sterweling kan wens",
          "om ooit 'n soeter naam te noem",
          "voor engel, God of mens."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "o Hoop van die verslae siel",
          "wat hom tot God bekeer,",
          "hoe tederlik rig U hom op",
          "wat val of struikel, Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wie kan die vreugde ooit beskryf",
          "van hom wat Jesus vind?",
          "Hoe groot Gods liefde, weet alleen",
          "Sy teer-beminde kind."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Jesus, dis U wat ek begeer,",
          "U is my saligheid;",
          "in U ontvou my klein bestaan",
          "stil met die ewigheid."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, these eyes have never seen",
    "hymnNumber": 130,
    "reference": "AL130",
    "title": "Jesus, Ek Het U Nooit Aanskou",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.4
    },
    "verses": [
      {
        "content": [
          "Jesus, ek het U nooit aanskou,",
          "my in U glans verbly;",
          "Die sluier van die vlees hang nou",
          "nog tussen U en my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek sien U nie, ek hoor U nie,",
          "tog is U aan my sy.",
          "Geen plek is dierbaarder as die",
          "waar ek U naam bely."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Net soos 'n droom wat my bekoor",
          "in soete sluimering,",
          "stel ek U skone beeld my voor,",
          "hoog bo my skemering."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U is onsigbaar, maar, o Heer,",
          "ek weet dat U bestaan,",
          "want U woon in my hart en leer",
          "my hoe die Godsweg gaan."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, and shall it ever be",
    "hymnNumber": 131,
    "reference": "AL131",
    "title": "Jesus! Hoe Kan Ek My Ooit Skaam?",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Jesus! Hoe kan ek my ooit skaam",
          "vir daardie soete, heil'ge Naam?",
          "My skaam vir Hom, die Opperheer",
          "wat engel aanbiddend eer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My skaam vir Jesus! Dit sy ver!",
          "Trots is die aand op elke ster!",
          "Hy laat die lig van liefde sprei",
          "oor hierdie duister siel van my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My skaam vir Jesus! Laat die nag",
          "dan skaam wees vir die helder dag!",
          "Ja, nag het uit my siel verdwyn",
          "toe U, my Môrester, verskyn."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "My skaam vir Hom, ons Vriend en lus,",
          "op wie ons hoop en toekoms rus!",
          "En as ek bloos dan sal dit wees",
          "om ek Hom nie meer loof en vrees."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "My skaam vir Jesus! Selfs as ek",
          "geen sonde had om te bedek,",
          "geen skandvlek om my oor te skaam",
          "van woord en daad wat nie betaam?"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Ek sal nog in die Heiland roem",
          "wat my voor God en eng'le noem;",
          "Goddank, die Heer wat ek bely,",
          "die Christus, skaam Hom nie vir my!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus Shall Reign",
    "hymnNumber": 132,
    "reference": "AL132",
    "title": "Jesus Sal Heers Waar Ster En Maan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 13.1
    },
    "verses": [
      {
        "content": [
          "Jesus sal heers waar ster en maan",
          "op wye hemelbane gaan;",
          "Sy Woord sal gaan van see tot see,",
          "tot selfs die son geen lig meer gee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Van noord tot suid kom prinse saam",
          "en bring hul hulde aan Sy Naam.",
          "Die jong beskawings wes en noord -",
          "selfs heidendom - erken Sy woord."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons bede sal Hom altyd loof,",
          "ons lofgesange kroon Sy hoof.",
          "Ek loof Sy Naam met hart en mond",
          "vroeg in die stille môrestond."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Mense van elke land en taal",
          "sing van Sy liefde wat nooit faal",
          "en kinderstemme juig tesaam",
          "in vreugde oor Sy soete Naam."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Fairest Lord Jesus",
    "hymnNumber": 133,
    "reference": "AL133",
    "title": "Skoonste Heer Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Skoonste Heer Jesus,",
          "Skepper, Heer en Koning;",
          "O Seun van God en van die mens;",
          "U sal ek liefhê",
          "U sal ek huldig,",
          "U is my vreugde en my kroon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Skoon is die velde,",
          "skoner nog die bosse,",
          "in hulle fris, jong lentegroen;",
          "Jesus is skoner,",
          "Jesus is reiner,",
          "Hy wat bedroefde harte troos."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skoon is die sonskyn,",
          "skoner nog die maanlig",
          "en al die sterre in hul prag!",
          "Jesus skyn skoner,",
          "Jesus skyn reiner,",
          "as al die engele omhoog!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O Thou in whose presence my soul takes delight",
    "hymnNumber": 134,
    "reference": "AL134",
    "title": "In U Is Daar Volheid Van Vreugde En Krag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.1
    },
    "verses": [
      {
        "content": [
          "In U is daar volheid",
          "van vreugde en krag,",
          "en troos in die haglikste lot;",
          "My sterkte bedags en my lied ",
          "in die nag,",
          "my Hoop, my Verlosser, my God!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U stem soos die klank",
          "van die dulsimer soet,",
          "dring deur tot die diep doodsvallei.",
          "Die Libanonseders buig neer ",
          "aan U voet,",
          "en die lug adem vrede vir my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U mond, die fontein",
          "waar geregtigheid vloei,",
          "‘n tuin deur genade begroet,",
          "waaruit al die nasies se redding",
          "sal groei,",
          "gebaai in U glimlag se gloed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U wink, en tienduisende engele ",
          "wag,",
          "miljoene volbring U gebod;",
          "U spreek, en die ewigheid tril",
          "met ontsag",
          "voor U, drie maal heilige God!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "There is a fountain filled with blood",
    "hymnNumber": 135,
    "reference": "AL135",
    "title": "Die Dierb're Heiland Het Sy Bloed",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Die dierb're Heiland het Sy bloed",
          "gepleng om ons te red;",
          "En deur die bloed word ons gemoed",
          "gewas van elke smet. (x3)",
          "En deur die bloed word ons gemoed",
          "gewas van elke smet."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die moordenaar, in sterwensnood,",
          "het hom daaroor verbly,",
          "en ek, net so doemwaardig snood,",
          "word van my skuld bevry. (x3)",
          "en ek, net so doemwaardig snood,",
          "word van my skuld bevry."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U bloed sal immer wonders werk,",
          "met Goddelike krag;",
          "So sal U vrygekoopte kerk",
          "steeds gaan van krag tot krag. (x3)",
          "So sal U vrygekoopte kerk",
          "steeds gaan van krag tot krag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En deur geloof sien ek die vloed",
          "van heil deur U verskaf;",
          "Solank ek leef, loof ek U bloed,",
          "o Heer, tot aan die graf. (x3)",
          "Solank ek leef, loof ek U bloed,",
          "o Heer, tot aan die graf."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "U het vir my 'n plek berei,",
          "‘skoon ek onwaardig is;",
          "Ja, deur U bloed is daar vir my",
          "‘n heil'ge erfenis. (x3)",
          "Ja, deur U bloed is daar vir my",
          "‘n heil'ge erfenis."
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Daar sal my loflied soeter klink",
          "want ek is vry van straf,",
          "as ek, onsterflik, met U volk",
          "ontwaak het uit die graf. (x3)",
          "as ek, onsterflik, met U volk",
          "ontwaak het uit die graf."
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 136,
    "reference": "AL136",
    "title": "Rig U Oog En Hart Na Bowe",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Rig u oog en hart na bowe;",
          "Veel word hier op aard gemis.",
          "Wil u lewe, liefhê, lowe,",
          "gaan dan na waar Jesus is.",
          "Alle aardse skatte faal",
          "om my losprys te betaal -",
          "wil u lewe, liefhê, lowe,",
          "rig u oog en hart na bowe."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons sal saligheid beërwe,",
          "ons sal lewe sonder pyn,",
          "sonder siekte, sonder sterwe,",
          "sondeloos - vir ewig rein;",
          "Lewe in volmaakte deug,",
          "vrome blydskap, hemelsvreug;",
          "Ons sal lewe, liefhê, lowe",
          "in die Vaderhuis daarbowe."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jesus! Bron van hemelvreugde",
          "wat vir elke vrome wag,",
          "U skenk ons in reine deugde",
          "meer as konings ooit vermag.",
          "Maak ons nou, o Heer, bereid",
          "vir die hemelsheerlikheid;",
          "Dan sal ons U ewig lowe!",
          "Jesus, trek ons hart na bowe."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O could I speak the matchless worth",
    "hymnNumber": 137,
    "reference": "AL137",
    "title": "Kon Ek My Heer Se Liefde Loof",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.9
    },
    "verses": [
      {
        "content": [
          "Kon ek my Heer se liefde loof,",
          "die glorie tot die wêreld bring",
          "wat Jesus steeds omring:",
          "tot by die hemel sou ek gaan,",
          "met Gabriël juigend voor God staan",
          "as ons die Lam besing."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sy kosb're bloed en bitter leed,",
          "die losprys vir my sonde skuld,",
          "Sy liefde en geduld -",
          "dit is my lied in ewigheid -",
          "Sy vleklose geregtigheid,",
          "my rein, wit bruilofskleed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Van Sy gesindheid wil ek sing;",
          "Van troue liefde wat ons red",
          "soos Hy belowe het.",
          "O prys Hom dan wat op die troon",
          "verhewe in die hemel woon,",
          "ver bo ons skemering."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ja, weldra breek die skone dag",
          "wanneer my Heiland sal verskyn",
          "op wolke wit en rein;",
          "Dan sien ek Hom in hemellig",
          "van aangesig tot aangesig:",
          "Oorwinnaar deur Sy mag!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Come, let us sing the song of songs",
    "hymnNumber": 138,
    "reference": "AL138",
    "title": "Hef Aan Die Nuwe Heil'ge Lied",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 13.6
    },
    "verses": [
      {
        "content": [
          "Hef aan die nuwe, heil'ge lied",
          "wat hemelwesens met ontsag",
          "aan Christus, ons Verlosser bied:",
          "Waardig die Lam vir ons geslag!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Juig, vrygekooptes van die Heer,",
          "Sy bloed verbreek die sondemag",
          "en maak ons priesters tot Sy eer:",
          "Waardig die Lam vir ons geslag!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sy siel het Jesus uitgegiet",
          "as offer vir ons siel, en wag",
          "om my Sy volheid aan te bied:",
          "Waardig die Lam vir ons geslag!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Aan Hom, Seun van Gods majesteit,",
          "kom toe die rykdom en die krag;",
          "Die lof en eer en heerlikheid:",
          "Waardig die Lam vir ons geslag!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Met hierdie nuwe lied vereer ons U",
          "ons hele lewensdag,",
          "totdat ons eens met U regeer:",
          "Waardig die Lam vir ons geslag!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "O for a thousand tongues, to sing",
    "hymnNumber": 139,
    "reference": "AL139",
    "title": "Kon Ek In Duisend Tale Sing",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.5
    },
    "verses": [
      {
        "content": [
          "Kon ek in duisend tale sing,",
          "sou ek God loof en prys;",
          "Die lof en glorie tot Hom bring",
          "vir elke guns bewys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O Grote Vader, help my om",
          "U boodskap uit te saai",
          "soos verre winde oor die see",
          "tot alle volke waai."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jesus! Die Naam wat vrede bied,",
          "wat vreugde bring uit smart!",
          "O soetste klank in elke lied",
          "vir my verslae hart!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die Heiland breek die sondemag",
          "en maak my waarlik vry;",
          "Sy bloed se wonderbare krag",
          "verlos en reinig my."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Hy laat die sondeblindes sien,",
          "Sy stem laat ons weer hoor;",
          "Gebroke harte kom Hom dien",
          "en neig tot Hom die oor."
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "O dowes, hoor, en stommes, prys",
          "Hom wat die lewe bring.",
          "O blindes, kyk die Heer verrys,",
          "kom, o verlamdes, spring!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "Praise Him! praise Him! Jesus, our blessed Redeemer!",
    "hymnNumber": 140,
    "reference": "AL140",
    "title": "Loof Hom! Loof Hom!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 33.6,
      "intro": 33.6
    },
    "verses": [
      {
        "content": [
          "Loof Hom! Loof Hom!",
          "Jesus die grote Verlosser!",
          "Sing, o volke,",
          "sing van Sy liefde saam!",
          "Juig Hom toe,",
          "o hoogste aartseng'le daarbowe,",
          "gee Hom eer,",
          "verheerlik Sy grote Naam.",
          "Soos 'n herder waak Hy oor al Sy kinders",
          "met Sy hand beskut Hy hul elke dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Loof Hom! Loof Hom!",
          "Jesus die grote Verlosser!",
          "Vir ons sondes het Hy Sy troon ontbeer.",
          "Hy ons Rots, ons hoop",
          "en ons enigste redding -",
          "juig Hom toe, want Hy het getriomfeer!",
          "Bring Hom hulde,",
          "Jesus die Man van smarte,",
          "liefde peilloos,",
          "wonderbaar, skoon en sterk."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Loof Hom! Loof Hom!",
          "Jesus die grote Verlosser!",
          "Laat hosannas Hom in Sy poorte eer.",
          "Jesus, Heiland,",
          "heers as ons ewige Koning,",
          "kroon Hom! Kroon Hom!",
          "Priester, Profeet en Heer!",
          "Christus kom weer,",
          "kom na ons as Oorwinnaar,",
          "eng'leskare sal Hom met prag omring."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Loof Hom! Loof Hom!",
      "Spreek van Sy heerlike grootheid;",
      "Loof Hom! Loof Hom!",
      "Ewig met vreugdesang."
    ]
  },
  {
    "english": "Majestic sweetness sits enthroned",
    "hymnNumber": 141,
    "reference": "AL141",
    "title": "Vol Liefde Is Die Majesteit",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.1
    },
    "verses": [
      {
        "content": [
          "Vol liefde is die Majesteit",
          "wat op Sy voorhoof troon;",
          "Sy woord is goedertierenheid",
          "en lig Sy gloriekroon!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Geen sterfling wat op aarde woon,",
          "kan met Hom vergelyk;",
          "Geen heil'ge engel is so skoon",
          "in gindse hemelryk!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Toe ek in wanhoop wou beswyk,",
          "deur sondelas gepla,",
          "het Hy my bitter kruis gekies",
          "en al my smart gedra!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "My lewe het in Hom begin,",
          "vir my is Hy gestraf;",
          "In my het Hy die dood oorwin -",
          "Hy red my van die graf!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Na wonings vir my voorberei",
          "rig U my skrede, Heer,",
          "en toon U heerlikheid aan my -",
          "wat kan ek nog begeer?"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Want van Sy rykdom skenk Hy my",
          "die liefde van Sy Woord.",
          "Had ek 'n duisend harte, Heer,",
          "hul sou U toebehoort!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "O Saviour, precious Saviour",
    "hymnNumber": 142,
    "reference": "AL142",
    "title": "O Heiland, Dierb're Heiland",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "O Heiland, dierb're Heiland,",
          "hoe lieflik is U Naam!",
          "Onsigbaar, tog naby, want",
          "U wandel met ons saam.",
          "Ons seën en aanbid U,",
          "en sing steeds tot U eer;",
          "Ons loof U en bely U,",
          "want heilig is ons Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "o Brenger van verlossing,",
          "Bewerker van ons heil,",
          "U self die openbaring",
          "van liefde sonder peil;",
          "Ons seën en aanbid U,",
          "en sing steeds tot U eer;",
          "Ons loof U en bely U,",
          "want liefd'ryk is ons Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In U woon al die volheid",
          "van Goddelike krag,",
          "en heerlikheid en hoogheid,",
          "en al die skeppingsmag!",
          "Ons seën en aanbid U,",
          "en sing steeds tot U eer;",
          "Ons loof U en bely U,",
          "want magtig is ons Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O skenk ons die vervulling",
          "hiernamaals van ons lied.",
          "In eind'lose aanbidding",
          "wil ons U liefde bied.",
          "Ons seën en aanbid U,",
          "en sing steeds tot U eer;",
          "Ons loof U en bely U,",
          "ons Redder en ons Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Ye servants of God, your Master proclaim",
    "hymnNumber": 143,
    "reference": "AL143",
    "title": "O Knegte Van God, Verkondig Sy Naam",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "O knegte van God, ",
          "verkondig Sy Naam,",
          "ja maak dit bekend, ",
          "en prys Hom tesaam;",
          "Verheerlik die Heiland, ",
          "aanbid onse Heer",
          "die grote Oorwinnaar ",
          "wat oor ons regeer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Here regeer ",
          "met wysheid en krag,",
          "maar tog is Hy hier, ",
          "Hy red die wat wag;",
          "Laat elke gemeente ",
          "Sy sege besing,",
          "aan Hom as Verlosser ",
          "hul dankoffer bring"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heil aan onse God ",
          "wat sit op die troon",
          "laat almal Hom eer ",
          "en hulde betoon.",
          "Die engele val op ",
          "hul aangesig neer",
          "in diepe aanbidding ",
          "voor Jesus, hul Heer"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom laat ons aanbid,",
          "want Hy voer gesag",
          "oor hemel en aard' ",
          "in wysheid en krag.",
          "Laat ons saam met eng'le",
          "Hom hulde betoon;",
          "Sy liefde is ewig, ",
          "Sy heerlikheid skoon."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "To God be the glory, great things He hath done",
    "hymnNumber": 144,
    "reference": "AL144",
    "title": "Bring Eer Aan Die Here",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 26,
      "intro": 39.1
    },
    "verses": [
      {
        "content": [
          "Bring eer aan die Here, ",
          "ons Redder en steun;",
          "Uit liefde vir sondaars ",
          "gee Hy ons Sy Seun;",
          "Hy offer Sy lewe, ",
          "daal neer tot die dood,",
          "en maak self die kerker ",
          "se poorte wyd oop."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Volmaakte verlossing ",
          "deur Jesus se bloed,",
          "dit is die belofte ",
          "so lieflik en soet.",
          "Die laagste oortreder ",
          "wat glo in die Heer,",
          "word spoedig van sondige ",
          "weë bekeer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sy woorde was magtig, ",
          "Sy dade was groot;",
          "Sy naam gee ons lewe ",
          "en daaglikse brood;",
          "Maar skoner en blyer ",
          "en groter die dag",
          "wanneer ons die Here ",
          "aanskou in Sy prag!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Loof die Heer, loof die Heer, ",
      "wat die sondaars bevry!",
      "Loof die Heer, loof die Heer! ",
      "Laat Sy volk hul verbly.",
      "O kom tot die Vader in Jesus se Naam,",
      "en bring Hom die ere, ",
      "want Hy neem ons aan."
    ]
  },
  {
    "english": "Worthy, worthy is the Lamb",
    "hymnNumber": 145,
    "reference": "AL145",
    "title": "Waardig, Waardig Is Die Lam!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Waardig, waardig is die Lam!",
          "Waardig, waardig is die Lam!",
          "Waardig, waardig is die rein",
          "Offerlam!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heiland, wil U koms verhaas,",
          "breek die bose sondemag;",
          "Lui die duisend jaar nou in,",
          "Heil'ge Lam!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat ons Hom in liefde dien,",
          "en Hom loof tot ons Hom sien",
          "op die kruin van Sion staan,",
          "Lam van God!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ere, Halleluja!",
      "Loof Hom, Halleluja!",
      "Ere, Halleluja!",
      "Aan die Lam!"
    ]
  },
  {
    "english": "Come, Holy Spirit, heavenly Dove",
    "hymnNumber": 146,
    "reference": "AL146",
    "title": "Heilige Gees, Kom Sweef Oor Ons",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.4
    },
    "verses": [
      {
        "content": [
          "Heilige Gees, kom sweef oor ons,",
          "Hemelse Duif, daal neer;",
          "Laat in ons hart U liefde brand",
          "en trek ons tot die Heer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Red ons van dwase eiewaan",
          "en aardse ydelheid,",
          "dan sal ons met hernieude moed",
          "volhard in hierdie stryd."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Stem U ons harte om te sing",
          "van onse God en Heer,",
          "dan hef ons saam 'n danklied aan",
          "en twyfel nimmermeer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vader, ons wil nie langer leef",
          "in duisternis en leed;",
          "Ons gee aan U ons hele hart,",
          "U sal ons nooit vergeet."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Heilige Gees, kom sweef oor ons,",
          "Hemelse Duif, daal neer!",
          "Blaas hoog die liefde in ons hart",
          "met U groot liefde, Heer!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Holy Spirit, light divine",
    "hymnNumber": 147,
    "reference": "AL147",
    "title": "Heil'ge Gees, O God'lik Lig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Heil'ge Gees, o God'lik Lig,",
          "skyn U oor my aangesig,",
          "laat die skadu's van my nag",
          "wegvlug voor U nuwe dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heil'ge Gees, o God'lik krag,",
          "reinig U my hart vandag",
          "van die sonde wat daar woon,",
          "maak my lewe rein en skoon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heil'ge Gees, o Vreugde rein,",
          "stil U in my hart die pyn;",
          "Neem van my die dood se smart,",
          "heel U my gewonde hart."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gees van God, kom in my woon,",
          "duld geen afgod op U troon;",
          "Kom, o Heiland, en regeer",
          "in my hart as God en Heer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Holy Spirit, faithful Guide",
    "hymnNumber": 148,
    "reference": "AL148",
    "title": "Heil'ge Gees Van God, O Lei",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 33.1
    },
    "verses": [
      {
        "content": [
          "Heil'ge Gees van God,",
          "o lei my deur hierdie woesteny;",
          "Troue Gids, neem U my hand",
          "deur die dorre vyandsland.",
          "Moeë siele skep weer moed",
          "as U saggies, wondersoet",
          "fluister deur die aardsgedruis:",
          "Volg my na die Vaderhuis."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heil'ge, wonderbare Vriend,",
          "Hemelgawe, onverdiend,",
          "enkel U kan ons behoed",
          "as die storme om ons woed!",
          "Laat, o laat ons nie alleen",
          "as dit nag word om ons heen!",
          "Fluister dan: Neem op jou kruis,",
          "volg My na die Vaderhuis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Aan die einde van die baan,",
          "met ons taak hier afgedaan,",
          "sal U hand ons veilig lei",
          "deur die kille doodsvallei;",
          "Neem vertwyfeling en vrees",
          "van my weg, o Heil'ge Gees,",
          "fluister as die doodsvloed bruis:",
          "Volg my na die Vaderhuis."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O for that flame of living fire",
    "hymnNumber": 149,
    "reference": "AL149",
    "title": "O Mag In Ons Die Heil'ge Vuur",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "O mag in ons die heil'ge vuur",
          "weer, soos van ouds, ",
          "ontbrand met krag,",
          "dat ons verdrukking mag verduur",
          "en op die Heer in kalmte wag!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waar is die gees ",
          "wat Abraham",
          "besiel het tot sy offerdaad?",
          "Die ywer wat in Paulus vlam,",
          "tot alles vir sy God in staat?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die Gees wat deur die Psalme ",
          "straal",
          "en die profete inspireer,",
          "wat in die allerskoonste taal",
          "U sondaarsliefde loof, o Heer?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kan U genade nog vandag,",
          "soos deur Elia, wonders doen?",
          "Soos Moses, ons versterk met ",
          "krag?",
          "Soos Job, ons met ons lot versoen?"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Laat Heer, soos in die vroeë tyd,",
          "U krag weer sigbaar ",
          "met ons wees;",
          "Sterk ons vir onse worstelstryd,",
          "stort op ons uit U Heil'ge Gees."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Breathe on me, Breath of God",
    "hymnNumber": 150,
    "reference": "AL150",
    "title": "Vul My, O Gees Van God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.7
    },
    "verses": [
      {
        "content": [
          "Vul my, o Gees van God,",
          "vul my met lewe weer.",
          "Dat ek mag min wat U bemin",
          "en doen wat U begeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Vul my, o Gees van God,",
          "en maak my lewe rein.",
          "Tot my wil een met U wil is",
          "en self in my verdwyn."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vul my, o Gees van God,",
          "vul my in hierdie uur;",
          "Vul my tot hierdie aardse klei",
          "sal gloei met God'lik vuur!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vul my, o Gees van God,",
          "tot liefdesdiens bereid -",
          "Dat ek volmaak voor U kan leef",
          "in alle ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, I hear of showers of blessing",
    "hymnNumber": 151,
    "reference": "AL151",
    "title": "Heer, Ek Hoor Van Seënstrome",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Heer, ek hoor van seënstrome",
          "wat U uitstort, ryk en vry.",
          "Les dan ook my dors volkome,",
          "stort die druppels ook op my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gaan my nie verby, o Vader,",
          "ek het al my skuld bely;",
          "Trek my deur U liefde nader -",
          "Heer, ontferm U ook oor my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Was ek dood in bose sonde?",
          "Skenk herlewing ook aan my.",
          "Is 'k deur ydelheid gebonde?",
          "O, ek smeek U, maak my vry!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Heil'ge Gees, o hoor my klagte,",
          "U kan blindes ook genees!",
          "Spreek tot my in bange nagte,",
          "laat U vrede oor my wees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ook op my, ook op my,",
      "stort die druppels ook op my."
    ]
  },
  {
    "english": "Hover o'er me, Holy Spirit",
    "hymnNumber": 152,
    "reference": "AL152",
    "title": "Gees Van God Word Vaardig Oor My",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22,
      "intro": 33.1
    },
    "verses": [
      {
        "content": [
          "Gees van God, word vaardig oor my,",
          "laaf my met U hemeldou;",
          "Maak in my U tempelwoning,",
          "kom, o kom en vul my nou!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U kan my vervul, o Trooster,",
          "skoon ek U nie mag aanskou;",
          "Ek begryp nie hoe U kom nie,",
          "nogtans smeek ek: vul my nou!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer, in swakheid, vol gebreke",
          "kniel ek hier in diep berou;",
          "Laat U Gees my nou vernuwe,",
          "vul met liefde, vul my nou!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Reinig my en red my, Heiland,",
          "laaf my met U hemeldou!",
          "Ja, U troos my en verlos my!",
          "Ek ervaar U werking nou!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Vul my nou, vul my nou,",
      "Jesus kom, en vul my nou;",
      "Maak in my U tempelwoning,",
      "kom, o kom en vul my nou!"
    ]
  },
  {
    "english": "'There shall be showers of blessing;'",
    "hymnNumber": 153,
    "reference": "AL153",
    "title": "Stortreëns Van Seën Sal Neerdaal",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.2,
      "intro": 25.9
    },
    "verses": [
      {
        "content": [
          "Stortreëns van seën sal neerdaal -",
          "dit is beloof aan die land -",
          "heerlike tyd van verkwikking",
          "kom uit die Vader se hand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Stortreëns van seën sal neerdaal -",
          "heerlik verfrissend van Hom -",
          "hoor hoe die lieflike ruising",
          "nader, steeds naderby kom!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Stortreëns van seën sal neerdaal;",
          "stuur hulle oor ons, o Heer!",
          "Skenk die verkwikkende buie,",
          "wil U belofte vereer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Stortreëns van seën sal neerdaal;",
          "mag dit vandag nog gebeur!",
          "Ons roep tot U om 'n seën;",
          "stel ons, o Heer, nie teleur!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Stortreëns van seën,",
      "stortreëns van seën daal neer;",
      "Druppels val nou al genadig,",
      "skenk ons die stortreëns, o Heer!"
    ]
  },
  {
    "english": "O, spread the tidings round",
    "hymnNumber": 154,
    "reference": "AL154",
    "title": "O Laat Die Tyding Gaan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "O laat die tyding gaan",
          "net waar 'n volk bestaan,",
          "waar haat en stryd gedy",
          "in elke stad en laan.",
          "Laat elke mensehart",
          "die Woord van God verstaan;",
          "Die Trooster het gekom!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die nag is haas verby,",
          "die more kom so bly;",
          "Na donker nag van stryd",
          "sal ons weer vrede kry.",
          "Die dag kom vinnig aan",
          "oor berg en rant en vlei;",
          "Die Trooster het gekom!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O liefde eindeloos!",
          "Hoe sal ek swak en broos,",
          "aan sterflinge vertel",
          "dat Hy hul kan vertroos -",
          "dat Hy deur my moet skyn",
          "so skoon en vlekkeloos?",
          "Die Trooster het gekom!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sing tot die eggo's gaan",
          "deur elke hemelbaan -",
          "totdat 'n antwoord klink",
          "van sterre, son en maan.",
          "Die boodskap van die lied",
          "sal eindeloos bestaan;",
          "Die Trooster het gekom!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Baptize us anew",
    "hymnNumber": 155,
    "reference": "AL155",
    "title": "Heer, Doop Ons Opnuut",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": true,
    "timestamps": {
      "chorus": 12.9,
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "Heer, doop ons opnuut",
          "met krag van U troon;",
          "Verkwik ons met liefde,",
          "o Heiland, so skoon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Onwaardig is ons,",
          "onheilig, onrein;",
          "O was ons dat sonde",
          "se smette verdwyn."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Heilige Gees",
          "daal nou op ons neer;",
          "Ons bid om U seën",
          "Genadige Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O hoor tog die stem",
          "wat kom van die troon;",
          "U is my geliefde,",
          "in U wil ek woon."
        ],
        "verseNumber": 4,
        "chorus": [
          "Ons lowe en prys U,",
          "o Lam van die kruis,",
          "ons bring U die ere.",
          "Amen en Amen."
        ]
      }
    ],
    "chorus": [
      "Ons smeek U so need'rig,",
      "Heer Jesus, ons smag,",
      "met Gees en met liefde,",
      "o, doop ons vandag."
    ]
  },
  {
    "english": "Our blest Redeemer, ere He breathed",
    "hymnNumber": 156,
    "reference": "AL156",
    "title": "Die Heer Het In Sy Afskeidsuur",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.6
    },
    "verses": [
      {
        "content": [
          "Die Heer het in Sy afskeidsuur",
          "aan ons beloof dat Hy",
          "die Trooster as ons gids sou stuur",
          "om ons te lei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is Sy invloed wat ons trek",
          "tot God, en ons bekeer;",
          "Wat in ons siele liefde wek",
          "vir onse Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sy soete stem kalmeer die gees,",
          "vermaan ons liefd'ryk sag;",
          "Hy maak ons vry van dwase vrees",
          "en skenk ons krag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ja, elke deug wat ons besit,",
          "die blydskap en die vree,",
          "die heiligheid waarom ons bid -",
          "deel Hy ons mee."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "o Gees van reinheid en gena,",
          "werk onvermoeid in my",
          "tot ek die Heer se beelt'nis dra,",
          "en word soos Hy."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Revive Us Again",
    "hymnNumber": 157,
    "reference": "AL157",
    "title": "Ons Loof U, O God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 11.9,
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Ons loof U, o God,",
          "vir die Seun van U hart,",
          "vir Jesus, gekruisig,",
          "gepynig in smart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons loof U, o God,",
          "vir U Gees met Sy lig,",
          "wat ons Jesus getoon het",
          "en duister laat swig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gee lof aan die Lam",
          "wat ons sondes moes dra,",
          "en in ons plek moes sterf",
          "deur Sy grote gena."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Verfris ons opnuut;",
          "Laat U lieflike Gees",
          "ons besiel met 'n ywer",
          "wat ewig sal wees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Halleluja, U die ere,",
      "Halleluja, amen!",
      "Halleluja, U die ere,",
      "besiel ons nou weer."
    ]
  },
  {
    "english": "Break Thou the bread of life",
    "hymnNumber": 158,
    "reference": "AL158",
    "title": "Breek U Die Lewensbrood",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Breek U die Lewensbrood",
          "vir my, o Heer,",
          "soos vir die menigte",
          "eens by die meer;",
          "Spreek uit die Heil'ge Skrif",
          "tot my met krag,",
          "Lewende Woord van God,",
          "na wie ek smag!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Seën die waarheid wat",
          "U openbaar,",
          "net soos die voedsel aan",
          "die honger skaar.",
          "Met elke band verbreek",
          "staan ek dan vry",
          "en word U beeld, o Heer,",
          "volmaak in my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heiland, U woorde is",
          "Lewe en gees;",
          "Spreek tot my siel terwyl",
          "ek biddend lees.",
          "O Lewensbrood, U kan",
          "my honger stil,",
          "spysig my siel nou met",
          "U heil'ge wil."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 159,
    "reference": "AL159",
    "title": "Here, Laat My Tog U Weë",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Here laat my tog U weë",
          "deur U Woord en Gees verstaan.",
          "Maak my voetstap meer geneë",
          "daagliks op die weg te gaan.",
          "Laat my ook U waarheid leer;",
          "Reinig, heilig my gedagte,",
          "want U is my heil, o Heer,",
          "ek is U reeds lank te wagte."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Goedheid, liefde, is die koorde",
          "wat ons lei op weë trou,",
          "as ons net U wet en woorde",
          "suiwer, onbevlek wil hou.",
          "Dikwels het ek voor U, Heer,",
          "sondig en onrein gelewe;",
          "Wil my dan, U Naam ter eer,",
          "al my sondeskuld vergewe."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die geheime van die Here",
          "is vir hulle wat Hom vrees;",
          "Hy gee Sy verbond in ere",
          "dat Sy wil bekend kan wees.",
          "Here, U is krag vir my",
          "as ek voor die bose bewe;",
          "Uit Sy net sal U my lei",
          "sodat ek in U kan lewe."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Unshaken as the sacred hills",
    "hymnNumber": 160,
    "reference": "AL160",
    "title": "Die Siel Wat Op Sy God Vertrou",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Die siel wat op sy God vertrou,",
          "sal vas soos berge staan;",
          "Soos rotse in die woeste storm,",
          "kan hy nooit ondergaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die heuwels van Jerusalem",
          "bewaak die stad so skoon;",
          "Gods arm is rondom die wat vrees",
          "en in Sy liefde woon!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Vader, dink in liefde aan",
          "die diepbeproefde skaar,",
          "wat op U waarheid steeds bly hoop",
          "en U gebod bewaar."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I love the sacred book of God",
    "hymnNumber": 161,
    "reference": "AL161",
    "title": "Heilige Boek Van God",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Heilige Boek van God, U lig",
          "val op my pad en lei my voort.",
          "Skyn in my hart, toon elke plig,",
          "Heilige, wonderbare Woord!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dierbare Boek, U openbaar",
          "die God van liefde wat ek dien;",
          "U Woorde waarsku teen gevaar",
          "en laat my ook Gods vreugde sien."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kosbare Boek, weergaloos rein,",
          "Woord van die allerhoogste God,",
          "waaruit die diepste wysheid skyn,",
          "ewige vreugde en genot."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Heilige Boek wat vrede bring,",
          "en kennis van my dierb're Heer;",
          "Tot my oorlegginge selfs dring",
          "U Woorde deur, en triomfeer."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O hoe bemin ek hierdie Boek!",
          "Geen ander kan my siel vertroos;",
          "Ek sal die Skrifte ondersoek,",
          "daarin is lewe, eindeloos."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Sing them over again to me",
    "hymnNumber": 162,
    "reference": "AL162",
    "title": "Sing, O Sing Weer Die Boodskap Oor",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.5,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Sing, o sing weer die boodskap oor,",
          "lewende Woord van God!",
          "Laat dit telkens my hart bekoor,",
          "lewende Woord van God!",
          "Skone Woord van lewe,",
          "rig my ganse strewe!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Christus bring ons die tyding nou,",
          "lewende Woord van God!",
          "Sondaar, luister, Hy roep tot jou;",
          "Lewende Woord van God!",
          "Gawe van die Vader,",
          "trek ons daagliks nader!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Neem die boodskap net waar jy gaan,",
          "lewende Woord van God!",
          "Bied Sy vryheid en vrede aan;",
          "Lewende Woord van God!",
          "Jesus, hoog verhewe,",
          "Heilig U ons lewe!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Lieflike Woord, lewende Woord,",
      "lieflike Lewenswoord!",
      "Lieflike Woord, lewende Woord,",
      "lieflike Lewenswoord!"
    ]
  },
  {
    "english": "",
    "hymnNumber": 163,
    "reference": "AL163",
    "title": "O Mens, Wat Soek Jy Goud Of Eer",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "O mens, wat soek jy goud of eer",
          "as jy in Jesus en Sy leer",
          "die grootste skat besit op aarde!",
          "Daar is vir jou die saligheid;",
          "Dit rig jou vir die ewigheid",
          "en skenk jou eenmaal eng'lewaarde.",
          "Dit stem jou hart tot ware deug",
          "berei jou siel vir hemelsvreug."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waar vind die mens in sy verdriet",
          "die troos wat Jesus leer Hom bied?",
          "Waar is, in lyding, God Hom nader?",
          "Waar sien Sy oog in skoner lig.",
          "Ook waar die tugtiging nie swig,",
          "die doel van 'n vergewend' Vader?",
          "Waar is Sy eeu'ge saal'ge lot?",
          "Gegrondves op die eer van God."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O sterfling! Wat jou ooit ontgaan,",
          "mag hierdie leer nog voor jou staan",
          "waar jy in angs van dood sal bewe.",
          "Dit is 'n lamp vir elke voet,",
          "die staf wat jou van val behoed,",
          "jou troue gids tot beter lewe.",
          "Daarmee is jy vir elke kring,",
          "in elke stand Gods kwekeling."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Give me the Bible, star of gladness gleaming",
    "hymnNumber": 164,
    "reference": "AL164",
    "title": "Gee My Die Bybel",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Gee my die Bybel,",
          "Ster vol lig en luister,",
          "vir eensaam' swerwers",
          "op hul pelgrimsreis;",
          "Geen storm kan daardie ",
          "ster se lig verduister,",
          "want Jesus self het ",
          "uit die graf verrys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gee my die Bybel ",
          "in my donker droefheid,",
          "as leed en pyn my ",
          "hart vervul met vrees;",
          "Gee my die boodskap ",
          "in sy volle skoonheid,",
          "leer my U weë ",
          "deur die Heil'ge Gees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gee my die Bybel, ",
          "gids vir al my skrede,",
          "lamp vir my voet en ",
          "lig hier op my pad;",
          "In stryd en duisternis ",
          "vind ek nog vrede -",
          "die pad lei eens ",
          "tot in die Hemelstad."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gee my die Bybel, ",
          "lamp van eeu'ge Lewe,",
          "verhef sy glans nog ",
          "by die ope graf;",
          "Toon my die lig uit ",
          "poorte hoog verhewe,",
          "al lê ek hier die ",
          "aardse lewe af."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Gee my die Bybel, evangelie heilig,",
      "my gids en leidster op die noue pad",
      "voorskrif, belofte rig ons skrede veilig",
      "deur donker nag tot in die hemelstad."
    ]
  },
  {
    "english": "",
    "hymnNumber": 165,
    "reference": "AL165",
    "title": "God Het Ons Sy Woord Gegewe",
    "hasMidi": false,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "God het ons Sy Woord gegewe,",
          "want Sy Woord bly ewig waar.",
          "Niks kan ons hier ooit laat bewe,",
          "selfs al dreig daar doodsgevaar.",
          "Ja, Gods Woord bly ewig waar,",
          "selfs al dreig daar doodsgevaar.",
          "Niks kan ons hier ooit laat bewe;",
          "God het ons Sy Woord gegewe."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Trotse berge sal eens bewe",
          "en die vaste rots vergaan,",
          "maar Sy trou bly hoog verhewe -",
          "Sy verbond bly ewig staan.",
          "Laat die wêreld self vergaan;",
          "God se trou bly ewig staan!",
          "Wat ooit wankel, val of bewe",
          "Sy verbond bly hoog verhewe."
        ],
        "verseNumber": 2
      }
    ],
    "chorus": null
  },
  {
    "english": "O Word of God Incarnate",
    "hymnNumber": 166,
    "reference": "AL166",
    "title": "O Woord Van God, Vol Wysheid",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "o Woord van God, vol wysheid,",
          "onpeilbaar diep en rein;",
          "O waarheid wat die wêreld",
          "met hemellig beskyn;",
          "O Lamp vir onse voete,",
          "wat nooit verdof of faal,",
          "en reeds deur lange eeue",
          "die weg met lig bestraal!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons dank God vir die gawe",
          "wat ons van Hom ontvang:",
          "die Lig waarna die mensdom",
          "so vuriglik verlang,",
          "skyn uit die Boek der boeke;",
          "Kom uit die Vader voort",
          "in menslike gestalte",
          "as vleesgeworde Woord!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Soos 'n banier wat wapper",
          "sal daardie Woord ons lei;",
          "‘n vuur hoog op 'n heuwel",
          "kan nie verborge bly.",
          "Die lig sal moeë pelgrims",
          "beveilig in gevaar,",
          "en lei totdat die lewe",
          "se storms eenmaal bedaar."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Maak van U kerk op aarde",
          "‘n lamp wat helder brand,",
          "en lig bring aan die nasies,",
          "o Heer, in elke land;",
          "Totdat U evangelie",
          "die ganse aarde dek,",
          "en ons voor U, o Christus,",
          "verskyn sonder gebrek."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "While Jesus whispers to you",
    "hymnNumber": 167,
    "reference": "AL167",
    "title": "Wyl Jesus Saggies Fluister",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.1
    },
    "verses": [
      {
        "content": [
          "Wyl Jesus saggies fluister,",
          "Kom, sondaar, kom!",
          "Wyl ons hier bid, o luister,",
          "Kom, sondaar, kom!",
          "Dit is jou beste tyd nou,",
          "Kom, sondaar, kom!",
          "Nou is die tyd, Hy roep jou:",
          "Kom, sondaar, kom!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Beswyk jy onder sonde?",
          "Kom, sondaar, kom!",
          "Die Heer genees jou wonde;",
          "Kom, sondaar, kom!",
          "Jesus verlaat jou nimmer,",
          "Kom, sondaar, kom!",
          "By Hom is redding immer;",
          "Kom, sondaar, kom!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O hoor hoe dringend pleit Hy:",
          "Kom, sondaar, kom!",
          "Hy seën, nooit verwyt Hy;",
          "Kom, sondaar, kom!",
          "Wyl Jesus tot jou fluister,",
          "Kom, sondaar, kom!",
          "Wyl ons hier bid, o luister;",
          "Kom, sondaar, kom!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus is tenderly calling thee home",
    "hymnNumber": 168,
    "reference": "AL168",
    "title": "Jesus Roep Ons Na Sy Lieflike Rus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.2,
      "intro": 25.9
    },
    "verses": [
      {
        "content": [
          "Jesus roep ons na Sy lieflike rus -",
          "Hy roep vandag, Hy roep met krag;",
          "Waarom so ver ",
          "van die sonnige kus -",
          "Ver in die donkere nag?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus roep al die vermoeides na Hom -",
          "Hy roep vandag, Hy roep met krag;",
          "Bring Hom jou laste, ",
          "Hy seën jou - kom!",
          "Hy sal geen sondaar verag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jesus verwag jou, o kom tot Hom nou -",
          "Hy wag vandag, Hy wag vandag;",
          "Kniel aan Sy voete ",
          "met ware berou -",
          "Kom, moet geen oomblik meer wag!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Jesus pleit dringend, o luister verheug",
          "Hy pleit vandag, Hy pleit met krag.",
          "Die wat Hom aanneem ",
          "vervul Hy met vreug",
          "kom en gehoorsaam vandag!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Jesus roep nou, Jesus roep nou;",
      "Jesus roep saggies, roep tederlik,",
      "saggies na jou."
    ]
  },
  {
    "english": "Softly and tenderly Jesus is calling",
    "hymnNumber": 169,
    "reference": "AL169",
    "title": "Sag En Vol Teerheid Is Jesus Se Roepstem",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 26.7,
      "intro": 41
    },
    "verses": [
      {
        "content": [
          "Sag en vol teerheid is Jesus",
          "se roepstem;",
          "Hy roep tot jou en tot my -",
          "Voor die deur staan Hy al kloppend",
          "en wagtend,",
          "Hy wag op jou en op my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waarom vertoef ons?",
          "Hoor Jesus se pleitstem;",
          "Hy pleit met jou en met my.",
          "Waarom nog aarsel? Hy bied ons",
          "Sy redding -",
          "Redding vir jou en vir my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Eens gaan die son van ons lewens",
          "hier onder;",
          "Wat wag vir jou en vir my?",
          "Skadu's rek langer en nag kom",
          "al nader -",
          "Duister vir jou en vir my."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dink aan die liefde wat Hy ons",
          "beloof het,",
          "liefde vir jou en vir my;",
          "Al is ons sondes soos purper,",
          "Hy reinig,",
          "reinig vir jou en vir my."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Kom tuis, kom nou,",
      "Jy wat so moeg is, kom tuis.",
      "Pleitend vol liefde is Jesus se roepstem",
      "“Kom tot My, sondaar, kom nou!'"
    ]
  },
  {
    "english": "I heard the voice of Jesus say",
    "hymnNumber": 170,
    "reference": "AL170",
    "title": "Ek Het Gehoor Dat Jesus Sê",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 26.6
    },
    "verses": [
      {
        "content": [
          "Ek het gehoor dat Jesus sê:",
          "'o Kom na My en rus;",
          "Leun aan My bors, vermoeide siel,",
          "daar word My juk jou lus'.",
          "Ek het gegaan net soos ek was -",
          "bedroef, terneergedruk;",
          "In Jesus het ek rus gevind,",
          "en hemelse geluk."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het gehoor dat Jesus sê:",
          "“Kom, dorstige, na My;",
          "Die water van die lewe",
          "gee Ek aan jou, ryk en vry'.",
          "Ek het gegaan en diep gedrink",
          "uit daardie Heilfontein;",
          "My dors is nou in Hom geles,",
          "my hart vernieu en rein."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek het gehoor dat Jesus sê:",
          "“In My alleen is lig;",
          "O siel wat in die donker sit,",
          "aanskou My aangesig'.",
          "Ek het gekyk en my verheug",
          "in Hom, my Ster, my Son;",
          "En ek sal wandel in die lig",
          "van daardie heil'ge Bron!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I heard the voice of Jesus say",
    "hymnNumber": 171,
    "reference": "AL171",
    "title": "Ek Het Gehoor Dat Jesus Sê",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 27.5
    },
    "verses": [
      {
        "content": [
          "Ek het gehoor dat Jesus sê:",
          "'o Kom na My en rus;",
          "leun aan My bors, vermoeide siel,",
          "daar word My juk jou lus'.",
          "Ek het gegaan net soos ek was -",
          "bedroef, terneergedruk;",
          "In Jesus het ek rus gevind,",
          "en hemelse geluk."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het gehoor dat Jesus sê:",
          "“Kom, dorstige, na My;",
          "Die water van die lewe",
          "gee Ek aan jou, ryk en vry'.",
          "Ek het gegaan en diep gedrink",
          "uit daardie Heilfontein;",
          "My dors is nou in Hom geles,",
          "my hart vernieu en rein."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek het gehoor dat Jesus sê:",
          "“In My alleen is lig;",
          "O siel wat in die donker sit,",
          "aanskou My aangesig'.",
          "Ek het gekyk en my verheug",
          "in Hom, my Ster, my Son;",
          "En ek sal wandel in die lig",
          "van daardie heil'ge Bron!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O tender and sweet was the Father's voice",
    "hymnNumber": 172,
    "reference": "AL172",
    "title": "So Tederlik Sag Was Die Vaderstem",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 29.7
    },
    "verses": [
      {
        "content": [
          "So tederlik sag was die Vaderstem",
          "toe Hy my nog in sonde vind:",
          "“Kom stap oor die lyn,",
          "dit is net maar 'n tree;",
          "Ek wag vir jou, My kind'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "“My sondes is groot,",
          "my geloof so klein!'",
          "dog Sy antwoord kom t'rug met krag:",
          "“Vertrou nie op self of op mense nie;",
          "stap oor die lyn, Ek wag'."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "“Maar my wil is so swak',",
          "het ek uitgeroep,",
          "'hoe sal ek die weg ooit kry?",
          "Ek vrees ek sal dalk 'n mislukking wees,",
          "U Naam daardeur laat ly'."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die weg is te donker ",
          "om t'rug te gaan",
          "ek moet voorwaarts na Jesus spoed;",
          "Nou lê ek my hand in U Vaderhand,",
          "stap oor die lyn vol moed!"
        ],
        "verseNumber": 4,
        "chorus": [
          "Stap oor die lyn, hoor die soet refrein,",
          "lieflike sang uit die hemele rein;",
          "Waarom nog wag",
          "tot die roepstem verdwyn?",
          "Ek stap oor en ek gaan na Jesus"
        ]
      }
    ],
    "chorus": [
      "Stap oor die lyn, hoor die soet refrein,",
      "lieflike sang uit die hemele rein;",
      "Stap oor die lyn",
      "eer die roepstem verdwyn",
      "net 'n tree tussen my en Jesus."
    ]
  },
  {
    "english": "I hear Thy welcome voice",
    "hymnNumber": 173,
    "reference": "AL173",
    "title": "U Stem Dring By My Aan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.4,
      "intro": 28.4
    },
    "verses": [
      {
        "content": [
          "U stem dring by my aan -",
          "so pleitend sag en teer -",
          "om my te reinig in die bloed",
          "van Jesus, onse Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek kom in swakheid, Heer,",
          "tot U wat my kan red;",
          "O reinig my gewete nou",
          "van alle sondesmet."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis Jesus wat my roep",
          "na liefde groot en wyd,",
          "volmaakte vrede en geloof",
          "vir tyd en ewigheid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O heil versoeningsbloed,",
          "vir ons die saligheid!",
          "Heil Jesus, ons getroue Heer",
          "en ons geregtigheid!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Heer, ek kom tot U,",
      "kom tot aan U sy!",
      "Was my in U dierb're bloed,",
      "so ruim gestort vir my!"
    ]
  },
  {
    "english": "I have a Saviour, He's pleading in glory",
    "hymnNumber": 174,
    "reference": "AL174",
    "title": "Ek Het ‘n Voorspraak By God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 25.9,
      "intro": 25.9
    },
    "verses": [
      {
        "content": [
          "Ek het 'n voorspraak ",
          "by God in die hemel -",
          "my dierbare Heiland, ",
          "my Vriend so getrou;",
          "Oor my waak Hy altyd ",
          "so minlik en teder,",
          "maar is hierdie Heiland",
          "ook voorspraak vir jou?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het 'n Vader ",
          "en Hy het belowe",
          "dat ek in Sy huis ",
          "eens 'n woning sal kry",
          "en as Hy my eendag ",
          "kom roep na Sy howe,",
          "wil ek jou, my vriend, ",
          "ook daar hê aan my sy."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek het 'n kleed",
          "wat my Heiland gemaak het,",
          "die Vader bewaar dit ",
          "daarbowe vir my;",
          "En as ek dit neem",
          "uit die hand van my Here,",
          "wil ek sien dat jy ook",
          "‘n feeskleed daar kry."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As Hy jou vind",
          "gaan verkondig die tyding",
          "dat my dierb're Heiland",
          "‘n sondaar kan red;",
          "En bid tot die Vader",
          "vir ander se redding,",
          "want Jesus sal hoor ",
          "as jy roep in gebed."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Vir jou is my bede, ",
      "vir jou is my bede,",
      "vir jou is my bede,",
      "Ek bid steeds vir jou."
    ]
  },
  {
    "english": "Christ is knocking at my sad heart",
    "hymnNumber": 175,
    "reference": "AL175",
    "title": "Christus Klop Aan My Trotse Hart",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.5
    },
    "verses": [
      {
        "content": [
          "Christus klop aan my trotse hart;",
          "Sal ek Hom laat wag?",
          "Hy pleit so mooi met my harde hart:",
          "Sal ek Hom nog laat wag?",
          "Koud en trots is die hart van my,",
          "waar net selfsug en hoogmoed bly;",
          "Christus kan my van sonde bevry;",
          "Sal ek Hom nog laat wag?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sal ek Hom nou my liefde gee,",
          "of moet Hy nog wag?",
          "Sal ek my lewe aan Hom bestee,",
          "of moet Hy langer wag?",
          "Hy bied vriendskap en liefde aan,",
          "Hy wil my van my skuld ontslaan;",
          "Kan ek Hom uit my lewe laat gaan?",
          "Hoelank moet Hy nog wag?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, ek maak nou die deur wyd oop,",
          "woon in my, o Heer!",
          "Neem nou besit, U het my gekoop;",
          "Ja, woon in my, o Heer!",
          "Liewe Heiland, kom bly by my.",
          "U stel my van my kommer vry;",
          "Ek is veilig as U in my bly,",
          "kom in, o Heer, kom in."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Someone will enter the pearly gate",
    "hymnNumber": 176,
    "reference": "AL176",
    "title": "Iemand Sal Eens Deur Die Poorte Gaan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 25.9
    },
    "verses": [
      {
        "content": [
          "Iemand sal eens deur die poorte gaan;",
          "Salig Hy! Salig Hy!",
          "Daar deur die skoonheid oorweldig staan,",
          "sal ek? Sal jy? Sal ek? Sal jy?",
          "Iemand sal loop op die goue straat,",
          "daar is geen sonde of spoor van kwaad,",
          "daar is net vreugde en feesgewaad!",
          "Sal ek? Sal jy? Sal ek? Sal jy?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Iemand lê spoedig sy kruis hier neer,",
          "salig Hy! Salig Hy!",
          "Daar word hy dan met 'n kroon vereer,",
          "word ek? Word jy? Word ek? Word jy?",
          "Iemand sal Jesus verheerlik sien,",
          "vry van versoeking sal hy Hom dien;",
          "Salige voorreg so onverdien!",
          "Sal ek? Sal jy? Sal ek? Sal jy?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Iemand sal klop, maar helaas te laat!",
          "Is dit ek? Is dit jy?",
          "Smeking en bede sal dan nie baat",
          "vir jou! Vir my! Vir jou! Vir my!",
          "Iemand sal roep tot sy stem verflou,",
          "roep tevergeefs, daar's geen toegang nou",
          "wenende wag in die nag van rou!",
          "Sal ek? Sal jy? Sal ek? Sal jy?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Iemand sal saam met die heil'ges sing,",
          "salig Hy! Salig Hy!",
          "Saam met verlostes Hom ere bring,",
          "sal ek? Sal jy? Sal ek? Sal jy?",
          "Iemand sal met sy bemindes staan,",
          "ewige vreugde wat nooit vergaan!",
          "Veilig woon hy daar met Jesus saam.",
          "Sal ek? Sal jy? Sal ek? Sal jy?"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "There is a gate that stands ajar",
    "hymnNumber": 177,
    "reference": "AL177",
    "title": "Daar Is ‘n Poort Wat Ope Staan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22.7,
      "intro": 34.1
    },
    "verses": [
      {
        "content": [
          "Daar is 'n poort wat ope staan,",
          "en deur my aardse duister,",
          "straal daar, van Golgota vandaan,",
          "die Lewenslig vol luister."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die poort staan oop vir iedereen",
          "wat eerlik soek na grasie;",
          "Vir arm en ryk, vir groot en klein,",
          "in elke stam en nasie."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Beur voorwaarts dan teen spot en hoon",
          "genade sterk U strewe;",
          "Neem op die kruis en wen die kroon -",
          "die kroon van eeu'ge lewe!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dan aan die einde van ons reis",
          "neem ons die kruis nie verder;",
          "Ons ruil dit vir 'n lewenskroon",
          "berei deur onse Herder."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Genade Gods, so wyd en vry,",
      "die poort is oopgelaat vir my!",
      "Vir my, vir my,",
      "is oopgelaat vir my!"
    ]
  },
  {
    "english": "I gave My life for thee",
    "hymnNumber": 178,
    "reference": "AL178",
    "title": "U Het Die Dood Gesterf",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.6
    },
    "verses": [
      {
        "content": [
          "U het die dood gesterf -",
          "U bloed vir my gestort -",
          "dat ek in U kan leef",
          "en eens gereinig word.",
          "Vir my het U U bloed gegee,",
          "wat doen ek nou daarmee?",
          "Vir my het U U bloed gegee,",
          "wat doen ek nou daarmee?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U Vadershemelhuis",
          "en boogomringde troon",
          "verruil U vir 'n kruis",
          "en vir 'n doringkroon.",
          "Vir my laat U die hemel staan,",
          "wat bied ek U tog aan?",
          "Vir my laat U die hemel staan,",
          "wat bied ek U tog aan?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer, U het bloed gesweet,",
          "meer smart en angs verdra",
          "as wat ek ooit sal weet,",
          "of U van my kan vra.",
          "Vir my is U gekruisig, Heer",
          "hoe kan ek U vereer?",
          "Vir my is U gekruisig, Heer,",
          "hoe kan ek U vereer?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "My lewe gee ek, Heer -",
          "my korte lewenspan;",
          "Laat aardse bande breek",
          "en vreug my leed verban.",
          "U het my deur U dood hernieu -",
          "ek gee myself aan U!",
          "U het my deur U dood hernieu -",
          "ek gee myself aan U!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "'Whosoever heareth,' shout, shout the sound!",
    "hymnNumber": 179,
    "reference": "AL179",
    "title": "Jy Wat Dit Gehoor Het",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.7,
      "intro": 29.3
    },
    "verses": [
      {
        "content": [
          "Jy wat dit gehoor het, roep, roep dit pal, ",
          "stuur die evangelie met trompetgeskal; ",
          "maak die woord bekend, oor elke berg en dal, ",
          "enigeen wat hoor, kan kom."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jy wat dit gehoor het, waarom nog wag? ",
          "God neem sondaars aan, o kom tot Hom vandag! ",
          "Jesus is die weg, die Lam vir ons geslag, ",
          "enigeen wat hoor, kan kom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jy wat dit gehoor het, salig is jy; ",
          "jy wat dit gehoor het, moet die stryd volstry; ",
          "Jy wat dit gehoor het, kan die lewe kry, ",
          "enigeen wat hoor, kan kom."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Enigeen wat hoor, enigeen wat hoor, ",
      "stuur die boodskap berge en riviere oor; ",
      "God die Vader nooi die sondaar om te kom, ",
      "enigeen wat hoor, kan kom."
    ]
  },
  {
    "english": "Would You Believe?",
    "hymnNumber": 180,
    "reference": "AL180",
    "title": "As Jy Vanaand Voor Jesus Kon Gaan Staan",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20,
      "intro": 35.3
    },
    "verses": [
      {
        "content": [
          "As jy vanaand voor Jesus",
          "kon gaan staan,",
          "Sy doringkroon en wonde kon aanskou,",
          "die lig kon sien wat uit Sy oë gaan,",
          "en Hom hoor sê:",
          "“My kind, dit was vir jou'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kon jy die smarte van die Heiland meet",
          "op bleke lippe met die boodskap trou,",
          "in spykerwonde en in koue sweet",
          "as jy kon hoor:",
          "“My kind, dit was vir jou!'"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hy fluister tot jou hart:",
          "“Waarom nog wag?'",
          "Waar jy nou sit, staan Jesus aan jou sy",
          "o luister nou, Sy stem is soet en sag",
          "as Hy vertel: “Ek het vir jou gely'."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Sou jy verstaan, sou jy tot Hom gaan",
      "as Hy voor jou kon staan?",
      "Sou jy verstaan, sou jy tot Hom gaan",
      "as Hy voor jou kon staan?"
    ]
  },
  {
    "english": "Calling",
    "hymnNumber": 181,
    "reference": "AL181",
    "title": "Ek Hoor My Heiland Roep My",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Ek hoor my Heiland roep my,",
          "Sy stem is sag en teer;",
          "Voortdurend roep en roep Hy",
          "maar ek verset my weer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek hoor my Heiland roep my",
          "so smekend soet en skoon;",
          "Voortdurend roep en roep Hy:",
          "'mag ek by jou kom woon?'"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek hoor my Heiland roep my",
          "met meegevoel so sag;",
          "Voortdurend roep en roep Hy",
          "dit raak my hart vandag."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Waarom draai ek my weg van Hom -",
      "Die Heer wat my bemin?"
    ]
  },
  {
    "english": "Jesus, the loving Shepherd",
    "hymnNumber": 182,
    "reference": "AL182",
    "title": "Jesus, Die Troue Herder",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 34.5,
      "intro": 43.2
    },
    "verses": [
      {
        "content": [
          "Jesus, die troue Herder,",
          "roep ons om nou te kom.",
          "Hy hou Sy kleine kudde",
          "veilig teen reën en storm.",
          "Kom in jou jong'lingsjare,",
          "kom in die bloei van jeug,",
          "Hy roep ons tot Sy kudde,",
          "daar vind ons ware vreug."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus, die troue Herder,",
          "moes eenmaal sterf vir jou.",
          "Tederlik klink Sy roepstem:",
          "Swerweling, kom tog gou!",
          "Haas jou die vyand is buite,",
          "vlug van sy wrede lis;",
          "Hier is die skape veilig,",
          "hier waar net vrede is."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Waarom nog langer aarsel?",
          "Wolwe wag voor die deur!",
          "Hulle verslind verdwaaldes;",
          "Hulle sal jou verskeur.",
          "Jesus, die troue Herder,",
          "roep wyl die skadu's daal;",
          "Kom na My, voor jul sterwe,",
          "kom na My veil'ge kraal."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Liefdevol, tederlik, saggies roep Hy:",
      "“Swerweling, swerweling, ",
      "kom nou na My;",
      "Ek sal jou siel van die sonde bevry,",
      "Ek is jou Herder en God'."
    ]
  },
  {
    "english": "Almost persuaded now to believe",
    "hymnNumber": 183,
    "reference": "AL183",
    "title": "Byna Beweeg Die Heilige Gees",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 18.3
    },
    "verses": [
      {
        "content": [
          "Byna beweeg die Heilige Gees",
          "my om vandag 'n Christen te wees.",
          "Waarom sê ek in stryd:",
          "'ek is nie nou bereid;",
          "Op 'n gelee'ner tyd",
          "sal ek U roep?'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Byna beweeg Hy my om te kom;",
          "Byna bewoë - ek draai weer om!",
          "Dierbares bid vandag,",
          "eng'le hou digby wag;",
          "Jesus roep teer en sag:",
          "'o, sondaar, kom!'"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Byna beweeg die Gees nou vir my;",
          "Byna beweeg - die tyd snel verby!",
          "Waarom is daar nog stryd?",
          "Daar is geen beter tyd.",
          "Heer, ek is nou bereid,",
          "neem U my aan!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I am coming to the cross",
    "hymnNumber": 184,
    "reference": "AL184",
    "title": "Heer, Ek Kom Nou Tot Die Kruis",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Heer, ek kom nou tot die kruis,",
          "ek is swak en arm en blind;",
          "Ek verlaat selfs haard en huis,",
          "om by U gena te vind."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het lank na U verlang;",
          "Ek het ver van U geleef.",
          "Nou loof ek U in gesang,",
          "want U het my skuld vergeef."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer ek gee myself aan U,",
          "alles wat ek mag begeer -",
          "Siel en liggaam wy ek U,",
          "neem my as U eie, Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Jesus kom! Hy maak my vry",
          "en Hy bring volmaaktheid mee;",
          "Hy herstel Sy beeld in my,",
          "ek wil Hom die ere gee."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Vol vertroue kom ek na ",
      "U, die Lam van Golgota;",
      "Wyl ek need'rig voor U kniel,",
      "red my, Jesus, red my siel."
    ]
  },
  {
    "english": "Jesus, I Come",
    "hymnNumber": 185,
    "reference": "AL185",
    "title": "Uit My Verneed'ring, Lyding En Nag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "Uit my verneed'ring, lyding en nag;",
          "Jesus, ek kom, Jesus, ek kom;",
          "Tot U verlossing, luister en prag;",
          "Jesus ek kom na U.",
          "Uit al my siekte - U kan genees;",
          "Uit my gebrek - hoe ryk sal ek wees;",
          "Uit al my sonde kom ek na U,",
          "Jesus, ek kom na U."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Uit my mislukking, skande, verdriet;",
          "Jesus, ek kom, Jesus, ek kom,",
          "in die triomf wat Golgota bied;",
          "Jesus ek kom na U.",
          "Uit aardse sorge - laste wat druk;",
          "Uit elke storm en in U geluk;",
          "Uit al my nood in jubelgesang;",
          "Jesus, ek kom na U."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Uit al my onrus, hoogmoed en waan;",
          "Jesus, ek kom, Jesus, ek kom.",
          "Ek wil U wil steeds beter verstaan;",
          "Jesus ek kom na U.",
          "Uit my ou self na liefde en lig;",
          "Uit min geloof na heerlike plig;",
          "Opwaarts na bowe, vlieg soos 'n duif;",
          "Jesus, ek kom na U."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Uit al die vrees vir dood en die graf;",
          "Jesus, ek kom, Jesus, ek kom;",
          "In diepe vreug en lig wat ons wag;",
          "Jesus ek kom na U.",
          "Uit elke smart deur lyding en kruis;",
          "In al die vrede wat woon in U huis;",
          "Ewig U heerlik' lig te aanskou;",
          "Jesus, ek kom na U."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I've wandered far away from God",
    "hymnNumber": 186,
    "reference": "AL186",
    "title": "Hoe Ver Van God Het Ek Gedwaal",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.4,
      "intro": 21.4
    },
    "verses": [
      {
        "content": [
          "Hoe ver van God het ek gedwaal,",
          "nou kom ek weer t'rug;",
          "Uit sondenag kom U my haal,",
          "Heer, ek kom nou t'rug."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My jare het ek hier verkwis,",
          "nou kom ek weer t'rug,",
          "met trane van belydenis",
          "Heer, kom ek nou t'rug."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die sonde het my siel gebreek,",
          "nou kom ek weer t'rug;",
          "Skenk my U liefde, Heer, ek smeek,",
          "want ek kom nou t'rug."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Geen ander hoop is daar vir my,",
          "nou kom ek weer t'rug;",
          "As Jesus wat vir my moes ly -",
          "Heer, ek kom nou t'rug."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "My sondes pynig my gemoed;",
          "Nou kom ek weer t'rug.",
          "O, was my rein in Jesus bloed;",
          "Heer, ek kom nou t'rug."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Eenmaal tuis, eenmaal tuis,",
      "wil ek nooit meer dwaal;",
      "Laat my aan U boesem rus,",
      "Heer, ek kom nou tuis."
    ]
  },
  {
    "english": "Pass me not, O gentle Saviour",
    "hymnNumber": 187,
    "reference": "AL187",
    "title": "Gaan My Nie Verby, O Heiland",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Gaan my nie verby, o Heiland,",
          "neig U oor tot my!",
          "Wyl U ander seën, Heiland,",
          "gaan my nie verby!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Voor die troon van U genade,",
          "is ons rus beloof;",
          "As ek daar in ootmoed neerkniel,",
          "sterk tog my geloof!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek vertrou op U verdienste,",
          "smagtend na U lig;",
          "My gebroke gees soek heling",
          "voor U aangesig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U, die bron van my vertroosting,",
          "is my saligheid.",
          "Wie het ek hier buiten Jesus -",
          "of in ewigheid?"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Jesus, Heiland, neig U oor tot my,",
      "wyl U ander seën, Heiland,",
      "gaan my nie verby!"
    ]
  },
  {
    "english": "Chief of sinners though I be",
    "hymnNumber": 188,
    "reference": "AL188",
    "title": "Ek, Vernaamste Sondaarskind",
    "timestamps": {
      "intro": 15.9
    },
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Ek, vernaamste sondaarskind,",
          "kan in Jesus redding vind.",
          "In Sy bloed is saligheid -",
          "lewe tot in ewigheid.",
          "Loot en wynstok leef as een,",
          "so bly ek in Hom alleen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoër as die hemel reik,",
          "aan die ewigheid gelyk,",
          "dieper as die diepste see",
          "is die liefde wat Hy gee;",
          "Liefde wat ook my kon vind,",
          "en vir ewig aan Hom bind."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek vernaamste sondaarskind,",
          "sal in Jesus alles vind;",
          "Hy weet wat my hart begeer -",
          "in my droefheid troos die Heer.",
          "Ek is veilig in Sy mag;",
          "Hy is my verborge krag."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Amazing grace! how sweet the sound",
    "hymnNumber": 189,
    "reference": "AL189",
    "title": "Hoe Wonderbaar Is Gods Gena",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Hoe wonderbaar is Gods gena",
          "aan my, ellendeling!",
          "Die afgedwaalde wat Hy dra,",
          "en by die kudde bring."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Genade het my hart laat vrees",
          "in diepe skuldbesef;",
          "Genade het my ook genees",
          "en liefd'ryk opgehef."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Deur arbeid, droefheid en gevaar",
          "bring Sy genade my;",
          "Ek weet, wat my ook wedervaar,",
          "dat Hy my veilig lei."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "All to Jesus I surrender",
    "hymnNumber": 190,
    "reference": "AL190",
    "title": "Ek Gee Alles Oor Aan Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Ek gee alles oor aan Jesus,",
          "niks behou ek, Heer, vir my;",
          "Hom sal ek vertrou en liefhê,",
          "daagliks in my Here bly."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek gee alles oor aan Jesus,",
          "need'rig kniel ek voor Hom neer.",
          "Ek versaak die aardse vreugde,",
          "neem my, Jesus, neem my, Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek gee alles oor aan Jesus,",
          "laat my tog U eie wees!",
          "Maak my seker van U liefde,",
          "vul my met U Heil'ge Gees."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek gee alles oor aan Jesus,",
          "en ek juig met eng'le saam;",
          "'o, die vreugde van verlossing!",
          "Heerlik, heerlik is Sy Naam!'"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ek gee alles oor, ek gee alles oor;",
      "Ja, aan U, my dierb're Heiland,",
      "gee ek alles oor."
    ]
  },
  {
    "english": "Just as I am, without one plea",
    "hymnNumber": 191,
    "reference": "AL191",
    "title": "Net Soos Ek Is",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "Net soos ek is - geen woord van my -",
          "net dat U, Heer, vir my moes ly,",
          "en dat U bloed my kan bevry -",
          "o Lam van God, ek kom, ek kom!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Net soos ek is - vergeefs probeer",
          "ek om myself te reinig, Heer;",
          "Net soos ek is, ek wag nie meer -",
          "o Lam van God, ek kom, ek kom!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Net soos ek is, gekwel deur vrees,",
          "gebroke, met verslae gees;",
          "Net U alleen kan my genees -",
          "o Lam van God, ek kom, ek kom!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Net soos ek is, ellendig, blind,",
          "kortsigtig, dwaas en aardsgesind,",
          "om redding in my Heer te vind -",
          "o Lam van God, ek kom, ek kom!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Net soos ek is, ontvang U my,",
          "vergewe, reinig en bevry;",
          "Van alles wat my siel kasty -",
          "o Lam van God, ek kom, ek kom!"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Net soos ek is - o liefde teer -",
          "werp elke skeidsmuur voor my neer",
          "maak my U kind, net uwe, Heer -",
          "o Lam van God, ek kom, ek kom!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "Depth of mercy! -can there be",
    "hymnNumber": 192,
    "reference": "AL192",
    "title": "Diepte Van Genade, Heer!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.9
    },
    "verses": [
      {
        "content": [
          "Diepte van genade! Heer,",
          "red U my uit liefde weer?",
          "Kan my God nogeens vergeef?",
          "Mag die grootste sondaar leef?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Lank het ek my Heer bestry,",
          "tergend Sy gebod vermy;",
          "Vir Sy roepstem was ek doof",
          "in my dwase ongeloof!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O, hoe diep is my berou,",
          "wanneer ek die kruis aanskou;",
          "In die droefheid van my siel",
          "kom ek wenend voor U kniel."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Daar staan Jesus nou voor my",
          "met Sy hande uitgesprei;",
          "God is liefde! Waarom tog?",
          "Jesus ween en min my nog."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 193,
    "reference": "AL193",
    "title": "Verlosser, Vriend, O Hoop, O Lus",
    "hasMidi": false,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Verlosser, Vriend, o Hoop, o Lus,",
          "gee ag, o Heer, op hierdie lied",
          "wat ek, 'n sterfling, aan U bied.",
          "‘n Sondaar wat U voete kus-",
          "‘n sondaar, maar gered, o Heer,",
          "en nou geen sondaar meer.",
          "O, neem dit aan!",
          "U laat geen bidder staan.",
          "U hoor in lofgesange",
          "die sondaar se verlange;",
          "O, neem dit aan!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waar is 'n vreug of kalme heil",
          "so salig soos die groot genot?",
          "Dit vloei uit God en keer tot God;",
          "Dit het geen maat, nog perk, nog peil",
          "in Jesus is my saal'ge lot -",
          "Verborge by my God.",
          "Hy is my lus",
          "totdat my stof eens rus.",
          "Ek prys Hom met gesange;",
          "Sy koms is my verlange;",
          "Hy is my lus."
        ],
        "verseNumber": 2
      }
    ],
    "chorus": null
  },
  {
    "english": "I have a song I love to sing",
    "hymnNumber": 194,
    "reference": "AL194",
    "title": "Daar Is ‘n Lied Wat Ek Graag Sing",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.3,
      "intro": 30.5
    },
    "verses": [
      {
        "content": [
          "Daar is 'n lied wat ek graag sing:",
          "Die Heer het my verlos!",
          "Ek sal my Heiland hulde bring,",
          "want Hy het my verlos!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het 'n Christus - danksy God",
          "Hy het my siel verlos!",
          "Om Hom te dien, is my genot,",
          "want Hy het my verlos."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Nou kan my lewe ook getuig",
          "dat Christus my verlos.",
          "My vrees is weg en ek kan juig,",
          "want Hy het my verlos."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "‘n Tuiste is vir my berei -",
          "want ek is ook verlos -",
          "waar ek in ewigheid sal bly,",
          "my siel het Hy verlos."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Die Heer het my verlos!",
      "Die Heer het my verlos!",
      "Ek verheug my in Sy Naam,",
      "want Hy het my verlos.",
      "Ek verheug my in my Heer se Naam."
    ]
  },
  {
    "english": "Redeemed! how I love to proclaim it!",
    "hymnNumber": 195,
    "reference": "AL195",
    "title": "Verlos! O Hoe Lieflik Die Boodskap",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Verlos! O hoe lieflik die boodskap:",
          "verlossing deur Jesus se bloed.",
          "Verlos deur Sy grote genade -",
          "Hy is vir Sy kinders so goed!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Verlos! So gelukkig in Jesus,",
          "kan taal my geluk ooit beskryf!",
          "Ek weet dat die lig van Sy aanskyn",
          "die donker vir altoos verdryf."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek dink aan my dierbare Heiland,",
          "ek loof Hom die hele dag lank;",
          "Ek sing want ek kan nie meer swyg nie",
          "ek bring Hom my liefde as dank."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek weet ek sal eenmaal in skoonheid",
          "die Koning der eeue aanskou;",
          "Wat liefderyk waak oor my skrede -",
          "my vul met 'n lied oor Sy trou."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ek weet in die hemel is krone",
          "waar Jesus ons wonings berei;",
          "En spoedig, met harte volkome,",
          "sal ons daar by Jesus gaan bly."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Verlos, verlos;",
      "Verlossing deur Jesus se bloed.",
      "Verlos, verlos;",
      "Hy is vir Sy kinders so goed!"
    ]
  },
  {
    "english": "We have heard a joyful sound",
    "hymnNumber": 196,
    "reference": "AL196",
    "title": "O Ons Hoor Die Blye Woord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "O ons hoor die blye woord:",
          "Jesus red, Jesus red!",
          "Dra dit nou na elke oord:",
          "Jesus red, Jesus red!",
          "Gaan daarmee na elke land",
          "oor die see van strand tot strand;",
          "Dis Sy opdrag wat ons het:",
          "Jesus red, Jesus red!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Golwe dra dit oor die see:",
          "Jesus red, Jesus red!",
          "Deel aan elke sondaar mee:",
          "Jesus red, Jesus red!",
          "Sing dit, eilande verspreid,",
          "seespelonke eggo wyd,",
          "laat die hele aarde juig:",
          "Jesus red, Jesus red!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sing dit bo die strydgedreun:",
          "Jesus red, Jesus red!",
          "Deur die sterwe van die Seun -",
          "Jesus red, Jesus red!",
          "Sing dit saggies deur die nag",
          "as die siel na vrede smag,",
          "sing oorwinnend oor die graf:",
          "Jesus red, Jesus red!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Winde, laat die boodskap hoor:",
          "Jesus red, Jesus red!",
          "Sing, o nasies, oor en oor:",
          "Jesus red, Jesus red!",
          "Sing verlossing vol en vry,",
          "berge hoog, spelonke diep,",
          "dis oorwinning ook vir my -",
          "Jesus red! Jesus red!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Come, Thou Fount of every blessing",
    "hymnNumber": 197,
    "reference": "AL197",
    "title": "Heil'ge Bron Van Elke Seën",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 26.2
    },
    "verses": [
      {
        "content": [
          "Heil'ge Bron van elke seën,",
          "help my U gena besing!",
          "Liefdestrome sonder einde",
          "laat ons hulde tot U bring.",
          "Leer my om U Naam in ere",
          "hoog bo elke skat te hou;",
          "Wyl die hoop van hemelsvreugde",
          "my vervul met moed en trou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hier plant ek my Ebeneser,",
          "want tot hier het U gelei;",
          "In die Vaderhuis eens veilig",
          "sal ek ewig by U bly.",
          "Ver van God het ek geswerwe,",
          "gans verduister van gemoed,",
          "toe U liefde my gevind het",
          "en versoen het deur U bloed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoeveel is my siel verskuldig",
          "aan U goedheid, elke dag!",
          "Bind my met U liefdebande,",
          "onverbreekbaar en tog sag.",
          "Steeds geneig om, tot my skande,",
          "weg te dwaal van U gebod,",
          "smeek ek, neem my hart, verseël dit",
          "ewig vir U Naam, my God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Look upon Jesus sinless is He",
    "hymnNumber": 198,
    "reference": "AL198",
    "title": "Let Op My Heiland; Vlekloos Is Hy",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 35.9
    },
    "verses": [
      {
        "content": [
          "Let op my Heiland; vlekloos is Hy;",
          "Vader, Hy gee Sy lewe aan my.",
          "Dek my met Jesus, maak my ook rein",
          "tot elke smet van sonde verdwyn."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Diep is die wond deur sonde geslaan;",
          "Ek is bevlek, tot wie sal ek gaan?",
          "O, om te skuil in Jesus, my Heer,",
          "dan vrees ek wet en oordeel nie meer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O, ek begeer vergifnis en vree;",
          "Jesus wil my met reinheid beklee,",
          "Heer, ek aanvaar dit - ek is gereed;",
          "Neem weg my vodde; gee my U kleed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek is versoen deur Jesus se bloed;",
          "En geregverdig - Hy het vergoed.",
          "As ek gehoorsaam, dan heilig Hy,",
          "en met Sy koms verheerlik Hy my."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Dek my met Jesus, maak my ook rein,",
      "tot elke smet van sonde verdwyn.",
      "Reinig my, Heiland, vul my, o Heer,",
      "dan woon die sonde in my nie meer."
    ]
  },
  {
    "english": "",
    "hymnNumber": 199,
    "reference": "AL199",
    "title": "O Heer, Ek Is Verlore",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "O Heer, ek is verlore,",
          "waar sal ek redding vind?",
          "Die sonde het diep spore gelaat",
          "op my, U kind.",
          "O God, hoor my gebede,",
          "aanskou my bitter smart!",
          "Wis uit die swart verlede",
          "en reinig nou my hart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As U in ons die sonde, o Heer,",
          "wil gadeslaan,",
          "sal niemand van U kinders",
          "ooit voor U troon kan staan.",
          "Maar nee - daar is vergewing",
          "deur Jesus bloed gewees;",
          "Daarom word U met bewing",
          "reg kinderlik gevrees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek is Sy koms te wagte,",
          "en ek verlang steeds meer",
          "dat Hy met al Sy magte",
          "moet kom as onse Heer.",
          "My siel, vol angs en sorge,",
          "wag sterker op die Heer",
          "as wagters op die môre -",
          "O kom tog gou, o Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hoop op die Heer gelowig",
          "al is Sy volk in nood;",
          "Verlossing is belowe -",
          "Sy goedheid is so groot.",
          "Hy maak, op hul gebede,",
          "Sy kinders almal vry",
          "van ongeregtighede,",
          "en skenk dit ook aan my."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord Jesus, I long to be perfectly whole",
    "hymnNumber": 200,
    "reference": "AL200",
    "title": "O Heer, Ek Verlang Om U Eie Te Wees",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 27.9,
      "intro": 34.1
    },
    "verses": [
      {
        "content": [
          "O Heer, ek verlang ",
          "om U eie te wees;",
          "Kom leef in my hart",
          "en verdryf al my vrees;",
          "Verbreek elke afgod;",
          "Vul my met U Gees;",
          "O was my en witter",
          "as sneeu sal ek wees."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heer Jesus, sien neer",
          "uit die hemel daarbo,",
          "volmaak U my offer,",
          "o Vader, ek glo",
          "dat U my volkome ",
          "van sonde genees!",
          "O, was my en witter",
          "as sneeu sal ek wees!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In need'righeid smeek ek,",
          "o Heer, om gena;",
          "Ek wag aan U voete,",
          "wat kan ek meer vra?",
          "Ek weet dat U bloed",
          "my van sonde genees;",
          "O was my en witter",
          "as sneeu sal ek wees."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O Here, ek smeek ",
          "U geduldig vandag,",
          "herskep U my hart",
          "wyl ek stil voor U wag;",
          "U bloed sal my reinig",
          "van sonde en vrees;",
          "O was my en witter",
          "as sneeu sal ek wees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Witter as sneeu,",
      "ja, witter as sneeu;",
      "O was my, en witter",
      "as sneeu sal ek wees."
    ]
  },
  {
    "english": "'Tis so sweet to trust in Jesus",
    "hymnNumber": 201,
    "reference": "AL201",
    "title": "Salig Hy Wat Steun Op Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Salig hy wat steun op Jesus,",
          "hy wat glo: so sê die Heer;",
          "Hy wat glo in Sy beloftes,",
          "en die waarheid wat Hy leer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Salig hy wat steun op Jesus,",
          "wat hom op Sy bloed verlaat;",
          "Hy wat sy gemoed laat reinig",
          "van die sonde, nyd en haat."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Salig hy wat steun op Jesus,",
          "van die eie-ek bevry;",
          "Hy wat vrede, vreug en lewe",
          "van sy Heer en Meester kry."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek is bly ek steun op Jesus,",
          "dierb're Heiland, Skepper, Vriend;",
          "En ek weet dat U allenig",
          "my sal bystaan tot die end."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Jesus, Jesus, ek vertrou U,",
      "U's die Rots waarop ek bou;",
      "Jesus, Jesus, dierb're Jesus,",
      "leer my U steeds meer vertrou."
    ]
  },
  {
    "english": "Father, I stretch my hands to Thee",
    "hymnNumber": 202,
    "reference": "AL202",
    "title": "Vader, Tot U Hef Ek My Oog",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 7.9
    },
    "verses": [
      {
        "content": [
          "Vader, tot U hef ek my oog,",
          "U ken my klein bestaan;",
          "Is daar geen hulp by U omhoog,",
          "tot wie sal ek dan gaan?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek glo in Jesus meer en meer,",
          "Sy krag vul my met vuur.",
          "Verlig my vele laste, Heer,",
          "in hierdie laaste uur."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek wil, voleinder van geloof,",
          "U weë beter sien;",
          "Skenk my die krag wat U beloof,",
          "ek wil U beter dien."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U sal my nie alleen laat sterf,",
          "wil U my heil bewerk!",
          "En hier sal ek, ellendig mens,",
          "wag tot U Gees my sterk."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Kon tog my oog U aangesig",
          "net sien: o blye dag!",
          "Roep my tot lewe in U lig",
          "uit hierdie sondenag."
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Ek glo, o Heer, ek glo dit nou",
          "dat U vir my moes ly;",
          "U kosb're bloed sal my behou",
          "en van die dood bevry."
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "O for a faith that will not shrink",
    "hymnNumber": 203,
    "reference": "AL203",
    "title": "O Skenk My Die Geloof",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.3
    },
    "verses": [
      {
        "content": [
          "O skenk my die geloof wat swyg",
          "wanneer U my kasty;",
          "En as gevaar my siel bedreig,",
          "my siel bedreig,",
          "steeds in die Heiland bly. (x2)"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wat nie sal murmureer en sug",
          "oor armoed of gebrek,",
          "maar in die uur van smart sal vlug,",
          "van smart sal vlug,",
          "na onse Hoogvertrek! (x2)"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Jesus, gee my die geloof",
          "wat triomfeer oor vrees;",
          "Dan sal geen storm my kalmte roof,",
          "my kalmte roof,",
          "want ek sal veilig wees. (x2)"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dan sal geen bose lis of strik",
          "my ooit verlei tot kwaad;",
          "Sy woede sal my nie verskrik,",
          "my nie verskrik,",
          "nog sal Sy vleitaal baat. (x2)"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Skenk deur geloof 'n voorsmaak,",
          "Heer, wyl laste ons nog druk,",
          "van vrede wat die hart begeer,",
          "die hart begeer,",
          "en hemelse geluk. (x2)"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "My faith looks up to Thee",
    "hymnNumber": 204,
    "reference": "AL204",
    "title": "Gelowig Kom Ek Na U",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 24.6
    },
    "verses": [
      {
        "content": [
          "Gelowig kom ek na",
          "U, Lam van Golgota;",
          "Dierbare Heer,",
          "verhoor my smeekgebed,",
          "neem weg die sondesmet",
          "wat my verdoem,",
          "en red my, tot U eer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wil U genadiglik",
          "my moeë hart verkwik",
          "met nuwe gees.",
          "Soos U vir my moes ly,",
          "mag liefde wat ek wy",
          "ewig en suiwer bly",
          "en vurig wees!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Waar ek in droefheidsnag",
          "wag op die helder dag,",
          "wees U my lig!",
          "Verander nag in dag,",
          "trane tot blye dag;",
          "Hou U my oog vandag",
          "op U gerig."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Master, the tempest is raging!",
    "hymnNumber": 205,
    "reference": "AL205",
    "title": "Meester, Die Branders Breek Oor Ons!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 34.2,
      "intro": 69.5
    },
    "verses": [
      {
        "content": [
          "Meester, die branders breek oor ons!",
          "Die skip is in doodsgevaar.",
          "Die lug is so swart soos die dieptes:",
          "Geen skuiling of hulp is daar!",
          "Gee U nie om dat ons sterwe?",
          "Hoe kan U slaap in vree,",
          "wanneer ons elke oomblik kan wegsink",
          "in dieptes van hierdie see?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Meester, in sieleontstelt'nis",
          "en droefheid kniel ek hier neer;",
          "Want diep in my hart is daar weemoed,",
          "ontwaak tog en help my, Heer!",
          "Golwe van sonde en smarte",
          "het reeds my siel vermink,",
          "en ek sterwe, ek sterwe, o Meester,",
          "o help my tog eer ek sink!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Nou's die verskrikking verby, Heer,",
          "daar's stilte en vrede soet;",
          "Die son word weerkaats in die water,",
          "daar's vrede in my gemoed.",
          "Bly verder by my, my Heiland,",
          "laat my alleen nie meer,",
          "dan kom ek in die hawe van vrede,",
          "vir ewig by U, o Heer!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Die wind en die golwe gehoorsaam My, vrede stil!",
      "Al is daar storme wat dreig met vrees,",
      "of duiwels of mense of wat ook mag wees-",
      "geen water verswelg ooit 'n skippie waar",
      "die Skepper van aarde en see op vaar!",
      "Ja, alles luister en doen My wil,",
      "Vrede, stil! Vrede stil!",
      "Ja, alles luister en doen My wil, Vree, vrede stil!"
    ]
  },
  {
    "english": "God's Way",
    "hymnNumber": 206,
    "reference": "AL206",
    "title": "Gods Weg Is Die Beste",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 39.3,
      "intro": 39.3
    },
    "verses": [
      {
        "content": [
          "Gods weg is die beste,",
          "Hy dink ook aan my,",
          "al sien ek geen rede",
          "waarom ek moet ly.",
          "My hart wil Hy reinig",
          "met vreugde en rou,",
          "daarom sal ek need'rig",
          "Hom altyd vertrou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gods weg is die beste,",
          "Hy't my pad berei.",
          "Ek vertrou Hom altyd;",
          "Sy hand sal my lei.",
          "In skadu en sonskyn",
          "is Jesus naby,",
          "met Hom as my toevlug",
          "vrees ek niks vir my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gods weg is ook my weg,",
          "Hy weet wat is goed,",
          "ek leun net op Jesus,",
          "my rus is so soet.",
          "Niks sal my oorval nie -",
          "veilig by my God -",
          "by Hom bly ek ewig,",
          "o salige lot."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Gods weg is die beste,",
      "Gods weg is die regte,",
      "ek swyg voor Hom need'rig,",
      "Hy weet wat is goed."
    ]
  },
  {
    "english": "I know my heavenly Father knows",
    "hymnNumber": 207,
    "reference": "AL207",
    "title": "Ek Weet My Troue Vader Weet",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Ek weet my troue Vader weet",
          "van al my trane en my leed;",
          "En Hy verdryf die wolkenag,",
          "en skep die wye, blye dag (2x)"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek weet my troue Vader weet",
          "Hy sal my wonde nie vergeet,",
          "en met Sy God'lik tere hand",
          "versag Hy elke pyn wat brand. (2x)"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek weet my troue Vader weet",
          "hoe swak ek teen die vyand meet,",
          "maar in Sy wysheid en Sy mag",
          "bewaar Hy my van dag tot dag. (2x)"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek weet my troue Vader weet",
          "die tyd vir my hier afgemeet;",
          "En mag die uur, o troue Vrind",
          "my veilig aan U boesem vind! (2x)"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Hy weet, Hy weet",
      "van al my trane en my leed:",
      "Hy weet, Hy weet,",
      "en Hy sal nooit my smart vergeet."
    ]
  },
  {
    "english": "Will you anchor hold in the storm of life",
    "hymnNumber": 208,
    "reference": "AL208",
    "title": "Bly Jou Anker Vas In Die Lewenstorm",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.9,
      "intro": 30.5
    },
    "verses": [
      {
        "content": [
          "Bly jou anker vas in die lewenstorm",
          "as die wolke swart in die blou lug vorm?",
          "As die vloedgety elke kabel rek,",
          "sal jou anker sleep of vaster trek?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As die Heiland my vasgeanker het,",
          "sal ek veilig skuil in die aanlêplek.",
          "Want die kabel strek van Sy hart na my",
          "dis deur God gesterk teen die gety."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Waar die rif verskyn hou dit veilig stand",
          "as die rotse dreig om die skip te strand",
          "laat die storme dreun en die water woel",
          "nie een brander sal ons skip oorspoel."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dit sal stewig hou in die doodsgety,",
          "as ons skippie bang teen die golwe stry;",
          "As die waters groei, sal dit ons behou",
          "want ons anker rus op God se trou."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "As ons oog sal sien, in die môrelig,",
          "daardie pêrelpoort in die vergesig,",
          "werp ons anker daar aan die hemelkus",
          "waar geen storm ons ooit weer sal ontrus."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Ons het 'n anker wat vas sal staan,",
      "selfs as die stormwinde oor ons gaan",
      "stewig op die vaste Rots gegrond -",
      "ewig in Sy liefde en vree-verbond."
    ]
  },
  {
    "english": "Under His wings I am safely abiding",
    "hymnNumber": 209,
    "reference": "AL209",
    "title": "Onder Sy Vleuels",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 26,
      "intro": 39.1
    },
    "verses": [
      {
        "content": [
          "Onder Sy vleuels skuil ek veilig en rustig,",
          "Al is daar dreiging van brander en wind;",
          "Nogtans vertrou ek, want Hy is my anker,",
          "Hy's my Verlosser en ek is Sy kind."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Onder Sy vleuels, wat 'n toevlug in droefheid!",
          "O hoe verlang ek na vrede en rus;",
          "Dikwels vind ek selfs by vriende geen troos nie,",
          "Hy gee my vrede en Hy is my lus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Onder Sy vleuels, wat 'n heerlike woning!",
          "Daar wil ek skuil tot die woede bedaar;",
          "Daar is beskutting, o daar bly ek rustig -",
          "Ewig in Jesus se hoede bewaar."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Onder Sy vleuels, onder Sy vleuels,",
      "Wie kan my skei\tvan Sy liefde?",
      "Onder Sy vleuels is rus vir my siel",
      "Daar vind ek ewige vrede."
    ]
  },
  {
    "english": "O safe to the Rock that is higher than I",
    "hymnNumber": 210,
    "reference": "AL210",
    "title": "Ek Vlug Na Die Rots",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 38.9,
      "intro": 47.9
    },
    "verses": [
      {
        "content": [
          "Ek vlug na die Rots ",
          "soveel hoër as ek -",
          "in angs en benoudheid",
          "‘n veilige plek.",
          "So sondig en moeg,",
          "Heer, wend ek my tot U.",
          "Dat U, Rots der eeue,",
          "my krag kan hernieu."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In stil middagure,",
          "in lyding en smart,",
          "as sterke versoekings",
          "my hartstogte tart,",
          "oorval dan die storm",
          "op die lewensee my,",
          "dan anker ek veilig,",
          "o Rots, aan U sy."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe dikwels in stryd",
          "teen die bose se mag",
          "het ek nie gevlug",
          "na die Rots vir my krag?",
          "Hoe vaak in beproewings,",
          "as stormwinde huil,",
          "het ek, Rots der eeue,",
          "by U nie geskuil?"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Veilig by U!",
      "Veilig by U!",
      "Ek skuil, Rots der eeue,",
      "so veilig by U."
    ]
  },
  {
    "english": "The Lord's our Rock, in Him we hide",
    "hymnNumber": 211,
    "reference": "AL211",
    "title": "Die Heer Is Ons Rots",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 30.2
    },
    "verses": [
      {
        "content": [
          "Die Heer's ons Rots; ons skuil by Hom",
          "ons toevlug in die tyd van storm;",
          "Daar sal ons wag totdat Hy kom,",
          "ons toevlug in die tyd van storm!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons skadu teen die son bedags;",
          "Ons toevlug in die tyd van storm!",
          "Ons vesting en beskerming snags;",
          "Ons toevlug in die tyd van storm."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As wilde branders om ons slaan,",
          "ons toevlug in die tyd van storm;",
          "Sal ons tot Hom vir skuiling gaan;",
          "Ons toevlug in die tyd van storm."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O God, ons Rots, ons hulp in nood,",
          "ons toevlug in die tyd van storm!",
          "Staan U ons by tot in die dood,",
          "ons toevlug in die tyd van storm."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Eeu'ge Rots in 'n dorre land!",
      "Hy verkoel selfs die hete sand;",
      "Troue Gids na die Vaderland!",
      "Ons toevlug in die tyd van storm."
    ]
  },
  {
    "english": "My hope is built on nothing less",
    "hymnNumber": 212,
    "reference": "AL212",
    "title": "My Lewenshoop Het Ek Gegrond",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "My lewenshoop het ek gegrond",
          "op Jesus bloed en Sy verbond.",
          "Selfs prinse mag my hoop beskaam,",
          "maar ek vertrou op Jesus Naam."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As duisternis my van Hom skei,",
          "dan weet ek Jesus sal my lei;",
          "Al rol die bare hoog en blou,",
          "Hy is die anker wat my hou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sy liefdeseed, Sy wrede dood",
          "versterk my in die uur van nood.",
          "As alles om my heen versink,",
          "dan sal my lied oorwinnend klink."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En kom Hy met basuingeskal,",
          "as Heerser van die groot heelal -",
          "geklee in Sy geregtigheid,",
          "deel ek met Hom Sy heerlikheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Hy is die Rots waarop ek staan,",
      "elk ander vesting sal vergaan,",
      "elk ander vesting sal vergaan."
    ]
  },
  {
    "english": "We'll build on the Rock, the living Rock",
    "hymnNumber": 213,
    "reference": "AL213",
    "title": "Ons Bou Op Die Rots",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.3,
      "intro": 32.1
    },
    "verses": [
      {
        "content": [
          "Ons bou op die Rots, die vaste Rots,",
          "op Jesus, die Rots wat lewe;",
          "Op Hom sal ons staan deur vuur en vloed;",
          "Hy sal ons nooit begewe."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wie sal op die losse dryfsand bou,",
          "op newels van aardse voorspoed?",
          "Wie bou op die skyn van wêreldeer,",
          "van roem en yd'le hoogmoed?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O bou op die Rots wat nooit vergaan,",
          "wat staan deur die eind'loos eeue;",
          "Sy hoop is die hoop wat sal bly staan -",
          "Hy is ons Rots der eeue."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ons bou op die Rots",
      "Ons bou op die Rots",
      "Ons bou op die Rots; op die vaste Rots",
      "op Jesus, onse Rots."
    ]
  },
  {
    "english": "",
    "hymnNumber": 214,
    "reference": "AL214",
    "title": "Twyf'ling Swyg",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Twyf'ling swyg, swyg, bange smarte!",
          "God is my getroue Vriend",
          "en Sy Gees sê aan my harte:",
          "'jy is ewiglik My kind'.",
          "Al verkla my hart my immer,",
          "nogtans vrees ek onheil nimmer.",
          "Dikwels vind ek moed in smart,",
          "God is Heerser van my hart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus Christus wat gesterf het,",
          "het verrys en leef vir my.",
          "Hy wat segepraal verwerf het,",
          "gee oorwinning ook aan my.",
          "Ek kan nooit Sy wysheid meet nie,",
          "maar Hy sal my nie vergeet nie,",
          "want uit deernis met my lot",
          "tree Hy vir my in by God."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ruwe storme breek in woede,",
          "om my strek die donker nag.",
          "Maar God hou my in Sy hoede",
          "en hou oor my heil die wag.",
          "As ek lank in vrees vernag het,",
          "kom Hy soos ek Hom verwag het.",
          "En deur nagtlik' duister dig",
          "lei Hy my na eeu'ge lig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Watter lot in dood of lewe,",
          "Smaad of eer, hier op my wag,",
          "Jesus sal my nooit begewe;",
          "Is ek swak, by Hom is krag.",
          "Raad van vriend of teerbemindes,",
          "Bitter haat van kwaadgesindes,",
          "Hoogte, diepte, vreugde, rou -",
          "Niks ontroof my van U trou."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "How firm a foundation, ye saints of the Lord",
    "hymnNumber": 215,
    "reference": "AL215",
    "title": "Hoe Vas Is Jou Grondslag",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Hoe vas is jou grondslag,",
          "o Kerk van die Heer,",
          "gebou op Gods Woord",
          "en Sy heilige leer;",
          "In Christus het God Hom",
          "aan ons openbaar,",
          "ons toevlug en Redder",
          "in nood en gevaar."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "“Vrees nie, Ek is met jou,",
          "en wees nie verskrik,",
          "want Ek is jou God",
          "en Ek sal jou verkwik.",
          "Ek sterk en Ek help die wat stil",
          "op My wag,",
          "My hand ondersteun hul",
          "met reddende krag.”"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "“As jy deur die waters van droefheid",
          "moet gaan,",
          "vrees nie, oor jou hoof",
          "sal die golwe nie slaan.",
          "Want Ek is naby -",
          "tot jou redding gereed -",
          "om aan jou te heilig",
          "jou bitterste leed.”"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "“Wanneer Ek jou lei",
          "deur beproewende vuur,",
          "wanneer jy die vlamme",
          "van smart moet verduur,",
          "onthou My gena is genoeg",
          "en Ek waak;",
          "Ek wil jou slegs louter",
          "en heiliger maak.”"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "'o Siel wat volkome",
          "op Jesus vertrou,",
          "jou vyande sal Ek vernietig",
          "voor jou!",
          "En kyk, tot jou val is die hel",
          "nie in staat,",
          "want Ek sal jou nimmer,",
          "Nee nimmer verlaat.'"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord of our life, and God of our salvation",
    "hymnNumber": 216,
    "reference": "AL216",
    "title": "Here, Ons God, Ons Redder En Ons Lewe",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Here, ons God, ons Redder",
          "en ons lewe;",
          "Lig op ons pad en Hoop",
          "in al ons strewe,",
          "verhoor U volk as alles ons begewe,",
          "Here Almagtig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Here, ons Rots, bestand teen",
          "helse woede,",
          "stel ons teen bose liste op ons hoede,",
          "en skenk, wanneer ons weerstand bied",
          "ten bloede,",
          "vertroosting Heiland."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vrede van God wat al ",
          "ons smarte lenig,",
          "vrede wat broeders ",
          "in U kerk verenig,",
          "vrede in oorlog, wonderbaar en enig,",
          "daal uit die hemel!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Skenk ons U hulp ",
          "tot vyande verslaan is,",
          "skenk hul U lig op weë wat gebaan is,",
          "skenk vrede hier,",
          "en as U werk gedaan is,",
          "by U 'n woning."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord is my light; then why should I fear?",
    "hymnNumber": 217,
    "reference": "AL217",
    "title": "Die Heer Is My Lig!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22.4,
      "intro": 33.7
    },
    "verses": [
      {
        "content": [
          "Die Heer is my lig!",
          "Waarom sal ek vrees?",
          "In daglig en duister",
          "sal Hy by my wees;",
          "Hy red my van sonde",
          "en stil my verdriet,",
          "die Vader het ons",
          "die verseek'ring gebied."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die Heer is my lig",
          "as skaduwees daal,",
          "geloof sien na bowe",
          "waar sintuie faal -",
          "waar Jesus vir ewig regeer",
          "op Sy troon,",
          "hoe kan ek nog langer",
          "in duisternis woon?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die Heer is my lig,",
          "die Heer is my krag;",
          "ek weet in Sy Naam",
          "kan ek alles vermag.",
          "My swakheid sal Hy",
          "met Sy sterkte oordek,",
          "dan wandel ons saam,",
          "my Verlosser en ek."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die Heer is my lig,",
          "my alles en al,",
          "Sy heerlikheid skyn",
          "in die donkerste dal;",
          "Hy is my Verlosser,",
          "my Koning en Heer,",
          "met juiging en lofsang",
          "sal ek Hom vereer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Die Heer is my lig,",
      "my vreugde so bly,",
      "in daglig en duister",
      "sal Hy my lei.",
      "Die Heer is my lig,",
      "my vreugde so bly,",
      "in daglig en duister",
      "sal Hy my lei."
    ]
  },
  {
    "english": "When, my Saviour, shall I be",
    "hymnNumber": 218,
    "reference": "AL218",
    "title": "Wanneer, Heiland",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Wanneer, Heiland, sal my gees",
          "aan U onderworpe wees?",
          "Ek wil enkel in U leef,",
          "na geen selfverheffing streef;"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Aardse kennis graag ontbeer",
          "en van U my wysheid leer;",
          "In U mag alleenlik sterk,",
          "en gelukkig in U werk."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat U heiligmaking my",
          "van besoedeling bevry;",
          "En U liefde in my woon",
          "nederig en wonderskoon."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I am trusting Thee, Lord Jesus",
    "hymnNumber": 219,
    "reference": "AL219",
    "title": "Ek Vertrou Op U, Heer Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.4
    },
    "verses": [
      {
        "content": [
          "Ek vertrou op U, Heer Jesus,",
          "in U wil ek bly;",
          "Want in U is daar verlossing,",
          "ryk en vry."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek vertrou op U vergifnis -",
          "buig ootmoedig neer -",
          "U genade staan vir ewig",
          "dierb're Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek vertrou op U, my Leidsman,",
          "want U gee my krag",
          "en voorsien in my behoeftes",
          "elke dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek vertrou op U, my Hoeder;",
          "Laat my nimmer val;",
          "U beloftes staan vir ewig",
          "vas en pal."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Dying with Jesus, by death reckoned mine",
    "hymnNumber": 220,
    "reference": "AL220",
    "title": "Ek Sterf Met Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 26.6,
      "intro": 39.7
    },
    "verses": [
      {
        "content": [
          "Ek sterf met Jesus,",
          "Sy dood maak my vry;",
          "Ek leef in Jesus en Hy leef in my;",
          "Ek sal deur Jesus verheerliking kry,",
          "oomblik na oomblik ",
          "bly ek aan Sy Sy."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nooit 'n beproewing of Jesus is daar;",
          "Nooit word my laste, met Sy hulp,",
          "te swaar;",
          "Selfs in verdriet en in lewensgevaar -",
          "oomblik na oomblik ",
          "sal Hy my bewaar."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Nooit is daar droefheid, ‘n sug of 'n klag;",
          "Nooit is daar trane in donkere nag;",
          "Hy bring vertroosting",
          "as ons op Hom wag;",
          "Oomblik na oomblik skenk Hy nuwe krag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nooit is daar swakheid",
          "of knaende vrees,",
          "nooit is daar siekte,",
          "of Hy kan genees;",
          "Hy stuur Sy troostende Heilige Gees;",
          "Oomblik na oomblik sal Hy by my wees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Oomblik na oomblik bewaar Hy my teer;",
      "Oomblik na oomblik daal krag",
      "van Hom neer;",
      "Ek sal deur Jesus verheerliking kry,",
      "oomblik na oomblik bly ek aan Sy sy."
    ]
  },
  {
    "english": "Blessed Lord, how much I need Thee!",
    "hymnNumber": 221,
    "reference": "AL221",
    "title": "Heiland, Ek Het U So Nodig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Heiland, ek het U so nodig,",
          "ek is swak en arm en blind;",
          "Neem my swakke hand en lei my,",
          "laat my sterkte in U vind."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Klee my met 'n kleed van ootmoed,",
          "want my klere is nie wit;",
          "Toon my eers my eie swakheid,",
          "leer my dan vir krag te bid."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek is veilig in U leiding;",
          "Selfvertroue laat my val;",
          "Gaan met my op ruwe weë,",
          "wees my lewenslig, my al."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wat die toekoms ook mag lewer -",
          "louter vreug of bitter smart -",
          "ek verlang na U, o Here,",
          "op U steun my bange hart."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Elke uur, elke uur,",
      "Heiland, ek het U so nodig!",
      "Elke uur, elke uur,",
      "Heer, bewaar my elke uur."
    ]
  },
  {
    "english": "I need Thee every hour",
    "hymnNumber": 222,
    "reference": "AL222",
    "title": "Ek Hunker Elke Uur",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Ek hunker elke uur",
          "na U, o Heer,",
          "geen ander stem kan my",
          "gemoed kalmeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek hunker na U, Heer;",
          "Wees my naby,",
          "versoekings het geen mag",
          "as U my lei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek hunker na U, Heer,",
          "in vreug en pyn;",
          "Die lewe sonder U",
          "is ydel skyn."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek hunker na U, Heer;",
          "Leer my U wil,",
          "kom U beloftes nou",
          "in my vervul."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ek hunker na U, Heer;",
          "My Krag en Steun,",
          "neem my nou as U kind,",
          "geseënde Seun!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Heer, ek het U so nodig!",
      "Elke uur so nodig!",
      "Kom seën my, o Heiland,",
      "ek kom tot U."
    ]
  },
  {
    "english": "When we walk with the Lord",
    "hymnNumber": 223,
    "reference": "AL223",
    "title": "As Ons Wandel Met God",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 25.7,
      "intro": 32.3
    },
    "verses": [
      {
        "content": [
          "As ons wandel met God",
          "na Sy woord en gebod,",
          "en Sy lig op ons weë aanskou;",
          "As ons Sy wil begeer,",
          "dan versorg Hy ons teer -",
          "as ons eerlik wil volg en vertrou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sou die wolke my dek",
          "en die skaduwees rek,",
          "kyk, Sy glimlag verdryf hulle gou.",
          "Daar's geen vrees wat bestaan,",
          "daar's geen sug en geen traan,",
          "as ons eerlik wil volg en vertrou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Met die las wat ons dra,",
          "en die kommer wat pla,",
          "sal Hy edel karakters hier bou.",
          "Die verlies wat ons ly,",
          "elke stryd wat ons stry,",
          "word beloon as ons volg en vertrou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Al Sy liefde en heil",
          "sal ons nimmer kan peil,",
          "tot ons alles aan God toevertrou;",
          "Die oorwinnaar se lied",
          "en die seën wat Hy bied,",
          "is vir hulle wat volg en vertrou."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "In gemeenskap, so soet,",
          "sal ons sit aan Sy voet,",
          "en 'n altaar uit dankbaarheid bou;",
          "Op Sy woord sal ons staan,",
          "waar Hy stuur sal ons gaan,",
          "sonder vrees as ons volg en vertrou."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Volg en vertrou,",
      "op die weg wat Hy bou;",
      "Jesus gee ons Sy vrede",
      "as ons volg en vertrou."
    ]
  },
  {
    "english": "Anywhere with Jesus I can safely go",
    "hymnNumber": 224,
    "reference": "AL224",
    "title": "Ek Kan Orals Veilig Saam Met Jesus Gaan",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Ek kan orals veilig saam met Jesus gaan; ",
          "orals waar Hy lei, het Hy die weg gebaan.  ",
          "Sonder Hom sal al my vreugde smaakloos wees,",
          "maar as ek by Hom is, sal ek nimmer vrees!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nêrens saam met Jesus voel ek ooit alleen,",
          "sonder Hom kan vriende tog geen hulp verleen;",
          "Lei Hy my deur droefheid of deur wrede lot,",
          "orals saam met Jesus Is 'n huis van God."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Orals by my Jesus kan ek sag gaan rus;",
          "Hy’s van elke skadu om my heen bewus.",
          "As ek opstaan, gaan ek na my Vaderhuis,",
          "dan is ek nog altyd by my Heiland tuis."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Saam met Hom, saam met Hom, orals saam met Hom!",
      "Ek kan orals veilig saam met Jesus gaan!"
    ]
  },
  {
    "english": "Sometimes a light surprises",
    "hymnNumber": 225,
    "reference": "AL225",
    "title": "‘n Lig Verras Die Christen",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "‘n Lig verras die Christen",
          "somtyds terwyl Hy sing;",
          "Dit is die Heer se vleuels",
          "wat weer genesing bring;",
          "Hy skenk aan ons na droefheid,",
          "beproewing en geween",
          "‘n tydperk van verligting,",
          "soos sonskyn na die reën."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In heilige oorpeinsing",
          "van Sy verlossingsplan",
          "word ons gemoed vernuwe,",
          "en al ons vrees verban.",
          "Die onbekende toekoms",
          "gaan ons dan tegemoet",
          "versekerd van Sy liefde",
          "in voor en teëspoed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gods volk sal geen gebrek ly;",
          "Hy kan ons nie vergeet;",
          "Die Skepper van die lelies",
          "sal ook Sy kinders kleed.",
          "Die Here voed Sy skepsels",
          "en let op hulle nood;",
          "Hy sorg selfs vir die rawe",
          "en gee Sy kinders brood."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Al sou geen boord of wingerd",
          "ons met Sy vrug verbly,",
          "en op verdorde velde",
          "geen wild of kudde wei;",
          "Nog bly God onveranderd,",
          "en kan ek Hom vertrou;",
          "Ek prys en loof Sy goedheid",
          "wat nimmer sal verflou."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Come, O Thou Traveler unknown",
    "hymnNumber": 226,
    "reference": "AL226",
    "title": "O Reisiger, So Onbekend",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "o Reisiger, so onbekend,",
          "onsigbaar in die donker nag,",
          "trag nie om U van my te wend;",
          "Ek sal U vashou tot die dag;",
          "Al worstel ek met U alleen",
          "ek kleef U aan tot U my seën."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is geen deug waarop ek roem;",
          "U ken my sonde en my vrees,",
          "en het my op my naam genoem;",
          "Het U dit in U hand gelees?",
          "Maak tog U naam bekend, o Heer,",
          "U weet hoe sterk ek dit begeer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek sal U seker nie bevry",
          "voordat U doen wat ek U vra.",
          "Het U, o Heer, gesterf vir my?",
          "Is U die Man van Golgota?",
          "Al breek die dag, U kan nie gaan",
          "aleer ek weet wie voor my staan."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "In heavenly love abiding",
    "hymnNumber": 227,
    "reference": "AL227",
    "title": "Berus Ek In Gods Liefde",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 40.3
    },
    "verses": [
      {
        "content": [
          "Berus ek in Gods liefde,",
          "dan kom geen kwaad my oor,",
          "want Hy is my Geliefde,",
          "niks kan my rus verstoor.",
          "Met onweerswolke oor my",
          "mag ek mismoedig wees,",
          "maar met Sy laer om my,",
          "sal ek geen onheil vrees!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy lei my waar die waters",
          "my siel met rus omstroom,",
          "geen herder soos my Leidsman",
          "waarvan my siel kan droom.",
          "Hy lei my in Sy wysheid,",
          "so helder soos die son;",
          "Hy ken die weg van waarheid,",
          "en ek gaan saam met Hom!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Groen weivelde wag op my",
          "soos in die Paradys;",
          "Weldra die blou lug oor my",
          "al was die wolke grys.",
          "My hoop is onafmeetlik,",
          "my lewensweg gebaan,",
          "gemeenskap onvergeetlik,",
          "met Jesus waar ek gaan."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "My King Divine",
    "hymnNumber": 228,
    "reference": "AL228",
    "title": "Jesus, My Hemelheer, Koning En God",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "content": [
          "Jesus, my Hemelheer, Koning en God,",
          "heers U in hierdie hart vir U gewen,",
          "stig daar U aardse troon U wil geskied,",
          "leef U in hierdie hart, my Hemelheer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As die versoekings kom, Redder en God",
          "toon aan die vyand dan U grote krag.",
          "Gee sege uur na uur langs heel my weg,",
          "laat ek oorwinnaar wees, my Hemelheer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Maak U gebruik van my in hierdie uur;",
          "Maak my geskik, o Heer, om U te dien.",
          "Wen U 'n siel deur my, U sy die eer;",
          "Skenk U my hartewens, my Hemelheer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "My Hemelheer, my Hemelheer,",
      "leef U in hierdie hart, my Hemelheer."
    ]
  },
  {
    "english": "",
    "hymnNumber": 229,
    "reference": "AL229",
    "title": "Heil'ge Jesus, Wat U Lewe",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Heil'ge Jesus, wat U lewe",
          "my eens ter heiligmaking gewe,",
          "hoe heerlik is U heiligheid!",
          "Hemels' voorbeeld, al die luister",
          "van eng'le heiligheid word duister",
          "voor al U lig en heiligheid.",
          "O Heer so onbesmet, U is my Hoof en ",
          "wet!",
          "Heil'ge Jesus, o heilig my",
          "en wil my wy tot ek volmaak in U kan bly."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Matig in U lewenswyse,",
          "in werk en rede, drank en spyse,",
          "elk vrolikheid en lekkerny;",
          "Niks sal meer U honger stil nie",
          "as net dit wat U Vader wil nie;",
          "Dit was U spys en lekkerny.",
          "In selfverloëning was U versadiging.",
          "Heil'ge Jesus, o heilig my",
          "en wil my lei",
          "dat ek in alles matig bly."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heil'ge Jesus, vorm my lede,",
          "my kragte en begeerlikhede",
          "maak alles in my U gelyk -",
          "oog en voet in sien en wandel;",
          "Dat in my denke, woorde, handel -",
          "in alles slegs U beelt'nis blyk.",
          "Hervorm, veral volmaak",
          "my hart, Heer, na U smaak.",
          "Heil'ge Jesus, o heilig my",
          "tot ek gewy  geheel volmaak U lewe lei."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Take my life, and let it be",
    "hymnNumber": 230,
    "reference": "AL230",
    "title": "Neem My Lewe, Laat Dit, Heer",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Neem my lewe, laat dit, Heer,",
          "toegewy wees tot U eer;",
          "Neem my hande, maak hul sterk",
          "vir U reine liefdewerk. ",
          "Vir U reine liefdewerk."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Maak my voete, meer en meer,",
          "vlug en lieflik vir U Heer;",
          "Neem my stem en leer my sing",
          "van U liefde wat my dring. ",
          "Van U liefde wat my dring."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat my lippe immer dra",
          "boodskappe van U gena;",
          "Neem my goud en silwer, Heer,",
          "alles bring ek aan U weer. ",
          "Alles bring ek aan U weer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Neem die wil wat ek U bied,",
          "laat U wil in my geskied;",
          "Neem my hart, kom daarin woon,",
          "maak dit, Heiland, tot U troon. ",
          "Maak dit, Heiland, tot U troon."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Neem my liefde, dierb're Heer,",
          "aan U voet lê ek dit neer;",
          "Neem my soos ek tot U kom",
          "en maak my U eiendom. ",
          "En maak my U eiendom."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Not I, but Christ, be honored, loved, exalted",
    "hymnNumber": 231,
    "reference": "AL231",
    "title": "Nie Ek, Maar Christus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.1
    },
    "verses": [
      {
        "content": [
          "Nie ek, maar Christus, ",
          "moet in my verhoog word;",
          "Nie ek, maar Hy, ",
          "gehoor word en gesien;",
          "Nie ek, maar Hy, ",
          "in elke blik en hand'ling",
          "Nie ek, maar Hy, ",
          "die Meester wat ek dien"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nie ek, maar Christus, ",
          "troos die swaar beproefdes,",
          "nie ek, maar Hy, ",
          "verdryf hul blinde vrees;",
          "Nie ek, maar Hy, ",
          "verban die hete trane,",
          "nie ek, maar Hy, ",
          "moet in my alles wees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, Hy alleen, ",
          "geen waan of ydelhede,",
          "geen drukte wat ",
          "tot my die aandag trek.",
          "Ja, Hy alleen, ",
          "geen dwase selfverheffing",
          "net Hy, geen sweem ",
          "meer van die eie-ek."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nie ek, maar Hy, ",
          "voorsien in my behoeftes,",
          "my krag en sterkte ",
          "in die lewenstryd.",
          "Aan Hom gee ek ",
          "my siel en gees en liggaam",
          "en neem Hom aan ",
          "vir tyd en ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Make me a captive, Lord",
    "hymnNumber": 232,
    "reference": "AL232",
    "title": "Neem My Gevange Heer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Neem my gevange, Heer,",
          "dan word ek waarlik vry;",
          "As U vir my die swaard hanteer,",
          "sal ek oorwinning kry.",
          "Ek sink weg in die slyk",
          "as ek alleen wil staan;",
          "Maar as ek voor U krag beswyk",
          "dan gord ek sterkte aan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My hart is swak en broos,",
          "verraderlik soos wind;",
          "In alles is dit rigtingloos",
          "tot dit 'n Meester vind.",
          "Daar kan geen vryheid wees",
          "voor ek in slawerny",
          "U liefde dien, en onbevrees",
          "U Meesterskap bely."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My wil is sonder krag",
          "tot ek myself onttroon;",
          "Net na U wil in alles smag",
          "en U as Koning kroon.",
          "Dan word ek nie verlei,",
          "as sterk versoekings woed,",
          "want aan U boesem sag gevly,",
          "sal U my lewe voed."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Fade, fade, each earthly joy",
    "hymnNumber": 233,
    "reference": "AL233",
    "title": "Kwyn, Kwyn Weg, Aardse Vreug",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Kwyn, kwyn weg, aardse vreug,",
          "Jesus alleen",
          "kan hier my hart verheug,",
          "ja, Hy alleen!",
          "Die bose wêreld bied",
          "geen rusplek, slegs verdriet;",
          "Jesus is steeds my lied,",
          "ja, Hy alleen!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Niks mag my siel verlei;",
          "Jesus alleen",
          "moet ewig by my bly,",
          "ja, Hy alleen!",
          "Ek soek geen aardse goed;",
          "In voor- en teëspoed",
          "sal Hy my siel behoed,",
          "ja, Hy alleen!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vlug, drome van die nag;",
          "Jesus alleen",
          "bring helder lig en dag,",
          "ja, Hy alleen!",
          "Leeg het my siel gebly;",
          "Ek het Sy Gees bestry,",
          "maar nou versadig Hy,",
          "ja, Hy alleen!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vaarwel, verganklikheid!",
          "Jesus alleen",
          "skenk my onsterflikheid,",
          "ja, Hy alleen!",
          "Welkom, verlostes skoon,",
          "hier waar net vrede woon,",
          "welkome koningskroon",
          "vir Hom alleen!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "My Jesus, I love Thee, I know Thou art mine",
    "hymnNumber": 234,
    "reference": "AL234",
    "title": "My Heer, Ek Bemin U",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "My Heer, ek bemin U ",
          "wat op Golgota",
          "my losprys betaal het, ",
          "my smarte moes dra.",
          "Ek kniel aan U voete ",
          "in diepe berou;",
          "As'k U ooit bemin het, ",
          "my Heer, is dit nou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek min U want U het ",
          "my eerste bemin;",
          "Ek ag alles skade, ",
          "net U as gewin.",
          "Die wêreld versaak ek ",
          "om U te behou;",
          "As'k U ooit bemin het, ",
          "my Heer, is dit nou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al moet ek ook gaan ",
          "in die skaduvallei,",
          "geen dood sal my ooit ",
          "van U liefde kan skei;",
          "Ek sê - as die doodsweet ",
          "eens pêrel soos dou -",
          "as'k U ooit bemin het, ",
          "my Heer, is dit nou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "In wonings van vrede, ",
          "verruklik en skoon",
          "ontvang ek van U, ",
          "onverwelklik, my kroon",
          "en sing in aanbidding, ",
          "as ek U aanskou:",
          "As'k U ooit bemin het, ",
          "my Heer, is dit nou."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I am Thine, O Lord, I have heard Thy voice",
    "hymnNumber": 235,
    "reference": "AL235",
    "title": "Ek Is Uwe, Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Ek is uwe, Heer, want ek het gehoor",
          "dat U liefd'ryk spreek tot my.",
          "Ek wil hoër styg deur my stil geloof;",
          "Trek my digter aan U sy."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wil U my nou salf as U dienaar, Heer,",
          "met U goddelike krag;",
          "Ek wil opwaarts reik met 'n vaste hoop;",
          "Skenk U my wil, Heer, vandag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O, die diep genot van 'n enkel uur",
          "voor U liefdetroon, o Heer!",
          "As ek stil daar kniel om met U te",
          "spreek, en as vriend met vriend verkeer"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Daar is liefde wat ek nie nou verstaan",
          "voor die awendskeem'ring daal;",
          "Daar is vreugde soet wat ek nie sal ken",
          "eer die Heiland my kom haal."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Trek my nader,",
      "nader dierb're Heer,",
      "na die kruis waar U moes ly;",
      "Trek my nader, nader,",
      "nader dierb're Heer,",
      "na U wreed verwonde sy!"
    ]
  },
  {
    "english": "I would be, dear Saviour, wholly Thine",
    "hymnNumber": 236,
    "reference": "AL236",
    "title": "Ek Wil, Heiland, Net U Eie Wees",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.3,
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Ek wil, Heiland, net U eie wees,",
          "leer my hoe, leer my hoe;",
          "Leer my U wil doen en U Naam vrees,",
          "help my, help my nou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wat is aardse vreugde, roem of faam",
          "sonder U, sonder U?",
          "Ek gee alles prys vir Jesus Naam,",
          "alles is vir U."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As ek alles om U wil verlaat,",
          "wees naby, wees naby.",
          "U is al my hulp en toeverlaat,",
          "laat my in U bly."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Net vir U, net vir U,",
      "net vir U wil ek hier leef.",
      "Net tot U, net tot U,",
      "ek wil my tot U begeef."
    ]
  },
  {
    "english": "Rock of Ages, cleft for me",
    "hymnNumber": 237,
    "reference": "AL237",
    "title": "Rots Der Eeue, Oop Vir My",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "Rots der Eeue, oop vir my,",
          "laat my veilig in U bly!",
          "Laat die water en die bloed",
          "uit U sy as helend' vloed,",
          "my van sondeskuld en -mag",
          "dubbel vrymaak, Heer, vandag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Niks is daar wat ek kan doen,",
          "Heer, wat my, met U versoen;",
          "Sou my siel met ywer gloei,",
          "sou my trane ewig vloei -",
          "losser is daar net maar Een,",
          "U moet red, en U alleen!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ledig, slegs met sondelas,",
          "hou ek aan die kruishout vas.",
          "Nakend, smeek ek om 'n kleed,",
          "swak is ek, omring deur leed.",
          "Ek is vuil en vol verderf;",
          "Heiland, was my eer ek sterf!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Lê ek eens die pelgrimstaf",
          "van my swerwerslewe af,",
          "as die uur van oordeel slaan,",
          "en ek voor my Regter staan -",
          "Rots der eeue, oop vir my,",
          "laat my dan nog in U bly!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Give thou thy youth to God",
    "hymnNumber": 238,
    "reference": "AL238",
    "title": "Skenk God Jou Jonglingskap",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Skenk God jou jonglingskap,",
          "en dien Hom in jou jeug,",
          "terwyl jou lewe nog ontluik;",
          "Soek heiligheid en deug."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jou Skepper vra jou hart,",
          "jou jeug en al jou krag;",
          "Hy wil jou ware vreugde gee",
          "en vrede elke dag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kies nou die kant van God",
          "in alles, groot en klein;",
          "Dan staan Hy by jou in jou lot",
          "en hou jou lewe rein."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Have Thine own way, Lord! Have Thine own way!",
    "hymnNumber": 239,
    "reference": "AL239",
    "title": "Doen Net U Wil, Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 26.9
    },
    "verses": [
      {
        "content": [
          "Doen net U wil, Heer, U wil met my!",
          "o Pottebakker, ek is U klei;",
          "Vorm my en maak my volgens U wil,",
          "wyl ek my oorgee, wagtend en stil."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Doen net U wil, Heer, U wil met my!",
          "Toets en deurgrond my, al moet ek ly;",
          "Witter as sneeu, Heer, reinig my siel",
          "wyl ek in ootmoed hier voor U kniel."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Doen net U wil, Heer, U wil met my!",
          "Sterwend, gebroke, o help U my!",
          "U het oor dood en lewe die mag -",
          "raak my dan aan, o Meester, vandag!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Doen net U wil, Heer, U wil met my!",
          "Voer oor my wese die heerskappy;",
          "Vul my, o Gees, voortreflik en skoon",
          "tot almal sien dat U in my woon."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, keep me near the cross",
    "hymnNumber": 240,
    "reference": "AL240",
    "title": "Jesus, Hou My By Die Kruis",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21,
      "intro": 31.6
    },
    "verses": [
      {
        "content": [
          "Jesus, hou my by die kruis -",
          "die fontein van lewe;",
          "Waaruit helend' strome vloei,",
          "vry aan ons gegewe."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "By die kruis, bevreesde siel,",
          "slaan ek lyding gade;",
          "Daar omskyn die Môrester",
          "my met Sy genade."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "By die kruis, o Lam van God,",
          "sien ek weer U smarte;",
          "Laat ons wandel met Sy beeld",
          "daagliks in ons harte."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "By die kruis sal my geloof",
          "aansterk deur vertroue;",
          "Tot dit in die beter land",
          "oorgaan in aanskoue."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "In die kruis, in die kruis,",
      "sal ek roem vir ewig;",
      "Tot ek eens verheerlik staan",
      "by die stroom van lewe!"
    ]
  },
  {
    "english": "Beneath the cross of Jesus",
    "hymnNumber": 241,
    "reference": "AL241",
    "title": "Digby Die Kruis Van Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Digby die kruis van Jesus,",
          "o daar vertoef ek graag -",
          "die skadu van 'n reuse rots",
          "wat die vermoeide laaf;",
          "‘n rusplek in die wildernis,",
          "‘n tuiste onverwags;",
          "‘n skuiling teen die middagson",
          "en hitte van die dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "En aan die kruis van Jesus",
          "bespeur ek soms my Heer,",
          "soos Hy daar sterwende moes hang,",
          "deur foltering verteer.",
          "O sondaarsliefde, wonderbaar,",
          "oneindig diep en wyd!",
          "Gebroke, wenend treur my siel",
          "oor my onwaardigheid."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek neem o kruis, U skadu",
          "as toevlugsoord vir my;",
          "Die lig wat uit my Heiland straal,",
          "maak my so innig bly.",
          "Ek skei my van die wêreld af,",
          "ontvlug die aardsgedruis;",
          "My skande is my sondig' self,",
          "my roem alleen die kruis."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Saviour! Thy dying love",
    "hymnNumber": 242,
    "reference": "AL242",
    "title": "Sterwend Het U Aan My Gedink",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Sterwend het U aan my",
          "gedink, o Heer;",
          "Hoe kan ek iets weerhou",
          "wat U begeer?",
          "U het my siel omring",
          "met liefde, wat my dring -",
          "ek wil 'n offer bring,",
          "aan U, my Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Voor die genadetroon",
          "pleit U, o Heer,",
          "dat my geloof en moed",
          "mag triomfeer,",
          "ek sal my kruis aanvaar,",
          "U woorde trou bewaar;",
          "My liefde openbaar -",
          "vir U, my Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Maak my opreg en rein",
          "soos U, my Heer;",
          "Dat ek hier elke dag",
          "iets mag presteer:",
          "U woord en wet bemin,",
          "‘n liefdedaad begin,",
          "en sondaars tot U win -",
          "tot U, my Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Al wat ek het en is,",
          "skenk U, o Heer!",
          "Ek weet, deur lief en leed,",
          "dat U regeer.",
          "En is die stryd verby,",
          "my siel, deur U bevry,",
          "sal dan vir ewig bly",
          "net vir my Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "One thing I of the Lord desire",
    "hymnNumber": 243,
    "reference": "AL243",
    "title": "Een Ding Begeer Ek Van Die Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.5,
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "Een ding begeer ek van die Heer -",
          "my pad was donker, swaar met pyn -",
          "gebruik U water, loog of vuur,",
          "o, maak my rein! O, maak my rein!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As U my dieper insig gee,",
          "sal ek U altyd dankbaar wees;",
          "Maar bo dit alles vra ek U",
          "‘n reiner hart, 'n suiwer gees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Net as my lewe reiner word,",
          "sal groter insig in my woon;",
          "U lewe openbaar ons dit",
          "so God'lik skoon, so God'lik skoon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek wil die sondeweg vermy",
          "tot boosheid uit my hart verdwyn,",
          "maar hoe ek worstel, hoe ook waak,",
          "ek bly onrein, ek bly onrein!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "o Maak my hart van sonde rein,",
      "kom was en louter - reinig my!",
      "Al bring die vuur ook smart en pyn,",
      "maak my van elke sonde vry!"
    ]
  },
  {
    "english": "Father, we come to Thee",
    "hymnNumber": 244,
    "reference": "AL244",
    "title": "Vader, Ons Kom Na U",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 36.4,
      "intro": 45.6
    },
    "verses": [
      {
        "content": [
          "Vader, ons kom na U,",
          "hulp het ons anders nie,",
          "U kan ons krag hernieu,",
          "kyk op ons neer!",
          "Hou self oor ons die wag",
          "deur hierdie aardse nag",
          "tot daar 'n nuwe dag",
          "aanbreek, o Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Red ons van sondeweë,",
          "wil U ons vryheid gee;",
          "Vul nou ons hart met vree,",
          "neem weg ons vrees.",
          "Ons is vol ongeloof,",
          "maar U, ons Heer en Hoof,",
          "het krag en moed beloof",
          "vir hand en gees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skenk ons genade ryk,",
          "laat ons U liefde blyk,",
          "red ons uit stof en slyk",
          "slegs tot U eer.",
          "Wil ons dan verder lei,",
          "help ons die stryd volstry",
          "tot ons oorwinning kry",
          "in U, o Heer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Vader, ons kom tot U,",
      "wil op ons let!",
      "Ons is so hulpeloos;",
      "Hoor ons gebed."
    ]
  },
  {
    "english": "I lay my sins on Jesus",
    "hymnNumber": 245,
    "reference": "AL245",
    "title": "Ek Lê My Skuld Op Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 33.7
    },
    "verses": [
      {
        "content": [
          "Ek lê my skuld op Jesus",
          "die Offerlam van God;",
          "Hy dra die vloek en skande,",
          "gehoorsaam Gods gebod.",
          "Ek bring my sonde na Hom",
          "en in Sy dierb're bloed",
          "was Hy my en skenk vrede",
          "en rus in my gemoed."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek lê al my behoeftes",
          "op Jesus wat voorsien;",
          "En Hy genees my krankheid,",
          "gee meer as ek verdien.",
          "Ek lê my leed op Jesus,",
          "my laste en verdriet,",
          "en Hy verlos van almal,",
          "want Hy kan vrede bied."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ag, maak my tog soos Jesus",
          "so need'rig en so goed,",
          "o Vader van my Heiland,",
          "in alle teëspoed!",
          "O bring my tog by Jesus",
          "as die verloste skaar",
          "Hom loof saam met die eng'le,",
          "ag, wanneer kom ons daar!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O Jesus, Thou art standing",
    "hymnNumber": 246,
    "reference": "AL246",
    "title": "O Jesus, Waarom Staan U",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 30.2
    },
    "verses": [
      {
        "content": [
          "O Jesus, waarom staan U",
          "voor die geslote deur,",
          "lankmoedig en vol liefde",
          "al stel ons U teleur?",
          "o Skande, broeders, skande",
          "dat ons wat Hom bely,",
          "ons Redder en Verlosser",
          "nog buite kan laat bly!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O Jesus, waarom klop U",
          "met hemelse geduld,",
          "nadat U aan die kruishout",
          "deurboor is vir ons skuld?",
          "O liefde sonder weerga",
          "wat vir geen offer stuit!",
          "O snoodheid, onbegryplik,",
          "dat ons die deur kan sluit!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Jesus waarom pleit U",
          "so tederlik en sag;",
          "“Ek het vir jou gesterwe;",
          "hoe kan jy my laat wag?'",
          "Ek maak die deur wyd oop Heer,",
          "beskaamd en diep bedroef;",
          "Kom binne, dierb're Heiland;",
          "Kom in my hart vertoef."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Live out Thy life within me",
    "hymnNumber": 247,
    "reference": "AL247",
    "title": "Leef Uit U Lewe In My",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Leef uit U lewe in my -",
          "dit is wat ek begeer -",
          "en wees U self die antwoord",
          "op al my twyfel, Heer.",
          "Leef uit U lewe in my;",
          "Gebruik my soos U wil,",
          "want ek is slegs U werktuig,",
          "gedienstig, kalm en stil."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die tempel van my liggaam",
          "is aan Hom oorgegee,",
          "met heerlikheid van bowe",
          "sal Hy dit nou beklee -",
          "gereinig van die sonde,",
          "gesuiwer van die smet,",
          "gereed vir al die pligte",
          "wat Jesus vir my het."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En onderdanig wag ek",
          "om, waar U stuur, te gaan;",
          "Gereed om diens te lewer",
          "of om opsy te staan;",
          "Geen rustelose strewe",
          "of ontevredenheid,",
          "geen kwellinge of spanning",
          "dwing my gemoed tot stryd."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Maar rustig, kalm en buigsaam,",
          "van vooroordeel bevry,",
          "wag ek op U besluite",
          "en volg waar U my lei.",
          "O Koning aller konings,",
          "wil self in my kom leef,",
          "en antwoord wanneer twyfel",
          "weer aan my siel wil kleef."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O Jesus, I have promised",
    "hymnNumber": 248,
    "reference": "AL248",
    "title": "O Jesus, Ek Belowe",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 30.8
    },
    "verses": [
      {
        "content": [
          "O Jesus, ek belowe",
          "om U te dien as Heer;",
          "Laat my op aarde immer",
          "as vriend met U verkeer.",
          "Met U gedurig by my",
          "sal ek die stryd nie vrees;",
          "Geen dwaallig sal my weglok",
          "as U my Gids wil wees."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Maak my bewus, o Heiland,",
          "van U teenwoordigheid,",
          "te midde van versoeking",
          "en felle sielestryd.",
          "My vyande omring my",
          "en lok met sinsgenot -",
          "bewaar my vir die sonde;",
          "Beskerm my siel, o God!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Jesus, U belowe",
          "aan almal wat U dien",
          "dat hulle U daarbowe",
          "in heerlikheid sal sien;",
          "En Jesus, ek belowe",
          "om U te dien, my Heer;",
          "O laat my altyd met U",
          "as dierb're Vriend verkeer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Blessed Jesus, meek and lowly",
    "hymnNumber": 249,
    "reference": "AL249",
    "title": "Liewe Jesus, Maak U Woning",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 26.9
    },
    "verses": [
      {
        "content": [
          "Liewe Jesus, maak U woning",
          "in die hart wat na U smag;",
          "Need'rig, soos ons Heer en Koning,",
          "wil ons wandel elke dag;",
          "Sonder U is ons nie veilig,",
          "daarom wil ons in U bly;",
          "Laat U Gees ons lewe heilig",
          "en ons langs U weë lei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In U spore volg ons, seker",
          "dat U liefde ons omring,",
          "en dat elke wrange beker",
          "ons slegs nader aan U bring.",
          "Ja, die kruis dra ons geduldig,",
          "want ons weet daar wag 'n kroon;",
          "Hoeveel dank is ons verskuldig",
          "aan U heilige persoon!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Van U goedheid en genade",
          "wil ons altyddeur vertel;",
          "Tevergeefs ons goeie dade",
          "as U ons nie vergesel.",
          "Deur die nag van pyn en lyding",
          "sou ons, sonder U, beswyk;",
          "Voor die dag kom van bevryding",
          "voor die donker skadu's wyk."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dan, deur eindelose jare,",
          "sal ons U aanbid en loof",
          "waar geen doodsangs of gevare",
          "ons van vrede kan beroof;",
          "By U vind ons rus, o Here,",
          "uitgewoed is dan die stryd!",
          "U sy al die lof en ere",
          "tot in alle ewigheid!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "When peace, like a river, attendeth my way",
    "hymnNumber": 250,
    "reference": "AL250",
    "title": "As Vrede My Pad Hier Op Aarde Verlig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 27.4,
      "intro": 35.4
    },
    "verses": [
      {
        "content": [
          "As vrede my pad hier op aarde verlig,",
          "as droefheid my vreugde verniel",
          "o mag ek dan weet, watter lot my ook tref,",
          "dit is wel, dit is wel met my siel."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe satan ook woed, watter rampe genaak",
          "met sekerheid sal ek vertel:",
          "vir my het die Heiland Sy lewe gegee,",
          "dit is wel, met my siel, dit is wel."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My sondes, o saal'ge verseek'ring van Hom!",
          "Het Hy aan die kruishout genael;",
          "Nou ken ek die vrede wat Jesus ons gee",
          "loof die Heer, al my skuld is betaal."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Verhaas, liewe Heer, daardie heerlike dag,",
          "vanouds deur profete voorspel,",
          "as wolke sal wegvlug en Jesus sal kom,",
          "is dit wel, met my siel, is dit wel!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Dit is wel (Dit is wel)",
      "met my siel (met my siel)",
      "dit is wel,",
      "dit is wel, met my siel."
    ]
  },
  {
    "english": "Far away in the depths of my spirit tonight",
    "hymnNumber": 251,
    "reference": "AL251",
    "title": "Waar My Duister Gedagtes",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 24.4,
      "intro": 35.9
    },
    "youtube": "hP3xg9OtROQ",
    "verses": [
      {
        "content": [
          "Waar my duister gedagtes",
          "soms moedeloos dwaal,",
          "klink 'n lied soos die skoonste psalm",
          "en die hemelse klanke",
          "spoel sag oor my heen,",
          "en dit maak my so rustig en kalm."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O, die skat wat ek het",
          "in die vrede van God",
          "sal ek hou as die kosbaarste seën;",
          "So beskut dat geen mag",
          "my dit ooit kan ontroof,",
          "deur die eind'lose ewigheid heen."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek verheug my vanaand",
          "in die vrede van God,",
          "en berus in die Vader se wil;",
          "My Bewaarder is Hy,",
          "wat nie sluimer of slaap,",
          "en soos Dawid is ek voor Hom stil."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek verlang na die hemelse",
          "Godstad daarbo,",
          "ek sien Jesus alreeds in die gees;",
          "en ek glo dat 'n deel van ons",
          "loflied daarbo",
          "waar ons juig, oor Sy liefde sal wees."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Moeë siel, sonder blydskap",
          "of vrede of rus,",
          "soos die gras van die velde is jy;",
          "Maak die Heiland jou vriend,",
          "voor die vuur oor jou gaan,",
          "laat die vrede van God jou hier lei."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Vree, vree, lieflike vree;",
      "Daal so sag soos die dou in die nag;",
      "Wil, Heer, met U vrede my lewe verkwik,",
      "en vul my met liefde vandag."
    ]
  },
  {
    "english": "There is a place of quiet rest",
    "hymnNumber": 252,
    "reference": "AL252",
    "title": "Daar Is ‘n Plek Van Rus So Soet",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22.4,
      "intro": 33.7
    },
    "youtube": "l4-Jkb3vgSs",
    "verses": [
      {
        "content": [
          "Daar is 'n plek van rus so soet,",
          "digby die hart van God;",
          "Daar kwel geen sonde my gemoed,",
          "digby die hart van God;"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is 'n plek van troos, so soet,",
          "digby die hart van God;",
          "Die plek waar ons die Heer ontmoet,",
          "digby die hart van God."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar is verlossing, wondersoet,",
          "digby die hart van God;",
          "En vrede vul my bang gemoed,",
          "digby die hart van God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "o Jesus, my Verlosser,",
      "kom van die hart van God,",
      "en voer ons, wagtend voor U,",
      "tot by die troon van God."
    ]
  },
  {
    "english": "There comes to my heart one sweet strain",
    "hymnNumber": 253,
    "reference": "AL253",
    "title": "Daar Kom Tot My Hart ‘n Refrein",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 16.3,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Daar kom tot my hart 'n refrein,",
          "van hemelse vreugde so rein;",
          "Dit neem uit my siel al die pyn;",
          "o vrede, gawe van God!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Deur Jesus is vrede behaal,",
          "Sy dood het my skulde betaal -",
          "Sy vrede in ons sal nooit faal,",
          "want Vredevors is Sy Naam."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Met Jesus alleen op die troon,",
          "sal vrede my lewe bekroon,",
          "die vrede wat liefde betoon,",
          "o vrede, gawe van God."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "In Jesus is vrede vir my,",
          "en as ek net digby Hom bly,",
          "sal vrede my altyd verbly,",
          "o vrede, gawe van God!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Vrede, vrede,",
      "wondergeskenk van ons God,",
      "o rustige hemelse vree,",
      "o vrede, gawe van God!"
    ]
  },
  {
    "english": "Safe in the arms of Jesus",
    "hymnNumber": 254,
    "reference": "AL254",
    "title": "Veilig Is Ek By Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 38.9,
      "intro": 48.5
    },
    "youtube": "akCa9fqzgQg",
    "verses": [
      {
        "content": [
          "Veilig is ek by Jesus,",
          "sag aan Sy bors gevly;",
          "Veilig hier in Sy liefde,",
          "soet is Sy rus vir my!",
          "Luister hoe sing die eng'le",
          "ver oor die glasesee -",
          "singend van Jesus liefde,",
          "bring hul Sy vrede mee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Veilig is ek by Jesus,",
          "van alle sorge vry -",
          "stil is die wêreldlokstem -",
          "sonde nie meer vir my!",
          "Vry van die pyn en droefheid,",
          "twyfel of aardse vrees.",
          "Dof gloei die lout'ringsvure,",
          "min sal die trane wees!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jesus, my dierb're Toevlug,",
          "ek sal op U vertrou;",
          "Vas op die Rots der Eeue",
          "sal ek my lewe bou!",
          "Laat my hier wag geduldig,",
          "wag deur die donker nag,",
          "wag tot die helder môre",
          "breek oor die goue dag!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Veilig is ek by Jesus,",
      "sag aan Sy bors gevly;",
      "Veilig hier in Sy liefde,",
      "soet is Sy rus vir my!"
    ]
  },
  {
    "english": "There's sunshine in my soul today",
    "hymnNumber": 255,
    "reference": "AL255",
    "title": "Die Son Skyn In My Siel Vandag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Die son skyn in my siel vandag",
          "so heerlik skoon en bly,",
          "want Jesus het in my kom woon",
          "en Hy is lig vir my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In my siel is daar 'n melodie -",
          "‘n loflied wat ek bring -",
          "en Jesus hoor die stille lied",
          "wat net my hart kan sing."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis lente in my siel vandag,",
          "want in my hart is God,",
          "die Kunstenaar van die heelal,",
          "voor Wie die velde bot."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Daar is vreugde in my siel vandag,",
          "daar's liefde, hoop en lof,",
          "vir al Gods seëninge hier",
          "my dank klink in Sy hof."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "O die sonskyn, helder sonskyn,",
      "wyl die vreugdevolle ure snel;",
      "Wanneer my Heer Sy glimlag toon",
      "is daar sonskyn in my siel."
    ]
  },
  {
    "english": "There is sunlight on the hilltop",
    "hymnNumber": 256,
    "reference": "AL256",
    "title": "Daar Is Sonskyn Op Die Heuwels",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 30.2,
      "intro": 37.7
    },
    "verses": [
      {
        "content": [
          "Daar is sonskyn op die heuwels,",
          "daar is sonskyn op die see,",
          "en die groen vallei daar onder",
          "is in sonneskyn geklee.",
          "Maar die lig wat in my hart skyn,",
          "is meer helder en meer skoon,",
          "want U self woon daar, my Heiland,",
          "en dis sonskyn waar U woon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek werp al my droefheid van my",
          "soos 'n ou gewaad vol stof,",
          "want U dek my met U vreugde",
          "en U vul my met U lof.",
          "My geloofsoog sien die wonings,",
          "wat U nou vir ons berei,",
          "en met vreugde wag ek, Here,",
          "tot U ons ook daarheen lei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek behoort aan U, my Heiland,",
          "want U het my duur gekoop.",
          "Laat die sonskyn van U liefde",
          "in my skyn met nuwe hoop.",
          "Toon die luister van die wonings,",
          "wat U nou vir ons berei,",
          "en met vreugde wag ek, Here,",
          "tot U ons ook daarheen lei."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "O die sonskyn, lieflike sonskyn,",
      "o die sonskyn in my hart!",
      "Net wanneer die Meester glimlig",
      "skyn die son ook in my hart."
    ]
  },
  {
    "english": "O Jesus, my Redeemer",
    "hymnNumber": 257,
    "reference": "AL257",
    "title": "O Jesus, My Verlosser",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "O Jesus, my Verlosser,",
          "U is my vreugdelied",
          "my Redder en my Trooster",
          "in lyding en verdriet."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My hoop en my vertroosting",
          "deur lange jare heen,",
          "as onweerswolke saampak",
          "en ek soms bitter ween."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Op U vertrou ek, Heiland,",
          "U is die Seun van God.",
          "Vir my is U meer kosbaar",
          "as alle aardsgenot."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "My lied en my verblyding,",
          "hier op my pelgrimsbaan,",
          "my lied en my verblyding,",
          "as ek eens voor God staan!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "o Jesus, my Verlosser,",
      "wie sou ek nog begeer?",
      "Geen ander vriend so dierbaar,",
      "geen vriend vertrou ek meer."
    ]
  },
  {
    "english": "The home where changes never come",
    "hymnNumber": 258,
    "reference": "AL258",
    "title": "Ek Dink Nou Aan Die Hemelhuis",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Ek dink nou aan die hemelhuis",
          "waar pyn en droefheid nie bestaan,",
          "ja, daar gaan ek vir ewig tuis",
          "en wie wil nie ook daarheen gaan?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As jy in droefheid nog moet wag,",
          "druk lewenslaste jou terneer,",
          "as jy na daardie woning smag,",
          "wag, swerwer, wag en kla nie meer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As dorings soms jou pad versper,",
          "weet: Hy het dit as kroon gedra.",
          "Al sien jy ook geen enkel ster,",
          "dink aan die kruis van Golgota."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hou moed, al sou die winde ween,",
          "geen traan of sug ontgaan die Heer.",
          "Die sonskyn kom weer na die reën,",
          "o, swerwer, wag en kla nie meer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "O wag! Swerwer wag en kla nie meer",
      "O wag! Swerwer wag en kla nie meer",
      "O wag! O wag!",
      "O wag en kla nie meer!"
    ]
  },
  {
    "english": "My Father is rich in houses and lands",
    "hymnNumber": 259,
    "reference": "AL259",
    "title": "My Vader Is Ryk Aan Huise",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "youtube": "8TkuimZtCng",
    "timestamps": {
      "chorus": 31.9,
      "intro": 39.9
    },
    "verses": [
      {
        "content": [
          "My Vader is ryk ",
          "aan huise en land,",
          "Hy hou elke wêreldse ",
          "skat in Sy hand.",
          "Die edelgesteentes, ",
          "die duurste metaal",
          "wie kan ooit Sy rykdom ",
          "of skatte bepaal?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My Vader se Seun, ",
          "my Heiland en Heer,",
          "het eenmaal as kneg ",
          "onder mense verkeer;",
          "Maar nou tree Hy in ",
          "vir sondaars daarbo,",
          "berei daar 'n tuiste ",
          "en heerlike kroon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Eens was ek verworpe,",
          "‘n vreemdelingskind,",
          "‘n sondaar deur keuse;",
          "In sonde gebind.",
          "Dis alles verander:",
          "‘n kleed en 'n kroon",
          "word spoedig my erfdeel,",
          "my ewige loon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek kla oor geen woning,",
          "waar ek ook mag bly,",
          "die Here bou self",
          "‘n paleis daar vir my.",
          "Verban van die huis",
          "sal vreugde my vind",
          "en ek sing tot Sy eer:",
          "ek is Jesus se kind."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ek is Jesus se kind -",
      "die Koning se kind,",
      "my Vader is Koning,",
      "ek is Jesus se kind."
    ]
  },
  {
    "english": "Blessed assurance, Jesus is mine!",
    "hymnNumber": 260,
    "reference": "AL260",
    "title": "Blye Verseek'ring",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "youtube": "bLnYH7a7_ZQ",
    "timestamps": {
      "chorus": 23.1,
      "intro": 34.7
    },
    "verses": [
      {
        "content": [
          "Blye verseek'ring: Hy is my Heer!",
          "Salige voorsmaak van wat ons begeer!",
          "Jesus verlig my duister gemoed,",
          "wedergebore, rein deur Sy bloed."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As ek gehoorsaam, sien ek Sy lig",
          "heerlik daarbowe, o skone gesig!",
          "Hemelse wesens bring van Sy hof",
          "weerklank van liefde, vrede en lof."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daardie verseek'ring stel my gerus;",
          "Ek is van Jesus se liefde bewus.",
          "Wakend, gelowig, wag ek op Hom;",
          "Vas staan Sy woorde: “Ek sal weer kom!'"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Dit is my boodskap, dit is my lied,",
      "wat ek as lof aan Jesus wil bied.",
      "Dit is my boodskap, dit is my lied,",
      "wat ek as lof aan Jesus wil bied."
    ]
  },
  {
    "english": "What a fellowship, what a joy divine",
    "hymnNumber": 261,
    "reference": "AL261",
    "title": "O, Die Rein Genot",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "youtube": "SbCtc0obNTs",
    "verses": [
      {
        "content": [
          "O, die rein genot ",
          "van gemeenskap soet!",
          "Veilig aan die sterke arm van God;",
          "Watter vrede vloei ",
          "nou oor my gemoed!",
          "Veilig aan die sterke arm van God."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is blydskap op ",
          "hierdie pelgrimsweg, ",
          "veilig aan die sterke arm van God",
          "op my enge weg ",
          "skyn Sy helder lig,",
          "veilig aan die sterke arm van God."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Waarom sal ek vrees,",
          "waarom sal ek ly,",
          "veilig aan die sterke arm van God?",
          "Daar is soete rus ",
          "by die Heer vir my,",
          "veilig aan die sterke arm van God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Veilig, veilig,",
      "daar's geen gevaar so naby God.",
      "Veilig, veilig,",
      "veilig aan die sterke arm van God."
    ]
  },
  {
    "english": "O happy day! that fixed my choice",
    "hymnNumber": 262,
    "reference": "AL262",
    "title": "'K Verheug My In Die Blye Dag",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.3,
      "intro": 30.5
    },
    "verses": [
      {
        "content": [
          "‘k Verheug my in die blye dag",
          "van weergeboorte deur Gods Woord;",
          "‘n nuwe skepsel deur Sy mag,",
          "gaan ek van krag tot krag steeds voort."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die heilverbond is reeds verseël,",
          "ek weet dat ek Hom toebehoor;",
          "Hy is my keuse en my deel,",
          "Sy liefde het my hart bekoor."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Nou dat ek in my Heiland rus,",
          "deel Hy Sy volheid aan my mee,",
          "en, van geen tweespalt meer bewus,",
          "smaak ek op aarde hemelsvree."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die hoogste heem'le kan getuig",
          "van my gelofte aan my Heer;",
          "Voor eng'le wat oor sondaars juig",
          "hernuwe ek dit daagliks weer."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "En as my Heer in glorie kom,",
          "in Goddelike majesteit;",
          "Verrys en heers ek saam met Hom",
          "wat leef en heers in ewigheid."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Blye dag, blye dag,",
      "toe ek verlos is deur Gods mag!",
      "My Heiland leer my bid en waak,",
      "Hy skenk my krag vir elke taak,",
      "blye dag, blye dag,",
      "toe ek verlos is deur Gods mag!"
    ]
  },
  {
    "english": "Peace, perfect peace, in this dark world of sin?",
    "hymnNumber": 263,
    "reference": "AL263",
    "title": "Vrede Volmaak",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.9
    },
    "verses": [
      {
        "content": [
          "Vrede volmaak -",
          "omring deur pyn en smart?",
          "Die Here skenk Sy vrede in ons hart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Vrede volmaak -",
          "hoe swaar ook al my plig?",
          "Die wil van God is soet, Sy juk is lig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vrede volmaak -",
          "hoe bitter ook my leed?",
          "Hy sal my trane nimmer kan vergeet."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vrede volmaak -",
          "van dierbares geskei?",
          "Die Here sal ons almal veilig lei."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Vrede volmaak -",
          "wat ook die toekoms baar?",
          "Die Heer regeer en Hy sal ons bewaar."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Still with Thee, O my God!",
    "hymnNumber": 264,
    "reference": "AL264",
    "title": "Steeds By U, O My God!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.7
    },
    "verses": [
      {
        "content": [
          "Steeds by U, o my God!",
          "Dit is wat ek begeer;",
          "Daarin alleen vind ek genot,",
          "waar ek ook mag verkeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "By U wanneer die dag",
          "rooi in die ooste lig,",
          "soek ek die leiding en die krag,",
          "vir elke lewensplig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As awendskemering",
          "my siel met rus omvou,",
          "sal selfs die nag getuie wees",
          "dat ek op U vertrou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "By U die lewe deur",
          "en in die doodsvallei;",
          "By U kan niks my vrede steur,",
          "daar wil ek ewig bly."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "'Tis the blessed hour of prayer, when our hearts lowly bend",
    "hymnNumber": 265,
    "reference": "AL265",
    "title": "Dis Die Stille Uur Met God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 32.5,
      "intro": 40.5
    },
    "verses": [
      {
        "content": [
          "Dis die stille uur met God,",
          "wat ons harte begeer,",
          "en ons kom weer tot Jesus,",
          "ons Heiland en Heer;",
          "As ons net op Hom vertrou,",
          "bou Hy om ons 'n muur,",
          "hier is balsem vir droefheid",
          "in die salige uur."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dis die stille uur met God,",
          "wanneer Hy ons altoos",
          "met ontfermende liefde",
          "en teerheid vertroos;",
          "Van ons arbeid is hier rus",
          "wat vir ewig sal duur;",
          "Hier is balsem vir droefheid",
          "in die salige uur."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis die stille uur met God,",
          "wanneer treurendes gaan",
          "tot die Heiland wat altyd",
          "ons harte verstaan;",
          "Onse simpatieke Heer",
          "sal vertroostinge stuur;",
          "Hier is balsem vir droefheid",
          "in die salige uur."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "In die stille uur met God",
          "is ons dankbaar en bly,",
          "want die seën wat ons soek,",
          "sal ons seker verkry.",
          "In die krag van onse Heer",
          "kan ons alles verduur;",
          "Hier is balsem vir droefheid",
          "in die salige uur."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Stille uur met God, ",
      "mag dit ewig duur!",
      "Hier is rus vir vermoeides;",
      "O hoe salig die uur!"
    ]
  },
  {
    "english": "",
    "hymnNumber": 266,
    "reference": "AL266",
    "title": "Ek Het God Lief",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Ek het God lief,",
          "want die getroue Heer",
          "hoor my gebed -",
          "my smekinge en klagte.",
          "Ek roep tot Hom",
          "in angsvol donker nagte;",
          "Hy skenk my hulp",
          "en red my keer op keer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U gee my ryke ",
          "seëninge, Heer.",
          "Hoe sal ek U ",
          "vergoed vir U weldade?",
          "Ek neem die beker ",
          "van U groot genade;",
          "En sal U Naam in ",
          "dankbaarheid vereer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek sal U naam in ",
          "dankbaarheid besing -",
          "vir U getuig te ",
          "midde van die skare;",
          "En met die stem ",
          "van wind en duisend bare",
          "sal ek my liefde ",
          "tot die Here bring."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Sweet hour of prayer, sweet hour of prayer",
    "hymnNumber": 267,
    "reference": "AL267",
    "title": "Gewyde Ure Van Gebed",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 43.1
    },
    "verses": [
      {
        "content": [
          "Gewyde ure van gebed,",
          "wat my van sorg en kommer red,",
          "wanneer ek voor my Vader kniel",
          "en rus vind vir my moeë siel!",
          "Ek maak bekend wat ek begeer;",
          "Lê alles aan Sy voete neer;",
          "Ontvlug die bose strik en net,",
          "in stille ure van gebed."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gewyde ure van gebed,",
          "as ek met God gemeenskap het,",
          "en uit Sy Vaderhand ontvang",
          "die seën waarna ek verlang.",
          "Ek weet ek kan Sy woord vertrou,",
          "op Sy beloftes altyd bou;",
          "Hy wat op my behoeftes let,",
          "verhoor in ure van gebed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gewyde ure van gebed,",
          "o grootste voorreg wat ek het!",
          "Om Jesus deur geloof te eer,",
          "totdat Hy kom om te regeer!",
          "Dan sal my oë Hom aanskou;",
          "Geen sluier sal Hom meer omvou;",
          "Onsterflik, rein van alle smet",
          "is dan my lewe, deur gebed."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O, could I find, from day to day",
    "hymnNumber": 268,
    "reference": "AL268",
    "title": "O, Kon Ek Maar Van Dag Tot Dag",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "O, kon ek maar van dag tot dag,",
          "digby die Here bly;",
          "Dan vloei my ure, soet en sag,",
          "hier in Sy diens verby."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Meester, in U teenwoordigheid",
          "is rus vir my gemoed,",
          "wat bly vir ewig en altyd;",
          "En vreugde wondersoet!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Liewe Jesus, kom regeer",
          "as Koning in my hart;",
          "Met alles onder U beheer,",
          "ken ek geen sondesmart."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 269,
    "reference": "AL269",
    "title": "Hef ‘n Loflied Aan",
    "hasMidi": false,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Hef 'n loflied aan",
          "tot die Opperwese!",
          "Orals waar U gaan,",
          "sing tot Jakobs God",
          "van U groot genot;",
          "Hy is nooit volprese."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is die bevel",
          "van die Heer en Koning",
          "aan gans Israel:",
          "Dat hul saam sal sing",
          "om Sy lof te bring",
          "in elk need'rig woning."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Open julle mond:",
          "Vra van My vrymoedig",
          "volgens My verbond:",
          "Alles wat ontbreek,",
          "skenk Ek, as jul smeek,",
          "mildelik, oorvloedig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Maar My volk was traag",
          "om na My te luister,",
          "hul het My mishaag -",
          "My gebod verag -",
          "en hul nageslag",
          "dwaal nog in die duister."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "As My volk maar net",
          "na My woord wil strewe",
          "om daarop te let",
          "en gelowig gaan",
          "op die effe baan",
          "van My wet, en lewe!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, for tomorrow and its needs",
    "hymnNumber": 270,
    "reference": "AL270",
    "title": "Heer, Vir Die Dae Wat Nog Kom",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Heer, vir die dae wat nog kom,",
          "vra ek nie krag;",
          "Hou my van alle sonde vry",
          "deur hierdie dag.",
          "Help my om ywerig te werk,",
          "op U te wag;",
          "Maak my opreg in woord en daad,",
          "Vader, vandag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat ek nie gou wees met my wil,",
          "U wil is goed.",
          "Help my die eie-ek verslaan,",
          "gee my die moed.",
          "Laat my geen ydel woorde spreek -",
          "U Woord is soet.",
          "Plaas U 'n seël op my mond,",
          "dan spreek ek goed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Stem my tot erns wanneer dit pas,",
          "soms vriend'lik lag.",
          "Laat my U groot genade, Heer,",
          "nimmer verag.",
          "Heer, vir die dae wat nog kom,",
          "vra ek nie krag,",
          "maar hou my, lei my, min my, Heer,",
          "deur hierdie dag. Amen."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "What a friend we have in Jesus",
    "hymnNumber": 271,
    "reference": "AL271",
    "title": "Welk ‘n Vriend Het Ons In Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 37.3
    },
    "verses": [
      {
        "content": [
          "Welk 'n vriend het ons in Jesus,",
          "wat ons smart en sonde dra:",
          "welk 'n voorreg om die Vader",
          "alles in Sy Naam te vra!",
          "Ons verbeur die soetste vrede",
          "en ons laste druk ons neer,",
          "as ons nie in ons gebede",
          "alles bring tot onse Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In beproewings en versoekings",
          "vlug tot Hom wat altyd red;",
          "Laat geen kwelling jou ontmoedig,",
          "gaan tot Hom in die gebed.",
          "Kan 'n vriend ooit trouer handel",
          "as die Heer wat ons beskerm,",
          "Hy wat Hom in diepe deernis",
          "oor ons menslikheid ontferm?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wanneer laste my terneerdruk,",
          "as ek swak en eensaam is,",
          "op die Heer, my Hulp en Toevlug,",
          "werp ek my bekommernis.",
          "As my vriende my verstoot het,",
          "gaan ek biddend tot die Heer;",
          "Aan Sy boesem is vertroosting,",
          "Hy verlaat my nimmermeer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, Thou hast promised",
    "hymnNumber": 272,
    "reference": "AL272",
    "title": "Jesus, U Belowe Dat U Deur U Gees",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Jesus, U belowe ",
          "dat U deur U Gees,",
          "waar U kinders saamkom,",
          "sal teenwoordig wees.",
          "Op U Woord vertrouend ",
          "kniel ons voor U neer;",
          "Skenk ons nou U seën,",
          "wees teenwoordig, Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U het ons al dikwels ",
          "hier ontmoet, O Heer, ",
          "kom nou in ons midde,",
          "voed ons nog 'n keer.",
          "Kom, o dierb're Heiland,",
          "vul ons met U gees,",
          "wil vandag die gasheer ",
          "in ons midde wees"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat ons hier 'n loflied",
          "in U poorte sing;",
          "Hoor ook die gebede ",
          "wat ons voor U bring",
          "maak ons weer gelowig,",
          "laat U Gees ons stig;",
          "Maak ons weë helder ",
          "met U God'lik lig."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Jesus, wees teenwoordig",
      "waar ons voor U wag;",
      "Stort U ryke seën ook op ons vandag."
    ]
  },
  {
    "english": "Calm me, my God, and keep me calm",
    "hymnNumber": 273,
    "reference": "AL273",
    "title": "Kalmeer My, Heer, En Hou My Kalm!",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Kalmeer my, Heer, en hou my kalm!",
          "As storme om my woed",
          "en wrede woorde ru weergalm,",
          "kalmeer dan my gemoed."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ja, hou my kalm in die rumoer,",
          "en in die felle stryd;",
          "Kalm as die stilte my ontroer",
          "in droewe eensaamheid."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kalm in gesondheid en in pyn,",
          "in oorvloed en gebrek;",
          "Kalm as my liggaamskragte kwyn,",
          "o God, my Hoogvertrek."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kalm in die bang beproewingsuur",
          "wanneer gevare dreig;",
          "Kalm as ek onreg moet verduur",
          "en as die minste swyg."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ja, onverstoorbaar kalm en stil,",
          "sag aan U bors gevly,",
          "rus ek, my Heiland, in U wil,",
          "volkome toegewy."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "At first I prayed for light",
    "hymnNumber": 274,
    "reference": "AL274",
    "title": "Eers Het Ek Lig Gevra",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.7
    },
    "verses": [
      {
        "content": [
          "Eers het ek lig gevra,",
          "hier op my aardse pad,",
          "wat my in veiligheid sou lei",
          "na gindse hemelstad."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Toe het ek krag begeer",
          "om met standvastigheid",
          "steeds aan die kant van God te staan",
          "in hierdie lewenstryd."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daarna was sterk geloof",
          "immer my smeekgebed;",
          "Ag, kon ek net my God vertrou,",
          "hoe ferm was dan my tred!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Slegs liefde vra ek nou",
          "om God en mens te dien;",
          "Liefde wat alles kan verduur,",
          "en weet dat God voorsien."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Lig en geloof en krag",
          "met liefde skenk die Heer;",
          "Geduldig moes Hy wag om my",
          "die groot gebed te leer."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Still, still with Thee, when purple morning breaketh",
    "hymnNumber": 275,
    "reference": "AL275",
    "title": "Nog Steeds By U",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Nog steeds by U wanneer die purper dag breek,",
          "voëltjies ontwaak en skaduwees verdwyn",
          "ek is by U! O wondersoete wete,",
          "skoon soos die son wat oor die velde skyn."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Alleen met U in die gewyde stilte,",
          "voordat die skepping weer opnuut ontwaak;",
          "Alleen met U in heilige aanbidding,",
          "voordat die sonlig aan die berge raak."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Soos die weerkaatsing van die skone dagster",
          "blink op die boesem van die stille see,",
          "so sal my kalme hart U beeld weerspieël;",
          "Want U alleen kan daardie grond betree."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Voordat ek sluimer na die dag se arbeid,",
          "soek ek U aangesig in stil gebed;",
          "Onder U vleuels veilig in die donker;",
          "En in die daeraad hoor ek U tred."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "So sal dit wees op daardie blye môre",
          "as ons ontwaak en alle skadu's wyk!",
          "Ewig by U in heerlike gemeenskap,",
          "en aan U goddelike beeld gelyk!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Take time to be holy",
    "hymnNumber": 276,
    "reference": "AL276",
    "title": "Neem Tyd Vir Gemeenskap",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Neem tyd vir gemeenskap",
          "met Jesus, jou Heer,",
          "en bly in Hom altyd;",
          "Sy Woord sal jou leer.",
          "Gaan om met Sy kinders",
          "in vreugde en smart;",
          "Bid steeds om Sy seën,",
          "sterk daarmee U hart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Neem tyd vir gemeenskap",
          "met Jesus, jou Heer,",
          "die wêreld vergeet Hom -",
          "soek rykdom en eer.",
          "As jy let op Jesus,",
          "Hom altyd wil dien,",
          "sal jou vriende spoedig",
          "Jesus in jou sien."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Neem tyd vir gemeenskap,",
          "Hy sal jou steeds lei;",
          "Volg waar Hy vooruitgaan,",
          "maar gaan nie verby.",
          "In blydskap en droefheid,",
          "wees Hom nie ontrou;",
          "Sy weë is lieflik,",
          "o, volg Hom getrou!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Neem tyd vir gemeenskap,",
          "wees stil voor jou Heer,",
          "laat Hom jou gedagtes",
          "en dade beheer.",
          "Met lewens geheilig",
          "van wêreldse stof,",
          "word sondaars herskape",
          "vir diens in Gods hof."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "In the hour of trial",
    "hymnNumber": 277,
    "reference": "AL277",
    "title": "Gaan Ek Deur Beproewing",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Gaan ek deur beproewing,",
          "Jesus, bid vir my;",
          "Word ek tot bedroewing",
          "van U Gees verlei",
          "en U sien ek weifel, ",
          "rig U oog op my,",
          "dan sal vrees nog twyfel",
          "my tot kwaad verlei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Lok die ydelhede",
          "van die wêreld my,",
          "rig U dan my skrede, ",
          "wil my siel bevry!",
          "Wankel ek onseker, ",
          "'k sal berouvol dink",
          "aan die wrange beker",
          "wat my Heer moes drink."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wanneer U genade",
          "smart beskik oor my,",
          "as ek pyn en skade",
          "hier benee moet ly,",
          "sal ‘k my laste immer",
          "wentel op my, Heer,",
          "dan vergeet ek nimmer",
          "dat my God regeer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Be silent, be silent",
    "hymnNumber": 278,
    "reference": "AL278",
    "title": "Wees Stil Nou",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Wees stil nou, wees stil nou,",
          "wees stil voor die Heer.",
          "Wees stil nou en luister,",
          "Sy stem is so teer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wees stil nou, wees stil nou,",
          "want dit is Gods plan",
          "dat ons uit Sy tempel",
          "die wêreld verban."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wees stil nou, wees stil nou,",
          "bid need'rig en sag.",
          "‘n voorsmaak van Eden",
          "geniet jy vandag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wees stil nou, wees stil nou,",
          "Hy daal tot ons neer.",
          "Wees stil nou, wees stil nou,",
          "en wag op die Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Loop saggies, loop saggies,",
      "die Heer is naby.",
      "Loop saggies, loop saggies,",
      "Hy is aan jou Sy."
    ]
  },
  {
    "english": "Come, my soul, thy suit prepare!",
    "hymnNumber": 279,
    "reference": "AL279",
    "title": "Kom, My Siel, Berei Jou Voor",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Kom, my siel, berei jou voor;",
          "God sal jou gebed verhoor -",
          "gaan dan met vrymoedigheid,",
          "Hy alleen verstaan jou stryd."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Delg my sonde uit, o Heer,",
          "ek wil my tot U bekeer;",
          "Was my, Heiland, maak my rein,",
          "laat U liefde oor my skyn."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Meester, neem besit van my,",
          "as U heers, dan is ek vry!",
          "Van U koningskap bewus,",
          "vind my siel die soetste rus!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Let the words of my mouth",
    "hymnNumber": 280,
    "reference": "AL280",
    "title": "Laat Elk' Woord Van My Mond",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.5,
      "introEnd": 24.7
    },
    "verses": [
      {
        "content": [
          "Laat elk woord van my mond -",
          "die oordenkinge van hierdie hart",
          "welbehaaglik wees in U oog,",
          "my God, my Sterkte en Verlosser. ",
          "Amen."
        ],
        "verseNumber": 1
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, I care not for riches",
    "hymnNumber": 281,
    "reference": "AL281",
    "title": "Heer, Ek Vra U Geen Rykdom",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 29.3,
      "intro": 36.5
    },
    "verses": [
      {
        "content": [
          "Heer, ek vra U geen rykdom",
          "ook geen silwer of eer;",
          "Ek verlang om daarbowe",
          "te kan staan by my Heer.",
          "Is my naam ook geskrywe,",
          "o, my Heiland, ek vra,",
          "in die boek van die lewe,",
          "deur U grote gena?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heer, my sonde is vele,",
          "soos die sand aan die see,",
          "maar U bloed, o my Heiland,",
          "kan vergiffenis gee.",
          "U belofte is seker",
          "en U woorde staan vas:",
          "Is jou hart soos skarlaken,",
          "dit sal wit word soos was."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O die lieflike Godstad",
          "met sy wonings so skoon",
          "en sy heerlike wesens",
          "wat U handewerk kroon,",
          "waar geen sonde besoedel,",
          "maar U majesteit troon,",
          "sê my, Jesus my Heiland,",
          "sal ek eendag daar woon?"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Word my naam ook gevind,",
      "o my Heiland, ek vra,",
      "in die boek van die lewe,",
      "deur U grote gena?"
    ]
  },
  {
    "english": "I will follow Thee, my Saviour",
    "hymnNumber": 282,
    "reference": "AL282",
    "title": "Ek Sal Volg, Getroue Heiland",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.9,
      "intro": 26.9
    },
    "verses": [
      {
        "content": [
          "Ek sal volg, getroue Heiland,",
          "waar U my ook al mag lei;",
          "Waar U gaan, my Heer en Meester,",
          "volg ek immer aan U sy."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As my weg soms ru en steil is",
          "deur 'n wilde woesteny,",
          "weet ek dat U voor my daar was",
          "en ek volg waar U my lei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gaan ek soms deur groot verdrukking,",
          "al versoek die vyand my,",
          "ek onthou dat U versoek is",
          "en volg juigend waar U lei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gaan die weg soms deur beproewing,",
          "moet ek ook ontbering ly,",
          "U was arm en sonder tuiste;",
          "Ek sal volg net waar U lei."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Sluit die doodsrivier se waters",
          "eens in kille vrees om my,",
          "U was voor my deur die golwe,",
          "en ook daar sal U my lei."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Ek sal volg, deur U genade,",
      "want U sterwe was vir my;",
      "En as almal U verlaat het,",
      "sal ek volg waar U my lei."
    ]
  },
  {
    "english": "Jesus, I my cross have taken",
    "hymnNumber": 283,
    "reference": "AL283",
    "title": "Dierb're Heer, Deur U Genade",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "Dierb're Heer, deur U genade",
          "wil 'k my kruis geduldig dra;",
          "Wat gewin was, ag ek skade",
          "en ek volg U daagliks na.",
          "Ja, ek staak die dwase strewe",
          "na genot, na roem en eer,",
          "vir die volheid van 'n lewe",
          "in die rykdom van my Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sien die wêreld met veragting,",
          "soos op U, op my ook neer -",
          "net van U is my verwagting,",
          "dierbare, getroue Heer;",
          "Want geen aardse leed verstoor my",
          "as ek in U liefde bly,",
          "en geen aardse vreug bekoor my",
          "as dit my van U moet skei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O my siel, aanvaar die vryheid",
          "wat die evangelie bied,",
          "en verheug jou in die blyheid",
          "wat jy in jou Heer geniet!",
          "Dink! Jou Vader is almagtig,",
          "Jesus ken jou aardse lot,",
          "en die Gees werk in jou kragtig -",
          "kan jy twyfel, kind van God?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Lei my deur U hand, o Vader,",
          "hier van krag tot krag steeds voort,",
          "tot ek met U volk vergader",
          "daar in gindse saal'ge oord!",
          "Daar vir ewig eens behoue,",
          "sal ek aardse pyn vergeet;",
          "Daar word my geloof aanskoue,",
          "my gebed 'n triomfkreet!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O let me walk with Thee, my God",
    "hymnNumber": 284,
    "reference": "AL284",
    "title": "O Laat My Wandel, Heer, Met U",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "O laat my wandel, Heer, met U,",
          "soos Henog in gehoorsaamheid:",
          "Hou U my swakke hand hier vas;",
          "Omring my met U majesteit.",
          "Hoe duister ook die weg vir my,",
          "o laat my wandel aan U sy."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Alleen kan ek nie gaan nie, Heer,",
          "die nag is donker, vol gevaar;",
          "‘n duisend strikke op my weg",
          "sal skrik en dood en onheil baar.",
          "Verstil die winde om my heen,",
          "o Here, laat my nie alleen!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As U my aan die hand wil hou,",
          "word aardse vreugde net 'n skim,",
          "dan reis ek sonder vrees en dra",
          "die kruis se vaandel wyl ek klim",
          "na hoër sfere in U Naam,",
          "so wandel ek met Jesus saam."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O Master, let me walk with Thee",
    "hymnNumber": 285,
    "reference": "AL285",
    "title": "O Meester, Wandel U Met My",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "O Meester, wandel U met my;",
          "Ek wil U need'rig diensbaar bly,",
          "verdryf die twyfel wat nog pla,",
          "en help my om my las te dra."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat die wat traag is om te leer,",
          "hul op my woord tot U bekeer;",
          "Help my om dwalendes te rig",
          "en bring hul tot U groter lig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Maak my geduldig, liewe Heer,",
          "sagmoedig as ek ander leer;",
          "Wil U geloof in my versterk",
          "as ek met liefde vir U werk."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "In hoop wat al sy helder lig",
          "ver op die toekomsjare rig;",
          "In vrede wat ons nie verstaan,",
          "o Meester, laat my met U gaan."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Earthly Pleasures Vainly Call Me",
    "hymnNumber": 286,
    "reference": "AL286",
    "title": "Aardse Vreugde Lok Nie Meer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15,
      "intro": 15
    },
    "verses": [
      {
        "content": [
          "Aardse vreugde lok nie meer nie,",
          "ek wil wees soos Jesus.",
          "Geen plesier sal my ooit keer nie,",
          "ek wil wees soos Jesus!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy verbreek die sondebande,",
          "ek wil wees soos Jesus;",
          "Dan dien ek met hart en hande,",
          "ek wil wees soos Jesus!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heel die weg volg ek Sy leiding,",
          "ek wil wees soos Jesus;",
          "Telkens weer die ou, ou tyding,",
          "ek wil wees soos Jesus!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Eens by Hom in hemelhowe",
          "wil ek wees soos Jesus;",
          "Hoor ek: “Welgedaan' daarbowe,",
          "ek wil wees soos Jesus!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Net soos Jesus wil ek leef,",
      "orals waar ek my begeef;",
      "Ek wil maar gedurig streef",
      "om te wees soos Jesus."
    ]
  },
  {
    "english": "Sitting at the feet of Jesus",
    "hymnNumber": 287,
    "reference": "AL287",
    "title": "Aan Die Voete Van My Heiland",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Aan die voete van my Heiland",
          "klink Sy woorde teer en sag;",
          "Heil'ge plek so hoog verhewe,",
          "naby Jesus elke dag.",
          "Aan die voete van my Heiland",
          "met gedagtes van weleer,",
          "sien ek weer Sy groot genade -",
          "dit het my tot Hom bekeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Aan die voete van my Heiland",
          "Hy's my vreugde en my lus -",
          "lê ek al my sondeskulde;",
          "As ek moeg is - daar is rus.",
          "Aan die voete van my Heiland,",
          "waar ek dikwels ween en bid -",
          "daar is rykdom van genade",
          "waar ek aan Sy voete sit."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Seën my, my Heiland seën my,",
          "ek wag aan U voete nou.",
          "Kyk in liefde op U dienskneg,",
          "laat my U vandag aanskou.",
          "Gee my Jesus se gesindheid,",
          "maak my tot Sy diens bereid.",
          "Laat hul sien ek was met Jesus;",
          "Hy is my geregtigheid."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I come to the garden alone",
    "hymnNumber": 288,
    "reference": "AL288",
    "title": "Ek Kom Na Die Blomtuin",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 24.4,
      "intro": 37.4
    },
    "verses": [
      {
        "content": [
          "Ek kom na die blomtuin alleen,",
          "as die dou nog rus op die rose;",
          "En die stem wat spreek,",
          "as die môre breek",
          "is weer die stem van Jesus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy spreek en Sy stem is so soet",
          "dat die voëltjies stilby en luister;",
          "En die skone lied ",
          "wat Hy aan my bied,",
          "weerklink nog as Hy fluister."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek sou in die blomtuin wou bly,",
          "al kom daal die skaduwees oor my.",
          "En ek voel 'n traan,",
          "as Hy my laat gaan,",
          "en sien Sy glimlag voor my."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "En ons wandel daar en verstaan mekaar,",
      "en Hy praat met my as Sy kind;",
      "En die stil genot, daardie uur met God,",
      "sal iemand maar selde vind."
    ]
  },
  {
    "english": "From every stormy wind that blows",
    "hymnNumber": 289,
    "reference": "AL289",
    "title": "Van Ied're Stormwind Wat Daar Woed",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.9
    },
    "verses": [
      {
        "content": [
          "Van ied're stormwind wat daar woed,",
          "van elke hete tranevloed,",
          "is Gods genadetroon vir my",
          "‘n skuilplek deur die Heer berei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar sal die Heiland, na verdriet,",
          "weer vreugdeolie op ons giet;",
          "By Sy genadetroon het Hy",
          "‘n toevlugsoord vir ons berei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Soete gemeenskap het ons daar",
          "met onse God en met mekaar;",
          "Vir dierbares hier wreed geskei,",
          "het God die heiligdom berei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Op eng'lewieke sal ons styg,",
          "ver bo die aardse stryd en kryg",
          "na die genadetroon, waar Hy",
          "oorwinnings vir Sy volk berei."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ja, waar sou die verlate kind",
          "dan redding uit versoeking vind,",
          "en waar sou Hy dan uitkoms kry",
          "as God geen toevlugsoord berei?"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus calls us; o'er the tumult",
    "hymnNumber": 290,
    "reference": "AL290",
    "title": "Jesus Roep Ons Oor Die Dreuning",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.9
    },
    "verses": [
      {
        "content": [
          "Jesus roep ons oor die dreuning",
          "van die see se vloedgety;",
          "Dag na dag klink soet Sy roepstem:",
          "“Christen, kom en volg net My!'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus roep ons as ons harte",
          "smag na yd'le glans en eer.",
          "Weg van elke dwase afgod",
          "roep Hy: “Christen, min My meer!'"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In ons vreugde, in ons droefheid,",
          "waar ons arbei, waar ons rus,",
          "klink Sy stem vol tere liefde:",
          "“Christen, is die Heer jou lus?'"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Jesus roep ons! Skenk genade",
          "dat ons U mag hoor, o Heer,",
          "en ons harte en ons lewens",
          "wy om U alleen te eer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Be silent, be silent",
    "hymnNumber": 291,
    "reference": "AL291",
    "title": "Soet Belofte Van Die Here",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.5,
      "intro": 32.3
    },
    "verses": [
      {
        "content": [
          "Soet belofte van die Here",
          "aan die swerwer en aan my:",
          "“Op die ruwe weg na bowe",
          "sal Ek met My oog jou lei'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As versoekings jou wil neerdruk",
          "en geen medepelgrim bly,",
          "hoor die woorde van die Meester:",
          "'met My oog sal Ek jou lei'."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As die hart se hoop vergaan het",
          "met die jare lank verby,",
          "hoor die dierbare belofte",
          "'met My oog sal Ek jou lei'."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As die dood se skadu's nader,",
          "met jou lewenstryd verby,",
          "hoor die Gids se helder roepstem:",
          "'met My oog sal Ek jou lei'."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ek sal voorgaan na die hemel,",
      "met My oog sal Ek jou lei.",
      "Op die ruwe weg na bowe",
      "sal Ek met My oog jou lei."
    ]
  },
  {
    "english": "He leadeth me! O blessed thought!",
    "hymnNumber": 292,
    "reference": "AL292",
    "title": "Hy Lei My Voort Gedagte Soet!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.7,
      "intro": 29.3
    },
    "verses": [
      {
        "content": [
          "Hy lei my voort: gedagte soet!",
          "Die woorde troos my bang gemoed;",
          "Wat ek mag doen, waar ek mag bly,",
          "dit is Gods hand wat my hier lei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Deur bitter leed en stil geween,",
          "deur al my vreug en blydskap heen,",
          "in storm en stilte, daar is Hy,",
          "dis nog Sy hand wat my hier lei!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As ek net aan U hand kan hou,",
          "dan sal die weg my nooit berou -",
          "tevrede met U plan vir my,",
          "solank U hand my steeds gelei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En is my taak op aarde klaar,",
          "die einde van my loopbaan daar,",
          "dan vrees ek nie die doodsvallei,",
          "omdat U hand ook daar nog lei!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Die Here lei! Hy lei my voort",
      "op weë waar my voetstap hoort.",
      "Ek volg getrou net waar Hy lei,",
      "Sy hand sal altyd oor my bly."
    ]
  },
  {
    "english": "Lead Thou me on, and then my feet, though weary",
    "hymnNumber": 293,
    "reference": "AL293",
    "title": "Lei U My Voort",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 18.1
    },
    "verses": [
      {
        "content": [
          "Lei U my voort,",
          "dan struikel ek nie meer nie,",
          "hoe lank ook al die ",
          "ruwe lewensbaan,",
          "al val die skadu's oor my weg,",
          "ek vrees nie,",
          "want U, o Heer, het reeds ",
          "vooruitgegaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Vul my, o Heer, met liefde",
          "rein en heilig,",
          "dan reflekteer ek al ",
          "U liefde weer;",
          "Al sou die lewe my van ",
          "U wou wegskeur,",
          "dan juig ek nog, ",
          "want Jesus is my Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skenk my oorvloedige genade, Here,",
          "as al die vyandsmagte ",
          "teen my staan,",
          "en as die sorge my ",
          "sou dryf tot wanhoop,",
          "neem U my hand, ",
          "en wees oor my begaan!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "U vrede gaan my ",
          "klein verstand te bowe",
          "en hul my siel in ",
          "kalme hemelsrus,",
          "al dryf die storm my weg",
          "van land en hawe,",
          "sal ek tog veilig anker ",
          "aan die kus."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ek weet dat U my alles ",
          "skenk in Jesus",
          "in wie die rykdom van ",
          "die skpping woon.",
          "In die geloof reik ek ",
          "deur Hom na bowe -",
          "Hy gee my kruis, maar Hy skenk",
          "ook my kroon."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Saviour, like a Shepherd lead us",
    "hymnNumber": 294,
    "reference": "AL294",
    "title": "Heiland, Soos ‘n Herder Lei Ons",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.1
    },
    "verses": [
      {
        "content": [
          "Heiland, soos 'n herder lei ons,",
          "hoe kan ons U sorg ontbeer?",
          "In U groene velde wei ons,",
          "wees ons herder, troue Heer.",
          "Dierb're Jesus, dierb're Jesus,",
          "leer ons om U Naam te eer;",
          "Dierb're Jesus, dierb're Jesus,",
          "leer ons om U Naam te eer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons is skape van U weiding;",
          "Laat U gunste op ons daal;",
          "Skenk ons elke dag U leiding,",
          "roep ons t'rug wanneer ons dwaal.",
          "Dierb're Jesus, dierb're Jesus,",
          "laat U liefde ons bestraal;",
          "Dierb're Jesus, dierb're Jesus",
          "laat U liefde ons bestraal."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U, o Heer, het ons belowe",
          "dat U by U volk sal staan;",
          "Stuur 'n engel van U howe",
          "om die weg vir ons te baan.",
          "Dierb're Jesus, dierb're Jesus,",
          "ons wil altyd met U gaan;",
          "Dierb're Jesus, dierb're Jesus,",
          "ons wil altyd met U gaan."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord is my Shepherd, no want shall I know",
    "hymnNumber": 295,
    "reference": "AL295",
    "title": "Die Heer Is My Herder",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Die Heer is my Herder;",
          "Niks sal my ontbreek",
          "in weivelde groen ",
          "lê Hy my saggies neer.",
          "Na waters wat stil is,",
          "daar lei Hy my heen,",
          "en as ek soms wegdwaal,",
          "dan soek Hy my weer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Moet ek deur die dal van die",
          "doodskadu gaan,",
          "dan vrees ek geen kwaad,",
          "want die Heer is by my;",
          "Sy krag en genade ",
          "sal my steeds behou;",
          "Sy stok en Sy staf sal vertroos",
          "en bevry."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In droefheid sal U ",
          "my 'n tafel berei;",
          "U salf my met olie, ",
          "my beker loop oor;",
          "U skenk my verblyding,",
          "my siel word verkwik,",
          "o wie sal my vrede ",
          "in Jesus verstoor?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Net goedheid en guns",
          "sal my voetstappe volg",
          "tot ek eens in glorie ",
          "my Herder aanskou.",
          "Ek sal in die huis ",
          "van die Here vertoef,",
          "in lengte van dae ",
          "dien ek Hom getrou."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "All the way my Saviour leads me",
    "hymnNumber": 296,
    "reference": "AL296",
    "title": "Jesus Lei My Deur Die Lewe",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Jesus lei my deur die lewe -",
          "waarna kan ek anders smag?",
          "Kan ek twyfel aan Sy liefde?",
          "Dit gee leiding, lig en krag.",
          "Soete vrede en vertroosting",
          "sal my hart in Hom bewaar;",
          "Alles werk vir my ten goede,",
          "wat my ook mag wedervaar,",
          "alles werk vir my ten goede,",
          "wat my ook mag wedervaar."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus lei my deur die lewe,",
          "rig my op wanneer ek val;",
          "Sy genade is genoegsaam,",
          "selfs in hierdie skadudal!",
          "In Sy wil is hemelspyse,",
          "daarom word ek moeg nog mat;",
          "Uit die Rots vloei daar fonteine",
          "oor my dorre lewenspad,",
          "uit die Rots vloei daar fonteine",
          "oor my dorre lewenspad."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jesus lei my deur die lewe,",
          "deel Sy volheid aan my mee,",
          "en beloof om my 'n woning",
          "in die Vaderhuis te gee.",
          "As Hy my onsterflik opwek",
          "en met heerlikheid beklee,",
          "is my lied deur al die eeue:",
          "Jesus het my steeds gelei!",
          "Is my lied deur al die eeue:",
          "Jesus het my steeds gelei!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, Saviour, pilot me",
    "hymnNumber": 297,
    "reference": "AL297",
    "title": "Jesus, Heiland, Lei U My",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Jesus, Heiland, lei U my",
          "oor die wilde vloedgety.",
          "Onbekende strome maal,",
          "bange, donker nagte daal;",
          "Heer, U het kompas en kaart,",
          "lei my op my lewensvaart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Soos 'n moedershand wat sus",
          "tot die kindjie saggies rus,",
          "kan U met 'n handgebaar",
          "wilde golwe laat bedaar.",
          "Gaan, o Heerser van die see,",
          "na die hawe met my mee."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sien ek dan ten laaste land,",
          "hoor ek branders op die strand",
          "waar die ruwe rotse my",
          "van my vaderswoning skei;",
          "Mag ek dan U woorde hoor:",
          "“Vrees nie, ons gaan saam daaroor!'"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Shepherd of tender youth",
    "hymnNumber": 298,
    "reference": "AL298",
    "title": "Herder Van Prille Jeug",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Herder van prille jeug,",
          "wat waarheid leer en deug,",
          "U is alwys!",
          "Christus, Oorwinnaar, Heer,",
          "ons wil U Naam vereer,",
          "en ook ons kinders leer",
          "om U te prys."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heilig is U, ons God,",
          "U Woord en U gebod ",
          "skik alle twis;",
          "U het in smaad gesterf,",
          "en onse heil verwerf;",
          "Uit allerdiepst' verderf",
          "red U gewis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons Hoëpriester,",
          "Hy wat ons 'n fees ",
          "berei so liefderyk",
          "Hy lenig onse pyn,",
          "laat angs en vrees verdwyn,",
          "en maak ons harte rein;",
          "Laat sonde wyk."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wees onse Gids, o Heer,",
          "dan kan geen kwaad ons deer.",
          "Sterk ons geloof,",
          "lei in U eie spoor;",
          "Laat ons U woorde hoor,",
          "gaan self U kinders voor,",
          "ons Heer en Hoof!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The King of love my Shepherd is",
    "hymnNumber": 299,
    "reference": "AL299",
    "title": "My Troue Herder Is Die Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.5
    },
    "verses": [
      {
        "content": [
          "My troue herder is die Heer,",
          "niks goeds ontbreek my immer;",
          "Geen bose magte kan my deer,",
          "want Hy verlaat my nimmer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waar strome lewenswater vloei",
          "verkwik Hy my genadig;",
          "En waar die weiveld welig groei,",
          "sal Hy my siel versadig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hy roep my as ek soms verdwaal",
          "deur dwaasheid, eiesinnig;",
          "En in Sy boesem, telkemaal,",
          "berg Hy my teer en innig."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "So lank ek hier op aarde bly,",
          "ontbreek die goeie nimmer;",
          "As ek my eens daarbo verbly,",
          "loof ek my Herder immer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, Thy children guide and keep",
    "hymnNumber": 300,
    "reference": "AL300",
    "title": "Heer, Wil Ons Behoed, Bewaar",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Heer, wil ons behoed, bewaar,",
          "en ons teen die steiltes lei,",
          "want die pad is vol gevaar",
          "deur die wilde woesteny.",
          "Heil'ge Jesus, lei ons reg,",
          "daagliks op die enge weg."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar lê sandwoestyne voor -",
          "berge, dale, lyding, smart -",
          "waar die swakkes val en sterf,",
          "help ons om te kan volhard.",
          "Heil'ge Jesus, lei ons reg,",
          "daagliks op die enge weg."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar lê skoon valleie voor",
          "vol met goue weeldrigheid -",
          "skoonheid wat die hart bekoor -",
          "red ons dan van sorgloosheid.",
          "Heil'ge Jesus, lei ons reg,",
          "daagliks op die enge weg."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Opwaarts na die Vaderhuis,",
          "voorwaarts na die beter land",
          "waar die lewenstrome ruis -",
          "lei ons saggies aan die hand.",
          "Heil'ge Jesus, lei ons reg,",
          "daagliks op die enge weg."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I will never, never leave thee",
    "hymnNumber": 301,
    "reference": "AL301",
    "title": "Ek Sal Nimmer Jou Verlaat Nie",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Ek sal nimmer jou verlaat nie,",
          "nimmer laat Ek jou alleen;",
          "Ek sal lei en red en uithelp",
          "jou met krag en sterkte seën;",
          "Vrees geen kwaad nie,",
          "vrees geen kwaad nie,",
          "neem slegs wat Ek jou verleen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As die storms jou gans ",
          "omgewe,",
          "roep my aan in die gebed;",
          "Ek sal jou oordek met vleuels",
          "en jou uit gevare red.",
          "Uit beproewing en versoeking",
          "sal My sterke hand jou red."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As die lug daarbo weer blou is",
          "en die son weer helder skyn,",
          "en die vreugde vloei soos strome",
          "deur die dorre sandwoestyn,",
          "staan Ek by jou;",
          "Staan Ek by jou;",
          "Hou Ek jou gedagtes rein."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Is jou siel bedroef, ",
          "mismoedig,",
          "swaar belas met sorg en pyn;",
          "Sal Ek deur die donker wolke",
          "van My liefdeslig laat skyn;",
          "En die vaandel van My liefde",
          "sal oor jou nie weer verdwyn."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Shepherd divine, Thou leadest me",
    "hymnNumber": 302,
    "reference": "AL302",
    "title": "O Herder Trou, Wil U My Lei",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "O Herder trou, wil U my lei,",
          "waar stille waters saggies vloei,",
          "na groene velde bring U my,",
          "laat ook in my U liefde bloei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "En as die vyand om my skree,",
          "bedek U my teen elke skrik;",
          "U sal my in U skaduwee",
          "met Goddelike rus verkwik."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En as die dag ten einde spoed,",
          "dan roep U my om t'rug te keer:",
          "ek hoor U stem wat my begroet,",
          "en haas my na die kudde weer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Guide me, O Thou great Jehovah!",
    "hymnNumber": 303,
    "reference": "AL303",
    "title": "O Jehova, Gaan U Voor My",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.7
    },
    "verses": [
      {
        "content": [
          "O Jehova, gaan U voor my,",
          "pelgrim deur 'n dorre land;",
          "Ek is swak maar U is magtig;",
          "Lei my met U sterke hand.",
          "Lewegewer, Lewegewer;",
          "Voed my met die Lewensbrood! ",
          "Voed my met die Lewensbrood!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat die waters van genesing",
          "altyd langs my weë vloei,",
          "stuur die wolkkolom se skadu",
          "as die middagson my skroei;",
          "Sterke Redder, sterke Redder;",
          "Wees U krag en skild vir my. ",
          "Wees U krag en skild vir my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat my sonder angs of vrese",
          "deur die doodsjordaan ook gaan;",
          "Lei my veilig deur die water",
          "tot ek eens in Kanaän staan.",
          "Lofgesange, lofgesange,",
          "sing ek dan U Naam ter eer! ",
          "Sing ek dan U Naam ter eer!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "One precious boon, O Lord, I seek",
    "hymnNumber": 304,
    "reference": "AL304",
    "title": "Een Guns Wil Ek Van U Begeer",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Een guns wil ek van U begeer",
          "op hierdie ruwe lewensee;",
          "Wanneer ek U behaag, o Heer,",
          "wil dit aan my te kenne gee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek sal nie kla oor smaad en spot,",
          "al word ek deur die mens verstoot;",
          "Weet ek dit is die wil van God,",
          "bly ek getrou tot in die dood."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al sou my vriende van my keer",
          "en hul met my nie wil versoen,",
          "dan bid ek nog: o Troue Heer,",
          "vergeef! Hul weet nie wat hul doen."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As ek net weet ek doen Sy wil,",
          "die werke wat my Heer behaag,",
          "dan word die onrus in my stil",
          "en alle vrees en pyn vervaag."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ek wag op daardie blye dag",
          "deur heiliges van God voorspel",
          "wanneer U kom met grote krag,",
          "om alle dinge te herstel."
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Na ek die spot en smaad moes dra",
          "vir Hom wat nog vir sondaars pleit,",
          "verander dit in vreugde, ja,",
          "in heerlike onsterflikheid."
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "Father, lead me day by day",
    "hymnNumber": 305,
    "reference": "AL305",
    "title": "Vader, Lei My Dag Na Dag",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 10
    },
    "verses": [
      {
        "content": [
          "Vader, lei my dag na dag",
          "op U weë, soet en sag,",
          "ek is met U wil versoen;",
          "Toon my steeds wat ek moet doen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Immer veilig aan U sy,",
          "volg ek waar U Gees my lei,",
          "kloek en moedig in gevaar,",
          "wetend dat U my bewaar."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As die bose my versoek,",
          "laat die woorde van U Boek",
          "steeds in my gedagte wees",
          "as die wapen van die Gees."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Word die werk te hard vir my,",
          "maak my opgeruimd en bly;",
          "En is droefheid hier my lot,",
          "skenk my U geduld, o God."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ek wil goed doen waar ek kan,",
          "leed versag en pyn verban,",
          "tot die einde van die pad",
          "waar ek rus vind in U stad."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Lead, kindly Light, amid the encircling gloom",
    "hymnNumber": 306,
    "reference": "AL306",
    "title": "Lei, Vriend'lik Lig",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28
    },
    "verses": [
      {
        "content": [
          "Lei, vriend'lik lig,",
          "in awendskemering, ",
          "lei U my voort!",
          "Die nag is hier en ek is ver van huis,",
          "lei U my voort.",
          "Ek vra geen lig vir dae wat nog wag;",
          "Skenk U my lig genoeg vir hierdie dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het nie altyd so van U begeer",
          "dat U my lei;",
          "Ek wou self kies, maar nou bid ek,",
          "o Heer, wil U my lei!",
          "My eie wil, my eie trots moes lei,",
          "ag, Heer, vergeef!",
          "Want dit is nou verby."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Tot hier het U my moed",
          "en krag verleen - het U gelei;",
          "Oor berg en dal, oor wye vlaktes heen",
          "sal U my lei;",
          "Tot Jesus kom en ek verruk sal staan",
          "waar pelgrims saam met Hom",
          "sal binnegaan. Amen."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Hold Thou my hand, so weak I am and helpless",
    "hymnNumber": 307,
    "reference": "AL307",
    "title": "Hou U My Hand",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Hou U my hand,",
          "want ek is swak en hulp'loos;",
          "Ek durf geen skrede sonder Jesus gaan;",
          "Hou U my hand,",
          "want dan, o dierb're Heiland,",
          "vrees ek nie meer,",
          "omdat U by my staan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hou U my hand,",
          "trek my gedurig nader,",
          "dig aan U sy, my Hoop, my Troos,",
          "my Al!",
          "Hou U my hand,",
          "dan sal ek nimmer dwaal nie,",
          "rig U my op wanneer ek somtyds val."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hou U my hand,",
          "die weg daar voor is duister;",
          "O hoe verlang ek om by U te woon!",
          "Maar as ek in geloof",
          "U glorie waarneem,",
          "dan juig my siel",
          "en sing ek voor U troon."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "There is a blessed hope",
    "hymnNumber": 308,
    "reference": "AL308",
    "title": "Daar Is ‘n Saal'ge Hoop",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.7
    },
    "verses": [
      {
        "content": [
          "Daar is 'n saal'ge hoop,",
          "geseënd in die Heer,",
          "veel skoner as die dwase spot",
          "van aardse roem en eer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is 'n helder ster",
          "wat skone lig verskaf,",
          "dit sprei sy vrede stil en sag",
          "oor elke donker graf."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar is 'n blye stem",
          "wat ons na bowe roep;",
          "Dit neem ons vrees en twyfel weg",
          "en fluister: 'God is goed'."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die stem van Golgota,",
          "spreek elke sondaar vry!",
          "Die ster is openbaringslig,",
          "wat na die hemel lei."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Be Still, My Soul",
    "hymnNumber": 309,
    "reference": "AL309",
    "title": "Wees Stil My Siel",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 37.7
    },
    "verses": [
      {
        "content": [
          "Wees stil, my siel die Here hou die wag;",
          "Verdra geduldig kruis en bed en pyn,",
          "God sal voorsien - Hy lei ons dag na dag;",
          "Hy bly getrou,",
          "waar aardse vriendskap kwyn.",
          "Wees stil, my siel jou beste vriend is Hy;",
          "Hy sal jou veilig tot die einde lei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wees stil, my siel, jou God sal onderneem",
          "om ook vandag te lei soos in weleer.",
          "Jou hoop en jou geloof",
          "mag nie vervreem;",
          "Ons duisternis is helder voor die Heer.",
          "Wees stil, my siel die golwe en die wind",
          "ken nog die stem van Nasaret se Kind."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wees stil, my siel die uur sal spoedig slaan",
          "wanneer ons altyd by die Heer sal woon.",
          "Met elke grief en vrees en pyn vergaan",
          "sal ons vergeet,",
          "want heerlik is die kroon.",
          "Wees stil, my siel jou trane gaan verby,",
          "en veilig sal ons dan vir ewig bly."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O, for a closer walk with God!",
    "hymnNumber": 310,
    "reference": "AL310",
    "title": "Skenk My ‘n Nouer Band Met God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Skenk my 'n nouer band met God,",
          "van kalme lewensvree,",
          "‘n lig wat voorgaan op my weg,",
          "my lei tot by die Lam."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kom weer, o Heil'ge Gees, kom weer,",
          "o Boodskapper so bly;",
          "Ek haat die sonde daagliks meer",
          "wat U van my wil skei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die stille ure saam met U,",
          "o soet gedagtenis!",
          "Dit bring 'n weemoed in my hart",
          "as ek weer eensaam is."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die liefste afgod wat ek ken,",
          "wat ek ookal begeer -",
          "help my dit wegskeur uit my hart",
          "dat U daar kan regeer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "More love to Thee, O Christ!",
    "hymnNumber": 311,
    "reference": "AL311",
    "title": "Meer Liefde, Heer, Vir U",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Meer liefde, Heer, vir U,",
          "meer elke dag!",
          "Hoor tog, ek roep tot U,",
          "biddend om krag.",
          "Dis my gebed vandag;",
          "Meer liefde, Heer, vir U;",
          "Meer elke dag, meer elke dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het na eer gesoek – ",
          "aardse genot -",
          "nou soek ek U alleen; ",
          "U is my God.",
          "Dis my versoek vandag;",
          "Meer liefde, Heer, vir U;",
          "Meer elke dag, meer elke dag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat smart en droefheid kom;",
          "Stuur leed en pyn;",
          "Soet is U boodskappers,",
          "soet hul refrein,",
          "as hulle met my sing:",
          "meer liefde, Heer, vir U;",
          "Meer elke dag, meer elke dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ja, tot my laaste uur ",
          "sing ek U lof;",
          "En kom die dag wanneer ",
          "ek keer tot stof",
          "sal my gebed nog wees:",
          "meer liefde, Heer, vir U;",
          "Meer elke dag, meer elke dag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Nearer, my God, to Thee",
    "hymnNumber": 312,
    "reference": "AL312",
    "title": "Nader, My God, By U",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Nader, my God, by U,",
          "steeds naderby!",
          "Hoe swaar die kruis ook al,",
          "bestem vir my -",
          "tog sal my lied steeds bly:",
          "nader, my God, by U;",
          "Nader, my God, by U,",
          "steeds naderby!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al rus ek, swerweling,",
          "eensaam, alleen,",
          "met hierdie moeë hoof",
          "slegs op 'n steen;",
          "Tog voer my drome my",
          "nader, my God, by U;",
          "Nader, my God, by U,",
          "steeds naderby!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar sien ek in die lig",
          "‘n hemelleer;",
          "En duisend engele,",
          "klim op en neer.",
          "Hul roep en wink vir my",
          "nader, my God, by U;",
          "Nader, my God, by U,",
          "steeds naderby!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dan as ek weer ontwaak,",
          "daar in Gods hof,",
          "bou ek 'n altaar tot",
          "Sy eer en lof.",
          "So lei beproewing my",
          "nader, my God, by U;",
          "Nader, my God, by U,",
          "steeds naderby!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "En as ek juigend styg",
          "deur gindse sfeer -",
          "son, maan en ster verby -",
          "loof ek my Heer.",
          "Dan bring my loflied my",
          "nader, my God, by U;",
          "Nader, my God, by U,",
          "steeds naderby."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Nearer, still nearer, close to Thy heart",
    "hymnNumber": 313,
    "reference": "AL313",
    "title": "Nader, Steeds Nader",
    "hasMidi": true,
    "timestamps": {
      "intro": 28.7
    },
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Nader, steeds nader, dig aan U sy,",
          "trek my, my Heiland,",
          "so dierbaar vir my;",
          "Hou my genadig na aan U hart;",
          "Daar is geen trane,",
          "geen droefheid of smart.",
          "Daar is geen trane,",
          "geen droefheid of smart."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nader, steeds nader, niks kan ek gee,",
          "net maar my swakheid,",
          "my pyn en my wee;",
          "Neem U my sondes; rein wil ek wees!",
          "U kan my hart",
          "van sy wonde genees.",
          "U kan my hart",
          "van sy wonde genees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Nader, steeds nader, maak my U kind;",
          "Lank het die sonde",
          "my oë verblind;",
          "Ek soek die wêreldsvreugde nie meer;",
          "Gee my die kruishout",
          "en gee my die Heer!",
          "Gee my die kruishout",
          "en gee my die Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nader, steeds nader, wyl ek nog leef,",
          "tot eens U heerlike",
          "lig my omgeef;",
          "Deur al die eeue sal U my lei -",
          "nader, my Jesus,",
          "ja, dig aan U sy.",
          "Nader, my Jesus,",
          "ja, dig aan U sy."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Closer to Thee, my Father, draw me",
    "hymnNumber": 314,
    "reference": "AL314",
    "title": "Trek My Steeds Nader, O My Vader",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 30.2
    },
    "verses": [
      {
        "content": [
          "Trek my steeds nader, o my Vader,",
          "ek smag na U, my Heer;",
          "Daar aan U boesem vind ek ewig",
          "die rus wat ek begeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Trek my steeds nader, o my Heiland,",
          "U liefde is so skoon;",
          "Dan dwaal ek nie meer doelloos rond nie,",
          "want ek sal by U woon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heilige Gees, trek U my nader",
          "dat ek in U kan bly;",
          "Was my en heilig U my lewe,",
          "dan is ek rein en vry."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Nader aan U dierb're sy,",
      "trek, o Heiland, trek U my;",
      "Nader, nader, digter aan U sy."
    ]
  },
  {
    "english": "How tedious and tasteless the hours",
    "hymnNumber": 315,
    "reference": "AL315",
    "title": "Hoe Eensaam En Droewig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Hoe eensaam en droewig die uur",
          "as ek nie die Here kan sien!",
          "Die voëltjies, die blomme, die lug,",
          "is al hul bekoring ontneem;",
          "Die vol somerson het geen glans,",
          "die veld is in winter gehul;",
          "Maar sien ek Sy glimlag, is selfs",
          "die winter met skoonheid gevul."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sy Naam is 'n lieflike geur,",
          "Sy stem is 'n soet melodie,",
          "Sy glimlag verdrywe die nag",
          "en vul my met heilige vreug.",
          "En hou Hy my steeds by die hand,",
          "dan kan ek nie twyfel of vrees,",
          "geen sterfling gelukkig soos ek",
          "as lente my erf'nis sal wees!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My beker van vreugde loop oor",
          "wanneer ek my Heiland aanskou,",
          "geen voorspoed of teenspoed of tyd",
          "kan dan my gemoed meer ontrus.",
          "Vir my, van Sy liefde bewus,",
          "is rykdom slegs dwase vertoon;",
          "‘n kerker is soos 'n paleis",
          "as Jesus net daar by my woon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As ek dan U eiendom is",
          "en U dan my lied en my son,",
          "waarom bly daar droefheid en leed?",
          "Waarom is my winter so lank?",
          "Verdryf U my vrees en my nag,",
          "o gun my 'n plek voor U troon!",
          "Laat my U teenwoordigheid ken",
          "waar lente en liefde bly woon!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Some day the silver cord will break",
    "hymnNumber": 316,
    "reference": "AL316",
    "title": "Eendag Breek Hierdie Silwerkoord",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22,
      "intro": 33.1
    },
    "verses": [
      {
        "content": [
          "Eendag breek hierdie silwerkoord;",
          "My hart se lied sal dan verstom,",
          "maar, o, die vreugde ongehoord",
          "as ek ontwaak as Jesus kom!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Eens sal my aardse woning val -",
          "alleen die Bouer weet wanneer -",
          "maar dit weet ek: my Skepper sal",
          "my met 'n plek daarbo vereer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My son sal eendag laer sink,",
          "en ek sal stil ter ruste gaan",
          "totdat die groot basuin weerklink",
          "en ek verheerlik op sal staan."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ek sal Hom sien en na Hom gaan;",
      "En juigend voor my Heiland staan;",
      "Ek sal Hom daar my hulde bring",
      "en van Sy groot verlossing sing."
    ]
  },
  {
    "english": "I'm pressing on the upward way",
    "hymnNumber": 317,
    "reference": "AL317",
    "title": "Ek Gaan Langs Weë Hoog En Steil",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.9,
      "intro": 26.9
    },
    "verses": [
      {
        "content": [
          "Ek gaan langs weë hoog en steil",
          "en stadig klim ek myl na myl;",
          "My siel roep biddend waar ek gaan:",
          "laat my op hoër berge staan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek het nie lus om hier te bly",
          "waar ek teen vrees en twyfel stry;",
          "Nog bid ek as ek opwaarts gaan:",
          "laat my op hoër berge staan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek wil bo hierdie wêreld styg,",
          "waar selfs die bose magte swyg;",
          "O laat U hand my veilig bring",
          "waar heil'ges op die bergtop sing."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek wil die hoogste spits bereik",
          "vanwaar ek op die Godstad kyk;",
          "My bede: ek wil verder gaan -",
          "op Sion by die Here staan."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Heer, neem my hand en lei my voort",
      "na daardie saal'ge hemeloord;",
      "Ek wil met Jesus hoër gaan,",
      "en op die hemelvelde staan."
    ]
  },
  {
    "english": "O sometimes the shadows are deep",
    "hymnNumber": 318,
    "reference": "AL318",
    "title": "Die Skadu's Is Soms Byna Swart",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 30.2
    },
    "verses": [
      {
        "content": [
          "Die skadu's is soms byna swart,",
          "oneffe die weg na ons doel;",
          "En dikwels verduister my hart",
          "as droefheid en leed daaroor spoel."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe lank val my somtyds die dag,",
          "hoe steil is die pad wat ek gaan,",
          "as swoegend ek byna versmag,",
          "laat my dan, o Rots, by U staan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, digby die Rots wil ek staan",
          "om daar in Sy skadu te bly,",
          "wanneer ek oor berge moet gaan",
          "of selfs deur die skaduvallei."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "o Laat my dan vlug na die Rots,",
      "want die Rots is veel hoër as ek;",
      "O laat my dan vlug na die Rots,",
      "na die Rots soveel hoër as ek."
    ]
  },
  {
    "english": "Face to face with Christ my Saviour",
    "hymnNumber": 319,
    "reference": "AL319",
    "title": "Voor Die Aangesig Van Jesus!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22.4,
      "intro": 33.7
    },
    "verses": [
      {
        "content": [
          "Voor die aangesig van Jesus!",
          "O die vreugde wat ek erf!",
          "As ek in Sy oë opkyk,",
          "Hy wat hier vir my moes sterf!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hier sien ek Hom in die skemer,",
          "deur die sluier van my nag;",
          "Daar aanskou ek Hom in wese",
          "in die lig van volle dag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O die blydskap as ek daar is,",
          "met my pyn en smart verban!",
          "Al wat krom is, sal daar reg wees,",
          "elke 'waarom?' weet ek dan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O Sy aangesig so heerlik!",
          "Daar sien ek Sy glimlag soet;",
          "As ek opkyk na die Meester -",
          "Hy wat my so trou behoed!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Eens aanskou ek Hom in luister,",
      "ver verby die sterrelig;",
      "Niks sal dan my oog verduister,",
      "met my blik op Hom gerig."
    ]
  },
  {
    "english": "I need Thee, precious Jesus",
    "hymnNumber": 320,
    "reference": "AL320",
    "title": "Ek Het U Nodig, Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Ek het U nodig, Jesus,",
          "want ek is arm en swak -",
          "‘n swerwer en 'n pelgrim",
          "gekleed in as en sak.",
          "Ek het U liefde nodig,",
          "dit maak my laste lig;",
          "Dit lei my trae skrede",
          "en skenk my krag vir plig."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U hart, Heer, het ek nodig,",
          "oor al my sorg begaan,",
          "wat deel in my beproewings,",
          "en my verdriet verstaan.",
          "U Gees het ek ook nodig",
          "om self aan my te toon,",
          "om my te leer van Jesus -",
          "te lei tot voor Sy troon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek het U nodig, Jesus;",
          "Ek sal U spoedig sien",
          "omsirkel met 'n reënboog",
          "waar engele U dien.",
          "Daar met verloste skares",
          "sien ons U, Heer en Hoof;",
          "Met vreugde in ons harte",
          "sal ons U ewig loof."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Hark! hark, my soul! angelic songs are swelling",
    "hymnNumber": 321,
    "reference": "AL321",
    "title": "Luister Hoe Klink Die Skone Eng'lesange",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 31.9,
      "intro": 31.9
    },
    "verses": [
      {
        "content": [
          "Luister hoe klink die skone eng'lesange",
          "ver oor die velde en die oseaan!",
          "Hoe soet die boodskap",
          "in my diep verlange",
          "na daardie land waar ",
          "sonde nie bestaan!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons gaan steeds voorwaarts,",
          "want die stemme roep nog:",
          "'kom, moeë siel want Jesus wag vir jou!'",
          "En deur die donker nooi hul ons ",
          "so vriend'lik",
          "na daardie huis wat eng'le vir ons bou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ver, ver vandaan hoor ons",
          "soos awendklokke",
          "die stem van Jesus ",
          "roep oor berg en vlei",
          "na siele wat in aardse duister ronddwaal",
          "om hulle na die herder t'rug te lei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sing op jul pos, ",
          "o troue eng'lewagte,",
          "laat ons die hemelsmelodieë hoor;",
          "Eendag verdwyn ons ",
          "donker tranenagte,",
          "dan sing ons met die blye eng'lekoor."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Eng'le van Jesus, eng'le van krag,",
      "sing welkomsliedere vir pelgrims",
      "uit die nag!"
    ]
  },
  {
    "english": "A few more years shall roll",
    "hymnNumber": 322,
    "reference": "AL322",
    "title": "Net Enk'le Jare",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Net enk'le jare sal hul",
          "wisselgange gaan",
          "voor ons met ons bemindes",
          "weer verenig same staan;",
          "Berei my hart, o Heer,",
          "vir daardie grote dag;",
          "O reinig my met Jesus bloed",
          "terwyl ek waak en wag!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Eerlank bedaar die storms",
          "aan hierdie aardse kus,",
          "dan sal ons waar geen onweer dreun,",
          "by Gods verlostes rus;",
          "Berei my hart, o Heer,",
          "vir daardie grote dag;",
          "O reinig my met Jesus bloed",
          "terwyl ek waak en wag!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Nog net 'n weinig stryd,",
          "nog net 'n paar keer skei,",
          "dan is ons arbeid en ons trane",
          "ewiglik verby;",
          "Berei my hart, o Heer,",
          "vir daardie grote dag;",
          "O reinig my met Jesus bloed",
          "terwyl ek waak en wag!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die tyd is haas verby,",
          "dan kom die Heiland weer;",
          "Hy het gesterf dat ons ook eendag",
          "met Hom kan regeer;",
          "Berei my hart, o Heer,",
          "vir daardie grote dag;",
          "O reinig my met Jesus bloed",
          "terwyl ek waak en wag!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Awake my soul! stretch every nerve",
    "hymnNumber": 323,
    "reference": "AL323",
    "title": "Ontwaak, My Siel, Laat Jou Omgord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 7.1
    },
    "verses": [
      {
        "content": [
          "Ontwaak, my siel, laat jou omgord,",
          "die wedloop eis jou krag;",
          "Berei jou vir die felle stryd;",
          "‘n kroon sal op jou wag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is die stem van God wat roep:",
          "“Kom tot U erfenis;",
          "Kom en ontvang hier uit My hand",
          "die kroon wat ewig is'."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "‘n Wolk getuies rondom jou",
          "kan alles sien en hoor;",
          "Vergeet die pad van gister nou,",
          "die wenpaal lê nog voor."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ek het die wedloop hier begin",
          "wat U ons voorhou, Heer;",
          "Wanneer ek eens die kroon verkry,",
          "lê ek dit voor U neer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "One sweetly solemn thought",
    "hymnNumber": 324,
    "reference": "AL324",
    "title": "Een Soet Gedagte Kom",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.6
    },
    "verses": [
      {
        "content": [
          "Een soet gedagte kom",
          "so dikwels by my tuis:",
          "met elke nuwe dag kom ek",
          "nog nader aan my huis."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nader aan daardie stad",
          "waar vele wonings wag;",
          "Nader aan daardie groot wit troon",
          "en aan die goue prag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Na aan die reis se end,",
          "nader aan die loon",
          "wat ek sal kry wanneer my kruis",
          "verruil word vir 'n kroon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Maar swygend tussenin,",
          "kronkelend deur die nag,",
          "vloei, onbekend, die donker stroom,",
          "wat ons sal lei tot dag."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O Heer, gee my geloof",
          "en gaan U met my mee,",
          "en laat my nie die doodsvallei",
          "eendag alleen betree."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "There is sweet rest for feet now weary",
    "hymnNumber": 325,
    "reference": "AL325",
    "title": "Daar's Soete Rus Vir Moeë Voete",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Daar's soete rus vir moeë voete",
          "wat die doringpad betree;",
          "Na middernag kom weer die môre",
          "om ons nuwe moed te gee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O ons verlang na daardie môre,",
          "na die aardse nag van pyn,",
          "wanneer ons deur die poorte ingaan",
          "en ons laaste sorg verdwyn."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En binnekort sal moeë pelgrims",
          "gaan waar niks hul kan vermoei;",
          "Dan sal hul rus op groene velde",
          "waar die lewenswater vloei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hemelse Vader, lei ons voorwaarts",
          "na die wonings wat daar wag;",
          "U is ons Toevlug, Rots der eeue,",
          "tot op daardie blye dag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Art thou weary, art thou languid",
    "hymnNumber": 326,
    "reference": "AL326",
    "title": "Is U Afgemat Of Kwynend",
    "hasMidi": true,
    "numberOfVerses": 7,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Is U afgemat of kwynend",
          "en van skuld bewus?",
          "“Kom na My toe', sê die Heiland,",
          "“kom en rus'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Is daar tekens wat bevestig",
          "wie se stem ek hoor?",
          "Kyk, Sy hande en Sy voete",
          "is deurboor."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sier 'n koningskroon Sy voorhoof",
          "dat ek Hom sal dien?",
          "Ja, gewis, maar wrede dorings",
          "sal u sien."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vind ek Hom en volg Sy leiding,",
          "wat is dan my loon?",
          "In die wêreld, arbeid, trane,",
          "smaad en hoon."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Kleef ek dan nog aan my Heiland,",
          "wat sal dit my baat?",
          "Hy sal jou in dood en lewe",
          "nooit verlaat."
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Weier Jesus ooit die bede:",
          "'Here, neem my aan'?",
          "Eerder sou die ganse skepping",
          "kon vergaan."
        ],
        "verseNumber": 6
      },
      {
        "content": [
          "Sal Hy my in elke worst'ling",
          "steun deur Sy gena?",
          "Heiliges en martelare",
          "antwoord “Ja'!"
        ],
        "verseNumber": 7
      }
    ],
    "chorus": null
  },
  {
    "english": "I saw one weary, sad, and torn",
    "hymnNumber": 327,
    "reference": "AL327",
    "title": "Een Afgemat, Verwond En Moeg",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.7
    },
    "verses": [
      {
        "content": [
          "Een afgemat, verwond en moeg",
          "het ek langs steile weg sien wag;",
          "Hy't lank die heil'ge kruis gedra,",
          "gehoop op die beloofde dag.",
          "Wyl op Sy voorhoof menig lyn",
          "getuig van stil verduurde pyn,",
          "wat het Sy siel met krag gedoop?",
          "Sy antwoord was: “Die saal'ge hoop!'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "‘n Ander het met swaard en skild",
          "die wêreldshoon en spot bestry;",
          "Hy moes die vyandsaanslag duld",
          "om daardie goue kroon te kry.",
          "Hoe swaar die stryd, hoe nou die weg,",
          "Hy was blymoedig en opreg;",
          "Wat hy sy siel met krag gedoop?",
          "Sy antwoord was: “Die saal'ge hoop!'"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En daar was een wat moes verlaat",
          "die vriende van sy vroegste jeug;",
          "En eer en rykdom gee vir haat,",
          "die pad van dorings moes betree.",
          "En tog, hoe bitter ook sy lot,",
          "was hy blymoedig in sy God;",
          "Wat het sy siel met krag gedoop?",
          "Sy antwoord was: “Die saal'ge hoop!'"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons is maar almal pelgrims",
          "hier op aarde waar die vyand heers;",
          "Ons moet die haat en spot verduur,",
          "ons loon ontvang ons later eers",
          "as Jesus op die wolke kom",
          "as Here, Koning, Bruidegom;",
          "Kan iets ons siel met krag nou doop?",
          "Ja, dit alleen: Die saal'ge hoop!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I'm a pilgrim, and I'm a stranger",
    "hymnNumber": 328,
    "reference": "AL328",
    "title": "Ek Is Vreemd Hier",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Ek is vreemd hier en ek's 'n pelgrim;",
          "Ek kan hier bly, ek kan hier bly net 'n nag.",
          "Moet my nie t'rughou,",
          "want ek moet voorwaarts",
          "na waar die strome vir ewig vloei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daardie luister sal ewig skitter;",
          "Ek verlang so, ek verlang om daar te wees.",
          "In hierdie landskap van donker skadu's",
          "het ek geswerwe",
          "met moeë gees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar's die godstad wat Hy berei het,",
          "my Verlosser, my Verlosser is sy lig;",
          "Daar is geen droefheid",
          "en geen gesug nie,",
          "want daar gedenk ons ",
          "die dood nie meer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vaarwel vriende! Ek het gewaarsku",
          "ek moet nou weer, ek moet nou weer verder gaan.",
          "Waarom wil julle soos ander sterwe?",
          "Want hulle einde is in die vuur."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Vader, moeder, my broer en suster,",
          "as jul nie met my wil reis, gaan ek alleen.",
          "Sal ek met julle die dwaling aanneem",
          "en in die oordeel die pyn verduur?"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Vaarwel aarde vermink deur sonde!",
          "Jy keer spoedig tot jou vroe're",
          "heerlikheid;",
          "Die grote Skepper sal jou herskape,",
          "dan sal die sonde",
          "nie weer verskyn."
        ],
        "verseNumber": 6
      }
    ],
    "chorus": [
      "Ek is vreemd hier en ek's 'n pelgrim;",
      "Ek kan hier bly ek kan hier bly net 'n nag."
    ]
  },
  {
    "english": "We're bound for the land of the pure and the holy",
    "hymnNumber": 329,
    "reference": "AL329",
    "title": "Ons Reis Na Die Land",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 28.7,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Ons reis na die land",
          "wat die heiliges erwe -",
          "die tuiste van liefde",
          "en vreugde so skoon -",
          "en jy wat nog dwaal",
          "op onveilige weë,",
          "o sê, gaan jy mee",
          "om in Eden te woon?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die heerlike land",
          "ken geen trane of sonde,",
          "geen kommer of onreg",
          "word ooit daar gedoog;",
          "En jy, met jou sonde",
          "en trane en wonde,",
          "o sê, gaan jy mee",
          "na die Eden omhoog?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar heers geen bedrog,",
          "of die hand van verdrukking,",
          "want daar's geen geweld;",
          "O dis heerlik te glo!",
          "Geen sonde is daar,",
          "ook geen enkel mislukking;",
          "O sê, gaan jy mee",
          "na die Eden daarbo?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Geen armoede daar,",
          "nee, die heil'ges het rykdom",
          "geërf van die Heer,",
          "hulle Skepper en Voog.",
          "Die land ken geen siekte",
          "of sonde of lyding,",
          "o sê, gaan jy mee",
          "na die Eden omhoog?"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "O kom, arme sondaar,",
          "ons toef nog 'n stonde,",
          "besluit net vandag",
          "om in Jesus te glo;",
          "Ja, kom nog vandag",
          "en die Heer sal jou aanneem,",
          "Hy bring ook vir jou",
          "na die Eden daarbo."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Gaan jy mee? Gaan jy mee?",
      "Gaan jy mee? Gaan jy mee?",
      "O sê, gaan jy mee",
      "na die Eden daarbo?"
    ]
  },
  {
    "english": "Let every lamp be burning bright",
    "hymnNumber": 330,
    "reference": "AL330",
    "title": "Laat Elke Lamp Nou Helder Brand",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 16.5,
      "intro": 16.5
    },
    "verses": [
      {
        "content": [
          "Laat elke lamp nou helder brand,",
          "die swartste uur kom nader;",
          "Ja, duisternis bedek die land",
          "voor God Sy volk vergader."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Maar duisende verwerp Sy Woord,",
          "tot waaksaamheid onwillig;",
          "En slaap in hulle sonde voort,",
          "ligsinnig, onverskillig."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sy Woord - die lamp vir elke voet;",
          "Ons Gids - Sy vaste waarheid,",
          "wat in gevaar ons steeds behoed,",
          "en skyn met reine klaarheid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Beskaam die bose wêreld dan",
          "met blyke van genade,",
          "laat liefde alle vrees verban,",
          "wat werk tot onse skade."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Kom, vul jou lamp, verspil geen tyd",
      "met olie van godvresendheid;",
      "Die Meester kom, o wees bereid,",
      "en hou jou lamp steeds brandend!"
    ]
  },
  {
    "english": "Faith of our fathers! living still",
    "hymnNumber": 331,
    "reference": "AL331",
    "title": "Groot Was Ons Vaders Se Geloof",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "Groot was ons vaders se geloof,",
          "al was daar kerker, swaard en vuur;",
          "O hoe vervul dit ons met vreug!",
          "Sal ons ooit soveel kan verduur?",
          "Hulle geloof was sterk en groot;",
          "Maak ons getrou tot in die dood!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In kettings en gevangeskap",
          "was hul gewete rein voor God;",
          "As ons soos hul vir U mag sterf,",
          "salig is dan ook onse lot.",
          "Hulle geloof was sterk en groot;",
          "Maak ons getrou tot in die dood!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In hierdie stryd sal die geloof",
          "ons liefde sterk vir elke mens;",
          "Ons sal U Naam bely, o Heer,",
          "in woord en daad, in wil en wens.",
          "Hulle geloof was sterk en groot;",
          "Maak ons getrou tot in die dood!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 332,
    "reference": "AL332",
    "title": "Waak, Christen, Waak In Die Geloof",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Waak, Christen, waak in die geloof",
          "dat niemand jou die kroon ontroof;",
          "Gedra jou manlik, sterk en moedig",
          "in hierdie Godgewyde werk -",
          "standvastig, onbeweeglik, sterk,",
          "vol ywer altyddeur oorvloedig.",
          "Jou arbeid sal in onse Heer",
          "nooit ydel wees, Hom sy die eer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Voeg, Christen, by geloof ook deug",
          "en fiere moed in smart en vreug",
          "om steeds die kwaad te wederstrewe.",
          "Voeg by die deug 'n helder brein,",
          "vir selfsug en die kwaad te rein;",
          "By helder brein 'n matig' lewe.",
          "Wees dan geduldig ook soos Hy",
          "as God beskik dat jy moet ly."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Voeg by geduld godsaligheid;",
          "Dan skyn jou lig ook ver en wyd -",
          "want mense let steeds op jou voorbeeld.",
          "Gehoorsaam tog die groot gebod;",
          "Jou eerste liefde hoort aan God",
          "en gaan gepaard met naasteliefde;",
          "En met die liefde vir jou broer",
          "ook dié wat almal samesnoer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O God, staan met U Gees ons by",
          "dat ons dié deugde mag verkry.",
          "O laat hul steeds in ons vermeerder!",
          "Dan sal ons duid'liker verstaan",
          "die lydensweg wat Hy moes gaan -",
          "die groot verlossingswerk van Jesus.",
          "O mag ons in die jongste dag",
          "nie dwaas en ledig voor U wag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Sweet promise is given to all who believe",
    "hymnNumber": 333,
    "reference": "AL333",
    "title": "Die Woord Is Gegee Aan Almal Wat Glo",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 27.1,
      "intro": 27.1
    },
    "verses": [
      {
        "content": [
          "Die woord is gegee aan almal wat glo:",
          "die Here kom spoedig,",
          "Hy wag reeds daarbo;",
          "“Volhard tot Ek kom,",
          "hoe groot die gevaar!",
          "Slaap tog nie soos ander;",
          "Wees waaksaam, wees klaar.'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Met lampe wat brand,",
          "staan ons op die wag;",
          "(vir vele kom Hy soos 'n dief in die nag!)",
          "Ons weet Hy's naby,",
          "maar ken nie die dag;",
          "Ons moet na die lente",
          "die somer verwag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ja, dit is ons hoop;",
          "Hy het dit geleer -",
          "die heerlike koms",
          "van ons Heiland en Heer.",
          "Van alles beloof, is hierdie die som:",
          "'o kyk, Ek kom haastig;",
          "volhard tot Ek kom!'"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "“Volhard tot Ek kom!'",
      "Sy woorde staan vas,",
      "' 'n kleed is berei en sneeuwit gewas.",
      "Ek bied jou My vreug;",
      "Berei jou 'n troon;",
      "Volhard tot Ek weer kom,",
      "dan vind jy 'n kroon'."
    ]
  },
  {
    "english": "The church has one foundation",
    "hymnNumber": 334,
    "reference": "AL334",
    "title": "Die Kerk Het Net Een Grondslag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Die kerk het net een grondslag,",
          "dis Jesus onse Heer;",
          "Sy is die nuwe skepping",
          "deur water, woord en leer;",
          "Sy kerk is afgesonder",
          "Sy reine bruid te word;",
          "Sy bloed, o eeu'ge wonder,",
          "is vir haar heil gestort!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Uit elke volk verkore,",
          "tog een met Hom as Hoof;",
          "Deur Gees en bloed herbore,",
          "een Heer en een geloof;",
          "Een Naam by haar in ere,",
          "haar heil'ge Lewensbrood,",
          "haar hoop in Hom, die Here,",
          "in lewe en in dood."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al sou soveel haar minag,",
          "haar swaar en lank sien stry",
          "teen magte, met geen agting",
          "vir Hom wat haar bevry;",
          "Nog is daar troue wagte wat roep:",
          "o, Heer, hoe lank?",
          "Die nag van bitter klagte word haas",
          "die nag van dank."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Deur arbeid en verstrooiing,",
          "deur bange sielestryd,",
          "verwag ons die voltooiing,",
          "die blye ewigheid!",
          "Die bruid in al haar skoonheid,",
          "sal staan volmaak in Hom;",
          "Sy bruid sal rus vir altyd -",
          "kom gou, o Bruidegom!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 335,
    "reference": "AL335",
    "title": "Hoe Lieflik, Hoe Vol Heilgenot",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Hoe lieflik, hoe vol heilgenot,",
          "o Heer van leërskare, God!",
          "Is my U huis en tempelsange.",
          "Hoe brand ek van verlange om",
          "die Heer se voorhof in te kom.",
          "My siel beswyk van sterk verlange;",
          "My hart roep uit tot God wat leef",
          "en nasies vir Sy woord laat beef."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Welsalig hy wat al sy krag",
          "en hulp alleen van U verwag",
          "en reis die weg deur God geseën.",
          "Al brand die hete middagson",
          "in vlei of boord, U is hul bron",
          "en gee aan hul 'n vroeë reën",
          "wat veld en wingerd saggies dek,",
          "verkwik en hul tot seën strek."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hul gaan van krag tot krag steeds voort;",
          "Elkeen sal in die saal'ge oord",
          "van Sion voor hul God teregstaan.",
          "Let, Heer van leërskare,",
          "let op my ootmoedig' smeekgebed.",
          "Laat nooit U liefde van my weggaan.",
          "Neig tog U vriend'lik oor tot my",
          "en gaan, o God, my nie verby."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Want God die Heer, so goed en mild",
          "is altyd onse son en skild.",
          "Hy sal genade gee en ere.",
          "Hy sal die goeie nie in nood",
          "onthou nie, selfs nie in die dood.",
          "Hul wat in vroomheid voor Hom lewe,",
          "welsalig Heer! Wat op U bou,",
          "en alles aan U toevertrou."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, her watch Thy church is keeping",
    "hymnNumber": 336,
    "reference": "AL336",
    "title": "Heer, U Kerk Is Lankal Wagtend",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Heer, U kerk is lankal wagtend;",
          "Wanneer kom U koninkryk?",
          "Hoelank bly ons hier verwagtend?",
          "Wanneer sal die donker wyk?",
          "Op die land vergaan die gerwe,",
          "want die arbeiders is min;",
          "Het U Seun verniet gesterwe?",
          "Sal die vyand dan oorwin?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Stuur die evangelieboodskap",
          "deur miljoene ongehoord;",
          "Daar is vreugde, daar is blydskap,",
          "daar is lewe in die Woord.",
          "Stuur dit uit na elke nasie,",
          "elke volk en stam en taal;",
          "Spreek van redding deur U grasie",
          "waar die mens in sonde dwaal."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As U kerk se taak volbring is -",
          "veilig man en vrou en kind -",
          "as die sondenag verby is",
          "en die Satan is gebind;",
          "Dan sal pyn en dood en smarte",
          "ewig voor die lewe wyk;",
          "Hoor die bede van ons harte:",
          "Heer, kom stig U koninkryk."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "From Greenland's icy mountains",
    "hymnNumber": 337,
    "reference": "AL337",
    "title": "Van Groenlands Ysgebergtes",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Van Groenlands ysgebergtes",
          "en Indië se strand,",
          "waar Afrika se sonskyn op bos",
          "en vlakte brand;",
          "Van ou rivierbeskawings kom daar",
          "‘n stem wat smeek",
          "dat ons die sondebande in hul",
          "moet help verbreek."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wat baat die skone lane",
          "wat deur die palme vleg,",
          "al is die land so heerlik",
          "maar elke mens so sleg?",
          "Vergeefs is al die rykdom,",
          "die berge en die reën;",
          "Die heiden in sy blindheid",
          "buig neer voor hout en steen."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kan manne wat die lig het",
          "en God se waarheid hou,",
          "van hulle in die duister",
          "die woord van God weerhou?",
          "Verlossing! O verlossing!",
          "Roep uit met luide stem,",
          "tot elke stam en nasie",
          "ons dierb're Heiland ken!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O winde, neem die tyding",
          "en waai dit oor die land,",
          "tot soos 'n see van glorie",
          "dit strek van strand tot strand;",
          "Totdat oor die verlostes die Lam,",
          "vir ons geslag,",
          "as Koning heers vir ewig.",
          "Kom gou, o blye dag!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Far and near the fields are teeming",
    "hymnNumber": 338,
    "reference": "AL338",
    "title": "Orals Wag Die Koringlande",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.7,
      "intro": 19.7
    },
    "verses": [
      {
        "content": [
          "Orals wag die koringlande",
          "met die goue golwend' graan;",
          "Oor die wye veld en rande",
          "breek die oestyd vinnig aan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Stuur hul met die dagbreek, Meester;",
          "Stuur hul in die middaggloed;",
          "laat hul in die late middag",
          "na die koringlande spoed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U wat deur die Heer gestuur word,",
          "haas jul met die goue graan;",
          "Juigend sal ons na die arbeid",
          "met die Meester huis toe gaan."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Heer, die oestyd is op hande,",
      "waar sal ons die werkers kry?",
      "Laat hul nou die graan versamel",
      "want die oestyd gaan verby."
    ]
  },
  {
    "english": "The morning light is breaking",
    "hymnNumber": 339,
    "reference": "AL339",
    "title": "Die Nag Is Ver Verstreke",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Die nag is ver verstreke,",
          "die rooidag breek al aan;",
          "In alle wêreldstreke",
          "is sondaars diep begaan.",
          "Die winde oor die seë",
          "bring verre tydings mee",
          "van nasies in beroering,",
          "gereed vir Sionswee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kyk, heidennasies buig nou",
          "ootmoedig voor ons Heer!",
          "Ja, duisende bring daagliks",
          "aan Hom die lof en eer.",
          "Die evangelieboodskap",
          "trek sondaars na die kruis;",
          "En alle volke loof daar",
          "die Heiland eens vergruis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O stroom van lewenswater,",
          "vloei breed deur elke land;",
          "Tot elke volk en nasie,",
          "tot aan die verste strand;",
          "Vloei voort tot al Gods kinders",
          "gekom het tot die Bron;",
          "Laat niks U stroom verhinder",
          "totdat die Heer self kom."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "O Zion, haste, thy mission high fulfilling",
    "hymnNumber": 340,
    "reference": "AL340",
    "title": "Kom, Sion, Haas Jou",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 29.4,
      "intro": 29.4
    },
    "verses": [
      {
        "content": [
          "Kom, Sion, haas jou ",
          "en versprei die boodskap;",
          "Bring God se lig aan nasies wat nog wag.",
          "Hy wat die aarde ",
          "en die mens gemaak het,",
          "wil almal red uit hierdie donker nag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gaan almal voorwaarts, ",
          "leer in al die lande,",
          "dat God, die Lewegewer, liefde is;",
          "Vertel hoe Hy moes sterwe ",
          "hier in skande",
          "dat ons kan deel hê in Sy erfenis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God vra ons seuns en dogters ",
          "vir die boodskap,",
          "Hy vra dat ons moet gee dat hul kan gaan",
          "stort uit U hart voor God vir al Sy werkers,",
          "Hy is ons borg en Hy sal by ons staan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ja, Hy kom weer, o Sion, ",
          "voor Hy t'rugkeer,",
          "bied elke siel Sy reddende gena;",
          "Laat elke sterfling reg ",
          "wees vir die Koning",
          "as Hy Sy siel van my en jou sal vra."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Neem hierdie tyding, ",
      "tyding van vree,",
      "tyding van Jesus:",
      "dit bring verlossing mee."
    ]
  },
  {
    "english": "Hark! the voice of Jesus calling",
    "hymnNumber": 341,
    "reference": "AL341",
    "title": "Hoor! Daar Klink Die Stem Van Jesus!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Hoor! Daar klink die stem van Jesus!",
          "“Wie sal gaan?' hoor ek Hom vra,",
          "'kyk, die oes is ryp en wagtend,",
          "wie sal help die gerwe dra?'",
          "Helder klink die Heer se roepstem,",
          "ryk vergoeding bied Hy vry;",
          "Wie sal antwoord op Sy roepstem:",
          "'hier is ek, Heer, stuur U my?'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kan jy nie van huis af gaan nie,",
          "moet jy hierdie plig verbeur;",
          "Kyk, hier is ook heid'ne naby,",
          "hulle staan selfs aan jou deur.",
          "Ken jy nie die taal van eng'le?",
          "Kan jy nie soos Paulus preek?",
          "Tog kan jy getuig vir Jesus,",
          "van Sy kruisdood kan jy spreek."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al is jy ook nie die wagter",
          "wat op Sionsmure staan,",
          "en die hemelweg hier aanwys",
          "waarop dwalendes moet gaan;",
          "Met gebed en offergawes",
          "kan jy doen wat God verwag,",
          "daarmee skraag ook jy die hande",
          "van 'n Moses elke dag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wyl daar siele om jou sterwe,",
          "en die Meester jou wil stuur,",
          "laat tog niemand jou hoor sê nie:",
          "“Niemand het my ooit gehuur'.",
          "doen gewillig elke dagtaak,",
          "laat Sy werk jou vreugde bly;",
          "Op Sy roepstem antwoord daad'lik:",
          "'hier is ek, Heer, stuur U my!'"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "They come from the east and west",
    "hymnNumber": 342,
    "reference": "AL342",
    "title": "Hul Kom Aan Van Oos En Wes",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Hul kom aan van oos en wes,",
          "hul kom aan van suid en noord;",
          "Genooi om te gaan ",
          "na Jesus se huis;",
          "Hul gaan deur die goue poort,",
          "en staan op die glasesee;",
          "Beklee met onsterflikheid!",
          "Hoor hul lied wat helder klink",
          "deur alle ewigheid."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe groot die verloste skaar!",
          "Gered deur U liefde, Heer!",
          "Geen sonde of smart,",
          "geen droefheid of traan,",
          "geen donkere nag ooit weer!",
          "Want alles word nuut gemaak,",
          "ja, alles weer rein en skoon;",
          "Vreugde sal daar ewig heers,",
          "rondom die Vadertroon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O vriende, die hemelpoort ",
          "staan oop vir elkeen wat kom;",
          "‘n plek het die Heer ",
          "daarbo gaan berei",
          "vir almal wat glo in Hom;",
          "Ons dierb're ontslapenes",
          "rus nou waar die blomme staan,",
          "tot wanneer die wekroep klink",
          "en ons sal huis toe gaan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hul kom oor die ruwe pad,",
          "hul kom selfs oor see en meer,",
          "oor berge so hoog, ",
          "en vlaktes so wyd,",
          "hul kom nou na U, o Heer!",
          "Beklee met die bruilofskleed,",
          "verwag hul die Bruidegom;",
          "Hom, die Man van Golgota",
          "wat dan as Koning kom."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Master, no offering",
    "hymnNumber": 343,
    "reference": "AL343",
    "title": "Ons Het Geen Nardussalf",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Ons het geen nardussalf,",
          "dierbare Heer,",
          "om soos Maria, U mee te vereer;",
          "Maar ons wil dank betoon,",
          "soos wierook voor die troon,",
          "aan U, o Heer, aan U, o Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons wil graag elke dag krag vind,",
          "o Heer,",
          "om deur 'n liefdedaad U te vereer;",
          "Ons wil 'n loflied sing",
          "en ook 'n sondaar bring",
          "tot U, o Heer, tot U, o Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gun dat ons moed kan bring",
          "tot Hom wat vrees,",
          "laat ons vir hom wat ween,",
          "‘n trooster wees;",
          "Hom wat verbitter bly,",
          "deur liefde nader lei",
          "tot U, o Heer, tot U, o Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "So bly U diens, o Heer,",
          "vir ons 'n lus",
          "tot ons na lange dag eindelik rus;",
          "Wanneer die uur dan slaan,",
          "laat ons in vrede gaan",
          "na U, o Heer, na U, o Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "We give Thee but Thine own",
    "hymnNumber": 344,
    "reference": "AL344",
    "title": "Die Offer Wat Ons Hou",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Die offer wat ons hou,",
          "behoort aan U, o Heer,",
          "U het dit aan ons toevertrou,",
          "ons gee dit aan U weer. Amen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons wil U eiendom",
          "voordelig gaan bestee,",
          "en van die vrugte wat daar kom,",
          "die eerstelinge gee."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar's harte koud en dood",
          "en huise leeg en kaal;",
          "En soveel kinders, klein en groot,",
          "het ver van U verdwaal."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons glo wat U ons leer -",
          "hoe swak ook die geloof -",
          "wat ons vir hulle doen,",
          "o Heer, doen ons vir U, ons Hoof."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Would you win a Saviour's blessing?",
    "hymnNumber": 345,
    "reference": "AL345",
    "title": "Soek Jy Ook ‘n Seën",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "Soek jy ook 'n seën van Jesus?",
          "Gee dan mild en vry!",
          "Wil jy graag Sy werk laat voortgaan?",
          "Gee dan mild en vry!",
          "Laat jou hart met liefde brand;",
          "Gee aan Hom met ope hand;",
          "Smag jy na 'n beter land?",
          "Gee dan mild en vry!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "God bemin die blye gewer,",
          "gee dan mild en vry!",
          "Soos die sonskyn oeste lewer,",
          "gee so mild en vry!",
          "Het jy weinig om te gee?",
          "Lees dan wat die Here sê",
          "van die arme weduwee;",
          "Gee ook mild en vry!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Help verbrei die blye tyding;",
          "Gee dan mild en vry!",
          "Volg die Heer se wyse leiding;",
          "Gee dan mild en vry!",
          "Wag jy op 'n saal'ge loon?",
          "Wil jy eens by Jesus woon?",
          "En begeer jy ook 'n kroon?",
          "Gee dan mild en vry!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "They brought their gifts to Jesus",
    "hymnNumber": 346,
    "reference": "AL346",
    "title": "Hul Bring Na Jesus Gawes",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 34.5,
      "intro": 34.5
    },
    "verses": [
      {
        "content": [
          "Hul bring na Jesus gawes,",
          "en lê dit aan Sy voet;",
          "Hul liefde vir die Heiland",
          "maak elke offer soet.",
          "Weldadig en goedhartig",
          "het hul die nood versag;",
          "En Jesus het geen gawe",
          "ooit te gering geag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "En naby daardie gewers,",
          "staan ook 'n swerweling,",
          "wat sien die kleinste gawe",
          "word tot die Heer gebring.",
          "En dit was Sy verlange,",
          "om ook 'n gif te gee;",
          "Maar Hy was self 'n arme -",
          "behoeftig en verleë."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "“My Heer, ek merk U goedheid',",
          "roep hy diep uit sy smart,",
          "'neem al wat ek kan aanbied,",
          "my sondig', donker hart'.",
          "Toe antwoord Jesus vriend'lik:",
          "“ag nie jou gif gering -",
          "van al die gawes het jy",
          "die beste gif gebring'."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Bring jy ook 'n geskenkie",
      "vir Jesus en Sy kerk?",
      "Sê: Heer, ek gee my lewe,",
      "gebruik dit in U werk."
    ]
  },
  {
    "english": "Hark! 'tis the Shepherd's voice I hear",
    "hymnNumber": 347,
    "reference": "AL347",
    "title": "Wie Roep So Dringend In Die Nag?",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Wie roep so dringend in die nag?",
          "Dit is die Herder teer en sag -",
          "roepend na skape wat verdwaal",
          "ver van die veil'ge herderskraal."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wie sal die Herder help vandag?",
          "Daar is nog duisende wat wag;",
          "Bring hulle na die Herder teer,",
          "Hy sal beskut teen wind en weer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoog teen die berge steil en kaal",
          "is hul verstrooi en ver verdwaal;",
          "Jesus sê nou aan jou en my:",
          "“soek tot jul al My skape kry'."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Bring hul in, bring hul in;",
      "Bring hul in uit die sondenag;",
      "Bring hul in, bring hul in;",
      "Bring verdwaaldes weer na Jesus."
    ]
  },
  {
    "english": "Rescue the perishing",
    "hymnNumber": 348,
    "reference": "AL348",
    "title": "Red Wat Verlore Gaan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Red wat verlore gaan,",
          "help die wat sterwe,",
          "ruk hul ontfermend ",
          "uit sonde en dood;",
          "Ween oor die dwalendes,",
          "staan by die swakkes,",
          "laat hulle hoor van Gods liefde so groot."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al smaad die mense Hom,",
          "tog wag die Heiland,",
          "wag op die koms ",
          "van die sondaars tot Hom.",
          "Hy pleit so tederlik,",
          "roep hulle vriend'lik,",
          "Hy sal vergewe as hulle net kom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Diep in die sondaarshart ",
          "lê daar verbrysel,",
          "tere gevoelens wat ",
          "God kan hernieu;",
          "Raak dit met liefde aan,",
          "vriend'lik en teder,",
          "en hul ontwaak met 'n rein melodie."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Red wat verlore gaan, ",
          "liefde vereis dit,",
          "krag vir die taak sal die Here jou gee;",
          "Bring hulle almal tog",
          "t'rug na die nou weg,",
          "deel aan die pelgrims",
          "Sy reddingskrag mee!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Red wat verlore gaan,",
      "help die wat sterwe;",
      "Jesus is liefdevol,",
      "Jesus sal red!"
    ]
  },
  {
    "english": "Throw out the life line across the dark wave",
    "hymnNumber": 349,
    "reference": "AL349",
    "title": "Gaan Met Die Reddingstou Diep In Die See",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21,
      "intro": 21
    },
    "verses": [
      {
        "content": [
          "Gaan met die reddingstou diep in die see;",
          "Daar is 'n broeder, die stroom voer hom mee.",
          "Hy is 'n drenkeling diep in gevaar,",
          "o wie sal die tou neem en inswem tot daar?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gaan met die reddingstou, span in jou krag;",
          "Waarom nog aarsel, o waarom nog wag?",
          "Kyk hoe Hy worstel, gaan red hom tog gou,",
          "o gaan met die reddingsboot - gaan met die tou!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gaan met die reddingstou na die gevaar;",
          "Dink aan die angs van die drenkeling daar!",
          "Wind van versoeking en branders van wee",
          "oorrompel hom in die onstuimige see."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Spoedig is reddingsgeleentheid verby;",
          "Spoedig sal net hul gedagtenis bly.",
          "Gaan haastig, broeder, o waarom nog wag?",
          "Gaan nou tot hul redding en bring hul vandag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Haas tot Sy redding! (x2)",
      "Iemand dryf weg en verdrink.",
      "Haas tot Sy redding! (x2)",
      "Daar is 'n broeder wat sink."
    ]
  },
  {
    "english": "Watchman, blow the gospel trumpet",
    "hymnNumber": 350,
    "reference": "AL350",
    "title": "Neem Die Evangelieboodskap",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Neem die evangelieboodskap,",
          "waarsku elke volk en land;",
          "Hulle sal dit hoor en luister;",
          "Gaan tot aan die verste strand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat dit klink oor berg en vlakte",
          "waar daar son en skadu is,",
          "oor die wye oseane:",
          "Jesus skenk vergiffenis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gaan daarmee langs al die weë",
          "waar die mens in sonde ly;",
          "Roep hul na die Koningsbruilof,",
          "Hy't vir elk 'n plek berei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Bring dit aan die swaarbelastes",
          "waar hul met die sonde stry;",
          "Gee die Heer se welkomsboodskap:",
          "“Kom, o sondaar, kom na My'."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Neem die tyding, troue wagte,",
      "laat die verste land dit kry;",
      "God beveel jul: “Neem die boodskap;",
      "Dit maak elke sondaar vry'."
    ]
  },
  {
    "english": "If any little word of mine",
    "hymnNumber": 351,
    "reference": "AL351",
    "title": "Indien ‘n Woord Wat Ek Mag Bring",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Indien 'n woord wat ek mag bring,",
          "kan skyn in donker harte;",
          "Indien 'n lied wat ek mag sing,",
          "kan vreugde gee vir smarte."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Indien die liefde wat ek gee,",
          "verligting bring in lyding.",
          "Indien 'n bietjie sorg van my",
          "kan hoop gee op bevryding."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Indien 'n bietjie hulp van my",
          "die las van ander lenig,",
          "gee my dan liefde, sorg en krag -",
          "U hulp, o Heer, is enig."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Heer, help my om van lig te sing,",
      "en help my spreek van deugde,",
      "en wek dan in 'n sondaarshart",
      "die hoop op nuwe vreugde."
    ]
  },
  {
    "english": "I'll Go Where You Want Me to Go",
    "hymnNumber": 352,
    "reference": "AL352",
    "title": "U Roep Miskien Oor Die Berge Hoog",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 45.6,
      "intro": 45.6
    },
    "verses": [
      {
        "content": [
          "U roep miskien oor die berge hoog",
          "of ver oor die woeste see,",
          "miskien is dit in die hete stryd",
          "dat U my die werk wil gee.",
          "Maar, Heer, as U saggies roep na my -",
          "my stuur na 'n vreemde land,",
          "dan antwoord ek:",
          "Heer, waar U roep, sal ek gaan",
          "gelei deur U magtige hand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Miskien is daar nog 'n woord van troos",
          "wat ek aan 'n vriend moet sê:",
          "‘n sondaar mag in die donker dwaal",
          "wat Jesus van my wil hê.",
          "O Heiland, as U my gids wil wees -",
          "hoe moeilik en donker die nag -",
          "my stem sal U boodskap trou herhaal",
          "en spreek soos U wil elke dag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar moet 'n plek op die aarde wees,",
          "hoe nederig dit ook sy,",
          "waar ek my dierbare Heer kan dien",
          "so lank ek op aarde bly.",
          "Met volle vertroue in U sterk hand -",
          "ek weet van U liefde vir my -",
          "sal ek gehoorsaam, U wil volbring",
          "met U, o my Heer, aan my sy."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ek gaan waar U roep,",
      "o Heer, ek gaan,",
      "oor berge, of vlaktes of see;",
      "Wat U my beveel, sal ek sê, liewe Heer,",
      "ek gaan, want U gaan met my mee!"
    ]
  },
  {
    "english": "He that goeth forth with weeping",
    "hymnNumber": 353,
    "reference": "AL353",
    "title": "Hy Wat Loop En Saai Met Trane",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 7.1
    },
    "verses": [
      {
        "content": [
          "Hy wat loop en saai met trane,",
          "dra die saad terwyl Hy ween;",
          "Hy's nie moeg of mat of traag nie,",
          "want sy werk is hom tot seën."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoor hoe ruis dit oor die bulte,",
          "reën en sonskyn gee die Heer;",
          "Hy gee vrugte by die wasdom,",
          "Hy alleen gee lewe weer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Saai die saad met bly verwagting,",
          "laat geen vrees die oorhand kry;",
          "Al gaan baie saad verlore,",
          "oestyd sal jou hart verbly."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Golwend dek die graan die heuwels,",
          "spoedig kom die goue kleur;",
          "Maar die werkers - daar is weinig,",
          "en die oes is voor die deur."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Christ for the world we sing",
    "hymnNumber": 354,
    "reference": "AL354",
    "title": "Van Jesus Wil Ons Sing!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "Van Jesus wil ons sing!",
          "Die wêreld tot Hom bring",
          "met blye gees.",
          "Armes en treurendes,",
          "swakkes en beurendes;",
          "Siek van die sondelas,",
          "sal Hy genees."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Van Jesus wil ons sing!",
          "Die wêreld tot Hom bring",
          "met stil gebed -",
          "al die verlorenes,",
          "droefheidbeskorenes;",
          "Vry deur die Heer se bloed,",
          "lief vir die wet."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Van Jesus wil ons sing!",
          "Die wêreld tot Hom bring",
          "uit elke oord.",
          "Tot elke sondaar weer",
          "hom van die sonde keer;",
          "Deur hoop geinspireer,",
          "aan Hom behoort."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "I am thinking today of that beautiful land",
    "hymnNumber": 355,
    "reference": "AL355",
    "title": "Heer Ek Dink Aan Die Land",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 32.5
    },
    "verses": [
      {
        "content": [
          "Heer ek dink aan die land",
          "waar U kinders heen gaan",
          "as die Heer op die wolke verskyn,",
          "as ek daar deur genade",
          "voor Jesus kan staan,",
          "sal daar ook in my kroon sterre skyn?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In die Here se krag",
          "wil ek arbei en wag,",
          "ek wil red wat verlore mag gaan,",
          "sodat sterre mag skyn",
          "daardie heuglike dag",
          "as verlostes voor Jesus sal staan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Watter vreugde as ek eens",
          "die Heer kan aanskou",
          "en die oes van my arbeid kan toon;",
          "Maar die vreugde sal meer wees",
          "as ek ooit verdien",
          "as daar sterre sal skyn in my kroon."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Sal daar ook sterre skyn,",
      "sterre skyn in my kroon",
      "as die Heer op die wolke verskyn,",
      "as ek daar eendag rus,",
      "aan die hemelse kus,",
      "sal daar ook in my kroon sterre skyn?"
    ]
  },
  {
    "english": "Brightly beams our Father's mercy",
    "hymnNumber": 356,
    "reference": "AL356",
    "title": "Helder Skyn Gods Groot Genade",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 16.8,
      "intro": 16.8
    },
    "verses": [
      {
        "content": [
          "Helder skyn Gods groot genade",
          "uit die hemelsvaderland,",
          "maar Hy gee aan ons die opsig",
          "oor die liggies langs die strand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In die donker nag van sonde",
          "met die storm aan elke kant,",
          "soek daar oë met verlange",
          "na die liggies op die strand."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Maak jou lamp dan skoon en helder,",
          "want 'n siel in duisternis",
          "soek met angs en gaan verlore",
          "as hy daardie liggies mis."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Hou die kleiner liggies helder!",
      "Laat hul skyn oor land en see!",
      "Want miskien kan jy 'n drenk'ling",
      "daarmee hulp en redding gee."
    ]
  },
  {
    "english": "I love Thee, I love Thee, I love Thee, my Lord",
    "hymnNumber": 357,
    "reference": "AL357",
    "title": "Hoe Innig Bemin Ek My Dierbare Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Hoe innig bemin ek ",
          "my dierbare Heer,",
          "wat ek in my lofsang ",
          "aanbiddend vereer!",
          "Hoe innig bemin ek ",
          "die een wat my red?",
          "My dade sal aantoon ",
          "hoe lief ek Hom het."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe groot is my vreugde,",
          "hoe diep my genot",
          "in Jesus, my Heiland, ",
          "my Heer en my God!",
          "By Hom is daar vrede ",
          "en hemelse rus;",
          "Hy is my Beminde, ",
          "my lied en my lus!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Jesus, my Heiland, ",
          "by U vind ek rus,",
          "my vreugde en seën, ",
          "my redding en lus!",
          "U Naam is my boodskap, ",
          "U liefde my lied;",
          "O groot die genade ",
          "wat U aan my bied!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die Koning van Salem, ",
          "o wie is soos Hy,",
          "wat my met Sy liefde ",
          "en glimlag verbly?",
          "Deur dade en woorde ",
          "wil ek hulde bring,",
          "aan Hom wat my immer ",
          "met goedheid omring."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord, Help Me Live From Day to Day",
    "hymnNumber": 358,
    "reference": "AL358",
    "title": "Help My, O Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22.4,
      "intro": 30.9
    },
    "verses": [
      {
        "content": [
          "Help my, o Heer om elke dag",
          "die eie-ek so min te ag,",
          "dat my gebede dag en nag",
          "nog steeds mag wees vir and're."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Help my, dat ek in woord en daad",
          "getrou mag handel na U raad -",
          "my net op Jesus sal verlaat",
          "in al my werk vir and're."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verslaan die eie-ek in my",
          "en laat dit steeds gekruisig bly,",
          "dan sal ek sielevree verkry",
          "wanneer ek werk vir and're"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En is my taak op aarde klaar -",
          "as ek my hemelswerk aanvaar,",
          "mag ek my kroon vergeet, ook daar,",
          "terwyl ek dink aan and're."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ja and're, Heer, ja and're,",
      "laat dit my leuse wees;",
      "Help my in werk en strewe",
      "vir andere te lewe",
      "dat ek soos U mag wees,",
      "dat ek soos U mag wees."
    ]
  },
  {
    "english": "Tell it to every kindred and nation",
    "hymnNumber": 359,
    "reference": "AL359",
    "title": "Sê Dit Aan Alle Volke En Nasies",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Sê dit aan al die volke en nasies!",
          "Stuur die nuus alom!",
          "Donkerste nagte kom tot 'n einde;",
          "Jesus sal spoedig kom."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nasies verkeer in stryd en ellende!",
          "Wie sal hul bevry?",
          "Tekens het reeds verskyn aan dieheem'le,",
          "dagbreek is nou naby."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kinders van Jesus, glo en wees moedig!",
          "Sing tot lof van Hom!",
          "Salig is Hy wat wakend en biddend",
          "wag tot die dagbreek kom!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Heil Hom, die Erekoning,",
      "Godslam wat gekruisig is!",
      "Leer dit in elke woning:",
      "Jesus kom gewis."
    ]
  },
  {
    "english": "O where are the reapers that garner in",
    "hymnNumber": 360,
    "reference": "AL360",
    "title": "O Waar Is Die Werkers Wat Uit Kan Gaan?",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.9,
      "intro": 21.9
    },
    "verses": [
      {
        "content": [
          "O waar is die werkers ",
          "wat uit kan gaan",
          "om orals te soek ",
          "na die goeie graan?",
          "Met sekels van waarheid ",
          "en hande sterk",
          "moet ons onverpoos ",
          "in die oesland werk."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gaan soek nou die gange ",
          "en lanings deur;",
          "Die koring wys daar ",
          "ook Sy goue kleur.",
          "Gaan soek op die grootpad,",
          "slaan niemand oor,",
          "laat almal die hemelse ",
          "boodskap hoor."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die lande is wit ",
          "met die oes wat wag;",
          "Die tyd snel verby ",
          "na die oordeelsdag;",
          "Die oes is so groot ",
          "en die werkers min",
          "en veel sal vergaan ",
          "as ons nie begin."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O kom met jul sekels ",
          "en laat ons gaan,",
          "vergader tesame ",
          "die goue graan.",
          "Kom werk tot die Heer ",
          "van die oes sal kom, ",
          "en juig dan oor siele ",
          "gered vir Hom"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Waar is die werkers? ",
      "O wie sal gaan en koring vergader ",
      "waar die onkruid staan?",
      "O wie kom help ons die koring vind?",
      "En wie se hand sal die gerwe bind?"
    ]
  },
  {
    "english": "Working, O Christ, with Thee",
    "hymnNumber": 361,
    "reference": "AL361",
    "title": "As Medewerkers Saam Met U, O Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "As medewerkers ",
          "saam met U, o Heer,",
          "verkondig ons U Naam ",
          "en reine leer;",
          "Hoe swak ons ook mag wees,",
          "ons wandel deur die Gees,",
          "en arbei sonder vrees ",
          "saam met U, Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Vol ywer wil ons werk ",
          "saam met U, Heer;",
          "Om swakkes te versterk ",
          "en reg te leer;",
          "Ons soek die siele wat verdwaal het",
          "van die pad,",
          "en wrakke van die stad,",
          "saam met U, Heer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Volhardend wil ons stry",
          "saam met U, Heer;",
          "Soos U sal ons nooit ly,",
          "wat ons ook deer;",
          "Deur U genade swoeg ons immer,",
          "laat en vroeg;",
          "Dit is vir ons genoeg, ",
          "dierbare Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons werk blymoedig voort",
          "saam met U, Heer;",
          "Totdat U heil'ge Woord ",
          "sondaars bekeer,",
          "en almal wat verlang na lewe,",
          "dit ontvang;",
          "Gered van ondergang ",
          "deur U, o Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Work, for the night is coming",
    "hymnNumber": 362,
    "reference": "AL362",
    "title": "Werk, Want Die Nag Kom Nader",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.2
    },
    "verses": [
      {
        "content": [
          "Werk, want die nag kom nader;",
          "Werk in die môredou;",
          "Werk voor die son verrys het,",
          "wees jou taak getrou.",
          "Werk in die koele môre;",
          "Werk as die son jou brand;",
          "Werk, want die nag kom nader,",
          "dan rus elke hand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Werk, want die nag kom nader;",
          "Werk in die middaguur.",
          "Vul heel die dag met arbeid;",
          "Rus sal ewig duur.",
          "Laat nooit 'n enkel oomblik",
          "leeg uit jou hande gly;",
          "Werk, want die nag kom nader,",
          "werktyd spoed verby."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Werk, want die nag kom nader,",
          "voordat die skadu's daal;",
          "Werk in die laaste sonlig",
          "voor die daglig faal.",
          "Werk tot die dag hier sterwe,",
          "nooit skyn Sy lig hier weer.",
          "Werk, want die nag kom nader,",
          "dan werk ons nie meer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Sowing in the morning, sowing seeds of kindness",
    "hymnNumber": 363,
    "reference": "AL363",
    "title": "Saai die saad van Liefde in die Vroeë More",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 35.9
    },
    "verses": [
      {
        "content": [
          "Saai die saad van liefde in die vroeë more;",
          "Saai dit in die middag en die skemer –aand.",
          "Wag dan vir die wasdom wyl die oestyd nader,",
          "juigend sal ons dan die goue gerwe bring."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Saai dit in die sonskyn, saai dit in die skadu’s,",
          "sonder vrees vir wolke of die winterwind.",
          "As die oestyd aanbreek en die arbeid eindig,",
          "Bring ons met gejuig die goue gerwe in."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Saai die saad met trane, saai dit vir die Meester,",
          "Soms sal ons verlies ly en dit diep betreur,",
          "Droefheid sal ook eindig in die hemelwoning,",
          "as ons met gejuig die goue gerwe bring."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Bring die gerwe in, bring die gerwe in;",
      "ons bring met gejuig die goue gerwe in!",
      "Bring die gerwe in, bring die gerwe in;",
      "ons bring met gejuig die goue gerwe in!"
    ]
  },
  {
    "english": "Let others seek a home below",
    "hymnNumber": 364,
    "reference": "AL364",
    "title": "Laat Ander Hier ‘n Huis Begeer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.3,
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Laat ander hier 'n huis begeer -",
          "Jesus kom ons haal -",
          "waar watervloed en vuur verteer -",
          "Jesus kom ons haal!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nee, ek wil in iets beters woon -",
          "Jesus kom ons haal -",
          "‘n hemelhuis naby Sy troon -",
          "Jesus kom ons haal!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Laat alle aardse vreug verdwyn -",
          "Jesus kom ons haal -",
          "al sou die son en maan nie skyn -",
          "Jesus kom ons haal!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Al word dit hier 'n woesteny -",
          "Jesus kom ons haal -",
          "my hemelwoning sal steeds bly -",
          "Jesus kom ons haal!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ons werk tot Jesus kom,",
      "ons werk tot Jesus kom,",
      "ons werk tot Jesus kom,",
      "totdat Hy ons kom haal."
    ]
  },
  {
    "english": "In the heart of Jesus",
    "hymnNumber": 365,
    "reference": "AL365",
    "title": "In Die Hart Van Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "In die hart van Jesus ",
          "is daar ook vir jou",
          "liefde, rein en teder, ",
          "soos die môredou;",
          "Waarom voel jy eensaam, ",
          "sonder vriendekring,",
          "as die hart van Jesus ",
          "aan jou volheid bring?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In die siel van Jesus ",
          "is gena vir jou",
          "wat verwarm soos sonskyn,",
          "en verkwik soos dou;",
          "Waarom sou jy toegee ",
          "aan bekommernis",
          "as die siel van Jesus ",
          "vol ontferming is?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In die werk van Jesus ",
          "is 'n taak vir jou,",
          "wat Hy selfs aan eng'le ",
          "nie wou toevertrou;",
          "Waarom staan jy ledig, ",
          "loop met trae tred,",
          "as die saak van Jesus ",
          "jou van node het?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "In die huis van Jesus ",
          "is 'n plek vir jou,",
          "rustig en gelukkig, ",
          "skoon om te aanskou;",
          "Waarom sou jy droewig ",
          "rondswerf in verdriet,",
          "as die huis van Jesus ",
          "jou 'n woning bied."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O Master! when Thou callest",
    "hymnNumber": 366,
    "reference": "AL366",
    "title": "O Heer, As U Ons Oproep",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "O Heer, as U ons oproep,",
          "mag niemand U vermy;",
          "Alleenlik hy is salig",
          "wat volg waar U Hom lei.",
          "In jeug se lentemôre",
          "of in die rype dag",
          "is God se roepstem tydig;",
          "Ons durf nie langer wag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O Heer, waar U ons oproep,",
          "is daar geen plek vir vrees,",
          "as iemand U gehoorsaam,",
          "sal U steeds by hom wees;",
          "Alleen in binnekamer,",
          "of waar die mense stry,",
          "waar U regeer, o Here,",
          "daar sal ons siele kry."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "En hy, Heer, wat geroep word,",
          "mag nooit U stem verag;",
          "Die werk is altyd eerbaar",
          "wat U van hom verwag;",
          "Ons kragte, ons talente -",
          "wat U van ons begeer -",
          "lê ons hier aan U voete",
          "gewillig alles neer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die werkers in U wingerd",
          "en ons wat tuis moet bly,",
          "kan same wakend, biddend",
          "U koninkryk verbrei.",
          "Hier werk ons dan tesame,",
          "verenig in ons Hoof,",
          "totdat ons in die hemel",
          "Sy Naam tesame loof."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O Christian, awake! 'tis the Master's command",
    "hymnNumber": 367,
    "reference": "AL367",
    "title": "O Christen, Ontwaak",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 26.6,
      "intro": 26.6
    },
    "verses": [
      {
        "content": [
          "O Christen, ontwaak,",
          "hoor die Meester se stem,",
          "met helm en met skild",
          "en die swaard vasgeklem",
          "ontmoet die versoeker,",
          "stry dapper vir God,",
          "en staan soos 'n held",
          "sonder vrees vir jou lot."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe groot die gevaar,",
          "waak gedurig en bid,",
          "maar keer nie die rug,",
          "dis geheel onbeskut.",
          "Die magte van duisternis",
          "moet jy verslaan,",
          "staan vas soos 'n held,",
          "wees nie traag om te gaan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verdedig die saak ",
          "van die Meester met mag,",
          "wees yw'rig en waaksaam",
          "en stry in Sy krag;",
          "Net waar Hy mag lei,",
          "volg Hom dapper en gou",
          "en staan soos 'n held",
          "vir die Meester getrou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gaan voorwaarts met ywer",
          "om Jesus te dien,",
          "want Hy sal genade ",
          "en vreugde voorsien;",
          "Sy liefde sal dorstige siele verkwik -",
          "staan vas soos 'n held;",
          "Hy sal sege beskik."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Staan soos 'n held!",
      "Staan soos 'n held!",
      "Staan soos 'n held,",
      "want die stryd is vir God."
    ]
  },
  {
    "english": "Stand up! stand up for Jesus!",
    "hymnNumber": 368,
    "reference": "AL368",
    "title": "Staan Op! Trek Op Met Jesus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 16.5
    },
    "verses": [
      {
        "content": [
          "Staan op! Trek op met Jesus,",
          "o helde van die kruis!",
          "Verhef Sy krygsbaniere",
          "ver bo die aards' gedruis;",
          "Oorwinnend, steeds oorwinnend,",
          "lei Hy Sy heil'ge leër,",
          "tot elke vyand neerbuig",
          "voor Hom as God en Heer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Staan op! Trek op met Jesus,",
          "die krygsgeroep weergalm,",
          "dit roep u tot die slagveld,",
          "sal u nog langer talm?",
          "Kom, dien die Heer manmoedig,",
          "die vyand lê en wag",
          "met duisende gevare:",
          "maar God gee moed en krag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Staan op! Trek op met Jesus,",
          "staan in Sy krag alleen;",
          "Vergeefs die hulp van mense,",
          "u krag kom net van Een!",
          "Trek aan Gods wapenrusting,",
          "vertrou slegs op Sy Naam;",
          "Roep plig u deur gevare,",
          "wees moedig om te gaan!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Staan op! Trek op met Jesus,",
          "dit sal nie lank meer duur;",
          "Dan hoor ons segesange,",
          "in die oorwinningsuur.",
          "God gee die kroon van lewe",
          "aan elkeen wat Hom dien,",
          "as al die kruisgesante",
          "die groot oorwinnaar sien!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Soldiers of Christ, arise",
    "hymnNumber": 369,
    "reference": "AL369",
    "title": "Kom, Stryders Vir Die Heer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 16.8
    },
    "verses": [
      {
        "content": [
          "Kom, stryders vir die Heer,",
          "die wapenrusting aan!",
          "U moed en krag, soos Hy u leer,",
          "vind u in Jesus Naam;",
          "Wees sterk, wees voorbereid,",
          "geen dag sal onheil baar;",
          "Wie in die krag van Jesus stry,",
          "is steeds veroweraar!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Staan in die krag van God",
          "met al Sy mag vervul,",
          "u stryd is teen die duisternis,",
          "laat Gods lig u omhul;",
          "Standvastig, onbevrees,",
          "sal u die stryd volstry,",
          "want Jesus sal u vesting wees:",
          "u Rots en Sterkte, Hy!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Gaan dan van krag tot krag,",
          "en waak en bid en stry,",
          "totdat die bose in die slag",
          "die laaste neerlaag ly.",
          "Gods Gees roep saggies: Kom!",
          "en al wat hoor, sê: Kom!",
          "Weldra sing ons die segesang,",
          "dan juig ons saam met Hom!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Onward, Christian soldiers!",
    "hymnNumber": 370,
    "reference": "AL370",
    "title": "Voorwaarts, Christenstryders",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 34.8,
      "intro": 34.8
    },
    "verses": [
      {
        "content": [
          "Voorwaarts, Christenstryders!",
          "Voorwaarts na die stryd!",
          "Volg die kruis van Jesus",
          "tot die dood bereid.",
          "Christus sal ons aanvoer",
          "teen die hel se mag.",
          "Laat Sy vaandel wapper",
          "in oorwinningsprag!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Voor die groot Oorwinnaar",
          "sal die bose vlug;",
          "Voorwaarts, Christenstryders,",
          "moedig en gedug!",
          "Al die fondamente",
          "van die hel sal sink",
          "as ons lied van sege",
          "deur die skepping klink!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Soos 'n leërskare",
          "trek die kerk van God;",
          "Broeders, ons betree nou",
          "weë van ons God.",
          "Ons is nie verdeel nie;",
          "Christus bind ons saam,",
          "een in hoop en liefde",
          "vir Sy grote Naam."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Reuse wêreldryke",
          "het verbygegaan,",
          "maar die kerk van Jesus",
          "bly vir ewig staan.",
          "Al die donker magte",
          "woed met helse haat,",
          "maar ons sal, onwrikbaar,",
          "ons op God verlaat!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Voorwaarts, alle volke,",
          "sluit nou by ons aan;",
          "Hef met ons die skone",
          "segesange aan.",
          "Bring aan onse Koning",
          "hulde, lof en eer!",
          "So loof mens en engel",
          "Hom die eeue deur."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Voorwaarts, Christenstryders,",
      "voorwaarts na die stryd!",
      "Volg die kruis van Jesus,",
      "tot die dood bereid."
    ]
  },
  {
    "english": "Lead on, O King Eternal",
    "hymnNumber": 371,
    "reference": "AL371",
    "title": "Lei Voort, O Eeu'ge Koning",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "Lei voort, o eeu'ge Koning,",
          "die uur van stryd breek aan,",
          "ons wil op elke slagveld",
          "soos helde by U staan.",
          "In tyd van voorbereiding",
          "het U ons krag gegee,",
          "en nou, o eeu'ge Koning,",
          "maak ons die veldtog mee."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Lei voort, o eeu'ge Koning,",
          "totdat die vyand vlug,",
          "en elke heil'ge stryder",
          "‘n soet “Amen!' sal sug;",
          "Want nie met swaardgekletter",
          "of met 'n pantsermag,",
          "maar met die liefdewapen",
          "kan ons triomf verwag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Lei voort, o eeu'ge Koning,",
          "ons volg U sonder vrees,",
          "want lieflik is die môre",
          "as ons by U kan wees.",
          "U kruis is ons verseek'ring,",
          "die liefde is ons plig;",
          "Daar wag oorwinnaarskrone -",
          "lei voort, o God van lig!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Am I a soldier of the cross",
    "hymnNumber": 372,
    "reference": "AL372",
    "title": "Is Ek ‘n Stryder Vir My God?",
    "hasMidi": true,
    "numberOfVerses": 6,
    "hasChorus": false,
    "timestamps": {
      "intro": 7.1
    },
    "verses": [
      {
        "content": [
          "Is ek 'n stryder vir my God,",
          "‘n volg'ling van die Lam?",
          "Is ek bevrees as mense spot;",
          "Skaam ek my vir Sy Naam?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wil ek langs rosepad so wyd",
          "na gindse hawe gaan,",
          "waar ander kom met harde stryd",
          "en menig' bitter traan?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Het ek geen worstelstryd te stry?",
          "Is aards' gemak my lot?",
          "Bring wêreldse plesier vir my",
          "dan nader aan my God?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As ek nie moediglik wil stry,",
          "verbeur ek ook my kroon;",
          "Heer, ek sal werk en ween en ly",
          "as Jesus in my woon."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Oorwinnaars in die aardse slag -",
          "al sou hul ook beswyk -",
          "sien deur geloof die blye dag",
          "van toegang tot Gods ryk!"
        ],
        "verseNumber": 5
      },
      {
        "content": [
          "Want eenmaal kom die skone dag,",
          "dan sal U stryders sing -",
          "in kleure van oorwinningsprag",
          "aan U die hulde bring!"
        ],
        "verseNumber": 6
      }
    ],
    "chorus": null
  },
  {
    "english": "With willing hearts we tread",
    "hymnNumber": 373,
    "reference": "AL373",
    "title": "Ons Volg Gewillig",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.7
    },
    "verses": [
      {
        "content": [
          "Ons volg gewillig op",
          "die kruisweg van ons Heer;",
          "Ons volg die voorbeeld wat Hy stel,",
          "en gee Hom al die eer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Op U alleen berus",
          "ons hoop en ons geloof;",
          "Deur U versoening vind ons rus -",
          "die heil aan ons beloof."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "U het ons vrygekoop;",
          "O Heer, waak oor ons lot!",
          "Mag ons vir sonde daagliks sterf,",
          "en leef tot eer van God!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "In the blood from the cross",
    "hymnNumber": 374,
    "reference": "AL374",
    "title": "Deur Die Bloed Word Ek Rein",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 14.3,
      "intro": 14.3
    },
    "verses": [
      {
        "content": [
          "Deur die bloed word ek rein",
          "van alle sondesmet;",
          "Bose neigings verdwyn",
          "wanneer die Lam my red."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Uur na uur, dag na dag,",
          "seën die Heiland my;",
          "En Hy skenk my die krag",
          "wat tot oorwinning lei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Altyd volg ek my Heer,",
          "want ek wil by Hom wees;",
          "Alles wat ek begeer,",
          "vra ek Hom sonder vrees."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nou het ek vrede weer",
          "by al die smart en pyn,",
          "maar ek bid al hoe meer:",
          "“Maak my van sonde rein'."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Dieper steeds, dieper steeds",
      "in die genadevloed;",
      "Dieper steeds, dieper steeds",
      "onder Sy dierb're bloed."
    ]
  },
  {
    "english": "O now I see the crimson wave",
    "hymnNumber": 375,
    "reference": "AL375",
    "title": "Ek Sien Die Bloed Vloei Uit U Sy",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.9,
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "Ek sien die bloed vloei uit U sy -",
          "geopende fontein;",
          "Jesus, my Heer, net U kan red,",
          "was my van sonde rein."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek sien die nuwe skepping staan",
          "so rein, so onbevlek.",
          "My sondige natuur vergaan,",
          "Sy bloed het my bedek."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek wandel in die hemellig",
          "verhef bo sondenag;",
          "Met klere wit en hart gerig",
          "op Jesus waar ek wag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Genade Gods, so groot en ryk,",
          "dit is wat U ons vra;",
          "Word Hom, die Seun van God, gelyk,",
          "die Man van Golgota."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Die kosb're bloed, gestort vir my,",
      "was my van al my sonde vry;",
      "O prys die Heer! Dit reinig my,",
      "dit reinig my, ja, reinig my."
    ]
  },
  {
    "english": "Thy broken body, gracious Lord",
    "hymnNumber": 376,
    "reference": "AL376",
    "title": "Heer, Van U Liggaam, Eens Gebreek",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Heer, van U liggaam, eens gebreek",
          "het hierdie brood simbool geword;",
          "En hierdie wyn wat ons hier skink,",
          "wys op U bloed vir ons gestort."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wyl ons hier saamkom in U Naam -",
          "ons is verenig deur U bloed -",
          "wil ons U dood eerbiedig vier;",
          "Dit gee ons krag en nuwe moed."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons hoop staan vas dat U sal kom",
          "op wolke van U heerlikheid;",
          "Dan gaan ons met die Bruidegom,",
          "en leef met Hom in ewigheid."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus invites His saints",
    "hymnNumber": 377,
    "reference": "AL377",
    "title": "Die Here Nooi Sy Kerk",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Die Here nooi Sy kerk",
          "om Avondmaal te vier;",
          "Daardeur gedenk ons dan die lyding",
          "wat Hy moes verduur."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Gelowig neem ons wyn",
          "en ongesuurde brood;",
          "Die sinnebeelde van Sy bloed",
          "en liggaam in Sy dood."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons eet die lewensbrood",
          "en drink die lewenswyn;",
          "Dit sien verby die aardse nag",
          "en maak ons lewens rein."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Weldra verdwyn die nag,",
          "dan kom die Heiland weer,",
          "die bruilofsmaaltyd van die Lam",
          "eet ons dan met die Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The judgment has set, the books have been opened",
    "hymnNumber": 378,
    "reference": "AL378",
    "title": "Die Oordeel is hier",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.9,
      "intro": 20.9
    },
    "verses": [
      {
        "content": [
          "Die oordeel is hier, die boeke geopen,",
          "hoe sal ons daardie dag verdra;",
          "as Hy, ons Regter en ons Here,",
          "van ons rekenskap sal vra?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die oordeel begin by vroeër geslagte,",
          "Spoedig kom dit by jou en my;",
          "uit die gedenkboek sal die Regter ",
          "ons veroordeel of bevry."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Hoe sal ons staan in daardie oordeel?",
          "Is al ons skuld uitgewis?",
          "Daar’s geen appél as ons verhoor is.",
          "Daar’s die oordeel klaar beslis"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Hoe sal ons staan  op daardie dag?",
      "Hoe sal ons staan op daardie dag?",
      "Sal ons te lig deur Hom bevind word,",
      "Of wag vir ons die blye dag?"
    ]
  },
  {
    "english": "O solemn thought! and can it be",
    "hymnNumber": 379,
    "reference": "AL379",
    "title": "O Plegtig Is Die Werklikheid!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.3
    },
    "verses": [
      {
        "content": [
          "O plegtig is die werklikheid!",
          "Die uur van oordeel het gekom",
          "wat elke mens se lot getrou",
          "beslis vir wel of wee voor Hom.",
          "Ja, dit is so: die oordeelsuur",
          "haas vinnig na die ewigheid",
          "wanneer die Regter sal verskyn",
          "om reg te spreek in majesteit."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy wat moes kom om hier te sterf",
          "as offer vir misdadigheid,",
          "en opgevaar het na Sy huis,",
          "is eerlank vir Sy koms bereid.",
          "Hy staan nou in die heiligdom",
          "waar Hy as Hoëpriester dien,",
          "dat elkeen wat Sy Naam bely",
          "Sy heerlik aangesig mag sien."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Straks breek die oomblik plegtig aan",
          "dat elk wat hier Sy Naam bely,",
          "allenig voor sy God moet staan",
          "om daar sy loon of straf te kry.",
          "O Jesus, onse Middelaar,",
          "by U wil ons genade soek;",
          "Bely ons name voor Gods troon",
          "en wis ons sondes uit U boek."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O dierb're Heer, laat ons besef",
          "die plegtigheid van hierdie uur;",
          "Vul met U ywer elke hart,",
          "en wil in ons U liefde stuur.",
          "Dat ons mag sterk wees in U krag",
          "en dapper as die stryd ontbrand,",
          "dan sal ons bo-op Sion staan,",
          "oorwinnaars in die Vaderland!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Don't forget the Sabbath, The Lord our God hath blest",
    "hymnNumber": 380,
    "reference": "AL380",
    "title": "Kom, Gedenk Die Sabbat",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 38.3,
      "intro": 38.3
    },
    "verses": [
      {
        "content": [
          "Kom, gedenk die Sabbat,",
          "geheilig deur die Heer,",
          "van heel die week die skoonste -",
          "die kroon van skeppingseer.",
          "Dit bring ons rus van arbeid,",
          "en vreugde van die Heer;",
          "Sy reine hemelvrede",
          "skyn lieflik op ons neer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hou die Sabbat heilig",
          "en dien die Heer opreg",
          "wat Sy dissipels toeroep:",
          "“Ek is die ware weg!'",
          "As ons die Heer gehoorsaam",
          "en in die Heiland groei,",
          "bring Hy ons waar die strome",
          "van lewenswater vloei."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dag van heil'ge vreugde!",
          "Ek sal die ure wy",
          "aan lof en dank tot Jesus,",
          "die beste Vriend vir my.",
          "O Heiland, so sagmoedig,",
          "so vriendelik en skoon,",
          "hoe kosbaar U belofte",
          "om in ons hart te woon!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ons verlang na rus en vrede",
      "daagliks meer en meer;",
      "Ons verwelkom hierdie rusdag -",
      "Sabbat van die Heer."
    ]
  },
  {
    "english": "Holy day, Jehovah's rest",
    "hymnNumber": 381,
    "reference": "AL381",
    "title": "Uitverkore Dag Van God",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Uitverkore dag van God,",
          "kom tot ons in Sy gebod;",
          "Heil'ge dag, geseënde rus -",
          "steeds ons vreugde en ons lus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Na die Heer se skeppingsweek",
          "het Gods Sabbat aangebreek -",
          "heil'ge dag, deur God gereël,",
          "in Sy liefdeswet die seël."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vele hou die eerste dag,",
          "daardeur word Sy wet verkrag;",
          "Ondersoek die Skrif getrou",
          "en U sal die Sabbat hou."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dis die mens - wil daarop let -",
          "wat die dag verander het;",
          "Onverander deur die tyd",
          "staan Gods Woord in ewigheid."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ek kry na my ondersoek",
          "net een Sabbat in Sy Boek;",
          "Dit is God wat self daar spreek -",
          "“Hou my Sabbat week na week!'"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Welkom heil'ge, blye rusdag,",
      "ons wil op U seën wag,",
      "maak ons heilig, Heer, vandag."
    ]
  },
  {
    "english": "How sweet upon this sacred day",
    "hymnNumber": 382,
    "reference": "AL382",
    "title": "Hoe Lieflik Is Die Sabbatdag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.3
    },
    "verses": [
      {
        "content": [
          "Hoe lieflik is die Sabbatdag,",
          "die beste van die week,",
          "wanneer ons van ons werke rus,",
          "en aardse bande breek!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe lieflik dat ons saam kan bid -",
          "om skuldvergifnis smeek;",
          "Om soos 'n kind na Hom te gaan,",
          "en met ons Vader spreek."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe lieflik as die Here spreek:",
          "“Nou is jy wit soos wol'.",
          "Dit maak jou hart met hemelsrus",
          "en reine vreugde vol."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Omdat ons nie deur eie krag",
          "die sonde kan bestry,",
          "maak Jesus ons genadiglik",
          "van al ons sondes vry."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Welcome, welcome, day of rest",
    "hymnNumber": 383,
    "reference": "AL383",
    "title": "Welkom Is Die Sabbatdag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Welkom is die Sabbatdag,",
          "aan die mens deur God gegee;",
          "Welkom in my need'rig' hart,",
          "welkom dag van rus en vree."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dag van stille sielerus,",
          "lieflik gaan die tyd verby;",
          "Tot ons aan die hemelkus",
          "ons in eeu'ge rus verbly."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heil'ge dag, ons ag jou hoog,",
          "dag van lofsang en gebed;",
          "Jy maak selfs die dwase wys,",
          "jy's die seël van die wet."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Welkom is die Sabbatdag,",
          "met sy god'lik atmosfeer;",
          "Mag sy heiligheid vandag",
          "my gedagtes opwaarts keer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Another six days' work is done",
    "hymnNumber": 384,
    "reference": "AL384",
    "title": "Dis Weer Die Einde Van ‘n Week",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "Dis weer die einde van 'n week;",
          "Die Sabbatdag het aangebreek;",
          "Ontvang die rus wat God verleen,",
          "want Hy het self die dag geseën."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat ons 'n vrome loflied sing",
          "aan Hom wat rus en vrede bring;",
          "Op hierdie dag word ons gegee",
          "‘n voorsmaak van die eeu'ge vree."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Soos wierook styg ons dankgebed",
          "tot U wat ons van onheil red;",
          "In Christus sal ons salig rus,",
          "want ons is van Sy trou bewus."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kalme verseek'ring is die pand",
          "van rus in onse Vaderland;",
          "Wat op die kerk van Christus wag",
          "na hierdie aardse sondenag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Thy holy Sabbath, Lord",
    "hymnNumber": 385,
    "reference": "AL385",
    "title": "U Heil'ge Sabbat, Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "U heil'ge Sabbat, Heer,",
          "vervul U volk met lus;",
          "En wyl ons op U boodskap wag,",
          "sing ons van eeu'ge rus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die dag van onse Heer",
          "verwelkom ons met sang;",
          "Hier voor U troon bring ons U eer",
          "soos U van ons verlang."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O seën ons hier saam,",
          "verhoor ons stil gebed;",
          "Laat ons U heil'ge dag geniet",
          "en lewe na U wet."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En na die aardse stryd",
          "van lyding, smart en rou;",
          "Mag ons dan eindeloos met U",
          "die groter Sabbat hou!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Safely through another week",
    "hymnNumber": 386,
    "reference": "AL386",
    "title": "Veilig Deur ‘n Ander Week",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "Veilig deur 'n ander week",
          "het die Here ons gelei;",
          "Laat ons nou hier voor Hom wag",
          "tot Sy seën ons verbly.",
          "Dag van vreugde en van lus,",
          "teken van ons eeu'ge rus;",
          "Dag van vreugde en van lus,",
          "teken van ons eeu'ge rus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heer, ons soek by U gena",
          "in ons dierb're Heilands Naam;",
          "Was ons rein, so wit soos sneeu,",
          "Heer, U sal ons nooit beskaam!",
          "Maak ons vry van alle blaam,",
          "gee ons rus in Jesus Naam;",
          "Maak ons vry van alle blaam,",
          "gee ons rus in Jesus Naam."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer ons loof U grote Naam,",
          "skenk ons U teenwoordigheid;",
          "Wyl ons in U tempel wag,",
          "toon ons tog U heerlikheid.",
          "Skenk 'n voorsmaak deur U Gees",
          "van die groot hiernamaalsfees!",
          "Skenk 'n voorsmaak deur U Gees",
          "van die groot hiernamaalsfees!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Mag die evangeliewoord",
          "sondaars wen en heil'ges sterk;",
          "Skenk die vrugte van die Gees,",
          "laat daar troos vir droefheid wees.",
          "Maak elk Sabbat so, o Heer,",
          "tot ons eens met U regeer!",
          "Maak elk Sabbat so, o Heer,",
          "tot ons eens met U regeer!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "How sweet the light of Sabbath eve!",
    "hymnNumber": 387,
    "reference": "AL387",
    "title": "So Sag Die Lig Van Sabbataand",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.9
    },
    "verses": [
      {
        "content": [
          "So sag die lig van Sabbataand,",
          "die son se strale is van goud;",
          "Laat ons in stilte almal kniel -",
          "aanbid die Skepper, jonk en oud."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Rus vir my siel, o soete rus!",
          "Ek voel die vrede wat hier ruis,",
          "en wyl die Heer my siel verkwik,",
          "sien ek in gees my vaderhuis."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die stryd op aard' is nie meer lank,",
          "ons vreemd'lingskap is haas verby;",
          "Daarbo sal ons die Here dank,",
          "en in Sy Sabbat ons verbly."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "This is the day of rest",
    "hymnNumber": 388,
    "reference": "AL388",
    "title": "Dit Is Die Dag Van Rus",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Dit is die dag van rus,",
          "Heer, skenk ons nuwe krag;",
          "Verkwik ons liggaam en ons siel",
          "met hemeldou vandag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is die dag van vree,",
          "ons harte soek U wil;",
          "Bestraf die tweedragswinde, Heer,",
          "en maak die golwe stil."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die dag is vir gebed",
          "wat ons met U verbind;",
          "Mag ons wanneer ons na U soek",
          "die hemelsvrede vind."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dit is die beste dag,",
          "voed ons met lewensbrood!",
          "Wek siele op wat dood is, Heer,",
          "oorwinnaar oor die dood!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O day of rest and gladness",
    "hymnNumber": 389,
    "reference": "AL389",
    "title": "Die Dag Van Rus En Blydskap",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.1
    },
    "verses": [
      {
        "content": [
          "Die dag van rus en blydskap,",
          "die dag van vreugd en lig!",
          "‘n balsem vir ons droefheid,",
          "so skoon sy vergesig!",
          "Die prinse en die herders",
          "buig saam aanbiddend neer;",
          "Sing: “Heilig, heilig, heilig,",
          "o Allerhoogste Heer!'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is 'n veil'ge hawe",
          "teen elke storm wat kom;",
          "‘n tuin met helder strome",
          "vir elke boom en blom;",
          "Dit is 'n beek van water",
          "wat ons in dors behou,",
          "die Nebo waarvandaan ons",
          "die beter land aanskou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die dag van soet oordenking,",
          "die Godgewyde dag,",
          "van duisend lofgesange",
          "tot Hom op wie ons wag.",
          "Dit dra die Heer se seën,",
          "dit is vir ons 'n lus,",
          "maar ons verlang gedurig",
          "na die beloofde rus."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "The dawn of God's dear Sabbath",
    "hymnNumber": 390,
    "reference": "AL390",
    "title": "Die More Van Gods Sabbat",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Die more van Gods Sabbat",
          "kom stil in kleureprag;",
          "Net soos die helder sonskyn",
          "na lange lydingsnag.",
          "Dit kom soos somerbuie,",
          "oor dor-verskroeide land -",
          "soos skaduwees van palme",
          "op die woestyn se sand."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O Heer, neem U ons offer,",
          "al is dit onvolmaak;",
          "‘n week van troue arbeid,",
          "van werk en bid en waak -",
          "die vrug van selfverlo'ning,",
          "die hand tot diens bereid;",
          "Die hart gedwing deur liefde",
          "tot ware need'righeid."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons bring ons lewenslaste,",
          "elk sondig woord of daad;",
          "Ons kniel voor U in ootmoed,",
          "verlos ons van die kwaad!",
          "Ons hart se grootste droefheid;",
          "U werk nog onvoldaan!",
          "Talente word begrawe,",
          "terwyl die oes bly staan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En uit ons bitter droefheid,",
          "ontspring 'n sterk fontein",
          "van hoop, geloof en liefde -",
          "o Here, maak dit rein!",
          "Ja, daardie reinheid vind ons",
          "in U teenwoordigheid;",
          "En vrede vul ons harte",
          "tot in die ewigheid!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Again the day returns of holy rest",
    "hymnNumber": 391,
    "reference": "AL391",
    "title": "Dit Is Nou Weer Die Heil'ge Sabbatdag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Dit is nou weer die heil'ge Sabbatdag",
          "wat ons laat dink aan God se",
          "skeppingsmag;",
          "Hy het beveel dat ons daarop moet rus,",
          "van al Sy krag en heiligheid bewus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat ons dan saam op hierdie",
          "heil'ge dag",
          "leer wat die Heer van elke mens verwag;",
          "Dan sal die God tot wie ons hulde bring",
          "hoor as ons bid en luister as ons sing."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "o Grote Skepper, neig tot ons U oor!",
          "Wil U in liefde ons gebede hoor;",
          "U ryk beloftes, Heer, ",
          "sal nimmer faal;",
          "Laat nou U seën op U kinders daal."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hemelse Vader, U op wie ons bou,",
          "ons groot Beskermer wat ons steeds ",
          "behou",
          "dierbare Vriend, sien op U kinders neer;",
          "Aan U die lof die roem en al die eer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Lord of the Sabbath and its light",
    "hymnNumber": 392,
    "reference": "AL392",
    "title": "Heer Van Die Sabbat En Sy Lig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 13
    },
    "verses": [
      {
        "content": [
          "Heer van die Sabbat en sy lig,",
          "ek dank U vir U heil'ge dag;",
          "Dit is die vreugde van my hart,",
          "dit skenk my troos en nuwe krag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Geseënde dag van kalme rus,",
          "die ure is my baie soet;",
          "O Heer, maak my gedagtes rein,",
          "dan kan ek U vandag ontmoet."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe vreedsaam gaan die dag verby,",
          "die heil'ge ure bring my rus",
          "en hemelsvreugde, vol en bly -",
          "ek loof my God na hartelus."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O Jesus, mag ek U altyd",
          "verwelkom in die dag van rus,",
          "ontvang ek dan die dubb'le seën,",
          "omdat U, Heer, teenwoordig is."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The Lord is in His holy temple",
    "hymnNumber": 393,
    "reference": "AL393",
    "title": "Die Heer Is In Sy Heil'ge Tempel",
    "hasMidi": true,
    "numberOfVerses": 1,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.5
    },
    "verses": [
      {
        "content": [
          "Die Heer is in Sy heil’ge tempel;",
          "Swyg voor Hom, ganse aarde, aanbid Hom."
        ],
        "verseNumber": 1
      }
    ],
    "chorus": null
  },
  {
    "english": "The golden morning is fast approaching",
    "hymnNumber": 394,
    "reference": "AL394",
    "title": "Die Goue Môre Begin Al Aanbreek",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Die goue môre begin al aanbreek,",
          "Jesus sal weer kom!",
          "Om al Sy troue en blye kinders",
          "saam te neem met Hom."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die evangelie word nou verkondig",
          "heel die wêreld deur;",
          "Die Bruidegom sal nie versuim nie,",
          "Hy staan voor die deur."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Met al die engele van die hemel",
          "daal die Regter neer;",
          "Hy kom en neem Sy kinders met Hom -",
          "hulle sterf nooit weer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Bemindes wat deur die dood geskei is,",
          "sal mekaar weer sien;",
          "En Jesus droog dan self die trane",
          "waar ons Hom daar dien."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "o, Ons sien die lig van die goue môre -",
      "stromend deur die donker nag",
      "ja, ons hoor Sy stem in die goue môre -",
      "“Open elke graf!'"
    ]
  },
  {
    "english": "Called to the feast by the King are we",
    "hymnNumber": 395,
    "reference": "AL395",
    "title": "Ons Is Genooi Na Die Koningsfees",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Ons is genooi na die koningsfees,",
          "saam met Sy volk gaan ons sonder vrees;",
          "Hoe sal dit, vriend, ",
          "dan met ons twee wees ",
          "as die Koning kom?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is 'n kroon, ",
          "maar geen dorings meer",
          "Hy wat moes sterwe, ons God en Heer,",
          "word dan geheilig en hoog vereer,",
          "as die Koning kom."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar, in 'n oomblik, ",
          "sal almal skou",
          "dinge op aarde geheim gehou -",
          "dinge verborge vir man en vrou -",
          "as die Koning kom."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hy sal Sy oë oor ons laat gaan -",
          "ons wat in feesklere voor Hom staan -",
          "o! As ons tog maar ",
          "die toets deurstaan",
          "as die Koning kom."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "As die Koning kom, broeder,",
      "as die Koning kom!",
      "Hoe sal dit staan met jou en my",
      "as die Koning kom?"
    ]
  },
  {
    "english": "When Jesus shall gather the nations",
    "hymnNumber": 396,
    "reference": "AL396",
    "title": "Wanneer Jesus Die Nasies Vergader",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Wanneer Jesus die nasies vergader,",
          "en elkeen se dade kom voor;",
          "Hoe sal ons dan staan in die oordeel,",
          "gedaag om ons vonnis te hoor?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sal ons hoor uit die mond van die Regter:",
          "wees welkom, o dienskneg getrou?",
          "Of sal ons met trane en bewing,",
          "ons lewe op aarde berou?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Met 'n glimlag kyk Hy na Sy kinders",
          "wat staan in die beeld van hul Heer;",
          "Hy beklee hul met hemelse skoonheid,",
          "dan buig hul aanbiddend daar neer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O laat ons dan waak en gereed wees,",
          "met brandende lamp in die hand;",
          "En wanneer Hy ons roep na die bruilof,",
          "gaan ons na die heerlike land."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Met oë gerig op die hemel,",
          "geduldig wag ons op die Heer;",
          "Met ons reis hier op aarde beëindig,",
          "sal ons daar met Jesus verkeer."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Al die koring sal Hy dan versamel,",
      "maar die kaf word verteer in die vuur;",
      "Hoe sal ons dan staan voor die Regter,",
      "in die vreeslike oordeelsuur?"
    ]
  },
  {
    "english": "O Prince of Peace",
    "hymnNumber": 397,
    "reference": "AL397",
    "title": "O Vredevors, U't Opgevaar",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "O Vredevors, U't opgevaar",
          "in wolk en glorie glansend klaar",
          "terwyl dissipels opwaarts staar;",
          "O kom, Heer Jesus, kom tog gou!",
          "Die wêreld wag dat U moet kom;",
          "Die jare gaan so stadig om",
          "die skepping sug en swyg dan stom;",
          "O kom, Heer Jesus, kom tog gou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoor U die ganse skepping kreun,",
          "die klag van hul waar oorlog dreun;",
          "Woestyne roep U, heil'ge Seun:",
          "O kom, Heer Jesus, kom tog gou!",
          "Die tekens van gevaar ontvou",
          "in lande skaars nog uit die rou;",
          "Ons kan op U alleen vertrou,",
          "o kom, Heer Jesus, kom tog gou!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Deur leed en twyfel diep geraak,",
          "deur vyande beleër, bewaak;",
          "Hoor hoe die nasies oproer maak,",
          "o kom, Heer Jesus, kom tog gou!",
          "Hoop van die lankbeproefde skaar,",
          "hul enig vreug en trots, voorwaar!",
          "Sonder U koms bly niks gespaar,",
          "o kom, Heer Jesus, kom tog gou!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom met U heerlik' koningskroon;",
          "Kom met die skaar wat by U woon;",
          "Kom met die eng'le om U troon,",
          "o kom, Heer Jesus, kom tog gou!",
          "Kom op die wolke helder blank;",
          "Kom met die luid' basuingeklank",
          "die skepping wag nou al so lank,",
          "o kom, Heer Jesus, kom tog gou!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "We know not the time when He cometh",
    "hymnNumber": 398,
    "reference": "AL398",
    "title": "Ons Weet Nie Wanneer Hy Sal Kom Nie",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 42.6,
      "intro": 42.6
    },
    "verses": [
      {
        "content": [
          "Ons weet nie wanneer Hy sal kom nie -",
          "met skemer of diep in die nag;",
          "Miskien kom Hy saam met die dagbreek,",
          "maar ons moet Hom altyd verwag.",
          "“Gereed wees en waak', is die boodskap,",
          "ons lampe moet helderder skyn,",
          "met harte volkome gereinig",
          "tot Hy op die wolke verskyn."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek dink aan Sy ewige liefde -",
          "die prys vir ons sonde en haat;",
          "Paleise van heerlike luister",
          "moes Hy vir die sondaar verlaat.",
          "En somtyds dink ek dit behaag Hom",
          "as hulle vir wie Hy moes ly,",
          "die hoop van hul harte verkondig,",
          "deur wakend en wagtend te bly."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Jesus, my dierb're Verlosser,",
          "ek koester die hoop oor en oor;",
          "Dat ek, as U kom op die wolke,",
          "U woorde van welkom sal hoor.",
          "Wanneer U verskyn as die Regter,",
          "vir die wat sal wegvlug in rou;",
          "Begroet ek U as my Verlosser!",
          "Ja, kom, Here Jesus, kom gou!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Wakend en biddend,",
      "wakend en biddend;",
      "Wakend en biddend;",
      "Steeds wakend en wagtend vir U."
    ]
  },
  {
    "english": "Hark! that shout of rapturous rapture high",
    "hymnNumber": 399,
    "reference": "AL399",
    "title": "Hoor! Dis Die Verlossingslied",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Hoor! Dis die verlossingslied",
          "van die ganse hemelkoor;",
          "Jesus kom, bekroon met eer,",
          "eng'le laat hul blydskap hoor."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoor! Dis die trompetgeskal",
          "wat die weerkoms begelei!",
          "Heil'ges, hef U hoofde op,",
          "U verlossing is naby."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kyk, die Here self verskyn,",
          "voor wie aard' en hemel wyk!",
          "Staan op, vrygekoopte volk,",
          "en beërf die koninkryk."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gaan die Heiland tegemoet,",
          "vry van kommer, sorg of vrees;",
          "By U Here en U God",
          "sal U ewig salig wees."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "We know not the hour of the Master's appearing",
    "hymnNumber": 400,
    "reference": "AL400",
    "title": "Die Uur Van Sy Koms",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 28.2,
      "intro": 28.2
    },
    "verses": [
      {
        "content": [
          "Die uur van Sy koms",
          "is vir ons nou nog duister,",
          "die wêreld is steeds",
          "aan die sonde gekluister;",
          "Maar Hy sal weer kom",
          "in Sy heerlike luister,",
          "maar ons ken nie die uur."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die lig is vir almal ",
          "wat Jesus bemin het,",
          "sekuur is die tekens ",
          "wat lankal begin het,",
          "vir elkeen wat biddend",
          "die wêreld oorwin het;",
          "Maar ons ken nie die uur."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons waak en ons wag,",
          "want dit kan nou die tyd wees,",
          "ons werk en ons bid -",
          "ons moet altyd bereid wees;",
          "Ons jubel en sing,",
          "nie meer lank sal die stryd wees,",
          "maar ons ken nie die uur."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Hy sal kom (Hy sal kom);",
      "laat ons waak en gereed wees;",
      "Hy sal kom (Hy sal kom)",
      "Halleluja! Halleluja!",
      "Hy sal kom in die prag",
      "van Sy Vader se luister,",
      "maar ons ken nie die uur."
    ]
  },
  {
    "english": "A glory in the word we find",
    "hymnNumber": 401,
    "reference": "AL401",
    "title": "Ons Sien Die Waarheid In Sy Boek",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.1
    },
    "verses": [
      {
        "content": [
          "Ons sien die waarheid in Sy Boek",
          "soos Hy ons wyser maak,",
          "want sonde was 'n sluierdoek",
          "voor daardie lig volmaak!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As God die sluier van ons vee",
          "dan sien ons reg en goed;",
          "God het Sy Woord aan ons gegee",
          "as lamp vir onse voet."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe salig met ontblote oog",
          "sien ons Sy heerlikheid.",
          "Deur heel Gods Woord word Hy verhoog,",
          "steeds tot ons hulp bereid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O laat ons deur aanskouing dien",
          "en groei in heiligheid,",
          "dat ons kan smag om U te sien,",
          "hoog in U heerlikheid!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "It may be at morn, when the day is awaking",
    "hymnNumber": 402,
    "reference": "AL402",
    "title": "Dit Mag Wees Wanneer Ons Die Rooidag",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 29.9,
      "intro": 29.9
    },
    "verses": [
      {
        "content": [
          "Dit mag wees wanneer ons die rooidag sien uitkom,",
          "as sonskyn die skadu's oor velde laat uitstrek;",
          "Dat Jesus sal kom in Sy heerlike luister",
          "om Sy volk na hul huis te neem."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit mag wees oordag, of as sterre reeds fonkel,",
          "dit mag wees, wie weet, dat die middernagsdonker",
          "sal uitbars in lig, weens die glans vanSy luister,",
          "as Jesus Sy volk kom haal."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O, blydskap volmaak, as ons gaan sonder sterwe;",
          "Geen siekte, geen droefheid, geen vrees en geen trane!",
          "Hoog vaar ons na Hom, waar Hy woon in Sy luister,",
          "as Jesus Sy volk kom haal."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "o, Heer Jesus, hoe lank, hoe lank,",
      "eer die groot segesang?",
      "Jesus kom weer, halleluja,",
      "halleluja, amen! Halleluja, amen!"
    ]
  },
  {
    "english": "Joy to the world, the Lord will come!",
    "hymnNumber": 403,
    "reference": "AL403",
    "title": "Juig, Aarde, Juig",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 8
    },
    "verses": [
      {
        "content": [
          "Juig, aarde, juig, die Here kom!",
          "Laat elke nasie juig!",
          "Maak elke hart 'n troon vir Hom",
          "voor wie die eng'le buig,",
          "voor wie die eng'le buig;",
          "Voor wie die heil'ge eng'le buig!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Juig, nasies, juig, Hy kom regeer!",
          "Hef aan 'n vreugdepsalm,",
          "en laat oor veld en berg en meer",
          "die triomfkreet weergalm,",
          "die triomfkreet weergalm;",
          "Die luide triomfkreet weergalm!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Geen sonde meer",
          "om smart te baar,",
          "geen doring sal daar groei;",
          "waar nou die vloek Hom openbaar",
          "sal seëninge vloei,",
          "sal seëninge vloei;",
          "Sal ryke seëninge vloei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dan heers die Heiland",
          "oor Sy volk,",
          "groot in geregtigheid;",
          "Hul sal Sy liefde daar vertolk",
          "in alle ewigheid,",
          "in alle ewigheid;",
          "In alle, alle ewigheid!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O brother, be faithful! soon Jesus will come",
    "hymnNumber": 404,
    "reference": "AL404",
    "title": "O, Broeder, Wees Waaksaam!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.7
    },
    "verses": [
      {
        "content": [
          "o, Broeder, wees waaksaam!",
          "Want spoedig kom Hy",
          "op wie ons so lank reeds al wag.",
          "O, spoedig sal ons die beloning verkry,",
          "oorwinnaars deur Jesus se krag.",
          "O, broeder, wees waaksaam,",
          "opreg en getrou,",
          "want Hy het Sy lewe gegee,",
          "uit grenslose liefde,",
          "om ons te behou,",
          "te red van die ewige weë."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "o, Broeder, wees waaksaam!",
          "Die Godstad so skoon",
          "berei vir die reines van hart;",
          "Sal ons, na Sy weerkoms,",
          "in vrede bewoon,",
          "want daar is geen trane of smart.",
          "O broeder, wees waaksaam,",
          "lank sal ons nie bly",
          "in droefheid, vermoeid en belas;",
          "Die nag van verdriet is al byna verby",
          "die dag sal ons spoedig verras."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O, broeder, wees waaksaam! ",
          "Hy kom spoedig weer, ",
          "om sonde en boosheid te straf;",
          "Met duisende engele kom onse Heer in triomf oor dood en die graf.",
          "O, broeder, wees waaksaam;",
          "Ons sal Hom aanskou",
          "en hoor wat ons vurig begeer:",
          "“Mooi so, goeie dienskneg, oor weinig getrou, gaan in, in die vreug van jou Heer!'"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O, broeder, wees waaksaam! ",
          "Volhard in die stryd;",
          "Die kruis word vervang deur 'n kroon,",
          "wanneer ons beklee word met onsterflikheid,",
          "en God in ons midde sal woon.",
          "O, broeder, wees waaksaam, die tyd is so kort, die eind'lose ewigheid wag;",
          "Daar sal ons geen smart ly, geen trane ",
          "ooit stort, want daar is geen pyn en geen nag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Come, Lord, and tarry not",
    "hymnNumber": 405,
    "reference": "AL405",
    "title": "Kom, Here, O Vertraag Tog Nie",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 7.1
    },
    "verses": [
      {
        "content": [
          "Kom, Here, o vertraag",
          "tog nie die blye dag;",
          "Ag, wanneer sal ons U aanskou?",
          "Waarom moet ons nog wag?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kom, want die skepping sug",
          "onder verganklikheid,",
          "en wag reikhalsend op U koms!",
          "O God, verkort die tyd!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kom, want die oes is ryp;",
          "O, stuur die maaiers uit",
          "na al U uitverkorenes",
          "onder trompetgeluid."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom, laat die sterk man bind,",
          "vernietig al sy werk;",
          "Werp uit die vyand van U volk",
          "en van U heil'ge kerk!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Kom, onse Koning, kom,",
          "aanvaar die heerskappy;",
          "Laat vrede en geregtigheid",
          "in ewigheid gedy!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "Lift up the trumpet, and loud let it ring",
    "hymnNumber": 406,
    "reference": "AL406",
    "title": "Blaas Die Basuine",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.3,
      "intro": 20.3
    },
    "verses": [
      {
        "content": [
          "Blaas die basuine, ",
          "verkondig dit luid:",
          "Jesus, ons Heiland, kom weer!",
          "Hou moed, o pelgrims,",
          "wees hoopvol en sing:",
          "Jesus, ons Heiland, kom weer!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Berge weergalm dit, ",
          "en vlaktes herhaal",
          "Jesus, ons Heiland, kom weer!",
          "Hy kom verheerlik ",
          "met hemelse praal -",
          "Jesus, ons Heiland, kom weer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Seë, verkondig ",
          "in brandergedruis:",
          "Jesus, ons Heiland, kom weer!",
          "Laat al jul golwe ",
          "dit donderend bruis:",
          "Jesus, ons Heiland, kom weer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Aardbewings teister ",
          "die wêreld alom,",
          "Jesus, ons Heiland, kom weer!",
          "Storms en orkane",
          "leer ons dat Hy kom,",
          "Jesus, ons Heiland, kom weer!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Nasies is toornig, ",
          "hieraan moet ons weet: ",
          "Jesus, ons Heiland, kom weer!",
          "Kennis vermeerder,",
          "verwoesting bring leed;",
          "Jesus, ons Heiland, kom weer!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Jesus kom weer!",
      "Jesus kom weer!",
      "Jesus, ons Heiland, kom weer!"
    ]
  },
  {
    "english": "How sweet are the tidings that greet the pilgrim's ear",
    "hymnNumber": 407,
    "reference": "AL407",
    "title": "Hoe Lieflik Die Tyding",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 20.1
    },
    "verses": [
      {
        "content": [
          "Hoe lieflik die tyding",
          "vir elke swerwersoor",
          "wat so ver van sy vaderland dwaal:",
          "die Koning sal eersdaags",
          "in heerlikheid kom",
          "om die banneling huis toe te haal."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die verweerde ou grafte",
          "waar martelare rus,",
          "sal oopskeur en berge sal beef!",
          "Uit die see sal die dode",
          "in heerlikheid ontwaak",
          "en weer op die aarde leef."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar kom die oorwinnaars",
          "van alle eeue saam",
          "om die lied van verlossing te sing;",
          "Uit die noorde en suide kom hulle",
          "om die Naam van ons Heiland",
          "die hulde te bring."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Laat ons jubel en sing!",
          "Halleluja, Amen!",
          "Wie volhard kry 'n ewige kroon.",
          "Laat ons wakend en biddend",
          "en juigend volhard,",
          "dat ons ewig by Jesus kan woon!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Die Here kom, die Here kom gewis;",
      "O, Hy daal met die wolke neer;",
      "En vermoeide pelgrims kry hul erfenis",
      "as die Heiland eens regeer."
    ]
  },
  {
    "english": "Lord, Thy children guide and keep",
    "hymnNumber": 408,
    "reference": "AL408",
    "title": "As Die Koringlande Wit Is",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "As die koringlande wit is,",
          "en die oes het aangebreek,",
          "kom die Koning met Sy septer",
          "om die oordeel uit te spreek.",
          "Uit hul grafte sal die dode",
          "voor die Regterstoel verskyn;",
          "En regverdig is die uitspraak",
          "wanneer God Sy kinders eien."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O die blydskap van Sy kinders",
          "wat so lank gebonde was;",
          "Hul gedagtes staan steeds huiswaarts -",
          "daar verdwyn die aardse las.",
          "Hy maak almal daar onsterflik;",
          "Daar is al hul klere rein;",
          "Hul sal ken soos hul geken word,",
          "wanneer God Sy kinders eien."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Lank het hul die oes bearbei,",
          "en met trane saad gesaai;",
          "Spoedig eindig al hul arbeid",
          "as die Koning self kom maai.",
          "Hul sal vreugde vind daarbowe,",
          "daar sal elke sug verdwyn;",
          "Hul ontvang daar sterrekrone,",
          "wanneer God Sy kinders eien."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Na die skeiding sal bemindes",
          "daardie dag mekaar ontmoet.",
          "Al hul leed sal dan vergeet word",
          "as die Heer Sy kinders groet.",
          "Daar kwel sonde ons nie meer nie,",
          "in ons heerlik' samesyn;",
          "Spoedig kom die blye môre,",
          "wanneer God Sy kinders eien."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Watchman, tell me, does the morning",
    "hymnNumber": 409,
    "reference": "AL409",
    "title": "Wagter, Sê My, Kom Die Môre",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "Wagter, sê my, kom die môre,",
          "is die daeraad naby?",
          "En bespeur jy al die tekens",
          "wat ons harte sal verbly?",
          "Pelgrim ja! Staan op, kyk om jou,",
          "sien jy nie die môrelig?",
          "Maak gereed jou bruilofsklere,",
          "haas jou en vervul jou plig!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Wagter, kyk die lig skyn om ons,",
          "helder langs die hele weg!",
          "Tekens vul die ganse aarde,",
          "langer bly ons nie gekneg.",
          "Onder jubelklank sal Jesus,",
          "uit die stof en uit die see,",
          "al die heiliges kom opwek,",
          "met onsterflikheid beklee!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wagter, kyk, die lig verrys al",
          "van die heil'ge Sabbatjaar!",
          "Alles hier verkondig juigend:",
          "Hy kom met Sy eng'leskaar!",
          "Pelgrim, ja, daar in die verte",
          "sien ek die Beloofde land,",
          "en die Godstad in haar skoonheid",
          "daar aan gindse hemelstrand!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wagter, in die stad daarbowe,",
          "op die troon van die heelal,",
          "sit die Lam van God as Koning.",
          "Vrede rus op berg en dal;",
          "Groene velde, koel fonteine,",
          "helder strome word bestraal",
          "deur die sagte gloed van Sion,",
          "waar geen awend ooit sal daal."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Wagter, kyk, die land kom nader!",
          "O, aanskou die blommeprag!",
          "Byna daar - nog net 'n skrede!",
          "Kom, laat ons nie langer wag.",
          "Luister! Op die reine luggie",
          "sweef musiek, verruklik skoon!",
          "Kyk, die skares! Hoor hul loflied:",
          "hier kan pelgrims ewig woon."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "We are living, we are dwelling",
    "hymnNumber": 410,
    "reference": "AL410",
    "title": "Uit Die Nag Van Verre Eeue",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Uit die nag van verre eeue -",
          "uit die grys verlee ontvou",
          "hierdie slottonele voor ons",
          "van die nasies in die rou.",
          "Volke is in diep beroering,",
          "Gog en Magog in die stryd;",
          "Hoor! Die skepping in vervoering:",
          "dis die einde van die tyd!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kind van God, ontwaak, omgord jou,",
          "vir die stryd is krag beloof;",
          "Neem die helm van die verlossing",
          "en die skild van die geloof,",
          "ook geregtigheidsborswapen",
          "en die Gees se skerpe swaard;",
          "Gaan, en moenie vrees of wankel,",
          "Hy roep jou: wees nie vervaard!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Bose geeste veg met woede -",
          "al die hel se magte saam;",
          "Owerhede, o so listig,",
          "sonder eerbied vir Gods Naam;",
          "Ja, hul trek op na die slagveld,",
          "aangehits deur bitter haat!",
          "Wees gereed en waak, o Christen,",
          "Christus sal jou nooit verlaat!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ja, die vors van duister magte,",
          "wat die mensdom so mislei,",
          "wou ook eens ons dierbr'e Heiland",
          "met versoekinge verlei.",
          "Ja, hy kom in al sy sluheid,",
          "want hy weet sy troon gaan val;",
          "Dan sal Jesus eind'lik optree",
          "as die Vors van die heelal!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Voorwaarts, Christen! Neem jou wapens",
          "eerlank is die stryd volstry;",
          "Hy wat glo in die beloftes,",
          "moet volhard en moedig ly.",
          "In die koninkryk daarbowe,",
          "na die lyding van weleer,",
          "sal ons Heer en Meester uitroep:",
          "“Mooi so, dienskneg van die Heer!'"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "The coming King is at the door",
    "hymnNumber": 411,
    "reference": "AL411",
    "title": "Die Vors Wat Aan Die Kruis Moes Ly",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Die Vors wat aan die kruis moes ly,",
          "se wederkoms is nou naby;",
          "Dan red Hy ons wat Hom verwag,",
          "uit hierdie sondenag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die tekens wat Sy koms voorspel,",
          "word deur Gods uurwerk afgetel;",
          "En spoedig breek die goue dag",
          "waarvoor ons lank reeds wag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Op aarde moet ons stryd verwag",
          "tot daardie vreugdevolle dag,",
          "wanneer die Heiland sal verskyn,",
          "en sonde eens verdwyn."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Daar op die nuwe aarde skoon,",
          "sal Jesus by Sy kinders woon;",
          "Die sterflik word onsterflikheid;",
          "En tyd die ewigheid."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Aan die deur, aan die deur,",
      "aan die deur, ja, Hy is aan die deur!",
      "Hy kom nader, Hy kom nader,",
      "Hy is reeds al aan die deur."
    ]
  },
  {
    "english": "'Tis almost time for the Lord to come",
    "hymnNumber": 412,
    "reference": "AL412",
    "title": "Dis Byna Tyd Dat Die Heer Moet Kom",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.7,
      "intro": 19.7
    },
    "verses": [
      {
        "content": [
          "Dis byna tyd dat die Heer moet kom,",
          "die tyding gaan al rond;",
          "Die sterlig taan, die dag breek aan,",
          "kom ons juig oor die goue môrestond!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die handskrif staan in die son en maan",
          "op aarde, lug en see;",
          "En kondig luid die weerkoms aan",
          "van Hom wat aan ons die lewe gee!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dis tyd om hoogmoed af te sweer,",
          "die lende te omgord;",
          "En deur die krag van onse Heer",
          "steeds reiner en heiliger te word."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Gaan haastig uit op die straat en laan",
          "en op die weë breed;",
          "Bring blindes en verminktes aan",
          "en maak hulle voor die koms gereed."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "O, die sterre verdwyn reeds voor die dag",
      "o, die sterre verdwyn reeds voor die dag",
      "die nag is haas verby,",
      "die dag kom ons verbly;",
      "O, die sterre verdwyn reeds voor die dag"
    ]
  },
  {
    "english": "Heir of the Kingdom, O why dost thou slumber?",
    "hymnNumber": 413,
    "reference": "AL413",
    "title": "Kind Van Gods Koninkryk",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "chorus": 10.5,
      "intro": 10.5
    },
    "verses": [
      {
        "content": [
          "Kind van Gods koninkryk,",
          "hoe kan jy sluimer,",
          "hoe kan jy slaap",
          "wyl die stryd om jou woed?",
          "Maak jou gereed",
          "vir die koms van die Heiland,",
          "haas jou want kyk",
          "hoe die oomblikke spoed!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Kind van Gods koninkryk,",
          "hoe kan jy weifel?",
          "Hoe kan jy talm?",
          "Hy is reeds voor die deur!",
          "Was wit jou klere,",
          "gereed vir Sy weerkoms,",
          "wil jy kortsigtig",
          "jou erf'nis verbeur?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kyk hoe die nasies",
          "verdruk en verdelg word,",
          "hoor die gekerm",
          "en aanskou al die leed!",
          "Dis die geruis",
          "van die hemelse strydwa;",
          "Kind van Gods koninkryk,",
          "o wees gereed!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Hoe kan jy hunker",
          "na roem en besittings?",
          "Kyk hoe kortstondig",
          "is aardse genot;",
          "Breek nou die bande",
          "van lis en bekoring,",
          "kind van Gods ryk,",
          "keer terug na jou God!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Hef op jou oë",
          "en soek na die dagbreek,",
          "wees op jou hoede,",
          "volhard in die stryd;",
          "Weldra verskyn",
          "op die wolke jou Koning,",
          "sing van Sy koms,",
          "waak en bid, wees bereid!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "How far from home? I asked, as on",
    "hymnNumber": 414,
    "reference": "AL414",
    "title": "Wanneer, O Wagter, Kom Ons Tuis!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Wanneer, o wagter, kom ons tuis!",
          "Die antwoord kom, die hemel spreek:",
          "“Die donker nag is haas verby,",
          "die helder môre breek!",
          "Ween dan nie meer, versnel jou pas,",
          "jou Leidsman is die Môrester;",
          "Tot aan die hemelpoort lei Hy -",
          "die dag is nou nie ver'."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ek vra die krygsman op sy pos:",
          "dit was sy lied, vol lof en dank:",
          "'met moed voleindig ek die stryd,",
          "die slag duur nie meer lank.",
          "Ween dan nie meer, maar glo in God!",
          "Ons het die goeie stryd begin,",
          "Hy sal ons sekerlik beloon;",
          "Ons sal gewis oorwin!'"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek vra die aarde, see en son,",
          "met een stem antwoord hulle my:",
          "“die tyd haas na sy laaste uur,",
          "die einde is naby!",
          "Ween dan nie meer, die tekens kom",
          "en waarsku ons deur son en maan;",
          "Die hele skepping sug en kla,",
          "die oordeelsuur moet slaan'."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Dit duur nie lank dan is ons tuis.",
          "Die tyding gee die krygsman moed",
          "en beur die moeë swerwer op;",
          "Dit bring vertroosting soet -",
          "ween dan nie meer, maar juig my siel,",
          "jou swerftog loop ten einde nou;",
          "Verdriet en droefheid is verby -",
          "‘n kroon wag daar op jou!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Watch, ye saints, with eyelids waking",
    "hymnNumber": 415,
    "reference": "AL415",
    "title": "Heil'ges, Waak! Die Dag Kom Nader",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.1,
      "intro": 15.1
    },
    "verses": [
      {
        "content": [
          "Heil'ges, waak! Die dag kom nader,",
          "bose magte sal vergader;",
          "Vul jul lampe voor die nag kom,",
          "Jesus kom - Sy volk verwag Hom;"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy belowe ons die lewe,",
          "guns by God en skuld vergewe;",
          "Bruilofsklere, lewenskrone -",
          "as Hy kom, bring Hy ons lone."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Trotse ryke gaan ten gronde,",
          "hoor! Sy waens se wiele donder;",
          "Gaan! Verkondig Sy genade,",
          "roep die sondaars op tot dade;"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nasies is met vrees bevange,",
          "maar Gods volk wag met verlange;",
          "Doodsangs laat die volke bewe;",
          "Ons verwag die bron van lewe;"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Hoor hoe pleit Hy: “Skei van sonde'.",
          "Sondaar, kom, Hy heel jou wonde;",
          "Haas jou! Reik na beter dade,",
          "spoedig eindig Sy genade;"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Kyk, Hy kom! Ja, Jesus kom!",
      "Jesus kom, Hy kom in luister,",
      "om te heers oor lig en duister,",
      "Hy sal kom! Ja, Jesus kom!"
    ]
  },
  {
    "english": "Look for the waymarks as you journey on",
    "hymnNumber": 416,
    "reference": "AL416",
    "title": "Let Op Die Tekens Waar Die Weg Ons Lei",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.7,
      "intro": 20.7
    },
    "verses": [
      {
        "content": [
          "Let op die tekens",
          "waar die weg ons lei,",
          "stil gaan die bakens ",
          "een vir een verby.",
          "Vier koninkryke het ",
          "verbygegaan;",
          "Let op die tekens,",
          "kyk tog waar ons staan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Eenmaal het Babel, ",
          "wêreldstad, gebloei,",
          "maar is deur Medo-Persië ",
          "uitgeroei.",
          "Toe kom die Griekse ",
          "wêreldkoninkryk",
          "wat voor Romeinse ",
          "ysterhand moes wyk."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons ken die voete -",
          "yster saam met klei!",
          "Hierdie verdeeldheid ",
          "is ook haas verby;",
          "Wat volg daarna met ",
          "heerlikheid en krag?",
          "Jesus se weerkoms ",
          "waarna alles smag!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Let op die bakens -",
      "die evangelietyding -",
      "al vier die koninkryke is verby.",
      "Let op die bakens -",
      "profeties is die tyding -",
      "die einde is naby!"
    ]
  },
  {
    "english": "We've no abiding city here",
    "hymnNumber": 417,
    "reference": "AL417",
    "title": "Ons Het Geen Tuiste Hier Benee",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.8
    },
    "verses": [
      {
        "content": [
          "Ons het geen tuiste hier benee -",
          "hoe treurig as ons hier moes bly;",
          "Maar God sal aan ons wonings gee,",
          "‘n stad wat Hy vir ons berei. (2x)"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Niks blywends kan ons hier bespeur,",
          "ons soek 'n stad deur God gebou!",
          "Jerusalem, waar niemand treur,",
          "wanneer sal ons jou lig aanskou? (2x)"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Hoe salig is die oord van vree,",
          "waar moeë pelgrims eind'lik rus!",
          "Had ek maar vleuels, dan",
          "betree ek spoedig daardie kus! (2x)"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wees stil my siel, en wag op Hom,",
          "wat daar omhoog die godstad bou;",
          "Hy ken Sy tyd, en tot Hy kom,",
          "wees aan Sy wil en wet getrou. (2x)"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Watchmen on the walls of Zion",
    "hymnNumber": 418,
    "reference": "AL418",
    "title": "Wagters Op Die Muur Van Sion",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.2
    },
    "verses": [
      {
        "content": [
          "Wagters op die muur van Sion,",
          "kyk hoe ver is tog die nag?",
          "Sal die môrester haas opkom?",
          "Breek weldra die skone dag?",
          "Sien jy tekens van die lig net voor die dag?",
          "Sien jy tekens van die lig net voor die dag?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Het ons nou die laaste baken",
          "van ons lange reis bereik?",
          "Vaar ons reeds die hawe binne?",
          "Sal die newels weldra wyk?",
          "Is ons byna in die heil'ge koninkryk?",
          "Is ons byna in die heil'ge koninkryk?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Reeds verrys die blinke dagster",
          "om die wagters te verbly;",
          "Kyk, die lig verdring die duister,",
          "spoedig word Gods kerk bevry!",
          "Juig dan, heil'ges, ons verlossing is naby!",
          "Juig dan, heil'ges, ons verlossing is naby!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Vinnig nader ons die hawe,",
          "vol vertroue vaar ons voort;",
          "Ons kompas en kaart, geliefdes,",
          "is die onvervalste Woord.",
          "Juigend nader ons die Goddelike oord!",
          "Juigend nader ons die Goddelike oord!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "On Jordan's stormy banks I stand",
    "hymnNumber": 419,
    "reference": "AL419",
    "title": "Ek Staan Op Die Jordaan Se Wal",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Ek staan op die Jordaan se wal,",
          "en laat my oë gaan",
          "oor berg en songedrenkte veld",
          "waar spoedig ek sal staan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Oor daardie wye velde welf",
          "die ewig-skone dag,",
          "want Jesus is daar self die dag",
          "en Hy verdryf die nag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Wanneer bereik ek daardie land?",
          "(daar dwaal ek nimmer meer!)",
          "Wanneer sien ek die aangesig",
          "van Hom, my God en Heer?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "My siel, vervul met hemelsvreug,",
          "wil hier nie langer bly;",
          "Deur die Jordaan wil ek liefs gaan,",
          "al dek die golwe my."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ons sal rus in die skone, blye dag",
      "net hier oorkant die aardse Jordaan!",
      "Sing die lied van Moses en die Lam,",
      "en woon met Jesus ewig saam."
    ]
  },
  {
    "english": "Just over the mountains in the Promised Land",
    "hymnNumber": 420,
    "reference": "AL420",
    "title": "Net Oorkant Die Berge",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.5,
      "intro": 40.7
    },
    "verses": [
      {
        "content": [
          "Net oorkant die berge in die land wat wag,",
          "lê die skone godstad in Sy heil'ge prag;",
          "As ons moeë skrede oor die bergkruin gaan,",
          "sien ons reeds die einde van ons pelgrimsbaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In die dae van Abram is die stad verwag",
          "met die goue strate sonder dood of nag;",
          "In vervoering sien ons reeds sy skone glans",
          "en die jaspismure teen die hemeltrans."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Deur die poorte sal almal gaan wat nog getrou",
          "hier in Jesus glo en Gods gebooie hou;",
          "En daar loof ons Jesus tot in ewigheid,",
          "vir Sy liefde, trou en goedertierenheid!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "My broeder, my suster, sal ons jul daar sien",
          "in die land van vrede waar ons Jesus dien?",
          "Neem Sy boodskap aan en bly aan Hom getrou;",
          "As Hy weer terugkom, roep Hy ook vir jou!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ons is byna tuis!  Ons is byna tuis!",
      "Sien die lig wat stromend van die koepels daal;",
      "Sien die luister wat uit elke stadspoort straal!",
      "Ons sal spoedig deur die goue strate gaan;",
      "Hoor die eng'lestemme waar die tempel staan!",
      "Ons is byna tuis!"
    ]
  },
  {
    "english": "In the land of fadeless day",
    "hymnNumber": 421,
    "reference": "AL421",
    "title": "In Die Land Waarheen Ons Gaan",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17.9,
      "intro": 17.9
    },
    "verses": [
      {
        "content": [
          "In die land waarheen ons gaan,",
          "lê die Godstad en wag;",
          "Dit sal altyd voortbestaan",
          "en daar is ook geen nag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Pêrelpoorte word nooit oud",
          "in die Godstad wat wag;",
          "Al Sy strate is van goud",
          "en daar is ook geen nag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons sal nooit die poorte sluit",
          "in die Godstad wat wag;",
          "Daar vloei lewenswater uit",
          "en daar is ook geen nag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons sal nooit na lig verlang",
          "in die Godstad wat wag,",
          "want die lig kom van die Lam",
          "en daar is ook geen nag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Dan vee God ons trane af;",
      "Daar's geen pyn, geen dood of vrees;",
      "Jare tel die tyd nie af,",
      "want daar sal geen nag wees."
    ]
  },
  {
    "english": "We speak of the realms of the blest",
    "hymnNumber": 422,
    "reference": "AL422",
    "title": "Ons Spreek Van Die Salige Oord",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Ons spreek van die salige oord,",
          "die land soos die môre so skoon;",
          "En lieflik is daar elke woord;",
          "Hoe salig om eens daar te woon!",
          "Ons praat van die strate van goud",
          "en mure so helder en skoon,",
          "Sy wonders as nog onbekend -",
          "hoe salig om eens daar te woon!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons spreek van verlossing uit smart,",
          "uit droefheid, versoeking en hoon,",
          "van stryd in die vlees en die hart -",
          "hoe salig om eens daar te woon!",
          "Ons spreek van die liefde wat dien,",
          "van ewige lewe en loon -",
          "die plek van verlostes omhoog -",
          "hoe salig om eens daar te woon!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Geen doodskuld meer om te betaal",
          "as Hy ons met lewe vereer;",
          "Ons sien hoe Jerusalem daal,",
          "versier soos 'n bruid vir haar Heer.",
          "Die stad is so heilig en rein,",
          "geen droefheid ontreinig die lug;",
          "Beproewing en sonde verdwyn;",
          "Daar hoor ons geen klag of gesug!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wil U in versoeking en leed",
          "my siel vir die hemel berei;",
          "En spoedig sal ek ook kan weet",
          "hoe voel dit om daar te kan bly.",
          "Ons wandel op seë van glas",
          "in vreugde eteries en skoon,",
          "met eng'le en heiliges tuis",
          "waar Jesus self by ons sal woon!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Angel voices sweetly singing",
    "hymnNumber": 423,
    "reference": "AL423",
    "title": "Eng'lestemme Saggies Singend",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Eng'lestemme saggies singend,",
          "eggo's deur die sfere kringend;",
          "Tyding van die hemel bringend:",
          "ons is byna tuis!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar is reeds die jaspismure,",
          "wat ons wink soos welkomsvure;",
          "O ons tel alreeds die ure,",
          "ons is byna daar!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sagte melodieë hoor ons,",
          "dit oorweldig en bekoor ons;",
          "Elke aardse drang verloor ons,",
          "ons is byna daar!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nooit sal trane ooit daar val nie,",
          "nooit sal vreugde daar vergal nie;",
          "Die verwagting is nie al nie,",
          "ons is byna daar!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Skoonste Jesus, onse Here,",
          "is die lig; aan Hom die ere;",
          "Hy's die Lam, die Heer der Here,",
          "ons is byna daar!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Byna daar! Byna daar!",
      "Heerlike verwagting met Jesus daar!",
      "Byna daar! Byna daar!",
      "Eindelose vreugde met Jesus daar!"
    ]
  },
  {
    "english": "Out on an ocean all boundless we ride",
    "hymnNumber": 424,
    "reference": "AL424",
    "title": "Wyd Is Die Woesteny Hier Waar Ons Gaan",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Wyd is die woesteny hier waar ons gaan,",
          "maar huis toe nou, huis toe nou!",
          "Lank het die storme gewoed en geslaan,",
          "maar huis toe nou, huis toe nou!",
          "Ver was ons van daardie veilige kus,",
          "maar in die Vader se wonings is rus,",
          "met Sy belofte gaan ons doelbewus -",
          "ja, huis toe nou, huis toe nou!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Storme wat woed en wat dreun voer ons mee,",
          "steeds huis toe nou, huis toe nou!",
          "Daarna die hawe wat wag oor die see:",
          "o, huis toe nou, huis toe nou!",
          "Hou koers, o stuurman, staan vas by die stuur,",
          "hou koers, die storm is nou byna verby,",
          "op die ou aarde het ons veel verduur -",
          "maar huis toe nou, huis toe nou!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Binne die hawe aan hemelse strand,",
          "nou eind'lik tuis, eind'lik tuis.",
          "Veilig word ons nou gevoer",
          "deur Gods hand:",
          "in daardie huis is ons tuis;",
          "Ere aan God! Die gevaar is verby!",
          "Veilig staan ons nou, van storme bevry.",
          "Ere aan God! Sing ons dankbaar en bly -",
          "in daardie huis is ons tuis!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "When all my labors and trials are o'er",
    "hymnNumber": 425,
    "reference": "AL425",
    "title": "Eens Is Beproewing En Arbeid Verby",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 22.9,
      "intro": 22.9
    },
    "verses": [
      {
        "content": [
          "Eens is beproewing en arbeid verby,",
          "dan sal ek my in die godstad verbly -",
          "veilig, tevrede aan Jesus se sy,",
          "deur al die eeue so heerlik vir my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Eens deur genade wat my sondes dek,",
          "as die basuin uit die dode my wek,",
          "vind ek daarbowe vir my ook 'n plek",
          "deur al die eeue so heerlik vir my."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Vriende sal daar wees wat jare al rus",
          "strome van vreugde bring vrede en lus",
          "net om my Heiland se voete te kus -",
          "deur al die eeue so heerlik vir my."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "o, Dit sal wees heerlik en bly,",
      "heerlik en bly, heerlik en bly;",
      "As Hy dit gun dat ek voor Hom sal staan;",
      "Sal dit my vrede, my vreugde daar wees!"
    ]
  },
  {
    "english": "Ten thousand times ten thousand",
    "hymnNumber": 426,
    "reference": "AL426",
    "title": "Tienduisend Maal Tienduisend",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Tienduisend maal tienduisend,",
          "ontelbaar is die skaar,",
          "wat opwaarts deur die hemelruim",
          "saam met die Heiland vaar;",
          "Verlostes in wit klere,",
          "van rein geregtigheid,",
          "sal ingaan deur die hemelpoort -",
          "oorwinnaars in die stryd."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Soet klink die halleluja's",
          "met die oorwinningskreet;",
          "In daardie vreugdevolle stond,",
          "word alle pyn vergeet.",
          "Die dode sal weer opstaan,",
          "op daardie blye dag",
          "waarna die skepping van die Heer,",
          "en al die volke smag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O heerlik is die weersien",
          "aan gindse hemelkus,",
          "van dierbares hier wreed geskei!",
          "In daardie oord van rus",
          "vind ouers weer hul kinders;",
          "Hul trane afgedroog,",
          "want daar is wees nog weduwee,",
          "in onse huis omhoog."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom, bring die groot verlossing,",
          "o Lam vir ons geslag!",
          "Verskyn, soos U belowe het,",
          "in heerlikheid en krag!",
          "Bevry U volk van lyding,",
          "laat elke klag verstom;",
          "Verlange van die volkere",
          "en Prins van vrede, kom!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "I will sing you a song of that beautiful land",
    "hymnNumber": 427,
    "reference": "AL427",
    "title": "Kom Ons Sing Nou",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 21.4
    },
    "verses": [
      {
        "content": [
          "Kom ons sing nou ‘n lied van die lieflike land -",
          "die heerlike land van ons heil;",
          "Waar geen stormwinde woed teen die glinsterende strand,",
          "deur die tydlose ewigheid heen.",
          "deur die tydlose ewigheid heen.",
          "Waar geen stormwinde woed teen die glinsterende strand,",
          "deur die tydlose ewigheid heen."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "O ek sien in my drome die heilige stad",
          "met 'n weelde van kleure versier,",
          "tot dit skyn of ek staan in die pêrelblink stad",
          "van deurskynende goud en saffier.",
          "van deurskynende goud en saffier.",
          "tot dit skyn of ek staan in die pêrelblink stad",
          "van deurskynende goud en saffier."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daardie ewige stad is vir jou en vir my",
          "en daar is die Heiland se troon;",
          "Ja, die heerlike Koning van konings is Hy",
          "en Hy wag om Sy kinders te kroon.",
          "en Hy wag om Sy kinders te kroon.",
          "Ja, die heerlike Koning van konings is Hy",
          "en Hy wag om Sy kinders te kroon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O hoe bly sal ons wees in die lieflike land,",
          "van droefheid en pyn eens bevry.",
          "Waar ons staan voor die troon met 'n harp in die hand",
          "en bemindes weer eens aan ons Sy.",
          "en bemindes weer eens aan ons Sy.",
          "Waar ons staan voor die troon met 'n harp in die hand",
          "en bemindes weer eens aan ons Sy."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "The homeland! O the homeland!",
    "hymnNumber": 428,
    "reference": "AL428",
    "title": "Die Hemel! O Die Hemel!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Die hemel! O die hemel!",
          "Ondenkbaar is sy prag,",
          "geen nag is in die hemel,",
          "daar bly dit ewig dag.",
          "Ek smag steeds na die hemel",
          "op aarde is ek bang;",
          "Daar is geen smart in die hemel",
          "waarna ek so verlang."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar's eng'le in die hemel",
          "by onse liewe Heer.",
          "Geen kwaad is in die hemel",
          "en geen versoeking meer.",
          "Die snarespel van eng'le",
          "klink strelend soet daarbo;",
          "En as ek dink aan die hemel,",
          "kom trane na my oë."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die eng'le in die hemel",
          "roep sondaars om te gaan",
          "waar dood of droefheid nimmer",
          "sal inkom of bestaan.",
          "O heil'ge hemeltuiste",
          "waar rus en vrede bly!",
          "Ag, Heer, bring my na die hemel,",
          "U bloed was ook vir my."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Beautiful valley of Eden",
    "hymnNumber": 429,
    "reference": "AL429",
    "title": "Lieflike Velde Van Eden",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 20.1,
      "intro": 20.1
    },
    "verses": [
      {
        "content": [
          "Lieflike velde van Eden,",
          "stil is jul middaguur;",
          "Salig die hoop vir die pelgrim,",
          "wyl Hy nog leed verduur."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Bokant die hart van bedroefdes",
          "straal reeds die goue dag;",
          "Hoor tog die lied van die eng'le,",
          "ver deur die donker nag."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar in die Vader se woning",
          "juig die verloste skaar;",
          "Daar op die velde van glorie",
          "vier ons die jubeljaar!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Lieflike velde van Eden,",
      "daar is ons eenmaal tuis;",
      "Hoe smeek ek in woedende storme,",
      "o Heer, bring ons tuis, ja, tuis."
    ]
  },
  {
    "english": "Shall we gather at the river",
    "hymnNumber": 430,
    "reference": "AL430",
    "title": "Sal Ons Saamkom Met Die Vrome?",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Sal ons saamkom met die vrome,",
          "waar die eng'leskare staan,",
          "by die helder waterstrome",
          "wat van God se troon uitgaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Op die Godsrivier se oewers",
          "waar die reënboogkleure sprei,",
          "sal ons Hom aanbid vir ewig;",
          "Elke goue dag so bly!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Voor ons op die oewers aankom,",
          "lê ons al ons laste neer,",
          "en ontvang oorwinnaarskrone",
          "uit die hand van onse Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Nie meer lank nie en dan sien ons",
          "daardie ligomstraalde stroom,",
          "daar sal al ons harte saam juig",
          "by die groene lewensboom."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Daar ontmoet ons al die vrome,",
      "by altyd helder, altyd klaar strome -",
      "skoner nog as ons aardse drome -",
      "daar rondom die troon van God."
    ]
  },
  {
    "english": "Shall we meet beyond the river",
    "hymnNumber": 431,
    "reference": "AL431",
    "title": "Sal Ek Jou Ontmoet, My Broeder",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Sal ek jou ontmoet, my broeder,",
          "anderkant die doodsjordaan;",
          "Waar Gods kinders eens sal lewe",
          "sonder pyn, verdriet of traan?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Sal ons anker in die hawe",
          "waar die branders nie meer bruis?",
          "Sal ek jou daar sien, my broeder,",
          "in die eeu'ge Vaderhuis?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Sal ons saamwoon in die Godstad,",
          "wat die Heer vir ons berei;",
          "Op die jaspisfondamente?",
          "Sal ons daar vir ewig bly?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sal ons saam met die verlostes",
          "in die stad van Jesus woon;",
          "En 'n blye lofsang aanhef",
          "voor die Godslam op Sy troon?"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "By die Heer! By die Heer!",
      "Sal jy ook daar wees, my broeder?",
      "Sal ek jou ontmoet, my broeder,",
      "anderkant die doodsjordaan?"
    ]
  },
  {
    "english": "There's a land that is fairer than day",
    "hymnNumber": 432,
    "reference": "AL432",
    "title": "Daar's ‘n Land Soos Die Môre So Skoon",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Daar's 'n land soos die môre so skoon",
          "deur geloof sal ons eenmaal daar bly",
          "waar verlostes vir ewig sal woon",
          "in die tuiste wat Jesus berei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hoe welluidend en bly sal ons sing",
          "aan die salige hemelse kus;",
          "Waar geen pyn of verdriet ons meer dwing",
          "om te smag na 'n oomblik van rus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Aan die Vader, so mild en so goed,",
          "sal ons elkeen ons dankbaarheid bied",
          "vir die gawe van Jesus se bloed",
          "en die einde van al ons verdriet."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "In die land van ons heil",
      "sal ons saam voor Gods troon juigend staan!",
      "In die land van ons heil",
      "sal ons saam voor Gods troon juigend staan!"
    ]
  },
  {
    "english": "There is a land of corn and wine",
    "hymnNumber": 433,
    "reference": "AL433",
    "title": "Daar Is ‘n Land Van Wyn",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 14.9,
      "intro": 22.1
    },
    "verses": [
      {
        "content": [
          "Daar is 'n land van wyn en graan,",
          "sy vreugde smaak ons spoedig saam;",
          "Waar onbewolk die eeu'ge dag,",
          "nooit sal verander tot die nag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My Heiland wandel daar met my,",
          "o blye stonde aan Sy sy!",
          "Hy neem my vriend'lik aan die hand",
          "en lei my deur die Vaderland."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Verfrissend is die geure daar,",
          "met lentekleure deur die jaar;",
          "Waar blomme onverwelklik bloei",
          "en lewenstrome rustig vloei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Op stille wind se vleuels sweef",
          "die lieflikheid van klank wat leef",
          "in eng’le lied so roerend mooi,",
          "waar hul die pelgrims huis toe nooi."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Verhewe land bo son en maan,",
      "hoog op jou berge wil ek staan",
      "en uitkyk oor die glasesee,",
      "oor wonings wat die Heer sal gee;",
      "En op sy strate en sy strand",
      "vind ek my eeu'ge Vaderland."
    ]
  },
  {
    "english": "Glorious things of thee are spoken",
    "hymnNumber": 434,
    "reference": "AL434",
    "title": "Sion, Stad Van God",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.1
    },
    "verses": [
      {
        "content": [
          "Sion, stad van God, hoe heerlik",
          "is U vestings daar omhoog!",
          "O hoe lieflik en begeerlik",
          "vir die moeë pelgrimsoog!",
          "Niks kan ooit U rus verstoor nie,",
          "veilig op die Rots gebou;",
          "Daar word nooit 'n sug gehoor nie,",
          "geen geween of klag van rou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Uit Gods liefde vloei die strome",
          "Lewenswater, ryk en vry;",
          "Les die dors van elke vrome,",
          "wat nooit weer gebrek sal ly.",
          "Milde Gewer, U genade",
          "duur vir ewig en altoos!",
          "Ondeurgrond'lik is U dade,",
          "en U liefde eindeloos!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar sweef sag oor elke woning,",
          "weer die wolk- en vuurkolom,",
          "as bewys dat onse Koning",
          "wag hou oor Sy eiendom.",
          "Sion is die stad van vrede,",
          "glorieryke godsverblyf;",
          "Wat die siener lank gelede",
          "in verrukking kon beskryf."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O, hoe sterk is my verlange",
          "na die vreugde van my Heer!",
          "Sion, neem my hart gevange,",
          "hier is niks wat ek begeer.",
          "Heiland, enkel deur genade",
          "kom ek in U koninkryk;",
          "Hiervoor ag ek alles skade,",
          "dat ek Sion mag bereik."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Come, we that love the Lord",
    "hymnNumber": 435,
    "reference": "AL435",
    "title": "Laat Ons Wat God Bemin",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Laat ons wat God bemin,",
          "ons dank aan Hom betoon.",
          "Kom sing eenparig tot Sy lof!  ",
          "Kom sing eenparig tot Sy lof!",
          "Aanbid Hom op Sy troon.        ",
          "Aanbid Hom op Sy troon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Laat hul wat God nie ken,",
          "maar weier om te sing,",
          "maar koningskinders ken hul Heer; ",
          "Maar koningskinders ken hul Heer;",
          "En sal Hom hulde bring. ",
          "En sal Hom hulde bring."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die Sionsheuwel gee",
          "sy vreugde mild en skoon,",
          "nog voor ons land aan gindse strand",
          "nog voor ons land aan gindse strand",
          "of daardie oord bewoon.            ",
          "Of daardie oord bewoon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Kom, laat ons juig en sing",
          "maak al die trane droog.",
          "Ons reis gaan na Immanuelsland -",
          "ons reis gaan na Immanuelsland -",
          "na oorde rein omhoog,            ",
          "na oorde rein omhoog."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ons reis is na Sion,",
      "lieflike, heerlike Sion,",
      "ons reis is opwaarts na Sion,",
      "die heerlike stad van ons God."
    ]
  },
  {
    "english": "Beyond the Sunset",
    "hymnNumber": 436,
    "reference": "AL436",
    "title": "Na Hierdie Skeem'ring",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Na hierdie skeem'ring,",
          "o blye môre",
          "as ons met Jesus ",
          "daarbo sal woon!",
          "Die stryd geëindig, ",
          "o goue môre!",
          "Na hierdie skeem'ring ",
          "is vreugde skoon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Na hierdie skeem'ring ",
          "verdwyn die wolke,",
          "geen storme dreig dan, ",
          "geen angs of pyn,",
          "o dag van blydskap, ",
          "o eeu'ge môre!",
          "Na hierdie skeem'ring,",
          "slegs vreugde rein."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Na hierdie skeem'ring",
          "sal ek gelei word",
          "na God, die Vader ",
          "wat ek vereer.",
          "Sy grootste luister, ",
          "Sy welkomswoorde",
          "sal daar my deel wees, ",
          "by onse Heer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Na hierdie skeem'ring,",
          "blye ontmoeting!",
          "Daar met ons dierb'res ",
          "ween ons nie meer.",
          "In daardie tuiste ",
          "is nie meer skeiding",
          "na hierdie skeem'ring, ",
          "by onse Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jerusalem the golden",
    "hymnNumber": 437,
    "reference": "AL437",
    "title": "Jerusalem",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Jerusalem, die Godstad",
          "waar melk en heuning vloei!",
          "Versonke in oorpeinsing,",
          "deur daardie beeld geboei,",
          "weet ek? O nee, ek weet nie",
          "wat my daarbowe wag:",
          "die heerlikheid en vreugde,",
          "die Goddelike prag!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "‘n lied klink uit die sale",
          "van Sion met gejuig,",
          "waar al die martelare",
          "van Gods gena getuig!",
          "Die Lam is in hul midde;",
          "op Hom is elke oog,",
          "want Hy self het hul trane",
          "vir ewig afgedroog."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Daar is die troon van Dawid,",
          "en daar, van sorg bevry,",
          "kan al die bruilofsgaste",
          "hul in die fees verbly;",
          "Saam met die Heer, oorwinnaars",
          "oor sonde, dood en haat,",
          "vir ewig en vir ewig",
          "in blinkende gewaad."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O tuiste van Gods kinders,",
          "waar rus en vrede woon!",
          "O land van uitverkoor'nes",
          "so onbeskryflik skoon!",
          "Bring ons daar uit genade,",
          "o Jesus, onse Heer,",
          "waar U saam met die Vader",
          "en Heil'ge Gees regeer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O perfect Love, all human thought transcending",
    "hymnNumber": 438,
    "reference": "AL438",
    "title": "Volmaakte Liefde, Ver Bo Ons Verhewe",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Volmaakte liefde, ver bo ons verhewe,",
          "ons kniel ootmoedig, biddend voor U troon;",
          "Skenk hulle tog in hierdie aardse lewe",
          "liefde wat eenheid met geluk bekroon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Volmaakte lewe, seën hul verwagting",
          "van tere liefde en 'n sterk geloof,",
          "van hoop en stil, geduldige volharding",
          "waarvan nog smart nog dood hul kan beroof."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Skenk hulle vreug wat aardse smart oorskadu,",
          "en vrede wat die aardse stryd kalmeer;",
          "Voeg by die dag die heerlike verwagting",
          "van al die skone wat hul hart begeer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Happy the home when God is there",
    "hymnNumber": 439,
    "reference": "AL439",
    "title": "Welsalig Is Die Huisgesin",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Welsalig is die huisgesin",
          "waar God se liefde woon,",
          "waar almal saam eenstemmig bid",
          "in vrede voor Gods troon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Welsalig is die huisgesin",
          "waar Jesus soete Naam",
          "geheilig en eerbiedig word",
          "deur kind en ouer saam."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Welsalig is die huisgesin",
          "waar Gods Woord en gebed",
          "geleer, geken, geuiter word",
          "voor Hom wat sondaars red."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "O laat ons eensgesindheid vind",
          "en vrede, in ons Heer;",
          "Laat goue bande almal bind",
          "en liefde ons regeer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 440,
    "reference": "AL440",
    "title": "Hy Wat Die Eerste Egpaar",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Hy wat die eerste egpaar",
          "so ruim geseën het,",
          "staan altyd in ons midde",
          "om op ons vreug te let."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As Christenman en -dame",
          "hul in die eg verbind,",
          "is ook die groot Drie-eenheid",
          "se seën nog te vind."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "O Heer, waak oor die egpaar",
          "wat wagtend voor U staan,",
          "tot hulle in die hemel",
          "eens na U troon sal gaan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Om daar voor U aanbiddend",
          "hul krone neer te lê,",
          "en as die Bruid van Christus",
          "hul deel met U te hê."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jerusalem, my happy home",
    "hymnNumber": 441,
    "reference": "AL441",
    "title": "Jerusalem, My Hemelhuis",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Jerusalem, my hemelhuis,",
          "hoe lank moet ek nog wag",
          "voordat my siel, van droefheid vry,",
          "jou vreugde sien en prag?"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jou mure is van edelsteen,",
          "met pêrelpoorte rein,",
          "jou strate is van suiwer goud;",
          "Jou lig sal ewig skyn!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die hemeltuine daar omhoog,",
          "is onbeskryflik skoon,",
          "waar die verlostes van die Heer",
          "in heerlikheid sal woon."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Wil U genade, liewe Heer,",
          "tog aan my siel bewys;",
          "Wanneer U kom, neem dan ook my",
          "na gindse Paradys!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "By cool Siloam's shady rill",
    "hymnNumber": 442,
    "reference": "AL442",
    "title": "Waar Koel Siloam Saggies Bruis",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.5
    },
    "verses": [
      {
        "content": [
          "Waar koel Siloam saggies bruis,",
          "kan lelies welig groei;",
          "Waar geurbelaaide windjies suis,",
          "kan Saronrose bloei."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Waar liefde in die huis regeer,",
          "en kalme vrede woon,",
          "sal kinders opwas tot Gods eer",
          "en ouersorg beloon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Van dag tot dag skenk U ons brood,",
          "die lewe, ja, veel meer;",
          "As kind en man en in die dood",
          "bly ons U eie, Heer!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Lead them, my God, to Thee",
    "hymnNumber": 443,
    "reference": "AL443",
    "title": "Bring Hul Tot U, My Heer",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "Bring hul tot U, my Heer,",
          "bring hul vandag,",
          "my kinders, elke een,",
          "onder U mag.",
          "O, deur U groot gena",
          "bring hul tot U, my Heer,",
          "bring hul tot U, my Heer,",
          "bring hul tot U."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As aardse vreugde wink,",
          "helder en bly,",
          "laat geen gesigsbedrog",
          "hul dan verlei;",
          "Maar van versoekingsmag",
          "bring hul tot U, my Heer,",
          "bring hul tot U, my Heer,",
          "bring hul tot U."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Selfs kleine kindertjies",
          "het U kom red.",
          "U het as kind geleef",
          "rein, onbesmet.",
          "Ek bid in Jesus Naam:",
          "bring hul tot U, my Heer,",
          "bring hul tot U, my Heer,",
          "bring hul tot U."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Sterk U my klein geloof",
          "om te vertrou",
          "dat U my kosb're skat",
          "ook sal behou;",
          "Neem hulle harte nou,",
          "bring hul tot U, my Heer,",
          "bring hul tot U, my Heer,",
          "bring hul tot U."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Jesus, I will follow Thee",
    "hymnNumber": 444,
    "reference": "AL444",
    "title": "Jesus, Ek Volg Waar U Lei",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 11.9,
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Jesus, ek volg waar U lei,",
          "want ek hoor U roep na my;",
          "Orals gaan ek met U saam,",
          "want ek glo in U Naam."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ogies kyk nie altyd reg,",
          "voetjies dwaal so dikwels weg;",
          "Al is ek ook swak en blind",
          "maar ek is nog U kind."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al kry ek ook baie swaar,",
          "Jesus sal my nog bewaar;",
          "Aan my hand sal Hy my lei",
          "solank ek by Hom bly."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Jesus ek sal gaan (x3),",
      "net waar U my sal lei."
    ]
  },
  {
    "english": "How sweet, how heavenly is the sight",
    "hymnNumber": 445,
    "reference": "AL445",
    "title": "Hoe Lieflik Wanneer Broeders Hier",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 12.5
    },
    "verses": [
      {
        "content": [
          "Hoe lieflik wanneer broeders hier",
          "in liefde same woon;",
          "Waar vrede heerlik seëvier,",
          "met elke self verloën;"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As elkeen met sy broeder sug",
          "en deel in al sy smart,",
          "en juigend met hom saam kan lug",
          "die vreugde van sy hart;"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As elkeen sonder nyd of kwaad",
          "sy eie sin vergeet,",
          "en niemand van 'n ander praat",
          "die kwade wat hy weet;"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As liefde soos 'n helder stroom",
          "deur alle harte vloei;",
          "En eenheidskrag en eerbetoon",
          "in alle dade gloei;"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Ja, in die blye hemelland",
          "sal ons diegene vind",
          "wat hul op aarde met die band",
          "van liefdedade bind."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "'Mid pleasures and palaces though we may roam",
    "hymnNumber": 446,
    "reference": "AL446",
    "title": "Waar Rykdom Of Weelde",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 38.9,
      "intro": 38.9
    },
    "verses": [
      {
        "content": [
          "Waar rykdom of weelde my skrede mag lei,",
          "my need'rige huisie bly dierbaar vir my;",
          "Op geen ander plek is ek ooit so bewus",
          "van hemelse vrede wat sag op my rus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al sou ek as swerwer in weelde verkeer,",
          "o gee my my need'rige huisie net weer,",
          "want daar sing die voëltjies so vreedsaam en bly;",
          "Waar elders sal ek daardie vrede verkry?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Selfs hul wat Sy vrede al jarelank mis,",
          "besef ook hoe soet Sy herin'ringe is.",
          "Van wêreldse skyn - dis niks meer as 'n klug -",
          "keer duisende harte verlangende t'rug."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Tuis, tuis, bring my tuis;",
      "Na my need'rige huisie",
      "so dierbaar vir my."
    ]
  },
  {
    "english": "Once in royal David's city",
    "hymnNumber": 447,
    "reference": "AL447",
    "title": "Daar Was In Die Stad Van Dawid",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Daar was in die stad van Dawid",
          "eens 'n nederige stal,",
          "waar 'n vrou wat ver gereis het,",
          "tussen diere moes beval.",
          "Onbekend en onbemind",
          "was Maria en haar Kind!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy, die Skepper van die aarde,",
          "Heerser van die groot heelal,",
          "het Hom in 'n krip laat neerlê",
          "voor die diere in 'n stal.",
          "Onse Koning se verhewe",
          "moes op aarde need'rig lewe."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In Sy kinderjare het Hy",
          "aan Sy ouers eer bewys;",
          "Let op haar, die liewe moeder,",
          "laat ons God vir moeders prys!",
          "Christenkind, ons vra, wees jy",
          "ook gehoorsaam net soos Hy."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Jesus was vir ons 'n voorbeeld",
          "deur Sy kinderjare heen;",
          "Hy was klein en swak en hulp'loos,",
          "soms het Hy soos ons geween.",
          "Ja, Hy voel nog as ons ly;",
          "Oor ons vreugde is Hy bly."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "En die Jesus wat so need'rig",
          "as die Offerlam moes dien;",
          "Sal ons eendag deur genade",
          "as die Erekoning sien.",
          "Hy lei elke kind wat glo,",
          "na Sy Vaderhuis daarbo."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "I think, when I read that sweet story of old",
    "hymnNumber": 448,
    "reference": "AL448",
    "title": "Wanneer Ek In Bybelverhale",
    "hasMidi": false,
    "numberOfVerses": 2,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Wanneer ek in Bybelverhale soms lees",
          "van Jesus se lewe as mens,",
          "hoe graag Hy in kindergeselskap wou wees,",
          "dan ontstaan in my hart hierdie wens:",
          "o ek wens ek was daar,",
          "waar dissipels Hom dien",
          "aan my dierbare Heiland se sy;",
          "Om Sy stem te kon hoor",
          "en Sy oog te kon sien,",
          "toe Hy sê: “Bring die kinders na My!'"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Maar nou gaan ek deur die gebed",
          "na my Heer,",
          "want Hy het beloof, en ek glo,",
          "dat as ek hier op aarde",
          "my Heiland vereer,",
          "ek sal gaan na 'n woning daarbo.",
          "In die heerlike huis waar verlostes sal woon,",
          "en die engele lofsange sing;",
          "Daar sal ons voor die Here se heerlike troon",
          "onse hulde en liefde kan bring."
        ],
        "verseNumber": 2
      }
    ],
    "chorus": null
  },
  {
    "english": "When He cometh, when He cometh",
    "hymnNumber": 449,
    "reference": "AL449",
    "title": "As Hy Weer Kom",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "As Hy weer kom, as Hy weer kom,",
          "kom haal Hy Sy pêrels,",
          "al Sy pêrels, fraaie pêrels",
          "vir Jesus se kroon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy versamel, Hy versamel",
          "die hemel se pêrels;",
          "al die reines, al die skones,",
          "vir Jesus se kroon."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Al die kinders, al die kinders",
          "wat Jesus gehoorsaam,",
          "is die pêrels, fraaie pêrels,",
          "vir Jesus se kroon."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Al die kindergesiggies",
      "soos die sterre se liggies,",
      "is die hemel se pêrels",
      "vir Jesus se kroon"
    ]
  },
  {
    "english": "I will early seek the Saviour",
    "hymnNumber": 450,
    "reference": "AL450",
    "title": "Ek Soek Jesus Wyl Ek Jonk Is",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 15.9,
      "intro": 15.9
    },
    "verses": [
      {
        "content": [
          "Ek soek Jesus wyl ek jonk is,",
          "daagliks wil ek van Hom leer;",
          "Ek wil volg in elke voetspoor,",
          "ek wil doen wat Hy begeer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "As Hy stuur, wil ek gehoorsaam;",
          "Ek is jonk, maar ek sal gaan.",
          "Elke dag wil ek Sy boodskap",
          "en Sy doel met my verstaan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "In versoekings is Hy naby,",
          "en sal my van sonde red;",
          "Ek sal roep en Hy sal antwoord,",
          "want Hy hoor ook my gebed."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Want Hy min my, en Sy liefde",
      "dwing my om in Hom te glo;",
      "Jesus red my en Hy lei my,",
      "daarom min ek Jesus so."
    ]
  },
  {
    "english": "I am so glad that our Father in heaven",
    "hymnNumber": 451,
    "reference": "AL451",
    "title": "Ek Is So Bly Dat My Hemelse Heer",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 23.9,
      "intro": 23.9
    },
    "verses": [
      {
        "content": [
          "Ek is so bly dat my hemelse Heer",
          "ons van die liefde van Jesus wou leer;",
          "Wondere kom deur Sy woord tot ons vry,",
          "grootste van almal is: Jesus min my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Al sou ek wegdwaal in sonde en kwaad,",
          "Jesus se liefde sal my nooit verlaat;",
          "Ek het vir Jesus waarheen ek kan vlug,",
          "as ek verdwaal, bring Sy liefde my t'rug"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As daar maar een lied is wat ek kan sing,",
          "as ek daarbowe my dank aan Hom bring,",
          "dan sal my lied deur die ewigheid bly:",
          "'o, wat 'n dierbare Jesus min my!'"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ek is so bly, want Jesus min my,",
      "Jesus min my, Jesus min my!",
      "Ek is so bly, want Jesus min my,",
      "Jesus bemin ook my."
    ]
  },
  {
    "english": "Long Ago the Children Sang a Song",
    "hymnNumber": 452,
    "reference": "AL452",
    "title": "Lank Gelee' Het Kindertjies Gesing",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "content": [
          "Lank gelee' het kindertjies gesing,",
          "om lof en hulde aan die Heer te bring:",
          "Hosanna, hosanna,",
          "Hosanna vir die Koning!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Nou nog hoor Hy graag die skone lied",
          "wat kinderstemme aan die Koning bied.",
          "Hosanna, hosanna,",
          "Hosanna vir die Koning!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons sal eendag hoër hulde bring",
          "as al die vromes van verlossing sing.",
          "Hosanna, hosanna,",
          "Hosanna vir die Koning!"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Heerlik sing, heerlik sing,",
      "kom luister hoe die kindertjies daar sing,",
      "heerlik sing, heerlik sing,",
      "Jesus luister as ons sing."
    ]
  },
  {
    "english": "I would be true, for there are those who trust me",
    "hymnNumber": 453,
    "reference": "AL453",
    "title": "Heer, Maak My Rein",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "Heer, maak my rein,",
          "want ander soek na reinheid,",
          "maak my getrou",
          "dat ek U kan behaag;",
          "Gee my die krag",
          "vir elke uur van lyding,",
          "en maak my dapper:",
          "daar is veel te waag. (2x)"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Maak my 'n vriend",
          "van vyande en wese,",
          "laat my die gawe",
          "gee en dit vergeet;",
          "Maak my beskeie",
          "want ek ken my swakheid;",
          "Versag deur my",
          "die lydendes se leed. (2x)"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Graag leer ek hier",
          "die lesse van die lewe,",
          "maak oop U Woord",
          "en lei my elke dag;",
          "Laat my eerbiedig",
          "hoor as Jesus fluister",
          "en alles doen",
          "wat Hy van my verwag. (2x)"
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "'Tis Love That Makes Us Happy",
    "hymnNumber": 454,
    "reference": "AL454",
    "title": "Die Liefde Gee Ons Vreugde",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 10,
      "intro": 20.1
    },
    "verses": [
      {
        "content": [
          "Die liefde gee ons vreugde",
          "en hou ons paaie reg;",
          "Dit maak ons vriend'lik en bedagsaam",
          "orals op ons weg."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die wêreld is vol sonde,",
          "vol siekte, dood en smart.",
          "Ons werk vir Jesus elke dag",
          "met liefde in ons hart."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "As Hy ons eendag wegroep",
          "en na die hemel bring,",
          "Sal ons met blydskap elke dag",
          "van Jesus liefde sing."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Onse God is 'n God van liefde,",
      "ons moet ook liefhê net soos Hy.",
      "Die liefde gee ons vreugde",
      "en hou ons paaie reg;",
      "Dit maak ons vriend'lik en bedagsaam",
      "orals op ons weg."
    ]
  },
  {
    "english": "Jesus loves me! this I know",
    "hymnNumber": 455,
    "reference": "AL455",
    "title": "Jesus Is So Lief Vir My",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 13.6,
      "intro": 20.4
    },
    "verses": [
      {
        "content": [
          "Jesus is so lief vir my",
          "o, dit maak my hartjie bly!",
          "Kindertjies behoort aan Hom",
          "as hul net na Jesus kom."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Jesus het vir my gely",
          "en vir my 'n plek berei,",
          "Hy maak my van sonde rein -",
          "laat my in al is ek klein."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Jesus is nog lief vir my",
          "as ek siek is en moet ly;",
          "Dan hou eng'le elke dag",
          "by my bedjie oor my wag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Jesus is so lief vir my,",
          "Hy sal altyd by my bly;",
          "As ek Hom op aarde dien",
          "sal ek Hom daarbo ook sien."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Ja, Hy bemin my,",
      "ja, Hy bemin my,",
      "ja, Hy bemin my,",
      "die Bybel leer my so."
    ]
  },
  {
    "english": "He Loves Me, Too",
    "hymnNumber": 456,
    "reference": "AL456",
    "title": "God Sien Die Kleinste Voëltjie Val",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 17,
      "intro": 17
    },
    "verses": [
      {
        "content": [
          "God sien die kleinste voëltjie val,",
          "die kleinste ding sien Hy,",
          "as God die mossies lief kan kry,",
          "dan min Hy ook vir my."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy kleur die lelie van die veld",
          "en laat dit lekker geur;",
          "As Hy die blomme lief kan kry,",
          "min Hy my baie meer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God het elk blom en voël gemaak -",
          "die dinge groot en klein.",
          "Hy sal Sy kinders nie vergeet,",
          "Sy liefde is te rein."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Hy het my lief! Hy het my lief!",
      "Ek weet Hy het my lief!",
      "As Hy die kleinste ding bemin,",
      "bemin Hy ook vir my."
    ]
  },
  {
    "english": "A Little Light",
    "hymnNumber": 457,
    "reference": "AL457",
    "title": "Heer, Maak My Soos ‘n Lamp Wat Skyn",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.6
    },
    "verses": [
      {
        "content": [
          "Heer, maak my soos 'n lamp wat skyn",
          "op elke donker baan,",
          "‘n vlammetjie wat helder brand",
          "net waar ek ook mag gaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heer, maak my soos 'n blommetjie,",
          "‘n vreugde vir die oog,",
          "tevrede waar ek my bevind -",
          "in tuin of ereboog."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Heer, maak my soos 'n blye lied",
          "wat hulle troos wat treur,",
          "wat swakkes help om sterk te wees",
          "en hulle op kan beur."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Heer, maak my soos 'n wandelstaf",
          "waar swakkes op kan leun,",
          "maak al my krag en lewenslus",
          "my medemens tot steun."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "How I Wish I Knew",
    "hymnNumber": 458,
    "reference": "AL458",
    "title": "Sterretjies Wat Skitter",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Sterretjies wat skitter aan die hemelblou,",
          "ek het soms gewonder of jul nog onthou",
          "hoe daar een soos julle eenmaal was bestem",
          "as die gids van wyses na ou Betlehem."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Het jul die geskenke vir die kind gesien,",
          "en die stal en krippie wat as wieg moes dien,",
          "hoe hul Hom aanbid het soos dit hul betaam -",
          "Hom die vreemd kindjie met die vreemde Naam?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Het jul ooit die moeders pleitend daar sien staan",
          "waar die wrede manne met die swaarde slaan?",
          "Het jul ook vir Josef vlugtend weg sien ry",
          "na die land Egipte - deur jul lig gelei?"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Het jul Hom sien goed doen waar Hy rond moes swerf?",
          "Weet jul hoe vir sondaars Hy die dood moes sterf?",
          "Sterretjies wat skitter, het jul al vergeet?",
          "Wat jul daar gesien het, sou ek graag wou weet!"
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Little Feet, Be Careful",
    "hymnNumber": 459,
    "reference": "AL459",
    "title": "My Handjies Is Vanmôre",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 11.5,
      "intro": 11.5
    },
    "verses": [
      {
        "content": [
          "My handjies is vanmôre",
          "so pragtig skoon en sag,",
          "nou gee ek hul aan Jesus",
          "vir diens die hele dag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "My oortjies luister altyd",
          "net waar ons loop of speel",
          "of daar nie ook 'n kans is",
          "om liefde uit te deel."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "My ogies kyk gedurig",
          "wat handjies doen en laat",
          "en waarsku my ook altyd",
          "teen elke stoute daad."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Voetjies, wees versigtig",
      "waar jul loop of staan;",
      "Kies die regte paadjie",
      "wat na Jesus gaan."
    ]
  },
  {
    "english": "Jesus, Friend of little children",
    "hymnNumber": 460,
    "reference": "AL460",
    "title": "Jesus, Vriend Van Kinderhartjies",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 9.5
    },
    "verses": [
      {
        "content": [
          "Jesus, Vriend van kinderhartjies,",
          "wees 'n Vriend van my;",
          "Neem my hand en hou my altyd",
          "aan U sy."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Leer my groei in goeie dinge",
          "daagliks meer en meer;",
          "U was ook 'n kind, en seker",
          "weet U, Heer!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Stap vir stap moet U my voortlei,",
          "opwaarts in my jeug -",
          "sterker, wyser met die jare",
          "in U deug."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Laat my nooit alleen, o Jesus",
          "al is ek ook groot;",
          "Ek het U van kleins af nodig -",
          "tot die dood."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Like a Little Candle",
    "hymnNumber": 461,
    "reference": "AL461",
    "title": "Jesus Vra Dat Ons Soos ‘n Kersie Skyn",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Jesus vra dat ons ",
          "soos 'n kersie skyn,",
          "met 'n helder liggie ",
          "altyd skoon en rein",
          "in die donker wêreld ",
          "waar ons gaan;",
          "Elk op die plekkie ",
          "waar Hy staan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy vra dat ons lig ",
          "deur die nag moet dring,",
          "daar is soveel duisternis",
          "wat ons omring,",
          "sonde, nood en trane ",
          "sien ons aan,",
          "elk op die plekkie ",
          "waar Hy staan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons werk vir die Heer",
          "as ons ander dien,",
          "as ons liggies dof brand,",
          "sal Hy dit ook sien.",
          "Hy kyk uit die hemel ",
          "op ons neer -",
          "sien of ons lewe ",
          "Hom vereer."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Jesus is die lig van ",
          "die liefde rein,",
          "as ons net na Hom kyk,",
          "sal ons helder skyn",
          "soos die maan met ",
          "sy geleende lig;",
          "Elk op sy plekkie ",
          "doen sy plig."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Two Little Hands",
    "hymnNumber": 462,
    "reference": "AL462",
    "title": "Twee Handjies Kom Werk Vandag Vir Jesus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 14,
      "intro": 14
    },
    "verses": [
      {
        "content": [
          "Twee handjies kom werk vandag vir Jesus,",
          "een tongetjie kom sing Sy lof,",
          "twee oortjies hoor Sy liefdeswoorde,",
          "een stemmetjie klink in Sy hof."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Twee voetjies loop op die pad van Jesus -",
          "volg in die spore van die Heer -",
          "twee ogies lees die heil'ge Bybel",
          "waar ek van God se liefde leer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ek gee ook my hartjie nou aan Jesus,",
          "dan kan die Heer my sieltjie red.",
          "Ek gee aan Hom my hele lewe,",
          "dis al wat ek op aarde het."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Heer, ek kom, ja ek kom",
      "in my vroeë kinderjare,",
      "ek kom by U leer.",
      "ek kom by U leer."
    ]
  },
  {
    "english": "A year of precious blessings",
    "hymnNumber": 463,
    "reference": "AL463",
    "title": "‘n Jaar Vol Ryke Seën",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 38.3
    },
    "verses": [
      {
        "content": [
          "‘n Jaar vol ryke seën",
          "het weer verbygegaan -",
          "‘n jaar van groot oorwinning",
          "en vrugb're werk gedaan;",
          "O Heer, U was ons toevlug,",
          "U seën bekroon ons taak;",
          "Ons sing 'n blye loflied",
          "tot U wat oor ons waak.",
          "Ons sing 'n blye loflied",
          "tot U wat oor ons waak."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons kom vandag aanbiddend",
          "in hierdie huis byeen;",
          "Wees self hier in ons midde",
          "en skenk U ryke seën.",
          "O maak ons sterk en moedig;",
          "Vul ons met liefde, Heer,",
          "dat elkeen in sy lewe",
          "U altyd mag vereer.",
          "dat elkeen in sy lewe",
          "U altyd mag vereer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "o Kerk van die Gesalfde,",
          "wen siele in Gods krag,",
          "stry moedig teen die vyand;",
          "Bekamp die sondemag;",
          "Tot ons Hom in die hemel",
          "met eng'le saam vereer;",
          "Dan sing ons: “Halleluja!'",
          "en kroon Hom Allerheer.",
          "Dan sing ons: “Halleluja!'",
          "en kroon Hom Allerheer."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Wake the song of joy and gladness",
    "hymnNumber": 464,
    "reference": "AL464",
    "title": "Sing Die Lied Van Louter Vreugde",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 34.8,
      "intro": 34.8
    },
    "verses": [
      {
        "content": [
          "Sing die lied van louter vreugde,",
          "sing tot eer van onse God;",
          "Sing van onse Heer se deugde,",
          "in Sy hand hou Hy ons lot.",
          "Loof die Heer wat ons gelei het,",
          "om mekaar hier te ontmoet;",
          "Aan Hom al die lof want Hy het",
          "ons gekoop met kosb're bloed."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dankbaar jubel die groot skare,",
          "om die feesdag te begroet;",
          "Luid weerklink die blye mare;",
          "Laat ons neerbuig aan Sy voet.",
          "Sing dan van die Heer se lyding;",
          "Laat ons lof ten hemel styg;",
          "Dankbaar oor die ou, ou tyding",
          "juig ons nou - wie kan nog swyg."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons wil danksê, goeie Vader",
          "vir die jaar se seëning;",
          "Neem van ons wat hier vergader,",
          "nou die hulde wat ons bring.",
          "Ons wil danksê, dierb're Heiland,",
          "vir verlossing deur U bloed;",
          "Heil'ge Gees, rig U ons skrede,",
          "daagliks nader aan ons God."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Laat ons sing, laat ons sing,",
      "kom sing van louter vreugde;",
      "Laat ons sing, kom ons sing",
      "die groot verlossingslied."
    ]
  },
  {
    "english": "God of our fathers, known of old",
    "hymnNumber": 465,
    "reference": "AL465",
    "title": "God Van Ons Vaad're",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "God van ons vaad're van weleer,",
          "U was ons hulp op land en seë;",
          "Onder U sterke hand, o Heer,",
          "het U ons heerskappy gegee.",
          "O Heiland, wil U ons behou",
          "as ons vergeet, as ons verflou!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "In menig oorlog teen barbaar",
          "het U digby ons sy gestaan;",
          "U het ons van die dood bewaar",
          "en self die vyandsmag verslaan.",
          "O Heiland, wil U ons behou",
          "as ons vergeet, as ons verflou!"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dikwels is hulle uitgemoor,",
          "die trekkers in 'n woeste land,",
          "maar U het telkens weer gehoor",
          "die smeking van 'n hart wat brand.",
          "O Heiland, wil U ons behou",
          "as ons vergeet, as ons verflou!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En as beskawingsweelde soms",
          "met sinneluste ons verlei,",
          "herinner ons dan aan U koms",
          "en bly ons in die stryd naby!",
          "O Heiland, wil U ons behou",
          "as ons vergeet, as ons verflou!"
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Die vyand steun net op geweld,",
          "op staal en lood en mannekrag,",
          "maar selfs die sterkste heidenheld",
          "staan hulp'loos voor U groter mag.",
          "Maar ons wil op die Here bou,",
          "want Hy versterk en Hy behou!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 466,
    "reference": "AL466",
    "title": "Ure, Dae, Maande, Jare",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Ure, dae, maande, jare",
          "vlieg soos skadu's snel verby,",
          "kom en gaan net soos die bare",
          "slegs herinneringe bly.",
          "Op ons wandel hier benede",
          "sal geen voetspoor ooit bly staan,",
          "al die hede word verlede,",
          "maar ons werk sal met ons gaan!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Voorgeslagte het gesterwe",
          "en ons bou op hulle graf;",
          "Ons word spoedig hier vergete,",
          "mense val soos blare af.",
          "Wat die eeue opgegaar het,",
          "word slegs in die graf bewaar.",
          "Buiten U, o Eeu'ge Wese,",
          "wat bly nog vir ons gespaar?"
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Snel dan heen, o lewensjare,",
          "met jul blydskap onvoltooid,",
          "wissel maar, en bring gevare -",
          "God, my God, verander nooit.",
          "Al het alles my begewe,",
          "voortgelei deur God se hand,",
          "kyk ek uit die aardse lewe",
          "op my eeu'ge Vaderland."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Standing by a purpose true",
    "hymnNumber": 467,
    "reference": "AL467",
    "title": "Stel Beginsel As Jou Doel",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 11.9,
      "intro": 11.9
    },
    "verses": [
      {
        "content": [
          "Stel beginsel as jou doel,",
          "staan by Gods bevel;",
          "Eer die helde van die stryd",
          "en staan soos Daniël."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Helde het die stryd verloor -",
          "vrees was hul gesel -",
          "as hul maar by God wou staan,",
          "was elk 'n Daniël."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Baie reuse word vandag",
          "teen die grond gevel;",
          "Deur die manne van Gods Woord",
          "wat staan soos Daniël."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Ons moet matigheid as plig",
          "daagliks hoër stel;",
          "Om die bose mag te stuit",
          "vereis 'n Daniël."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Wees vandag 'n Daniël,",
      "wees jou doel getrou;",
      "Staan al is dit ook alleen,",
      "God sal jou behou."
    ]
  },
  {
    "english": "Yield not to temptation",
    "hymnNumber": 468,
    "reference": "AL468",
    "title": "Vlug Van Die Versoeking",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 34.5,
      "intro": 34.5
    },
    "verses": [
      {
        "content": [
          "Vlug van die versoeking,",
          "want daar is gevaar,",
          "roep slegs tot die Here;",
          "Hy sal jou bewaar;",
          "Stry teen donker drange,",
          "bly aan Hom getrou,",
          "as jy sien op Jesus,",
          "sal Hy jou behou."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Keer jou van die spotters,",
          "my hulle gedrag;",
          "Hou Gods Naam in ere,",
          "spreek dit met ontsag;",
          "Wees stil en bedagsaam,",
          "goedhartig, getrou;",
          "As jy sien op Jesus,",
          "sal Hy jou behou."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Aan Hom wat oorwin het,",
          "gee Jesus 'n kroon;",
          "Glo net in die Here,",
          "Hy sal jou beloon;",
          "Hy gee moed en sterkte",
          "as kragte verflou,",
          "Sien altyd op Jesus",
          "Hy sal jou behou."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Bid die Here om leiding,",
      "sterkte, troos en verblyding;",
      "Hy's jou krag en bevryding -",
      "Jesus sal jou behou."
    ]
  },
  {
    "english": "Sound the battle cry, See! the foe is nigh",
    "hymnNumber": 469,
    "reference": "AL469",
    "title": "Hef Die Strydkreet Aan!",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 28.7
    },
    "verses": [
      {
        "content": [
          "Hef die strydkreet aan!",
          "Waar die vyand staan,",
          "laat ons moedig gaan",
          "in die Heer.",
          "Ons moet ons omgord,",
          "en steeds sterker word;",
          "Want die tyd is kort,",
          "soos Hy ons leer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons gaan voorwaarts nou,",
          "aan die Heer getrou;",
          "Hy sal ons behou",
          "in die stryd.",
          "Met die pantser aan",
          "veg ons in die Naam",
          "wat ons nooit beskaam",
          "in ewigheid."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God van die heelal,",
          "tot U roep ons pal",
          "want ons weet U sal",
          "ons verhoor.",
          "Met die stryd verby,",
          "sal ons krone kry",
          "en ons saam verbly",
          "met eng'lekoor."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Staan dan op en skaar jul by die Leidsman;",
      "Hy het Satan lankal reeds verslaan;",
      "Trek dan voorwaarts, ",
      "singende: Hosanna!",
      "Christus voer ons ",
      "tot oorwinning aan."
    ]
  },
  {
    "english": "Christ is made the sure foundation",
    "hymnNumber": 470,
    "reference": "AL470",
    "title": "Christus Is Die Vaste Grondslag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 19.1
    },
    "verses": [
      {
        "content": [
          "Christus is die vaste grondslag,",
          "Hy die hoeksteen, is die Hoof",
          "deur Hom het die Vader eenheid",
          "aan Sy kerk op aard beloof.",
          "Sionshulp is Hy vir ewig,",
          "kom, laat ons die Heiland loof!"
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Heel die kerk van God op aarde",
          "loof die grote Hemelheer -",
          "loof Hom met 'n vrome lofsang,",
          "wat Sy heil'ge Naam vereer.",
          "Heel die kerk op aarde loof Hom -",
          "loof die grote Hemelheer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kom, bewoon die aardse tempel,",
          "opgerig U Naam ter eer;",
          "Luister na ons smeekgebede",
          "waar ons hier voor U verkeer.",
          "Strek U hande uit, o Vader -",
          "seën ons, o grote Heer!"
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Skenk nou aan U gunsgenote",
          "in U huis hier saamgeskaar,",
          "elke heilige verwagting,",
          "maak U groot beloftes waar.",
          "Wil U hulle deur die lewe",
          "met U Vaderhand bewaar."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "O bow Thine ear, Eternal One!",
    "hymnNumber": 471,
    "reference": "AL471",
    "title": "Neig Tog U Oor Tot Ons Vandag",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.7
    },
    "verses": [
      {
        "content": [
          "Neig tog U oor tot ons vandag",
          "en hoor ons lofgesange, Heer!",
          "Vir U het ons die huis gebou -",
          "‘n tempel tot U lof en eer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Mag dit vir ons 'n Bet-el wees",
          "waar ons U altyd hulde bring.",
          "Vervul ons met 'n heil'ge vrees",
          "as ons aanbid en spreek en sing."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Mag hier U seën op ons rus",
          "en elk gebed soos reukwerk wees;",
          "Skenk ons ook U teenwoordigheid",
          "en stort op ons U Heil'ge Gees."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "In hierdie plek wil ons U loof",
          "in elk gebed en lofgesang.",
          "En mag, soos eens oor die Jordaan,",
          "U Heil'ge Gees oor ons ook hang."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Great King of glory, come",
    "hymnNumber": 472,
    "reference": "AL472",
    "title": "O Erekoning, Kom!",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 17.3
    },
    "verses": [
      {
        "content": [
          "o Erekoning, kom!",
          "En kroon met guns en eer",
          "die tempel as U huis,",
          "ons as U eie, Heer.",
          "Wil U in hierdie tempel toon",
          "dat God selfs by die mens kan woon."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ag, hoor tog as ons smeek",
          "en dank en loflied bring;",
          "En wil tot elkeen spreek",
          "wat hier U Naam besing.",
          "Mag dorstig sondaars hier kom drink",
          "en laat U Woord hier helder klink."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Mag ook ons kinders hier",
          "U goedheid kom besing;",
          "Maak selfs die swakste fier",
          "in hierdie saal'ge kring.",
          "Ontbloot U krag en red vandag",
          "elkeen wat hier op Jesus wag."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As ons U Woord hier hoor,",
          "mag ons U waarheid glo;",
          "En sing in daardie koor",
          "met serafim daarbo.",
          "Tot almal wat die Heer verwag",
          "sal triomfeer op daardie dag."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 473,
    "reference": "AL473",
    "title": "Net Soos Die Landman Wat Geploeg Het",
    "hasMidi": false,
    "numberOfVerses": 4,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Net soos die landman wat geploeg het,",
          "die awendskadus bly begroet,",
          "so is ons bly wat hard geswoeg het,",
          "dat onse dag ten einde spoed.",
          "Dié hoop sal nooit in ons verdwyn nie",
          "ons wat na rus en vrede smag.",
          "Sal daardie dag dan nie verskyn nie?",
          "Ons het so lank daarvoor gewag."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dan sal ons saam met Jesus lewe,",
          "dan voel of ken ons geen verdriet.",
          "Dié uitsig moet ons nooit begewe,",
          "hy wat geloof het, wanhoop nie.",
          "Die dood sal ons die rus verseker;",
          "Ons gaan met vreugde na die graf -",
          "blymoedig ledig ons die beker,",
          "die kruis neem doodsvrees van ons af."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons vlees daal spoedig neer ter ruste,",
          "die graf ken geen vermoeiing meer;",
          "Eens hoor ons dan die luide wekstem",
          "tot hoër heil by onse Heer.",
          "En dan, dan word ons saam vergader",
          "en deur die Here ingelei",
          "in daardie huis van onse Vader",
          "waar Hy vir ons 'n plek berei."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die hoop verban die leed - die wrange;",
          "Kom reisgenote! Kyk omhoog!",
          "Vir ons wat wag met bly verlange,",
          "is berge vlak en seë droog.",
          "O saligheid, so ongemete,",
          "U bind ons met 'n liefdesband!",
          "Daar is die vreemd'lingskap vergete,",
          "want ons is in die Vaderland."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "Not now, but in the coming years",
    "hymnNumber": 474,
    "reference": "AL474",
    "title": "Nie Nou, Maar Eenmaal",
    "hasMidi": true,
    "numberOfVerses": 5,
    "hasChorus": true,
    "timestamps": {
      "chorus": 21.2,
      "intro": 21.2
    },
    "verses": [
      {
        "content": [
          "Nie nou, maar eenmaal, sal ons wel",
          "die doel kan sien van elke traan;",
          "Miskien eens in die beter land,",
          "maar eenmaal sal ons dit verstaan."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Ons sal die drade weer kan neem,",
          "en weef wat ons hier moes laat staan;",
          "Die raaisels lees ons een vir een,",
          "o dan, eers dan, sal ons verstaan."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Dan sal ons weet waarom ons hoop",
          "so dikwels met die mis vergaan;",
          "Waarom ons lied so gou verstil -",
          "dit alles sal ons daar verstaan."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Waarom moet dit wat ons begeer,",
          "so dikwels net die hand ontgaan;",
          "Waarom moet soveel werk misluk -",
          "eendag daarbo sal ons verstaan."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "God ken die pad, Hy sal bestier,",
          "Hy lei ons oor die lewensbaan;",
          "Eendag sal ons die waaroms peil,",
          "ja dan, daarbo, sal ons verstaan!"
        ],
        "verseNumber": 5
      }
    ],
    "chorus": [
      "Vertrou op God van dag tot dag,",
      "Hy hou jou hand waar jy ook gaan;",
      "Al is dit om jou donker nag,",
      "eendag, eendag sal ons verstaan."
    ]
  },
  {
    "english": "",
    "hymnNumber": 475,
    "reference": "AL475",
    "title": "Heerlik', Heilig', Opperwese",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Heerlik', heilig', Opperwese,",
          "U gebied die groot heelal,",
          "en verdryf die donker vrese",
          "van U skepsels sonder tal.",
          "Sit ons droewig in die duister,",
          "skyn U lig nog onverdoof",
          "met sy glans en al sy luister",
          "om U grote Naam te loof."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "U alleen is alles waardig;",
          "Ons is stof wat moet vergaan.",
          "Ons wil in ons pligte vaardig",
          "voor U val of voor U staan.",
          "As dit tot U luister bydra,",
          "doen dan vry soos U begeer;",
          "Of ons ondergaan of drywe -",
          "alles lei slegs tot U eer."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Diepe wysheid, ons verborge,",
          "is die weë van ons God.",
          "Ons ontwaar dit in ons sorge -",
          "in ons wis'lend lewenslot.",
          "Is dit bitterheid of soetheid,",
          "ons aanbid en swyg dan stil,",
          "want die wesenlike Goedheid",
          "maak ons heilig deur Sy wil."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Sweet be thy rest",
    "hymnNumber": 476,
    "reference": "AL476",
    "title": "Rus, Swerwer, Rus",
    "hasMidi": true,
    "numberOfVerses": 3,
    "hasChorus": false,
    "timestamps": {
      "intro": 26
    },
    "verses": [
      {
        "content": [
          "Rus, swerwer, rus,",
          "jy slaap nou in vrede,",
          "jou God onthou waar jy rus benede;",
          "Salige slaap waar sorge nie steur nie,",
          "ons treur nie meer;",
          "God het jou geseën.",
          "Rus, swerwer, rus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Dit is verby; jou taak is beëindig;",
          "Daar wag 'n kroon",
          "waar droefheid nie meer pynig;",
          "Daar is vir jou geen nag meer",
          "van pyn nie, net stille rus",
          "waar kragte nie kwyn nie.",
          "Rus, swerwer, rus."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Rus, swerwer, rus;",
          "Ons sien jou nie meer nie,",
          "voor daardie dag wanneer ook ons",
          "nie treur nie;",
          "O grote dag wanneer aardse skeiding",
          "ewig vergeet word in ons verblyding.",
          "Rus, swerwer, rus."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": null
  },
  {
    "english": "Asleep in Jesus! blessed sleep",
    "hymnNumber": 477,
    "reference": "AL477",
    "title": "Die Rus In Jesus Is Volmaak",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 8.3
    },
    "verses": [
      {
        "content": [
          "Die rus in Jesus is volmaak -",
          "om nooit tot trane te ontwaak -",
          "‘n ongestoorde, kalme rus,",
          "van pyn of lyding onbewus."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Die rus in Jesus! O hoe soet",
          "om Hom so rustig te ontmoet",
          "en elke uur bereid te wees,",
          "en stil te gaan, so sonder vrees."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Die rus in Jesus is so sag!",
          "Ons sal ontwaak deur God se mag;",
          "Geen vrees of ramp sal dan verhoed",
          "dat ons die Heiland sal ontmoet."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "Die rus in Hom is spoedig oor:",
          "as ons basuingeskal sal hoor,",
          "dan gee die graf sy lewe weer,",
          "onsterflik, skoon in onse Heer."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  },
  {
    "english": "",
    "hymnNumber": 478,
    "reference": "AL478",
    "title": "Ons Is Verheug Dat Onse God",
    "hasMidi": false,
    "numberOfVerses": 5,
    "hasChorus": false,
    "verses": [
      {
        "content": [
          "Ons is verheug dat onse God",
          "beskikker is van elke lot;",
          "Dat Hy genadig elke uur",
          "in wysheid, leed of vreugde stuur."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Hy wat sy eie weg wil gaan,",
          "sien dwaling vaak vir waarheid aan,",
          "en gee hy dan daaraan gehoor,",
          "verdwaal hy van die regte spoor."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God ken alleen die naaste pad",
          "wat uitloop op die hemelstad",
          "wat Hy beskik, is altyd goed,",
          "al is dit smart en teëspoed."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "As ons die doodsvallei betree,",
          "neem ons geen aardse vriende mee,",
          "maar Hy, die beste Vriend in nood,",
          "lei ons selfs deur die graf en dood."
        ],
        "verseNumber": 4
      },
      {
        "content": [
          "Kom, tree met my vrymoedig voort",
          "in vol vertroue op Sy woord.",
          "Hoe seer ons ook die weg mag vrees,",
          "tog sal die einde salig wees."
        ],
        "verseNumber": 5
      }
    ],
    "chorus": null
  },
  {
    "english": "God be with you till we meet again",
    "hymnNumber": 479,
    "reference": "AL479",
    "title": "God Sy Met U",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": true,
    "timestamps": {
      "chorus": 19.1,
      "intro": 29.3
    },
    "verses": [
      {
        "content": [
          "God sy met U tot ons weer ontmoet;",
          "Mag Sy raad U lei en heilig,",
          "met Sy kudde steeds beveilig;",
          "God sy met U tot ons weer ontmoet."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "God sy met U tot ons weer ontmoet;",
          "Dek U met Sy vleuels veilig,",
          "voed U met Sy manna heilig;",
          "God sy met U tot ons weer ontmoet."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "God sy met U tot ons weer ontmoet;",
          "Dreig daar storms en doodsgevare,",
          "red Sy hand U uit die bare;",
          "God sy met U tot ons weer ontmoet."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "God sy met U tot ons weer ontmoet;",
          "Sprei Sy liefdevaandel oor U,",
          "breek die kille doodsgolf voor U;",
          "God sy met U tot ons weer ontmoet."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": [
      "Weer ontmoet, weer ontmoet,",
      "deur Sy almag trou behoed;",
      "Weer ontmoet, weer ontmoet,",
      "God sy met U tot ons weer ontmoet."
    ]
  },
  {
    "english": "",
    "hymnNumber": 480,
    "reference": "AL480",
    "title": "Daar Is ‘n Land Van Rein Geluk",
    "hasMidi": false,
    "numberOfVerses": 3,
    "hasChorus": true,
    "verses": [
      {
        "content": [
          "Daar is 'n land van rein geluk",
          "waar vreugde steeds regeer -",
          "waar nag die hart nie meer bedruk;",
          "Daar ken ons pyn nie meer."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "Daar sal dit ewig lente bly;",
          "Wie kan Sy skoonheid weet?",
          "En slegs 'n korte tydjie skei",
          "dié land van ons planeet."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Kon ons maar saam met Moses staan",
          "en oor die landskap kyk,",
          "niks wat op aarde nog bestaan,",
          "kan daarmee vergelyk."
        ],
        "verseNumber": 3
      }
    ],
    "chorus": [
      "Ons reis nou voorwaarts hand aan hand,",
      "gelukkig na Immanuelsland",
      "waar Jesus ewig sal regeer -",
      "dan skei ons nimmer, nimmermeer.",
      "Wat, skei ons nimmermeer?",
      "Nee, daar skei ons nie weer!",
      "Wat, skei ons nimmermeer?",
      "Nee, daar skei ons nie weer!",
      "Waar Jesus ewig sal regeer,",
      "daar skei ons nimmer, nimmer meer!"
    ]
  },
  {
    "english": "Blest be the tie that binds",
    "hymnNumber": 481,
    "reference": "AL481",
    "title": "Geseën Die Liefdeband",
    "hasMidi": true,
    "numberOfVerses": 4,
    "hasChorus": false,
    "timestamps": {
      "intro": 10.7
    },
    "verses": [
      {
        "content": [
          "Geseën die liefdeband",
          "wat harte same bind,",
          "as broeders, susters in die Heer",
          "is almal eensgesind."
        ],
        "verseNumber": 1
      },
      {
        "content": [
          "En voor ons Vaderstroon",
          "word elke hart ontlas;",
          "Ons stryd, ons sorg, ons doel is een",
          "ons hoop op Hom staan vas."
        ],
        "verseNumber": 2
      },
      {
        "content": [
          "Ons dra die laste saam",
          "en deel mekaar se smart;",
          "Soms ween ons met die ander saam,",
          "met weemoed in ons hart."
        ],
        "verseNumber": 3
      },
      {
        "content": [
          "En moet ons weldra skei -",
          "dit gee ons harte pyn;",
          "Maar nogtans bly ons een van hart",
          "tot Jesus weer verskyn."
        ],
        "verseNumber": 4
      }
    ],
    "chorus": null
  }
]
